// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/material-design-icons/MaterialIcons-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/material-design-icons/MaterialIcons-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/material-design-icons/MaterialIcons-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/material-design-icons/MaterialIcons-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/images/gallery/3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/images/cards/macbook.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/images/cards/iphone.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../public/images/cards/applewatch.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Muli:300,300i,400,400i,500,600);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-------------------------------------------------
	Style file contain theme components style
-------------------------------------------------*/
.materialize-red
{
    background-color: #e51c23 !important;
}

.materialize-red-text
{
    color: #e51c23 !important;
}

.materialize-red.lighten-5
{
    background-color: #fdeaeb !important;
}

.materialize-red-text.text-lighten-5
{
    color: #fdeaeb !important;
}

.materialize-red.lighten-4
{
    background-color: #f8c1c3 !important;
}

.materialize-red-text.text-lighten-4
{
    color: #f8c1c3 !important;
}

.materialize-red.lighten-3
{
    background-color: #f3989b !important;
}

.materialize-red-text.text-lighten-3
{
    color: #f3989b !important;
}

.materialize-red.lighten-2
{
    background-color: #ee6e73 !important;
}

.materialize-red-text.text-lighten-2
{
    color: #ee6e73 !important;
}

.materialize-red.lighten-1
{
    background-color: #ea454b !important;
}

.materialize-red-text.text-lighten-1
{
    color: #ea454b !important;
}

.materialize-red.darken-1
{
    background-color: #d0181e !important;
}

.materialize-red-text.text-darken-1
{
    color: #d0181e !important;
}

.materialize-red.darken-2
{
    background-color: #b9151b !important;
}

.materialize-red-text.text-darken-2
{
    color: #b9151b !important;
}

.materialize-red.darken-3
{
    background-color: #a21318 !important;
}

.materialize-red-text.text-darken-3
{
    color: #a21318 !important;
}

.materialize-red.darken-4
{
    background-color: #8b1014 !important;
}

.materialize-red-text.text-darken-4
{
    color: #8b1014 !important;
}

.red
{
    background-color: #f44336 !important;
}

.red-text
{
    color: #f44336 !important;
}

.red.lighten-5
{
    background-color: #ffebee !important;
}

.red-text.text-lighten-5
{
    color: #ffebee !important;
}

.red.lighten-4
{
    background-color: #ffcdd2 !important;
}

.red-text.text-lighten-4
{
    color: #ffcdd2 !important;
}

.red.lighten-3
{
    background-color: #ef9a9a !important;
}

.red-text.text-lighten-3
{
    color: #ef9a9a !important;
}

.red.lighten-2
{
    background-color: #e57373 !important;
}

.red-text.text-lighten-2
{
    color: #e57373 !important;
}

.red.lighten-1
{
    background-color: #ef5350 !important;
}

.red-text.text-lighten-1
{
    color: #ef5350 !important;
}

.red.darken-1
{
    background-color: #e53935 !important;
}

.red-text.text-darken-1
{
    color: #e53935 !important;
}

.red.darken-2
{
    background-color: #d32f2f !important;
}

.red-text.text-darken-2
{
    color: #d32f2f !important;
}

.red.darken-3
{
    background-color: #c62828 !important;
}

.red-text.text-darken-3
{
    color: #c62828 !important;
}

.red.darken-4
{
    background-color: #b71c1c !important;
}

.red-text.text-darken-4
{
    color: #b71c1c !important;
}

.red.accent-1
{
    background-color: #ff8a80 !important;
}

.red-text.text-accent-1
{
    color: #ff8a80 !important;
}

.red.accent-2
{
    background-color: #ff5252 !important;
}

.red-text.text-accent-2
{
    color: #ff5252 !important;
}

.red.accent-3
{
    background-color: #ff1744 !important;
}

.red-text.text-accent-3
{
    color: #ff1744 !important;
}

.red.accent-4
{
    background-color: #d50000 !important;
}

.red-text.text-accent-4
{
    color: #d50000 !important;
}

.pink
{
    background-color: #e91e63 !important;
}

.pink-text
{
    color: #e91e63 !important;
}

.pink.lighten-5
{
    background-color: #fce4ec !important;
}

.pink-text.text-lighten-5
{
    color: #fce4ec !important;
}

.pink.lighten-4
{
    background-color: #f8bbd0 !important;
}

.pink-text.text-lighten-4
{
    color: #f8bbd0 !important;
}

.pink.lighten-3
{
    background-color: #f48fb1 !important;
}

.pink-text.text-lighten-3
{
    color: #f48fb1 !important;
}

.pink.lighten-2
{
    background-color: #f06292 !important;
}

.pink-text.text-lighten-2
{
    color: #f06292 !important;
}

.pink.lighten-1
{
    background-color: #ec407a !important;
}

.pink-text.text-lighten-1
{
    color: #ec407a !important;
}

.pink.darken-1
{
    background-color: #d81b60 !important;
}

.pink-text.text-darken-1
{
    color: #d81b60 !important;
}

.pink.darken-2
{
    background-color: #c2185b !important;
}

.pink-text.text-darken-2
{
    color: #c2185b !important;
}

.pink.darken-3
{
    background-color: #ad1457 !important;
}

.pink-text.text-darken-3
{
    color: #ad1457 !important;
}

.pink.darken-4
{
    background-color: #880e4f !important;
}

.pink-text.text-darken-4
{
    color: #880e4f !important;
}

.pink.accent-1
{
    background-color: #ff80ab !important;
}

.pink-text.text-accent-1
{
    color: #ff80ab !important;
}

.pink.accent-2
{
    background-color: #ff4081 !important;
}

.pink-text.text-accent-2
{
    color: #ff4081 !important;
}

.pink.accent-3
{
    background-color: #f50057 !important;
}

.pink-text.text-accent-3
{
    color: #f50057 !important;
}

.pink.accent-4
{
    background-color: #c51162 !important;
}

.pink-text.text-accent-4
{
    color: #c51162 !important;
}

.purple
{
    background-color: #9c27b0 !important;
}

.purple-text
{
    color: #9c27b0 !important;
}

.purple.lighten-5
{
    background-color: #f3e5f5 !important;
}

.purple-text.text-lighten-5
{
    color: #f3e5f5 !important;
}

.purple.lighten-4
{
    background-color: #e1bee7 !important;
}

.purple-text.text-lighten-4
{
    color: #e1bee7 !important;
}

.purple.lighten-3
{
    background-color: #ce93d8 !important;
}

.purple-text.text-lighten-3
{
    color: #ce93d8 !important;
}

.purple.lighten-2
{
    background-color: #ba68c8 !important;
}

.purple-text.text-lighten-2
{
    color: #ba68c8 !important;
}

.purple.lighten-1
{
    background-color: #ab47bc !important;
}

.purple-text.text-lighten-1
{
    color: #ab47bc !important;
}

.purple.darken-1
{
    background-color: #8e24aa !important;
}

.purple-text.text-darken-1
{
    color: #8e24aa !important;
}

.purple.darken-2
{
    background-color: #7b1fa2 !important;
}

.purple-text.text-darken-2
{
    color: #7b1fa2 !important;
}

.purple.darken-3
{
    background-color: #6a1b9a !important;
}

.purple-text.text-darken-3
{
    color: #6a1b9a !important;
}

.purple.darken-4
{
    background-color: #4a148c !important;
}

.purple-text.text-darken-4
{
    color: #4a148c !important;
}

.purple.accent-1
{
    background-color: #ea80fc !important;
}

.purple-text.text-accent-1
{
    color: #ea80fc !important;
}

.purple.accent-2
{
    background-color: #e040fb !important;
}

.purple-text.text-accent-2
{
    color: #e040fb !important;
}

.purple.accent-3
{
    background-color: #d500f9 !important;
}

.purple-text.text-accent-3
{
    color: #d500f9 !important;
}

.purple.accent-4
{
    background-color: #a0f !important;
}

.purple-text.text-accent-4
{
    color: #a0f !important;
}

.deep-purple
{
    background-color: #673ab7 !important;
}

.deep-purple-text
{
    color: #673ab7 !important;
}

.deep-purple.lighten-5
{
    background-color: #ede7f6 !important;
}

.deep-purple-text.text-lighten-5
{
    color: #ede7f6 !important;
}

.deep-purple.lighten-4
{
    background-color: #d1c4e9 !important;
}

.deep-purple-text.text-lighten-4
{
    color: #d1c4e9 !important;
}

.deep-purple.lighten-3
{
    background-color: #b39ddb !important;
}

.deep-purple-text.text-lighten-3
{
    color: #b39ddb !important;
}

.deep-purple.lighten-2
{
    background-color: #9575cd !important;
}

.deep-purple-text.text-lighten-2
{
    color: #9575cd !important;
}

.deep-purple.lighten-1
{
    background-color: #7e57c2 !important;
}

.deep-purple-text.text-lighten-1
{
    color: #7e57c2 !important;
}

.deep-purple.darken-1
{
    background-color: #5e35b1 !important;
}

.deep-purple-text.text-darken-1
{
    color: #5e35b1 !important;
}

.deep-purple.darken-2
{
    background-color: #512da8 !important;
}

.deep-purple-text.text-darken-2
{
    color: #512da8 !important;
}

.deep-purple.darken-3
{
    background-color: #4527a0 !important;
}

.deep-purple-text.text-darken-3
{
    color: #4527a0 !important;
}

.deep-purple.darken-4
{
    background-color: #311b92 !important;
}

.deep-purple-text.text-darken-4
{
    color: #311b92 !important;
}

.deep-purple.accent-1
{
    background-color: #b388ff !important;
}

.deep-purple-text.text-accent-1
{
    color: #b388ff !important;
}

.deep-purple.accent-2
{
    background-color: #7c4dff !important;
}

.deep-purple-text.text-accent-2
{
    color: #7c4dff !important;
}

.deep-purple.accent-3
{
    background-color: #651fff !important;
}

.deep-purple-text.text-accent-3
{
    color: #651fff !important;
}

.deep-purple.accent-4
{
    background-color: #6200ea !important;
}

.deep-purple-text.text-accent-4
{
    color: #6200ea !important;
}

.indigo
{
    background-color: #3f51b5 !important;
}

.indigo-text
{
    color: #3f51b5 !important;
}

.indigo.lighten-5
{
    background-color: #e8eaf6 !important;
}

.indigo-text.text-lighten-5
{
    color: #e8eaf6 !important;
}

.indigo.lighten-4
{
    background-color: #c5cae9 !important;
}

.indigo-text.text-lighten-4
{
    color: #c5cae9 !important;
}

.indigo.lighten-3
{
    background-color: #9fa8da !important;
}

.indigo-text.text-lighten-3
{
    color: #9fa8da !important;
}

.indigo.lighten-2
{
    background-color: #7986cb !important;
}

.indigo-text.text-lighten-2
{
    color: #7986cb !important;
}

.indigo.lighten-1
{
    background-color: #5c6bc0 !important;
}

.indigo-text.text-lighten-1
{
    color: #5c6bc0 !important;
}

.indigo.darken-1
{
    background-color: #3949ab !important;
}

.indigo-text.text-darken-1
{
    color: #3949ab !important;
}

.indigo.darken-2
{
    background-color: #303f9f !important;
}

.indigo-text.text-darken-2
{
    color: #303f9f !important;
}

.indigo.darken-3
{
    background-color: #283593 !important;
}

.indigo-text.text-darken-3
{
    color: #283593 !important;
}

.indigo.darken-4
{
    background-color: #1a237e !important;
}

.indigo-text.text-darken-4
{
    color: #1a237e !important;
}

.indigo.accent-1
{
    background-color: #8c9eff !important;
}

.indigo-text.text-accent-1
{
    color: #8c9eff !important;
}

.indigo.accent-2
{
    background-color: #536dfe !important;
}

.indigo-text.text-accent-2
{
    color: #536dfe !important;
}

.indigo.accent-3
{
    background-color: #3d5afe !important;
}

.indigo-text.text-accent-3
{
    color: #3d5afe !important;
}

.indigo.accent-4
{
    background-color: #304ffe !important;
}

.indigo-text.text-accent-4
{
    color: #304ffe !important;
}

.blue
{
    background-color: #2196f3 !important;
}

.blue-text
{
    color: #2196f3 !important;
}

.blue.lighten-5
{
    background-color: #e3f2fd !important;
}

.blue-text.text-lighten-5
{
    color: #e3f2fd !important;
}

.blue.lighten-4
{
    background-color: #bbdefb !important;
}

.blue-text.text-lighten-4
{
    color: #bbdefb !important;
}

.blue.lighten-3
{
    background-color: #90caf9 !important;
}

.blue-text.text-lighten-3
{
    color: #90caf9 !important;
}

.blue.lighten-2
{
    background-color: #64b5f6 !important;
}

.blue-text.text-lighten-2
{
    color: #64b5f6 !important;
}

.blue.lighten-1
{
    background-color: #42a5f5 !important;
}

.blue-text.text-lighten-1
{
    color: #42a5f5 !important;
}

.blue.darken-1
{
    background-color: #1e88e5 !important;
}

.blue-text.text-darken-1
{
    color: #1e88e5 !important;
}

.blue.darken-2
{
    background-color: #1976d2 !important;
}

.blue-text.text-darken-2
{
    color: #1976d2 !important;
}

.blue.darken-3
{
    background-color: #1565c0 !important;
}

.blue-text.text-darken-3
{
    color: #1565c0 !important;
}

.blue.darken-4
{
    background-color: #0d47a1 !important;
}

.blue-text.text-darken-4
{
    color: #0d47a1 !important;
}

.blue.accent-1
{
    background-color: #82b1ff !important;
}

.blue-text.text-accent-1
{
    color: #82b1ff !important;
}

.blue.accent-2
{
    background-color: #448aff !important;
}

.blue-text.text-accent-2
{
    color: #448aff !important;
}

.blue.accent-3
{
    background-color: #2979ff !important;
}

.blue-text.text-accent-3
{
    color: #2979ff !important;
}

.blue.accent-4
{
    background-color: #2962ff !important;
}

.blue-text.text-accent-4
{
    color: #2962ff !important;
}

.light-blue
{
    background-color: #03a9f4 !important;
}

.light-blue-text
{
    color: #03a9f4 !important;
}

.light-blue.lighten-5
{
    background-color: #e1f5fe !important;
}

.light-blue-text.text-lighten-5
{
    color: #e1f5fe !important;
}

.light-blue.lighten-4
{
    background-color: #b3e5fc !important;
}

.light-blue-text.text-lighten-4
{
    color: #b3e5fc !important;
}

.light-blue.lighten-3
{
    background-color: #81d4fa !important;
}

.light-blue-text.text-lighten-3
{
    color: #81d4fa !important;
}

.light-blue.lighten-2
{
    background-color: #4fc3f7 !important;
}

.light-blue-text.text-lighten-2
{
    color: #4fc3f7 !important;
}

.light-blue.lighten-1
{
    background-color: #29b6f6 !important;
}

.light-blue-text.text-lighten-1
{
    color: #29b6f6 !important;
}

.light-blue.darken-1
{
    background-color: #039be5 !important;
}

.light-blue-text.text-darken-1
{
    color: #039be5 !important;
}

.light-blue.darken-2
{
    background-color: #0288d1 !important;
}

.light-blue-text.text-darken-2
{
    color: #0288d1 !important;
}

.light-blue.darken-3
{
    background-color: #0277bd !important;
}

.light-blue-text.text-darken-3
{
    color: #0277bd !important;
}

.light-blue.darken-4
{
    background-color: #01579b !important;
}

.light-blue-text.text-darken-4
{
    color: #01579b !important;
}

.light-blue.accent-1
{
    background-color: #80d8ff !important;
}

.light-blue-text.text-accent-1
{
    color: #80d8ff !important;
}

.light-blue.accent-2
{
    background-color: #40c4ff !important;
}

.light-blue-text.text-accent-2
{
    color: #40c4ff !important;
}

.light-blue.accent-3
{
    background-color: #00b0ff !important;
}

.light-blue-text.text-accent-3
{
    color: #00b0ff !important;
}

.light-blue.accent-4
{
    background-color: #0091ea !important;
}

.light-blue-text.text-accent-4
{
    color: #0091ea !important;
}

.cyan
{
    background-color: #00bcd4 !important;
}

.cyan-text
{
    color: #00bcd4 !important;
}

.cyan.lighten-5
{
    background-color: #e0f7fa !important;
}

.cyan-text.text-lighten-5
{
    color: #e0f7fa !important;
}

.cyan.lighten-4
{
    background-color: #b2ebf2 !important;
}

.cyan-text.text-lighten-4
{
    color: #b2ebf2 !important;
}

.cyan.lighten-3
{
    background-color: #80deea !important;
}

.cyan-text.text-lighten-3
{
    color: #80deea !important;
}

.cyan.lighten-2
{
    background-color: #4dd0e1 !important;
}

.cyan-text.text-lighten-2
{
    color: #4dd0e1 !important;
}

.cyan.lighten-1
{
    background-color: #26c6da !important;
}

.cyan-text.text-lighten-1
{
    color: #26c6da !important;
}

.cyan.darken-1
{
    background-color: #00acc1 !important;
}

.cyan-text.text-darken-1
{
    color: #00acc1 !important;
}

.cyan.darken-2
{
    background-color: #0097a7 !important;
}

.cyan-text.text-darken-2
{
    color: #0097a7 !important;
}

.cyan.darken-3
{
    background-color: #00838f !important;
}

.cyan-text.text-darken-3
{
    color: #00838f !important;
}

.cyan.darken-4
{
    background-color: #006064 !important;
}

.cyan-text.text-darken-4
{
    color: #006064 !important;
}

.cyan.accent-1
{
    background-color: #84ffff !important;
}

.cyan-text.text-accent-1
{
    color: #84ffff !important;
}

.cyan.accent-2
{
    background-color: #18ffff !important;
}

.cyan-text.text-accent-2
{
    color: #18ffff !important;
}

.cyan.accent-3
{
    background-color: #00e5ff !important;
}

.cyan-text.text-accent-3
{
    color: #00e5ff !important;
}

.cyan.accent-4
{
    background-color: #00b8d4 !important;
}

.cyan-text.text-accent-4
{
    color: #00b8d4 !important;
}

.teal
{
    background-color: #009688 !important;
}

.teal-text
{
    color: #009688 !important;
}

.teal.lighten-5
{
    background-color: #e0f2f1 !important;
}

.teal-text.text-lighten-5
{
    color: #e0f2f1 !important;
}

.teal.lighten-4
{
    background-color: #b2dfdb !important;
}

.teal-text.text-lighten-4
{
    color: #b2dfdb !important;
}

.teal.lighten-3
{
    background-color: #80cbc4 !important;
}

.teal-text.text-lighten-3
{
    color: #80cbc4 !important;
}

.teal.lighten-2
{
    background-color: #4db6ac !important;
}

.teal-text.text-lighten-2
{
    color: #4db6ac !important;
}

.teal.lighten-1
{
    background-color: #26a69a !important;
}

.teal-text.text-lighten-1
{
    color: #26a69a !important;
}

.teal.darken-1
{
    background-color: #00897b !important;
}

.teal-text.text-darken-1
{
    color: #00897b !important;
}

.teal.darken-2
{
    background-color: #00796b !important;
}

.teal-text.text-darken-2
{
    color: #00796b !important;
}

.teal.darken-3
{
    background-color: #00695c !important;
}

.teal-text.text-darken-3
{
    color: #00695c !important;
}

.teal.darken-4
{
    background-color: #004d40 !important;
}

.teal-text.text-darken-4
{
    color: #004d40 !important;
}

.teal.accent-1
{
    background-color: #a7ffeb !important;
}

.teal-text.text-accent-1
{
    color: #a7ffeb !important;
}

.teal.accent-2
{
    background-color: #64ffda !important;
}

.teal-text.text-accent-2
{
    color: #64ffda !important;
}

.teal.accent-3
{
    background-color: #1de9b6 !important;
}

.teal-text.text-accent-3
{
    color: #1de9b6 !important;
}

.teal.accent-4
{
    background-color: #00bfa5 !important;
}

.teal-text.text-accent-4
{
    color: #00bfa5 !important;
}

.green
{
    background-color: #4caf50 !important;
}

.green-text
{
    color: #4caf50 !important;
}

.green.lighten-5
{
    background-color: #e8f5e9 !important;
}

.green-text.text-lighten-5
{
    color: #e8f5e9 !important;
}

.green.lighten-4
{
    background-color: #c8e6c9 !important;
}

.green-text.text-lighten-4
{
    color: #c8e6c9 !important;
}

.green.lighten-3
{
    background-color: #a5d6a7 !important;
}

.green-text.text-lighten-3
{
    color: #a5d6a7 !important;
}

.green.lighten-2
{
    background-color: #81c784 !important;
}

.green-text.text-lighten-2
{
    color: #81c784 !important;
}

.green.lighten-1
{
    background-color: #66bb6a !important;
}

.green-text.text-lighten-1
{
    color: #66bb6a !important;
}

.green.darken-1
{
    background-color: #43a047 !important;
}

.green-text.text-darken-1
{
    color: #43a047 !important;
}

.green.darken-2
{
    background-color: #388e3c !important;
}

.green-text.text-darken-2
{
    color: #388e3c !important;
}

.green.darken-3
{
    background-color: #2e7d32 !important;
}

.green-text.text-darken-3
{
    color: #2e7d32 !important;
}

.green.darken-4
{
    background-color: #1b5e20 !important;
}

.green-text.text-darken-4
{
    color: #1b5e20 !important;
}

.green.accent-1
{
    background-color: #b9f6ca !important;
}

.green-text.text-accent-1
{
    color: #b9f6ca !important;
}

.green.accent-2
{
    background-color: #69f0ae !important;
}

.green-text.text-accent-2
{
    color: #69f0ae !important;
}

.green.accent-3
{
    background-color: #00e676 !important;
}

.green-text.text-accent-3
{
    color: #00e676 !important;
}

.green.accent-4
{
    background-color: #00c853 !important;
}

.green-text.text-accent-4
{
    color: #00c853 !important;
}

.light-green
{
    background-color: #8bc34a !important;
}

.light-green-text
{
    color: #8bc34a !important;
}

.light-green.lighten-5
{
    background-color: #f1f8e9 !important;
}

.light-green-text.text-lighten-5
{
    color: #f1f8e9 !important;
}

.light-green.lighten-4
{
    background-color: #dcedc8 !important;
}

.light-green-text.text-lighten-4
{
    color: #dcedc8 !important;
}

.light-green.lighten-3
{
    background-color: #c5e1a5 !important;
}

.light-green-text.text-lighten-3
{
    color: #c5e1a5 !important;
}

.light-green.lighten-2
{
    background-color: #aed581 !important;
}

.light-green-text.text-lighten-2
{
    color: #aed581 !important;
}

.light-green.lighten-1
{
    background-color: #9ccc65 !important;
}

.light-green-text.text-lighten-1
{
    color: #9ccc65 !important;
}

.light-green.darken-1
{
    background-color: #7cb342 !important;
}

.light-green-text.text-darken-1
{
    color: #7cb342 !important;
}

.light-green.darken-2
{
    background-color: #689f38 !important;
}

.light-green-text.text-darken-2
{
    color: #689f38 !important;
}

.light-green.darken-3
{
    background-color: #558b2f !important;
}

.light-green-text.text-darken-3
{
    color: #558b2f !important;
}

.light-green.darken-4
{
    background-color: #33691e !important;
}

.light-green-text.text-darken-4
{
    color: #33691e !important;
}

.light-green.accent-1
{
    background-color: #ccff90 !important;
}

.light-green-text.text-accent-1
{
    color: #ccff90 !important;
}

.light-green.accent-2
{
    background-color: #b2ff59 !important;
}

.light-green-text.text-accent-2
{
    color: #b2ff59 !important;
}

.light-green.accent-3
{
    background-color: #76ff03 !important;
}

.light-green-text.text-accent-3
{
    color: #76ff03 !important;
}

.light-green.accent-4
{
    background-color: #64dd17 !important;
}

.light-green-text.text-accent-4
{
    color: #64dd17 !important;
}

.lime
{
    background-color: #cddc39 !important;
}

.lime-text
{
    color: #cddc39 !important;
}

.lime.lighten-5
{
    background-color: #f9fbe7 !important;
}

.lime-text.text-lighten-5
{
    color: #f9fbe7 !important;
}

.lime.lighten-4
{
    background-color: #f0f4c3 !important;
}

.lime-text.text-lighten-4
{
    color: #f0f4c3 !important;
}

.lime.lighten-3
{
    background-color: #e6ee9c !important;
}

.lime-text.text-lighten-3
{
    color: #e6ee9c !important;
}

.lime.lighten-2
{
    background-color: #dce775 !important;
}

.lime-text.text-lighten-2
{
    color: #dce775 !important;
}

.lime.lighten-1
{
    background-color: #d4e157 !important;
}

.lime-text.text-lighten-1
{
    color: #d4e157 !important;
}

.lime.darken-1
{
    background-color: #c0ca33 !important;
}

.lime-text.text-darken-1
{
    color: #c0ca33 !important;
}

.lime.darken-2
{
    background-color: #afb42b !important;
}

.lime-text.text-darken-2
{
    color: #afb42b !important;
}

.lime.darken-3
{
    background-color: #9e9d24 !important;
}

.lime-text.text-darken-3
{
    color: #9e9d24 !important;
}

.lime.darken-4
{
    background-color: #827717 !important;
}

.lime-text.text-darken-4
{
    color: #827717 !important;
}

.lime.accent-1
{
    background-color: #f4ff81 !important;
}

.lime-text.text-accent-1
{
    color: #f4ff81 !important;
}

.lime.accent-2
{
    background-color: #eeff41 !important;
}

.lime-text.text-accent-2
{
    color: #eeff41 !important;
}

.lime.accent-3
{
    background-color: #c6ff00 !important;
}

.lime-text.text-accent-3
{
    color: #c6ff00 !important;
}

.lime.accent-4
{
    background-color: #aeea00 !important;
}

.lime-text.text-accent-4
{
    color: #aeea00 !important;
}

.yellow
{
    background-color: #ffeb3b !important;
}

.yellow-text
{
    color: #ffeb3b !important;
}

.yellow.lighten-5
{
    background-color: #fffde7 !important;
}

.yellow-text.text-lighten-5
{
    color: #fffde7 !important;
}

.yellow.lighten-4
{
    background-color: #fff9c4 !important;
}

.yellow-text.text-lighten-4
{
    color: #fff9c4 !important;
}

.yellow.lighten-3
{
    background-color: #fff59d !important;
}

.yellow-text.text-lighten-3
{
    color: #fff59d !important;
}

.yellow.lighten-2
{
    background-color: #fff176 !important;
}

.yellow-text.text-lighten-2
{
    color: #fff176 !important;
}

.yellow.lighten-1
{
    background-color: #ffee58 !important;
}

.yellow-text.text-lighten-1
{
    color: #ffee58 !important;
}

.yellow.darken-1
{
    background-color: #fdd835 !important;
}

.yellow-text.text-darken-1
{
    color: #fdd835 !important;
}

.yellow.darken-2
{
    background-color: #fbc02d !important;
}

.yellow-text.text-darken-2
{
    color: #fbc02d !important;
}

.yellow.darken-3
{
    background-color: #f9a825 !important;
}

.yellow-text.text-darken-3
{
    color: #f9a825 !important;
}

.yellow.darken-4
{
    background-color: #f57f17 !important;
}

.yellow-text.text-darken-4
{
    color: #f57f17 !important;
}

.yellow.accent-1
{
    background-color: #ffff8d !important;
}

.yellow-text.text-accent-1
{
    color: #ffff8d !important;
}

.yellow.accent-2
{
    background-color: #ff0 !important;
}

.yellow-text.text-accent-2
{
    color: #ff0 !important;
}

.yellow.accent-3
{
    background-color: #ffea00 !important;
}

.yellow-text.text-accent-3
{
    color: #ffea00 !important;
}

.yellow.accent-4
{
    background-color: #ffd600 !important;
}

.yellow-text.text-accent-4
{
    color: #ffd600 !important;
}

.amber
{
    background-color: #ffc107 !important;
}

.amber-text
{
    color: #ffc107 !important;
}

.amber.lighten-5
{
    background-color: #fff8e1 !important;
}

.amber-text.text-lighten-5
{
    color: #fff8e1 !important;
}

.amber.lighten-4
{
    background-color: #ffecb3 !important;
}

.amber-text.text-lighten-4
{
    color: #ffecb3 !important;
}

.amber.lighten-3
{
    background-color: #ffe082 !important;
}

.amber-text.text-lighten-3
{
    color: #ffe082 !important;
}

.amber.lighten-2
{
    background-color: #ffd54f !important;
}

.amber-text.text-lighten-2
{
    color: #ffd54f !important;
}

.amber.lighten-1
{
    background-color: #ffca28 !important;
}

.amber-text.text-lighten-1
{
    color: #ffca28 !important;
}

.amber.darken-1
{
    background-color: #ffb300 !important;
}

.amber-text.text-darken-1
{
    color: #ffb300 !important;
}

.amber.darken-2
{
    background-color: #ffa000 !important;
}

.amber-text.text-darken-2
{
    color: #ffa000 !important;
}

.amber.darken-3
{
    background-color: #ff8f00 !important;
}

.amber-text.text-darken-3
{
    color: #ff8f00 !important;
}

.amber.darken-4
{
    background-color: #ff6f00 !important;
}

.amber-text.text-darken-4
{
    color: #ff6f00 !important;
}

.amber.accent-1
{
    background-color: #ffe57f !important;
}

.amber-text.text-accent-1
{
    color: #ffe57f !important;
}

.amber.accent-2
{
    background-color: #ffd740 !important;
}

.amber-text.text-accent-2
{
    color: #ffd740 !important;
}

.amber.accent-3
{
    background-color: #ffc400 !important;
}

.amber-text.text-accent-3
{
    color: #ffc400 !important;
}

.amber.accent-4
{
    background-color: #ffab00 !important;
}

.amber-text.text-accent-4
{
    color: #ffab00 !important;
}

.orange
{
    background-color: #ff9800 !important;
}

.orange-text
{
    color: #ff9800 !important;
}

.orange.lighten-5
{
    background-color: #fff3e0 !important;
}

.orange-text.text-lighten-5
{
    color: #fff3e0 !important;
}

.orange.lighten-4
{
    background-color: #ffe0b2 !important;
}

.orange-text.text-lighten-4
{
    color: #ffe0b2 !important;
}

.orange.lighten-3
{
    background-color: #ffcc80 !important;
}

.orange-text.text-lighten-3
{
    color: #ffcc80 !important;
}

.orange.lighten-2
{
    background-color: #ffb74d !important;
}

.orange-text.text-lighten-2
{
    color: #ffb74d !important;
}

.orange.lighten-1
{
    background-color: #ffa726 !important;
}

.orange-text.text-lighten-1
{
    color: #ffa726 !important;
}

.orange.darken-1
{
    background-color: #fb8c00 !important;
}

.orange-text.text-darken-1
{
    color: #fb8c00 !important;
}

.orange.darken-2
{
    background-color: #f57c00 !important;
}

.orange-text.text-darken-2
{
    color: #f57c00 !important;
}

.orange.darken-3
{
    background-color: #ef6c00 !important;
}

.orange-text.text-darken-3
{
    color: #ef6c00 !important;
}

.orange.darken-4
{
    background-color: #e65100 !important;
}

.orange-text.text-darken-4
{
    color: #e65100 !important;
}

.orange.accent-1
{
    background-color: #ffd180 !important;
}

.orange-text.text-accent-1
{
    color: #ffd180 !important;
}

.orange.accent-2
{
    background-color: #ffab40 !important;
}

.orange-text.text-accent-2
{
    color: #ffab40 !important;
}

.orange.accent-3
{
    background-color: #ff9100 !important;
}

.orange-text.text-accent-3
{
    color: #ff9100 !important;
}

.orange.accent-4
{
    background-color: #ff6d00 !important;
}

.orange-text.text-accent-4
{
    color: #ff6d00 !important;
}

.deep-orange
{
    background-color: #ff5722 !important;
}

.deep-orange-text
{
    color: #ff5722 !important;
}

.deep-orange.lighten-5
{
    background-color: #fbe9e7 !important;
}

.deep-orange-text.text-lighten-5
{
    color: #fbe9e7 !important;
}

.deep-orange.lighten-4
{
    background-color: #ffccbc !important;
}

.deep-orange-text.text-lighten-4
{
    color: #ffccbc !important;
}

.deep-orange.lighten-3
{
    background-color: #ffab91 !important;
}

.deep-orange-text.text-lighten-3
{
    color: #ffab91 !important;
}

.deep-orange.lighten-2
{
    background-color: #ff8a65 !important;
}

.deep-orange-text.text-lighten-2
{
    color: #ff8a65 !important;
}

.deep-orange.lighten-1
{
    background-color: #ff7043 !important;
}

.deep-orange-text.text-lighten-1
{
    color: #ff7043 !important;
}

.deep-orange.darken-1
{
    background-color: #f4511e !important;
}

.deep-orange-text.text-darken-1
{
    color: #f4511e !important;
}

.deep-orange.darken-2
{
    background-color: #e64a19 !important;
}

.deep-orange-text.text-darken-2
{
    color: #e64a19 !important;
}

.deep-orange.darken-3
{
    background-color: #d84315 !important;
}

.deep-orange-text.text-darken-3
{
    color: #d84315 !important;
}

.deep-orange.darken-4
{
    background-color: #bf360c !important;
}

.deep-orange-text.text-darken-4
{
    color: #bf360c !important;
}

.deep-orange.accent-1
{
    background-color: #ff9e80 !important;
}

.deep-orange-text.text-accent-1
{
    color: #ff9e80 !important;
}

.deep-orange.accent-2
{
    background-color: #ff6e40 !important;
}

.deep-orange-text.text-accent-2
{
    color: #ff6e40 !important;
}

.deep-orange.accent-3
{
    background-color: #ff3d00 !important;
}

.deep-orange-text.text-accent-3
{
    color: #ff3d00 !important;
}

.deep-orange.accent-4
{
    background-color: #dd2c00 !important;
}

.deep-orange-text.text-accent-4
{
    color: #dd2c00 !important;
}

.brown
{
    background-color: #795548 !important;
}

.brown-text
{
    color: #795548 !important;
}

.brown.lighten-5
{
    background-color: #efebe9 !important;
}

.brown-text.text-lighten-5
{
    color: #efebe9 !important;
}

.brown.lighten-4
{
    background-color: #d7ccc8 !important;
}

.brown-text.text-lighten-4
{
    color: #d7ccc8 !important;
}

.brown.lighten-3
{
    background-color: #bcaaa4 !important;
}

.brown-text.text-lighten-3
{
    color: #bcaaa4 !important;
}

.brown.lighten-2
{
    background-color: #a1887f !important;
}

.brown-text.text-lighten-2
{
    color: #a1887f !important;
}

.brown.lighten-1
{
    background-color: #8d6e63 !important;
}

.brown-text.text-lighten-1
{
    color: #8d6e63 !important;
}

.brown.darken-1
{
    background-color: #6d4c41 !important;
}

.brown-text.text-darken-1
{
    color: #6d4c41 !important;
}

.brown.darken-2
{
    background-color: #5d4037 !important;
}

.brown-text.text-darken-2
{
    color: #5d4037 !important;
}

.brown.darken-3
{
    background-color: #4e342e !important;
}

.brown-text.text-darken-3
{
    color: #4e342e !important;
}

.brown.darken-4
{
    background-color: #3e2723 !important;
}

.brown-text.text-darken-4
{
    color: #3e2723 !important;
}

.blue-grey
{
    background-color: #607d8b !important;
}

.blue-grey-text
{
    color: #607d8b !important;
}

.blue-grey.lighten-5
{
    background-color: #eceff1 !important;
}

.blue-grey-text.text-lighten-5
{
    color: #eceff1 !important;
}

.blue-grey.lighten-4
{
    background-color: #cfd8dc !important;
}

.blue-grey-text.text-lighten-4
{
    color: #cfd8dc !important;
}

.blue-grey.lighten-3
{
    background-color: #b0bec5 !important;
}

.blue-grey-text.text-lighten-3
{
    color: #b0bec5 !important;
}

.blue-grey.lighten-2
{
    background-color: #90a4ae !important;
}

.blue-grey-text.text-lighten-2
{
    color: #90a4ae !important;
}

.blue-grey.lighten-1
{
    background-color: #78909c !important;
}

.blue-grey-text.text-lighten-1
{
    color: #78909c !important;
}

.blue-grey.darken-1
{
    background-color: #546e7a !important;
}

.blue-grey-text.text-darken-1
{
    color: #546e7a !important;
}

.blue-grey.darken-2
{
    background-color: #455a64 !important;
}

.blue-grey-text.text-darken-2
{
    color: #455a64 !important;
}

.blue-grey.darken-3
{
    background-color: #37474f !important;
}

.blue-grey-text.text-darken-3
{
    color: #37474f !important;
}

.blue-grey.darken-4
{
    background-color: #263238 !important;
}

.blue-grey-text.text-darken-4
{
    color: #263238 !important;
}

.grey
{
    background-color: #9e9e9e !important;
}

.grey-text
{
    color: #9e9e9e !important;
}

.grey.lighten-5
{
    background-color: #fafafa !important;
}

.grey-text.text-lighten-5
{
    color: #fafafa !important;
}

.grey.lighten-4
{
    background-color: #f5f5f5 !important;
}

.grey-text.text-lighten-4
{
    color: #f5f5f5 !important;
}

.grey.lighten-3
{
    background-color: #eee !important;
}

.grey-text.text-lighten-3
{
    color: #eee !important;
}

.grey.lighten-2
{
    background-color: #e0e0e0 !important;
}

.grey-text.text-lighten-2
{
    color: #e0e0e0 !important;
}

.grey.lighten-1
{
    background-color: #bdbdbd !important;
}

.grey-text.text-lighten-1
{
    color: #bdbdbd !important;
}

.grey.darken-1
{
    background-color: #757575 !important;
}

.grey-text.text-darken-1
{
    color: #757575 !important;
}

.grey.darken-2
{
    background-color: #616161 !important;
}

.grey-text.text-darken-2
{
    color: #616161 !important;
}

.grey.darken-3
{
    background-color: #424242 !important;
}

.grey-text.text-darken-3
{
    color: #424242 !important;
}

.grey.darken-4
{
    background-color: #212121 !important;
}

.grey-text.text-darken-4
{
    color: #212121 !important;
}

.black
{
    background-color: #000 !important;
}

.black-text
{
    color: #000 !important;
}

.white
{
    background-color: #fff !important;
}

.white-text
{
    color: #fff !important;
}

.transparent
{
    background-color: transparent !important;
}

.transparent-text
{
    color: transparent !important;
}

/*
  Autogenerated theme file
*/
/*----------------------------------------
  General Layout Style
------------------------------------------*/
html,
body
{
    height: 100%;
}

body
{
    background-color: #f2f4f8;
    overflow: hidden;
}

@media only screen and (max-width: 600px)
{
    .layout-semi-dark #header nav.navbar-color
    {
        background: #37474f;
    }
}

.preload-transitions *
{
    transition: none !important;
}

#main
{
    min-height: calc(100% - 116px);
    padding-left: 0;
    transition: .3s ease all;
    backface-visibility: hidden;
}

#main.main-full
{
    padding-left: 0;
}

#main .content-wrapper-before
{
    position: absolute;
    z-index: -1;
    top: 64px;
    left: 0;

    width: 100%;
    height: 185px;
    transition: .3s ease all;
}

footer
{
    padding: 0 10px;
}

footer.page-footer
{
    padding-top: 1px;
}

select
{
    width: 100%;
    height: 3rem;
    padding: 5px;

    border: none;
    border-bottom: 1px solid #bdbdbd;
    border-radius: 2px;
    background-color: transparent;
}

.container
{
    width: 100%;
    max-width: 100% !important;
    margin: 0 auto;
    padding: 0 .5rem;
}

.container .dropdown-settings i.right
{
    margin-left: 0;
}

@media only screen and (min-width: 601px)
{
    .container
    {
        width: 100%;
    }
}

@media only screen and (max-width: 600px)
{
    #main
    {
        min-height: calc(100% - 107px);
    }
}

@media only screen and (min-width: 993px)
{
    .container
    {
        width: 100%;
    }
    .sidenav-overlay
    {
        background-color: transparent;
    }
}

@media only screen and (min-width: 993px)
{
    #main
    {
        padding-left: 250px;
    }
    #main.main-full
    {
        padding-left: 64px;
    }
    .nav-lock ~ footer
    {
        padding-left: 257px;
    }
    footer
    {
        padding-left: 71px;
    }
}

@media only screen and (max-width: 600px)
{
    #main .content-wrapper-before
    {
        top: 56px;
    }
}

.ps-scrollbar-x-rail
{
    z-index: 9999;
}

.ps-scrollbar-y-rail
{
    z-index: 9999;
}

.bg-opacity-8
{
    background-color: rgba(255, 255, 255, .8);
}

.height-100vh
{
    height: 100vh;
}

button,
html [type='button'],
[type='reset'],
[type='submit']
{
    cursor: pointer;

    -webkit-appearance: none;
}

/*----------------------------------------
  Healper Classes
------------------------------------------*/
/* Width */
.width-10
{
    width: 10% !important;
}

.width-20
{
    width: 20% !important;
}

.width-30
{
    width: 30% !important;
}

.width-40
{
    width: 40% !important;
}

.width-50
{
    width: 50% !important;
}

.width-60
{
    width: 60% !important;
}

.width-70
{
    width: 70% !important;
}

.width-80
{
    width: 80% !important;
}

.width-90
{
    width: 90% !important;
}

.width-100
{
    width: 100% !important;
}

/* Border Radius */
.border-radius-1
{
    border-radius: 1px !important;
}

.border-radius-2
{
    border-radius: 2px !important;
}

.border-radius-3
{
    border-radius: 3px !important;
}

.border-radius-4
{
    border-radius: 4px !important;
}

.border-radius-5
{
    border-radius: 5px !important;
}

.border-radius-6
{
    border-radius: 6px !important;
}

.border-radius-7
{
    border-radius: 7px !important;
}

.border-radius-8
{
    border-radius: 8px !important;
}

.border-radius-9
{
    border-radius: 9px !important;
}

.border-radius-10
{
    border-radius: 10px !important;
}

.border-round
{
    border-radius: 150px !important;
}

/* Font Weight */
.font-weight-100
{
    font-weight: 100 !important;
}

.font-weight-200
{
    font-weight: 200 !important;
}

.font-weight-300
{
    font-weight: 300 !important;
}

.font-weight-400
{
    font-weight: 400 !important;
}

.font-weight-500
{
    font-weight: 500 !important;
}

.font-weight-600
{
    font-weight: 600 !important;
}

.font-weight-700
{
    font-weight: 700 !important;
}

.font-weight-800
{
    font-weight: 800 !important;
}

.font-weight-900
{
    font-weight: 900 !important;
}

.m-0
{
    margin: 0 !important;
}

/* Margin Top */
.mt-0
{
    margin-top: 0 !important;
}

.mt-1
{
    margin-top: 1% !important;
}

.mt-2
{
    margin-top: 2% !important;
}

.mt-3
{
    margin-top: 3% !important;
}

.mt-4
{
    margin-top: 4% !important;
}

.mt-5
{
    margin-top: 5% !important;
}

.mt-6
{
    margin-top: 6% !important;
}

.mt-7
{
    margin-top: 7% !important;
}

.mt-8
{
    margin-top: 8% !important;
}

.mt-9
{
    margin-top: 9% !important;
}

.mt-10
{
    margin-top: 10% !important;
}

/* Margin Right */
.mr-0
{
    margin-right: 0 !important;
}

.mr-1
{
    margin-right: 1% !important;
}

.mr-2
{
    margin-right: 2% !important;
}

.mr-3
{
    margin-right: 3% !important;
}

.mr-4
{
    margin-right: 4% !important;
}

.mr-5
{
    margin-right: 5% !important;
}

.mr-6
{
    margin-right: 6% !important;
}

.mr-7
{
    margin-right: 7% !important;
}

.mr-8
{
    margin-right: 8% !important;
}

.mr-9
{
    margin-right: 9% !important;
}

.mr-10
{
    margin-right: 10% !important;
}

/* Margin Left */
.ml-0
{
    margin-left: 0 !important;
}

.ml-1
{
    margin-left: 1% !important;
}

.ml-2
{
    margin-left: 2% !important;
}

.ml-3
{
    margin-left: 3% !important;
}

.ml-4
{
    margin-left: 4% !important;
}

.ml-5
{
    margin-left: 5% !important;
}

.ml-6
{
    margin-left: 6% !important;
}

.ml-7
{
    margin-left: 7% !important;
}

.ml-8
{
    margin-left: 8% !important;
}

.ml-9
{
    margin-left: 9% !important;
}

.ml-10
{
    margin-left: 10% !important;
}

/* Margin Bottom */
.mb-0
{
    margin-bottom: 0 !important;
}

.mb-1
{
    margin-bottom: 1% !important;
}

.mb-2
{
    margin-bottom: 2% !important;
}

.mb-3
{
    margin-bottom: 3% !important;
}

.mb-4
{
    margin-bottom: 4% !important;
}

.mb-5
{
    margin-bottom: 5% !important;
}

.mb-6
{
    margin-bottom: 6% !important;
}

.mb-7
{
    margin-bottom: 7% !important;
}

.mb-8
{
    margin-bottom: 8% !important;
}

.mb-9
{
    margin-bottom: 9% !important;
}

.mb-10
{
    margin-bottom: 10% !important;
}

/* Padding All */
.padding-1
{
    padding: 1% !important;
}

.padding-2
{
    padding: 2% !important;
}

.padding-3
{
    padding: 3% !important;
}

.padding-4
{
    padding: 4% !important;
}

.padding-5
{
    padding: 5% !important;
}

.padding-6
{
    padding: 6% !important;
}

.padding-7
{
    padding: 7% !important;
}

.padding-8
{
    padding: 8% !important;
}

.padding-9
{
    padding: 9% !important;
}

.padding-10
{
    padding: 10% !important;
}

.p-0
{
    padding: 0 !important;
}

/* Padding Top */
.pt-0
{
    padding-top: 0 !important;
}

.pt-1
{
    padding-top: 1% !important;
}

.pt-2
{
    padding-top: 2% !important;
}

.pt-3
{
    padding-top: 3% !important;
}

.pt-4
{
    padding-top: 4% !important;
}

.pt-5
{
    padding-top: 5% !important;
}

.pt-6
{
    padding-top: 6% !important;
}

.pt-7
{
    padding-top: 7% !important;
}

.pt-8
{
    padding-top: 8% !important;
}

.pt-9
{
    padding-top: 9% !important;
}

.pt-10
{
    padding-top: 10% !important;
}

/* Padding Right */
.pr-0
{
    padding-right: 0 !important;
}

.pr-1
{
    padding-right: 1% !important;
}

.pr-2
{
    padding-right: 2% !important;
}

.pr-3
{
    padding-right: 3% !important;
}

.pr-4
{
    padding-right: 4% !important;
}

.pr-5
{
    padding-right: 5% !important;
}

.pr-6
{
    padding-right: 6% !important;
}

.pr-7
{
    padding-right: 7% !important;
}

.pr-8
{
    padding-right: 8% !important;
}

.pr-9
{
    padding-right: 9% !important;
}

.pr-10
{
    padding-right: 10% !important;
}

/* Padding Right */
.pl-0
{
    padding-left: 0 !important;
}

.pl-1
{
    padding-left: 1% !important;
}

.pl-2
{
    padding-left: 2% !important;
}

.pl-3
{
    padding-left: 3% !important;
}

.pl-4
{
    padding-left: 4% !important;
}

.pl-5
{
    padding-left: 5% !important;
}

.pl-6
{
    padding-left: 6% !important;
}

.pl-7
{
    padding-left: 7% !important;
}

.pl-8
{
    padding-left: 8% !important;
}

.pl-9
{
    padding-left: 9% !important;
}

.pl-10
{
    padding-left: 10% !important;
}

/* Padding Bottom */
.pb-0
{
    padding-bottom: 0 !important;
}

.pb-1
{
    padding-bottom: 1% !important;
}

.pb-2
{
    padding-bottom: 2% !important;
}

.pb-3
{
    padding-bottom: 3% !important;
}

.pb-4
{
    padding-bottom: 4% !important;
}

.pb-5
{
    padding-bottom: 5% !important;
}

.pb-6
{
    padding-bottom: 6% !important;
}

.pb-7
{
    padding-bottom: 7% !important;
}

.pb-8
{
    padding-bottom: 8% !important;
}

.pb-9
{
    padding-bottom: 9% !important;
}

.pb-10
{
    padding-bottom: 10% !important;
}

/* Minimum Height */
.min-height-100
{
    min-height: 100px !important;
}

.min-height-150
{
    min-height: 150px !important;
}

.min-height-200
{
    min-height: 200px !important;
}

.min-height-250
{
    min-height: 250px !important;
}

.min-height-300
{
    min-height: 300px !important;
}

@media (min-width: 576px)
{
    .left-align-sm
    {
        text-align: left !important;
    }
    .right-align-sm
    {
        text-align: right !important;
    }
    .center-align-sm
    {
        text-align: center !important;
    }
}

@media (min-width: 768px)
{
    .left-align-md
    {
        text-align: left !important;
    }
    .right-align-md
    {
        text-align: right !important;
    }
    .center-align-md
    {
        text-align: center !important;
    }
}

@media (min-width: 992px)
{
    .left-align-lg
    {
        text-align: left !important;
    }
    .right-align-lg
    {
        text-align: right !important;
    }
    .center-align-lg
    {
        text-align: center !important;
    }
}

@media (min-width: 1200px)
{
    .left-align-xl
    {
        text-align: left !important;
    }
    .right-align-xl
    {
        text-align: right !important;
    }
    .center-align-xl
    {
        text-align: center !important;
    }
}

.mx-auto
{
    margin-right: auto !important;
    margin-left: auto !important;
}

.text-lowercase
{
    text-transform: lowercase !important;
}

.text-uppercase
{
    text-transform: uppercase !important;
}

.text-capitalize
{
    text-transform: capitalize !important;
}

/* Icon Background Round */
.background-round
{
    padding: 15px;

    border-radius: 50%;
    background-color: rgba(0, 0, 0, .18);
}

.cursor-pointer
{
    cursor: pointer;
}

/* opacity 0 */
.opacity-0
{
    opacity: 0;
}

/* Border None & Shadow None */
.border-none
{
    border-top: none !important;
    border-right: none !important;
    border-bottom: none !important;
    border-left: none !important;
}

.box-shadow-none
{
    box-shadow: none !important;
}

/* Margin 0 & Padding 0 */
.no-margin
{
    margin: 0 !important;
}

.no-padding
{
    padding: 0 !important;
}

/* Position */
.position-absolute
{
    position: absolute;
}

.position-none
{
    position: unset;
}

/* Vertical Align */
.vertical-align-center
{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.vertical-align-bottom
{
    vertical-align: bottom;
}

.vertical-align-super
{
    vertical-align: super;
}

.vertical-text-top
{
    vertical-align: text-top !important;
}

.vertical-text-sub
{
    vertical-align: sub;
}

.vertical-text-middle
{
    vertical-align: middle;
}

.height-100vh
{
    height: 100vh;
}

/* Line Height */
.line-height-0
{
    line-height: 0 !important;
}

/* Icon Background */
.icon-bg-circle
{
    padding: .4rem;

    color: #fff;
    border-radius: 50%;
}

.text-shadow
{
    text-shadow: -1px 2px 4px black;
}

.display-none
{
    display: none;
}

.display-inline
{
    display: inline;
}

.display-block
{
    display: block;
}

.display-grid
{
    display: grid;
}

.display-flex
{
    display:         flex;
}

.float-none
{
    float: none !important;
}

.float-left
{
    float: left !important;
}

.float-right
{
    float: right !important;
}

.float-inherit
{
    float: inherit !important;
}

.clear-both
{
    clear: both;
}

ul.list-type-bullet
{
    padding-left: 40px;

    list-style-type: inherit;
}

ul.list-type-bullet li
{
    list-style-type: inherit;
}

.justify-content-end
{
    justify-content: flex-end;
}

.justify-content-between
{
    justify-content: space-between;
}

.justify-content-center
{
    justify-content: center;
}

.align-items-center
{
    align-items: center;
}

.flex-grow-1
{
    flex-grow: 1;
}

.flex-wrap
{
    flex-wrap: wrap;
}

.flex-column
{
            flex-direction: column;
}

.text-ellipsis
{
    overflow: hidden;

    white-space: nowrap;
    text-overflow: ellipsis;
}

.text-nowrap
{
    white-space: nowrap;
}

/*---------------------------------
    Typography
-----------------------------------*/
a
{
    text-decoration: none;
}

html
{
    font-family: 'Muli', sans-serif !important;
    font-weight: normal;
    line-height: 1.5;

    color: #6b6f82;
}

@media only screen and (min-width: 0)
{
    html
    {
        font-size: 14px;
    }
}

@media only screen and (min-width: 992px)
{
    html
    {
        font-size: 14.5px;
    }
}

@media only screen and (min-width: 1200px)
{
    html
    {
        font-size: 15px;
    }
}

h1,
h2,
h3,
h4,
h5,
h6
{
    font-family: 'Muli', sans-serif;
    font-weight: 400;
    line-height: 1.1;

    color: #333;
}
h6.text_pt {
    background: #ffd500;
    width: fit-content;
    padding: 10px;
    border-radius: 5px;
    font-weight: 500;
}

p
{
    font-family: 'Muli', sans-serif;
}

h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a
{
    font-weight: inherit;
}

h1
{
    font-size: 4.2rem;
    line-height: 110%;

    margin: 2.1rem 0 1.68rem 0;
}

h2
{
    font-size: 3.56rem;
    line-height: 110%;

    margin: 1.78rem 0 1.424rem 0;
}

h3
{
    font-size: 2.92rem;
    line-height: 110%;

    margin: 1.46rem 0 1.168rem 0;
}

h4
{
    font-size: 2.28rem;
    line-height: 110%;

    margin: 1.14rem 0 .912rem 0;
}

h5
{
    font-size: 1.64rem;
    line-height: 110%;

    margin: .82rem 0 .656rem 0;
}

h6
{
    font-size: 1.15rem;
    line-height: 110%;

    margin: .575rem 0 .46rem 0;
}

em
{
    font-style: italic;
}

strong
{
    font-weight: 500;
}

small
{
    font-size: 75%;
}

.light
{
    font-weight: 300;
}

.thin
{
    font-weight: 200;
}

.flow-text
{
    font-weight: 300;
}

@media only screen and (min-width: 360px)
{
    .flow-text
    {
        font-size: 1.2rem;
    }
}

@media only screen and (min-width: 390px)
{
    .flow-text
    {
        font-size: 1.224rem;
    }
}

@media only screen and (min-width: 420px)
{
    .flow-text
    {
        font-size: 1.248rem;
    }
}

@media only screen and (min-width: 450px)
{
    .flow-text
    {
        font-size: 1.272rem;
    }
}

@media only screen and (min-width: 480px)
{
    .flow-text
    {
        font-size: 1.296rem;
    }
}

@media only screen and (min-width: 510px)
{
    .flow-text
    {
        font-size: 1.32rem;
    }
}

@media only screen and (min-width: 540px)
{
    .flow-text
    {
        font-size: 1.344rem;
    }
}

@media only screen and (min-width: 570px)
{
    .flow-text
    {
        font-size: 1.368rem;
    }
}

@media only screen and (min-width: 600px)
{
    .flow-text
    {
        font-size: 1.392rem;
    }
}

@media only screen and (min-width: 630px)
{
    .flow-text
    {
        font-size: 1.416rem;
    }
}

@media only screen and (min-width: 660px)
{
    .flow-text
    {
        font-size: 1.44rem;
    }
}

@media only screen and (min-width: 690px)
{
    .flow-text
    {
        font-size: 1.464rem;
    }
}

@media only screen and (min-width: 720px)
{
    .flow-text
    {
        font-size: 1.488rem;
    }
}

@media only screen and (min-width: 750px)
{
    .flow-text
    {
        font-size: 1.512rem;
    }
}

@media only screen and (min-width: 780px)
{
    .flow-text
    {
        font-size: 1.536rem;
    }
}

@media only screen and (min-width: 810px)
{
    .flow-text
    {
        font-size: 1.56rem;
    }
}

@media only screen and (min-width: 840px)
{
    .flow-text
    {
        font-size: 1.584rem;
    }
}

@media only screen and (min-width: 870px)
{
    .flow-text
    {
        font-size: 1.608rem;
    }
}

@media only screen and (min-width: 900px)
{
    .flow-text
    {
        font-size: 1.632rem;
    }
}

@media only screen and (min-width: 930px)
{
    .flow-text
    {
        font-size: 1.656rem;
    }
}

@media only screen and (min-width: 960px)
{
    .flow-text
    {
        font-size: 1.68rem;
    }
}

@media only screen and (max-width: 360px)
{
    .flow-text
    {
        font-size: 1.2rem;
    }
}

@media only screen and (max-width: 768px)
{
    .nav-expanded .brand-sidebar
    {
        background: transparent !important;
    }
    .brand-sidebar .logo-wrapper
    {
        padding: 17px 18px !important;

        text-align: center;

        background: transparent;
    }
}

.small
{
    font-size: 1.0rem !important;
}

.medium-small
{
    font-size: .9rem !important;
}

.ultra-small
{
    font-size: .8rem !important;
}

small
{
    font-size: .8rem;
}

.strong
{
    font-weight: 600;
}

h4.header
{
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2.508rem;

    margin: 1.14rem 0 .912rem 0;

    text-transform: uppercase;
}

h4.header2
{
    font-size: 1.1rem;
    font-weight: 400;

    text-transform: uppercase;
}

p.title
{
    font-size: 1.3rem;
}

p.header
{
    font-size: 1rem;
    font-weight: 500;

    text-transform: uppercase;
}

li.li-hover:hover
{
    background: transparent !important;
}

li.search-out:hover
{
    background: transparent;
}

li.mobile:before
{
    background: #f7464a;
}

li.kitchen:before
{
    background: #46bfbd;
}

li.home:before
{
    background: #fdb45c;
}

.more-text
{
    font-weight: 500;

    padding: 5px 20px;

    letter-spacing: 1px;
    text-transform: uppercase;
}

.valign-demo
{
    height: 400px;

    background-color: #ddd;
}

.margin
{
    margin: 0 !important;
}

.uppercase
{
    text-transform: uppercase;
}

/*----------------------------------------
  Grid 
------------------------------------------*/
.section
{
    padding: .5rem 0;
}

.row
{
    margin-bottom: 0;
}

.row .col
{
    padding: 0 1rem;
}

.materialize-red
{
    background-color: #e51c23 !important;
}

.materialize-red-text
{
    color: #e51c23 !important;
}

.materialize-red.lighten-5
{
    background-color: #fdeaeb !important;
}

.materialize-red-text.text-lighten-5
{
    color: #fdeaeb !important;
}

.materialize-red.lighten-4
{
    background-color: #f8c1c3 !important;
}

.materialize-red-text.text-lighten-4
{
    color: #f8c1c3 !important;
}

.materialize-red.lighten-3
{
    background-color: #f3989b !important;
}

.materialize-red-text.text-lighten-3
{
    color: #f3989b !important;
}

.materialize-red.lighten-2
{
    background-color: #ee6e73 !important;
}

.materialize-red-text.text-lighten-2
{
    color: #ee6e73 !important;
}

.materialize-red.lighten-1
{
    background-color: #ea454b !important;
}

.materialize-red-text.text-lighten-1
{
    color: #ea454b !important;
}

.materialize-red.darken-1
{
    background-color: #d0181e !important;
}

.materialize-red-text.text-darken-1
{
    color: #d0181e !important;
}

.materialize-red.darken-2
{
    background-color: #b9151b !important;
}

.materialize-red-text.text-darken-2
{
    color: #b9151b !important;
}

.materialize-red.darken-3
{
    background-color: #a21318 !important;
}

.materialize-red-text.text-darken-3
{
    color: #a21318 !important;
}

.materialize-red.darken-4
{
    background-color: #8b1014 !important;
}

.materialize-red-text.text-darken-4
{
    color: #8b1014 !important;
}

.red
{
    background-color: #f44336 !important;
}

.red-text
{
    color: #f44336 !important;
}

.red.lighten-5
{
    background-color: #ffebee !important;
}

.red-text.text-lighten-5
{
    color: #ffebee !important;
}

.red.lighten-4
{
    background-color: #ffcdd2 !important;
}

.red-text.text-lighten-4
{
    color: #ffcdd2 !important;
}

.red.lighten-3
{
    background-color: #ef9a9a !important;
}

.red-text.text-lighten-3
{
    color: #ef9a9a !important;
}

.red.lighten-2
{
    background-color: #e57373 !important;
}

.red-text.text-lighten-2
{
    color: #e57373 !important;
}

.red.lighten-1
{
    background-color: #ef5350 !important;
}

.red-text.text-lighten-1
{
    color: #ef5350 !important;
}

.red.darken-1
{
    background-color: #e53935 !important;
}

.red-text.text-darken-1
{
    color: #e53935 !important;
}

.red.darken-2
{
    background-color: #d32f2f !important;
}

.red-text.text-darken-2
{
    color: #d32f2f !important;
}

.red.darken-3
{
    background-color: #c62828 !important;
}

.red-text.text-darken-3
{
    color: #c62828 !important;
}

.red.darken-4
{
    background-color: #b71c1c !important;
}

.red-text.text-darken-4
{
    color: #b71c1c !important;
}

.red.accent-1
{
    background-color: #ff8a80 !important;
}

.red-text.text-accent-1
{
    color: #ff8a80 !important;
}

.red.accent-2
{
    background-color: #ff5252 !important;
}

.red-text.text-accent-2
{
    color: #ff5252 !important;
}

.red.accent-3
{
    background-color: #ff1744 !important;
}

.red-text.text-accent-3
{
    color: #ff1744 !important;
}

.red.accent-4
{
    background-color: #d50000 !important;
}

.red-text.text-accent-4
{
    color: #d50000 !important;
}

.pink
{
    background-color: #e91e63 !important;
}

.pink-text
{
    color: #e91e63 !important;
}

.pink.lighten-5
{
    background-color: #fce4ec !important;
}

.pink-text.text-lighten-5
{
    color: #fce4ec !important;
}

.pink.lighten-4
{
    background-color: #f8bbd0 !important;
}

.pink-text.text-lighten-4
{
    color: #f8bbd0 !important;
}

.pink.lighten-3
{
    background-color: #f48fb1 !important;
}

.pink-text.text-lighten-3
{
    color: #f48fb1 !important;
}

.pink.lighten-2
{
    background-color: #f06292 !important;
}

.pink-text.text-lighten-2
{
    color: #f06292 !important;
}

.pink.lighten-1
{
    background-color: #ec407a !important;
}

.pink-text.text-lighten-1
{
    color: #ec407a !important;
}

.pink.darken-1
{
    background-color: #d81b60 !important;
}

.pink-text.text-darken-1
{
    color: #d81b60 !important;
}

.pink.darken-2
{
    background-color: #c2185b !important;
}

.pink-text.text-darken-2
{
    color: #c2185b !important;
}

.pink.darken-3
{
    background-color: #ad1457 !important;
}

.pink-text.text-darken-3
{
    color: #ad1457 !important;
}

.pink.darken-4
{
    background-color: #880e4f !important;
}

.pink-text.text-darken-4
{
    color: #880e4f !important;
}

.pink.accent-1
{
    background-color: #ff80ab !important;
}

.pink-text.text-accent-1
{
    color: #ff80ab !important;
}

.pink.accent-2
{
    background-color: #ff4081 !important;
}

.pink-text.text-accent-2
{
    color: #ff4081 !important;
}

.pink.accent-3
{
    background-color: #f50057 !important;
}

.pink-text.text-accent-3
{
    color: #f50057 !important;
}

.pink.accent-4
{
    background-color: #c51162 !important;
}

.pink-text.text-accent-4
{
    color: #c51162 !important;
}

.purple
{
    background-color: #9c27b0 !important;
}

.purple-text
{
    color: #9c27b0 !important;
}

.purple.lighten-5
{
    background-color: #f3e5f5 !important;
}

.purple-text.text-lighten-5
{
    color: #f3e5f5 !important;
}

.purple.lighten-4
{
    background-color: #e1bee7 !important;
}

.purple-text.text-lighten-4
{
    color: #e1bee7 !important;
}

.purple.lighten-3
{
    background-color: #ce93d8 !important;
}

.purple-text.text-lighten-3
{
    color: #ce93d8 !important;
}

.purple.lighten-2
{
    background-color: #ba68c8 !important;
}

.purple-text.text-lighten-2
{
    color: #ba68c8 !important;
}

.purple.lighten-1
{
    background-color: #ab47bc !important;
}

.purple-text.text-lighten-1
{
    color: #ab47bc !important;
}

.purple.darken-1
{
    background-color: #8e24aa !important;
}

.purple-text.text-darken-1
{
    color: #8e24aa !important;
}

.purple.darken-2
{
    background-color: #7b1fa2 !important;
}

.purple-text.text-darken-2
{
    color: #7b1fa2 !important;
}

.purple.darken-3
{
    background-color: #6a1b9a !important;
}

.purple-text.text-darken-3
{
    color: #6a1b9a !important;
}

.purple.darken-4
{
    background-color: #4a148c !important;
}

.purple-text.text-darken-4
{
    color: #4a148c !important;
}

.purple.accent-1
{
    background-color: #ea80fc !important;
}

.purple-text.text-accent-1
{
    color: #ea80fc !important;
}

.purple.accent-2
{
    background-color: #e040fb !important;
}

.purple-text.text-accent-2
{
    color: #e040fb !important;
}

.purple.accent-3
{
    background-color: #d500f9 !important;
}

.purple-text.text-accent-3
{
    color: #d500f9 !important;
}

.purple.accent-4
{
    background-color: #a0f !important;
}

.purple-text.text-accent-4
{
    color: #a0f !important;
}

.deep-purple
{
    background-color: #673ab7 !important;
}

.deep-purple-text
{
    color: #673ab7 !important;
}

.deep-purple.lighten-5
{
    background-color: #ede7f6 !important;
}

.deep-purple-text.text-lighten-5
{
    color: #ede7f6 !important;
}

.deep-purple.lighten-4
{
    background-color: #d1c4e9 !important;
}

.deep-purple-text.text-lighten-4
{
    color: #d1c4e9 !important;
}

.deep-purple.lighten-3
{
    background-color: #b39ddb !important;
}

.deep-purple-text.text-lighten-3
{
    color: #b39ddb !important;
}

.deep-purple.lighten-2
{
    background-color: #9575cd !important;
}

.deep-purple-text.text-lighten-2
{
    color: #9575cd !important;
}

.deep-purple.lighten-1
{
    background-color: #7e57c2 !important;
}

.deep-purple-text.text-lighten-1
{
    color: #7e57c2 !important;
}

.deep-purple.darken-1
{
    background-color: #5e35b1 !important;
}

.deep-purple-text.text-darken-1
{
    color: #5e35b1 !important;
}

.deep-purple.darken-2
{
    background-color: #512da8 !important;
}

.deep-purple-text.text-darken-2
{
    color: #512da8 !important;
}

.deep-purple.darken-3
{
    background-color: #4527a0 !important;
}

.deep-purple-text.text-darken-3
{
    color: #4527a0 !important;
}

.deep-purple.darken-4
{
    background-color: #311b92 !important;
}

.deep-purple-text.text-darken-4
{
    color: #311b92 !important;
}

.deep-purple.accent-1
{
    background-color: #b388ff !important;
}

.deep-purple-text.text-accent-1
{
    color: #b388ff !important;
}

.deep-purple.accent-2
{
    background-color: #7c4dff !important;
}

.deep-purple-text.text-accent-2
{
    color: #7c4dff !important;
}

.deep-purple.accent-3
{
    background-color: #651fff !important;
}

.deep-purple-text.text-accent-3
{
    color: #651fff !important;
}

.deep-purple.accent-4
{
    background-color: #6200ea !important;
}

.deep-purple-text.text-accent-4
{
    color: #6200ea !important;
}

.indigo
{
    background-color: #3f51b5 !important;
}

.indigo-text
{
    color: #3f51b5 !important;
}

.indigo.lighten-5
{
    background-color: #e8eaf6 !important;
}

.indigo-text.text-lighten-5
{
    color: #e8eaf6 !important;
}

.indigo.lighten-4
{
    background-color: #c5cae9 !important;
}

.indigo-text.text-lighten-4
{
    color: #c5cae9 !important;
}

.indigo.lighten-3
{
    background-color: #9fa8da !important;
}

.indigo-text.text-lighten-3
{
    color: #9fa8da !important;
}

.indigo.lighten-2
{
    background-color: #7986cb !important;
}

.indigo-text.text-lighten-2
{
    color: #7986cb !important;
}

.indigo.lighten-1
{
    background-color: #5c6bc0 !important;
}

.indigo-text.text-lighten-1
{
    color: #5c6bc0 !important;
}

.indigo.darken-1
{
    background-color: #3949ab !important;
}

.indigo-text.text-darken-1
{
    color: #3949ab !important;
}

.indigo.darken-2
{
    background-color: #303f9f !important;
}

.indigo-text.text-darken-2
{
    color: #303f9f !important;
}

.indigo.darken-3
{
    background-color: #283593 !important;
}

.indigo-text.text-darken-3
{
    color: #283593 !important;
}

.indigo.darken-4
{
    background-color: #1a237e !important;
}

.indigo-text.text-darken-4
{
    color: #1a237e !important;
}

.indigo.accent-1
{
    background-color: #8c9eff !important;
}

.indigo-text.text-accent-1
{
    color: #8c9eff !important;
}

.indigo.accent-2
{
    background-color: #536dfe !important;
}

.indigo-text.text-accent-2
{
    color: #536dfe !important;
}

.indigo.accent-3
{
    background-color: #3d5afe !important;
}

.indigo-text.text-accent-3
{
    color: #3d5afe !important;
}

.indigo.accent-4
{
    background-color: #304ffe !important;
}

.indigo-text.text-accent-4
{
    color: #304ffe !important;
}

.blue
{
    background-color: #2196f3 !important;
}

.blue-text
{
    color: #2196f3 !important;
}

.blue.lighten-5
{
    background-color: #e3f2fd !important;
}

.blue-text.text-lighten-5
{
    color: #e3f2fd !important;
}

.blue.lighten-4
{
    background-color: #bbdefb !important;
}

.blue-text.text-lighten-4
{
    color: #bbdefb !important;
}

.blue.lighten-3
{
    background-color: #90caf9 !important;
}

.blue-text.text-lighten-3
{
    color: #90caf9 !important;
}

.blue.lighten-2
{
    background-color: #64b5f6 !important;
}

.blue-text.text-lighten-2
{
    color: #64b5f6 !important;
}

.blue.lighten-1
{
    background-color: #42a5f5 !important;
}

.blue-text.text-lighten-1
{
    color: #42a5f5 !important;
}

.blue.darken-1
{
    background-color: #1e88e5 !important;
}

.blue-text.text-darken-1
{
    color: #1e88e5 !important;
}

.blue.darken-2
{
    background-color: #1976d2 !important;
}

.blue-text.text-darken-2
{
    color: #1976d2 !important;
}

.blue.darken-3
{
    background-color: #1565c0 !important;
}

.blue-text.text-darken-3
{
    color: #1565c0 !important;
}

.blue.darken-4
{
    background-color: #0d47a1 !important;
}

.blue-text.text-darken-4
{
    color: #0d47a1 !important;
}

.blue.accent-1
{
    background-color: #82b1ff !important;
}

.blue-text.text-accent-1
{
    color: #82b1ff !important;
}

.blue.accent-2
{
    background-color: #448aff !important;
}

.blue-text.text-accent-2
{
    color: #448aff !important;
}

.blue.accent-3
{
    background-color: #2979ff !important;
}

.blue-text.text-accent-3
{
    color: #2979ff !important;
}

.blue.accent-4
{
    background-color: #2962ff !important;
}

.blue-text.text-accent-4
{
    color: #2962ff !important;
}

.light-blue
{
    background-color: #03a9f4 !important;
}

.light-blue-text
{
    color: #03a9f4 !important;
}

.light-blue.lighten-5
{
    background-color: #e1f5fe !important;
}

.light-blue-text.text-lighten-5
{
    color: #e1f5fe !important;
}

.light-blue.lighten-4
{
    background-color: #b3e5fc !important;
}

.light-blue-text.text-lighten-4
{
    color: #b3e5fc !important;
}

.light-blue.lighten-3
{
    background-color: #81d4fa !important;
}

.light-blue-text.text-lighten-3
{
    color: #81d4fa !important;
}

.light-blue.lighten-2
{
    background-color: #4fc3f7 !important;
}

.light-blue-text.text-lighten-2
{
    color: #4fc3f7 !important;
}

.light-blue.lighten-1
{
    background-color: #29b6f6 !important;
}

.light-blue-text.text-lighten-1
{
    color: #29b6f6 !important;
}

.light-blue.darken-1
{
    background-color: #039be5 !important;
}

.light-blue-text.text-darken-1
{
    color: #039be5 !important;
}

.light-blue.darken-2
{
    background-color: #0288d1 !important;
}

.light-blue-text.text-darken-2
{
    color: #0288d1 !important;
}

.light-blue.darken-3
{
    background-color: #0277bd !important;
}

.light-blue-text.text-darken-3
{
    color: #0277bd !important;
}

.light-blue.darken-4
{
    background-color: #01579b !important;
}

.light-blue-text.text-darken-4
{
    color: #01579b !important;
}

.light-blue.accent-1
{
    background-color: #80d8ff !important;
}

.light-blue-text.text-accent-1
{
    color: #80d8ff !important;
}

.light-blue.accent-2
{
    background-color: #40c4ff !important;
}

.light-blue-text.text-accent-2
{
    color: #40c4ff !important;
}

.light-blue.accent-3
{
    background-color: #00b0ff !important;
}

.light-blue-text.text-accent-3
{
    color: #00b0ff !important;
}

.light-blue.accent-4
{
    background-color: #0091ea !important;
}

.light-blue-text.text-accent-4
{
    color: #0091ea !important;
}

.cyan
{
    background-color: #00bcd4 !important;
}

.cyan-text
{
    color: #00bcd4 !important;
}

.cyan.lighten-5
{
    background-color: #e0f7fa !important;
}

.cyan-text.text-lighten-5
{
    color: #e0f7fa !important;
}

.cyan.lighten-4
{
    background-color: #b2ebf2 !important;
}

.cyan-text.text-lighten-4
{
    color: #b2ebf2 !important;
}

.cyan.lighten-3
{
    background-color: #80deea !important;
}

.cyan-text.text-lighten-3
{
    color: #80deea !important;
}

.cyan.lighten-2
{
    background-color: #4dd0e1 !important;
}

.cyan-text.text-lighten-2
{
    color: #4dd0e1 !important;
}

.cyan.lighten-1
{
    background-color: #26c6da !important;
}

.cyan-text.text-lighten-1
{
    color: #26c6da !important;
}

.cyan.darken-1
{
    background-color: #00acc1 !important;
}

.cyan-text.text-darken-1
{
    color: #00acc1 !important;
}

.cyan.darken-2
{
    background-color: #0097a7 !important;
}

.cyan-text.text-darken-2
{
    color: #0097a7 !important;
}

.cyan.darken-3
{
    background-color: #00838f !important;
}

.cyan-text.text-darken-3
{
    color: #00838f !important;
}

.cyan.darken-4
{
    background-color: #006064 !important;
}

.cyan-text.text-darken-4
{
    color: #006064 !important;
}

.cyan.accent-1
{
    background-color: #84ffff !important;
}

.cyan-text.text-accent-1
{
    color: #84ffff !important;
}

.cyan.accent-2
{
    background-color: #18ffff !important;
}

.cyan-text.text-accent-2
{
    color: #18ffff !important;
}

.cyan.accent-3
{
    background-color: #00e5ff !important;
}

.cyan-text.text-accent-3
{
    color: #00e5ff !important;
}

.cyan.accent-4
{
    background-color: #00b8d4 !important;
}

.cyan-text.text-accent-4
{
    color: #00b8d4 !important;
}

.teal
{
    background-color: #009688 !important;
}

.teal-text
{
    color: #009688 !important;
}

.teal.lighten-5
{
    background-color: #e0f2f1 !important;
}

.teal-text.text-lighten-5
{
    color: #e0f2f1 !important;
}

.teal.lighten-4
{
    background-color: #b2dfdb !important;
}

.teal-text.text-lighten-4
{
    color: #b2dfdb !important;
}

.teal.lighten-3
{
    background-color: #80cbc4 !important;
}

.teal-text.text-lighten-3
{
    color: #80cbc4 !important;
}

.teal.lighten-2
{
    background-color: #4db6ac !important;
}

.teal-text.text-lighten-2
{
    color: #4db6ac !important;
}

.teal.lighten-1
{
    background-color: #26a69a !important;
}

.teal-text.text-lighten-1
{
    color: #26a69a !important;
}

.teal.darken-1
{
    background-color: #00897b !important;
}

.teal-text.text-darken-1
{
    color: #00897b !important;
}

.teal.darken-2
{
    background-color: #00796b !important;
}

.teal-text.text-darken-2
{
    color: #00796b !important;
}

.teal.darken-3
{
    background-color: #00695c !important;
}

.teal-text.text-darken-3
{
    color: #00695c !important;
}

.teal.darken-4
{
    background-color: #004d40 !important;
}

.teal-text.text-darken-4
{
    color: #004d40 !important;
}

.teal.accent-1
{
    background-color: #a7ffeb !important;
}

.teal-text.text-accent-1
{
    color: #a7ffeb !important;
}

.teal.accent-2
{
    background-color: #64ffda !important;
}

.teal-text.text-accent-2
{
    color: #64ffda !important;
}

.teal.accent-3
{
    background-color: #1de9b6 !important;
}

.teal-text.text-accent-3
{
    color: #1de9b6 !important;
}

.teal.accent-4
{
    background-color: #00bfa5 !important;
}

.teal-text.text-accent-4
{
    color: #00bfa5 !important;
}

.green
{
    background-color: #4caf50 !important;
}

.green-text
{
    color: #4caf50 !important;
}

.green.lighten-5
{
    background-color: #e8f5e9 !important;
}

.green-text.text-lighten-5
{
    color: #e8f5e9 !important;
}

.green.lighten-4
{
    background-color: #c8e6c9 !important;
}

.green-text.text-lighten-4
{
    color: #c8e6c9 !important;
}

.green.lighten-3
{
    background-color: #a5d6a7 !important;
}

.green-text.text-lighten-3
{
    color: #a5d6a7 !important;
}

.green.lighten-2
{
    background-color: #81c784 !important;
}

.green-text.text-lighten-2
{
    color: #81c784 !important;
}

.green.lighten-1
{
    background-color: #66bb6a !important;
}

.green-text.text-lighten-1
{
    color: #66bb6a !important;
}

.green.darken-1
{
    background-color: #43a047 !important;
}

.green-text.text-darken-1
{
    color: #43a047 !important;
}

.green.darken-2
{
    background-color: #388e3c !important;
}

.green-text.text-darken-2
{
    color: #388e3c !important;
}

.green.darken-3
{
    background-color: #2e7d32 !important;
}

.green-text.text-darken-3
{
    color: #2e7d32 !important;
}

.green.darken-4
{
    background-color: #1b5e20 !important;
}

.green-text.text-darken-4
{
    color: #1b5e20 !important;
}

.green.accent-1
{
    background-color: #b9f6ca !important;
}

.green-text.text-accent-1
{
    color: #b9f6ca !important;
}

.green.accent-2
{
    background-color: #69f0ae !important;
}

.green-text.text-accent-2
{
    color: #69f0ae !important;
}

.green.accent-3
{
    background-color: #00e676 !important;
}

.green-text.text-accent-3
{
    color: #00e676 !important;
}

.green.accent-4
{
    background-color: #00c853 !important;
}

.green-text.text-accent-4
{
    color: #00c853 !important;
}

.light-green
{
    background-color: #8bc34a !important;
}

.light-green-text
{
    color: #8bc34a !important;
}

.light-green.lighten-5
{
    background-color: #f1f8e9 !important;
}

.light-green-text.text-lighten-5
{
    color: #f1f8e9 !important;
}

.light-green.lighten-4
{
    background-color: #dcedc8 !important;
}

.light-green-text.text-lighten-4
{
    color: #dcedc8 !important;
}

.light-green.lighten-3
{
    background-color: #c5e1a5 !important;
}

.light-green-text.text-lighten-3
{
    color: #c5e1a5 !important;
}

.light-green.lighten-2
{
    background-color: #aed581 !important;
}

.light-green-text.text-lighten-2
{
    color: #aed581 !important;
}

.light-green.lighten-1
{
    background-color: #9ccc65 !important;
}

.light-green-text.text-lighten-1
{
    color: #9ccc65 !important;
}

.light-green.darken-1
{
    background-color: #7cb342 !important;
}

.light-green-text.text-darken-1
{
    color: #7cb342 !important;
}

.light-green.darken-2
{
    background-color: #689f38 !important;
}

.light-green-text.text-darken-2
{
    color: #689f38 !important;
}

.light-green.darken-3
{
    background-color: #558b2f !important;
}

.light-green-text.text-darken-3
{
    color: #558b2f !important;
}

.light-green.darken-4
{
    background-color: #33691e !important;
}

.light-green-text.text-darken-4
{
    color: #33691e !important;
}

.light-green.accent-1
{
    background-color: #ccff90 !important;
}

.light-green-text.text-accent-1
{
    color: #ccff90 !important;
}

.light-green.accent-2
{
    background-color: #b2ff59 !important;
}

.light-green-text.text-accent-2
{
    color: #b2ff59 !important;
}

.light-green.accent-3
{
    background-color: #76ff03 !important;
}

.light-green-text.text-accent-3
{
    color: #76ff03 !important;
}

.light-green.accent-4
{
    background-color: #64dd17 !important;
}

.light-green-text.text-accent-4
{
    color: #64dd17 !important;
}

.lime
{
    background-color: #cddc39 !important;
}

.lime-text
{
    color: #cddc39 !important;
}

.lime.lighten-5
{
    background-color: #f9fbe7 !important;
}

.lime-text.text-lighten-5
{
    color: #f9fbe7 !important;
}

.lime.lighten-4
{
    background-color: #f0f4c3 !important;
}

.lime-text.text-lighten-4
{
    color: #f0f4c3 !important;
}

.lime.lighten-3
{
    background-color: #e6ee9c !important;
}

.lime-text.text-lighten-3
{
    color: #e6ee9c !important;
}

.lime.lighten-2
{
    background-color: #dce775 !important;
}

.lime-text.text-lighten-2
{
    color: #dce775 !important;
}

.lime.lighten-1
{
    background-color: #d4e157 !important;
}

.lime-text.text-lighten-1
{
    color: #d4e157 !important;
}

.lime.darken-1
{
    background-color: #c0ca33 !important;
}

.lime-text.text-darken-1
{
    color: #c0ca33 !important;
}

.lime.darken-2
{
    background-color: #afb42b !important;
}

.lime-text.text-darken-2
{
    color: #afb42b !important;
}

.lime.darken-3
{
    background-color: #9e9d24 !important;
}

.lime-text.text-darken-3
{
    color: #9e9d24 !important;
}

.lime.darken-4
{
    background-color: #827717 !important;
}

.lime-text.text-darken-4
{
    color: #827717 !important;
}

.lime.accent-1
{
    background-color: #f4ff81 !important;
}

.lime-text.text-accent-1
{
    color: #f4ff81 !important;
}

.lime.accent-2
{
    background-color: #eeff41 !important;
}

.lime-text.text-accent-2
{
    color: #eeff41 !important;
}

.lime.accent-3
{
    background-color: #c6ff00 !important;
}

.lime-text.text-accent-3
{
    color: #c6ff00 !important;
}

.lime.accent-4
{
    background-color: #aeea00 !important;
}

.lime-text.text-accent-4
{
    color: #aeea00 !important;
}

.yellow
{
    background-color: #ffeb3b !important;
}

.yellow-text
{
    color: #ffeb3b !important;
}

.yellow.lighten-5
{
    background-color: #fffde7 !important;
}

.yellow-text.text-lighten-5
{
    color: #fffde7 !important;
}

.yellow.lighten-4
{
    background-color: #fff9c4 !important;
}

.yellow-text.text-lighten-4
{
    color: #fff9c4 !important;
}

.yellow.lighten-3
{
    background-color: #fff59d !important;
}

.yellow-text.text-lighten-3
{
    color: #fff59d !important;
}

.yellow.lighten-2
{
    background-color: #fff176 !important;
}

.yellow-text.text-lighten-2
{
    color: #fff176 !important;
}

.yellow.lighten-1
{
    background-color: #ffee58 !important;
}

.yellow-text.text-lighten-1
{
    color: #ffee58 !important;
}

.yellow.darken-1
{
    background-color: #fdd835 !important;
}

.yellow-text.text-darken-1
{
    color: #fdd835 !important;
}

.yellow.darken-2
{
    background-color: #fbc02d !important;
}

.yellow-text.text-darken-2
{
    color: #fbc02d !important;
}

.yellow.darken-3
{
    background-color: #f9a825 !important;
}

.yellow-text.text-darken-3
{
    color: #f9a825 !important;
}

.yellow.darken-4
{
    background-color: #f57f17 !important;
}

.yellow-text.text-darken-4
{
    color: #f57f17 !important;
}

.yellow.accent-1
{
    background-color: #ffff8d !important;
}

.yellow-text.text-accent-1
{
    color: #ffff8d !important;
}

.yellow.accent-2
{
    background-color: #ff0 !important;
}

.yellow-text.text-accent-2
{
    color: #ff0 !important;
}

.yellow.accent-3
{
    background-color: #ffea00 !important;
}

.yellow-text.text-accent-3
{
    color: #ffea00 !important;
}

.yellow.accent-4
{
    background-color: #ffd600 !important;
}

.yellow-text.text-accent-4
{
    color: #ffd600 !important;
}

.amber
{
    background-color: #ffc107 !important;
}

.amber-text
{
    color: #ffc107 !important;
}

.amber.lighten-5
{
    background-color: #fff8e1 !important;
}

.amber-text.text-lighten-5
{
    color: #fff8e1 !important;
}

.amber.lighten-4
{
    background-color: #ffecb3 !important;
}

.amber-text.text-lighten-4
{
    color: #ffecb3 !important;
}

.amber.lighten-3
{
    background-color: #ffe082 !important;
}

.amber-text.text-lighten-3
{
    color: #ffe082 !important;
}

.amber.lighten-2
{
    background-color: #ffd54f !important;
}

.amber-text.text-lighten-2
{
    color: #ffd54f !important;
}

.amber.lighten-1
{
    background-color: #ffca28 !important;
}

.amber-text.text-lighten-1
{
    color: #ffca28 !important;
}

.amber.darken-1
{
    background-color: #ffb300 !important;
}

.amber-text.text-darken-1
{
    color: #ffb300 !important;
}

.amber.darken-2
{
    background-color: #ffa000 !important;
}

.amber-text.text-darken-2
{
    color: #ffa000 !important;
}

.amber.darken-3
{
    background-color: #ff8f00 !important;
}

.amber-text.text-darken-3
{
    color: #ff8f00 !important;
}

.amber.darken-4
{
    background-color: #ff6f00 !important;
}

.amber-text.text-darken-4
{
    color: #ff6f00 !important;
}

.amber.accent-1
{
    background-color: #ffe57f !important;
}

.amber-text.text-accent-1
{
    color: #ffe57f !important;
}

.amber.accent-2
{
    background-color: #ffd740 !important;
}

.amber-text.text-accent-2
{
    color: #ffd740 !important;
}

.amber.accent-3
{
    background-color: #ffc400 !important;
}

.amber-text.text-accent-3
{
    color: #ffc400 !important;
}

.amber.accent-4
{
    background-color: #ffab00 !important;
}

.amber-text.text-accent-4
{
    color: #ffab00 !important;
}

.orange
{
    background-color: #ff9800 !important;
}

.orange-text
{
    color: #ff9800 !important;
}

.orange.lighten-5
{
    background-color: #fff3e0 !important;
}

.orange-text.text-lighten-5
{
    color: #fff3e0 !important;
}

.orange.lighten-4
{
    background-color: #ffe0b2 !important;
}

.orange-text.text-lighten-4
{
    color: #ffe0b2 !important;
}

.orange.lighten-3
{
    background-color: #ffcc80 !important;
}

.orange-text.text-lighten-3
{
    color: #ffcc80 !important;
}

.orange.lighten-2
{
    background-color: #ffb74d !important;
}

.orange-text.text-lighten-2
{
    color: #ffb74d !important;
}

.orange.lighten-1
{
    background-color: #ffa726 !important;
}

.orange-text.text-lighten-1
{
    color: #ffa726 !important;
}

.orange.darken-1
{
    background-color: #fb8c00 !important;
}

.orange-text.text-darken-1
{
    color: #fb8c00 !important;
}

.orange.darken-2
{
    background-color: #f57c00 !important;
}

.orange-text.text-darken-2
{
    color: #f57c00 !important;
}

.orange.darken-3
{
    background-color: #ef6c00 !important;
}

.orange-text.text-darken-3
{
    color: #ef6c00 !important;
}

.orange.darken-4
{
    background-color: #e65100 !important;
}

.orange-text.text-darken-4
{
    color: #e65100 !important;
}

.orange.accent-1
{
    background-color: #ffd180 !important;
}

.orange-text.text-accent-1
{
    color: #ffd180 !important;
}

.orange.accent-2
{
    background-color: #ffab40 !important;
}

.orange-text.text-accent-2
{
    color: #ffab40 !important;
}

.orange.accent-3
{
    background-color: #ff9100 !important;
}

.orange-text.text-accent-3
{
    color: #ff9100 !important;
}

.orange.accent-4
{
    background-color: #ff6d00 !important;
}

.orange-text.text-accent-4
{
    color: #ff6d00 !important;
}

.deep-orange
{
    background-color: #ff5722 !important;
}

.deep-orange-text
{
    color: #ff5722 !important;
}

.deep-orange.lighten-5
{
    background-color: #fbe9e7 !important;
}

.deep-orange-text.text-lighten-5
{
    color: #fbe9e7 !important;
}

.deep-orange.lighten-4
{
    background-color: #ffccbc !important;
}

.deep-orange-text.text-lighten-4
{
    color: #ffccbc !important;
}

.deep-orange.lighten-3
{
    background-color: #ffab91 !important;
}

.deep-orange-text.text-lighten-3
{
    color: #ffab91 !important;
}

.deep-orange.lighten-2
{
    background-color: #ff8a65 !important;
}

.deep-orange-text.text-lighten-2
{
    color: #ff8a65 !important;
}

.deep-orange.lighten-1
{
    background-color: #ff7043 !important;
}

.deep-orange-text.text-lighten-1
{
    color: #ff7043 !important;
}

.deep-orange.darken-1
{
    background-color: #f4511e !important;
}

.deep-orange-text.text-darken-1
{
    color: #f4511e !important;
}

.deep-orange.darken-2
{
    background-color: #e64a19 !important;
}

.deep-orange-text.text-darken-2
{
    color: #e64a19 !important;
}

.deep-orange.darken-3
{
    background-color: #d84315 !important;
}

.deep-orange-text.text-darken-3
{
    color: #d84315 !important;
}

.deep-orange.darken-4
{
    background-color: #bf360c !important;
}

.deep-orange-text.text-darken-4
{
    color: #bf360c !important;
}

.deep-orange.accent-1
{
    background-color: #ff9e80 !important;
}

.deep-orange-text.text-accent-1
{
    color: #ff9e80 !important;
}

.deep-orange.accent-2
{
    background-color: #ff6e40 !important;
}

.deep-orange-text.text-accent-2
{
    color: #ff6e40 !important;
}

.deep-orange.accent-3
{
    background-color: #ff3d00 !important;
}

.deep-orange-text.text-accent-3
{
    color: #ff3d00 !important;
}

.deep-orange.accent-4
{
    background-color: #dd2c00 !important;
}

.deep-orange-text.text-accent-4
{
    color: #dd2c00 !important;
}

.brown
{
    background-color: #795548 !important;
}

.brown-text
{
    color: #795548 !important;
}

.brown.lighten-5
{
    background-color: #efebe9 !important;
}

.brown-text.text-lighten-5
{
    color: #efebe9 !important;
}

.brown.lighten-4
{
    background-color: #d7ccc8 !important;
}

.brown-text.text-lighten-4
{
    color: #d7ccc8 !important;
}

.brown.lighten-3
{
    background-color: #bcaaa4 !important;
}

.brown-text.text-lighten-3
{
    color: #bcaaa4 !important;
}

.brown.lighten-2
{
    background-color: #a1887f !important;
}

.brown-text.text-lighten-2
{
    color: #a1887f !important;
}

.brown.lighten-1
{
    background-color: #8d6e63 !important;
}

.brown-text.text-lighten-1
{
    color: #8d6e63 !important;
}

.brown.darken-1
{
    background-color: #6d4c41 !important;
}

.brown-text.text-darken-1
{
    color: #6d4c41 !important;
}

.brown.darken-2
{
    background-color: #5d4037 !important;
}

.brown-text.text-darken-2
{
    color: #5d4037 !important;
}

.brown.darken-3
{
    background-color: #4e342e !important;
}

.brown-text.text-darken-3
{
    color: #4e342e !important;
}

.brown.darken-4
{
    background-color: #3e2723 !important;
}

.brown-text.text-darken-4
{
    color: #3e2723 !important;
}

.blue-grey
{
    background-color: #607d8b !important;
}

.blue-grey-text
{
    color: #607d8b !important;
}

.blue-grey.lighten-5
{
    background-color: #eceff1 !important;
}

.blue-grey-text.text-lighten-5
{
    color: #eceff1 !important;
}

.blue-grey.lighten-4
{
    background-color: #cfd8dc !important;
}

.blue-grey-text.text-lighten-4
{
    color: #cfd8dc !important;
}

.blue-grey.lighten-3
{
    background-color: #b0bec5 !important;
}

.blue-grey-text.text-lighten-3
{
    color: #b0bec5 !important;
}

.blue-grey.lighten-2
{
    background-color: #90a4ae !important;
}

.blue-grey-text.text-lighten-2
{
    color: #90a4ae !important;
}

.blue-grey.lighten-1
{
    background-color: #78909c !important;
}

.blue-grey-text.text-lighten-1
{
    color: #78909c !important;
}

.blue-grey.darken-1
{
    background-color: #546e7a !important;
}

.blue-grey-text.text-darken-1
{
    color: #546e7a !important;
}

.blue-grey.darken-2
{
    background-color: #455a64 !important;
}

.blue-grey-text.text-darken-2
{
    color: #455a64 !important;
}

.blue-grey.darken-3
{
    background-color: #37474f !important;
}

.blue-grey-text.text-darken-3
{
    color: #37474f !important;
}

.blue-grey.darken-4
{
    background-color: #263238 !important;
}

.blue-grey-text.text-darken-4
{
    color: #263238 !important;
}

.grey
{
    background-color: #9e9e9e !important;
}

.grey-text
{
    color: #9e9e9e !important;
}

.grey.lighten-5
{
    background-color: #fafafa !important;
}

.grey-text.text-lighten-5
{
    color: #fafafa !important;
}

.grey.lighten-4
{
    background-color: #f5f5f5 !important;
}

.grey-text.text-lighten-4
{
    color: #f5f5f5 !important;
}

.grey.lighten-3
{
    background-color: #eee !important;
}

.grey-text.text-lighten-3
{
    color: #eee !important;
}

.grey.lighten-2
{
    background-color: #e0e0e0 !important;
}

.grey-text.text-lighten-2
{
    color: #e0e0e0 !important;
}

.grey.lighten-1
{
    background-color: #bdbdbd !important;
}

.grey-text.text-lighten-1
{
    color: #bdbdbd !important;
}

.grey.darken-1
{
    background-color: #757575 !important;
}

.grey-text.text-darken-1
{
    color: #757575 !important;
}

.grey.darken-2
{
    background-color: #616161 !important;
}

.grey-text.text-darken-2
{
    color: #616161 !important;
}

.grey.darken-3
{
    background-color: #424242 !important;
}

.grey-text.text-darken-3
{
    color: #424242 !important;
}

.grey.darken-4
{
    background-color: #212121 !important;
}

.grey-text.text-darken-4
{
    color: #212121 !important;
}

.black
{
    background-color: #000 !important;
}

.black-text
{
    color: #000 !important;
}

.white
{
    background-color: #fff !important;
}

.white-text
{
    color: #fff !important;
}

.transparent
{
    background-color: transparent !important;
}

.transparent-text
{
    color: transparent !important;
}

/*
  Gradient color mixin
*/
.gradient-45deg-light-blue-teal
{
    background: #b3e5fc;
    background:         linear-gradient(45deg, #b3e5fc, #64ffda) !important;
}

.gradient-45deg-light-blue-teal.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(100, 255, 218, .5) !important;
}

.gradient-45deg-indigo-light-blue
{
    background: #3949ab;
    background:         linear-gradient(45deg, #3949ab, #4fc3f7) !important;
}

.gradient-45deg-indigo-light-blue.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(79, 195, 247, .5) !important;
}

.gradient-45deg-light-blue-indigo
{
    background: #b3e5fc;
    background:         linear-gradient(45deg, #b3e5fc, #9fa8da) !important;
}

.gradient-45deg-light-blue-indigo.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(159, 168, 218, .5) !important;
}

.gradient-45deg-yellow-green
{
    background: #ffff8d;
    background:         linear-gradient(45deg, #ffff8d, #b9f6ca) !important;
}

.gradient-45deg-yellow-green.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(185, 246, 202, .5) !important;
}

.gradient-45deg-orange-deep-orange
{
    background: #ffe0b2;
    background:         linear-gradient(45deg, #ffe0b2, #ffccbc) !important;
}

.gradient-45deg-orange-deep-orange.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(255, 204, 188, .5) !important;
}

.gradient-45deg-deep-purple-purple
{
    background: #d1c4e9;
    background:         linear-gradient(45deg, #d1c4e9, #f3e5f5) !important;
}

.gradient-45deg-deep-purple-purple.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(243, 229, 245, .5) !important;
}

.gradient-45deg-red-pink
{
    background: #ff5252;
    background:         linear-gradient(45deg, #ff5252, #f48fb1) !important;
}

.gradient-45deg-red-pink.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(244, 143, 177, .5) !important;
}

.gradient-45deg-light-green-amber
{
    background: #c5e1a5;
    background:         linear-gradient(45deg, #c5e1a5, #fff8e1) !important;
}

.gradient-45deg-light-green-amber.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(255, 248, 225, .5) !important;
}

.gradient-45deg-amber-amber
{
    background: #ff6f00;
    background:         linear-gradient(45deg, #ff6f00, #ffca28) !important;
}

.gradient-45deg-amber-amber.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(255, 202, 40, .5) !important;
}

.gradient-45deg-purple-pink
{
    background: #ea80fc;
    background:         linear-gradient(45deg, #ea80fc, #fce4ec) !important;
}

.gradient-45deg-purple-pink.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(252, 228, 236, .5) !important;
}

.gradient-45deg-teal-cyan
{
    background: #e0f2f1;
    background:         linear-gradient(45deg, #e0f2f1, #00e5ff) !important;
}

.gradient-45deg-teal-cyan.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(0, 229, 255, .5) !important;
}

.gradient-45deg-blue-grey-blue-grey
{
    background: #cfd8dc;
    background:         linear-gradient(45deg, #cfd8dc, #546e7a) !important;
}

.gradient-45deg-blue-grey-blue-grey.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(84, 110, 122, .5) !important;
}

.gradient-45deg-orange-amber
{
    background: #e65100;
    background:         linear-gradient(45deg, #e65100, #1976d2) !important;
}

.gradient-45deg-orange-amber.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(25, 118, 210, .5) !important;
}

.gradient-45deg-indigo-blue
{
    background: #303f9f;
    background:         linear-gradient(45deg, #303f9f, #1976d2) !important;
}

.gradient-45deg-indigo-blue.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(25, 118, 210, .5) !important;
}

.gradient-45deg-brown-brown
{
    background: #6d4c41;
    background:         linear-gradient(45deg, #6d4c41, #bbdefb) !important;
}

.gradient-45deg-brown-brown.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(187, 222, 251, .5) !important;
}

.gradient-45deg-blue-grey-blue
{
    background: #263238;
    background:         linear-gradient(45deg, #263238, #2979ff) !important;
}

.gradient-45deg-blue-grey-blue.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(41, 121, 255, .5) !important;
}

.gradient-45deg-purple-deep-orange
{
    background: #8e24aa;
    background:         linear-gradient(45deg, #8e24aa, #ff6e40) !important;
}

.gradient-45deg-purple-deep-orange.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(255, 110, 64, .5) !important;
}

.gradient-45deg-green-teal
{
    background: #43a047;
    background:         linear-gradient(45deg, #43a047, #1de9b6) !important;
}

.gradient-45deg-green-teal.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(29, 233, 182, .5) !important;
}

.gradient-45deg-purple-light-blue
{
    background: #e040fb;
    background:         linear-gradient(45deg, #e040fb, #4fc3f7) !important;
}

.gradient-45deg-purple-light-blue.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(79, 195, 247, .5) !important;
}

.gradient-45deg-cyan-cyan
{
    background: #18ffff;
    background:         linear-gradient(45deg, #18ffff, #00e5ff) !important;
}

.gradient-45deg-cyan-cyan.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(0, 229, 255, .5) !important;
}

.gradient-45deg-yellow-teal
{
    background: #fff9c4;
    background:         linear-gradient(45deg, #fff9c4, #64ffda) !important;
}

.gradient-45deg-yellow-teal.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(100, 255, 218, .5) !important;
}

.gradient-45deg-purple-deep-purple
{
    background: #7b1fa2;
    background:         linear-gradient(45deg, #7b1fa2, #7c4dff) !important;
}

.gradient-45deg-purple-deep-purple.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(124, 77, 255, .5) !important;
}

.gradient-45deg-cyan-light-green
{
    background: #0097a7;
    background:         linear-gradient(45deg, #0097a7, #b2ff59) !important;
}

.gradient-45deg-cyan-light-green.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(178, 255, 89, .5) !important;
}

.gradient-45deg-purple-amber
{
    background: #d500f9;
    background:         linear-gradient(45deg, #d500f9, #ffa000) !important;
}

.gradient-45deg-purple-amber.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(255, 160, 0, .5) !important;
}

.gradient-45deg-indigo-purple
{
    background: #303f9f;
    background:         linear-gradient(45deg, #303f9f, #7b1fa2) !important;
}

.gradient-45deg-indigo-purple.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(123, 31, 162, .5) !important;
}

.gradient-45deg-deep-purple-blue
{
    background: #6200ea;
    background:         linear-gradient(45deg, #6200ea, #1976d2) !important;
}

.gradient-45deg-deep-purple-blue.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(25, 118, 210, .5) !important;
}

.gradient-45deg-deep-orange-orange
{
    background: #bf360c;
    background:         linear-gradient(45deg, #bf360c, #f57c00) !important;
}

.gradient-45deg-deep-orange-orange.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(245, 124, 0, .5) !important;
}

.gradient-45deg-light-blue-cyan
{
    background: #0288d1;
    background:         linear-gradient(45deg, #0288d1, #26c6da) !important;
}

.gradient-45deg-light-blue-cyan.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(38, 198, 218, .5) !important;
}

.gradient-45deg-blue-indigo
{
    background: #2962ff;
    background:         linear-gradient(45deg, #2962ff, #3949ab) !important;
}

.gradient-45deg-blue-indigo.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(57, 73, 171, .5) !important;
}

.gradient-45deg-semi-dark
{
    background: #00aeff;
    background:         linear-gradient(-90deg, #00aeff, #3369e6) !important;
}

.gradient-45deg-semi-dark.gradient-shadow
{
    box-shadow: 0 6px 20px 0 rgba(51, 105, 230, .5) !important;
}

.btn-light-materialize-red
{
    color: #e51c23 !important;
    background-color: #fdeaeb;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-materialize-red:hover,
.btn-light-materialize-red:focus,
.btn-light-materialize-red.hover
{
    color: #fff !important;
    background-color: #ea454b !important;
}

.btn-light-materialize-red:active,
.btn-light-materialize-red.active
{
    color: #fff !important;
    background-color: #d0181e !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-materialize-red:before
{
    background: #e51c23 !important;
}

.btn-light-red
{
    color: #f44336 !important;
    background-color: #ffebee;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-red:hover,
.btn-light-red:focus,
.btn-light-red.hover
{
    color: #fff !important;
    background-color: #ef5350 !important;
}

.btn-light-red:active,
.btn-light-red.active
{
    color: #fff !important;
    background-color: #e53935 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-red:before
{
    background: #f44336 !important;
}

.btn-light-pink
{
    color: #e91e63 !important;
    background-color: #fce4ec;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-pink:hover,
.btn-light-pink:focus,
.btn-light-pink.hover
{
    color: #fff !important;
    background-color: #ec407a !important;
}

.btn-light-pink:active,
.btn-light-pink.active
{
    color: #fff !important;
    background-color: #d81b60 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-pink:before
{
    background: #e91e63 !important;
}

.btn-light-purple
{
    color: #9c27b0 !important;
    background-color: #f3e5f5;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-purple:hover,
.btn-light-purple:focus,
.btn-light-purple.hover
{
    color: #fff !important;
    background-color: #ab47bc !important;
}

.btn-light-purple:active,
.btn-light-purple.active
{
    color: #fff !important;
    background-color: #8e24aa !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-purple:before
{
    background: #9c27b0 !important;
}

.btn-light-deep-purple
{
    color: #673ab7 !important;
    background-color: #ede7f6;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-deep-purple:hover,
.btn-light-deep-purple:focus,
.btn-light-deep-purple.hover
{
    color: #fff !important;
    background-color: #7e57c2 !important;
}

.btn-light-deep-purple:active,
.btn-light-deep-purple.active
{
    color: #fff !important;
    background-color: #5e35b1 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-deep-purple:before
{
    background: #673ab7 !important;
}

.btn-light-indigo
{
    color: #3f51b5 !important;
    background-color: #e8eaf6;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-indigo:hover,
.btn-light-indigo:focus,
.btn-light-indigo.hover
{
    color: #fff !important;
    background-color: #5c6bc0 !important;
}

.btn-light-indigo:active,
.btn-light-indigo.active
{
    color: #fff !important;
    background-color: #3949ab !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-indigo:before
{
    background: #3f51b5 !important;
}

.btn-light-blue
{
    color: #2196f3 !important;
    background-color: #e3f2fd;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-blue:hover,
.btn-light-blue:focus,
.btn-light-blue.hover
{
    color: #fff !important;
    background-color: #42a5f5 !important;
}

.btn-light-blue:active,
.btn-light-blue.active
{
    color: #fff !important;
    background-color: #1e88e5 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-blue:before
{
    background: #2196f3 !important;
}

.btn-light-light-blue
{
    color: #03a9f4 !important;
    background-color: #e1f5fe;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-light-blue:hover,
.btn-light-light-blue:focus,
.btn-light-light-blue.hover
{
    color: #fff !important;
    background-color: #29b6f6 !important;
}

.btn-light-light-blue:active,
.btn-light-light-blue.active
{
    color: #fff !important;
    background-color: #039be5 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-light-blue:before
{
    background: #03a9f4 !important;
}

.btn-light-cyan
{
    color: #00bcd4 !important;
    background-color: #e0f7fa;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-cyan:hover,
.btn-light-cyan:focus,
.btn-light-cyan.hover
{
    color: #fff !important;
    background-color: #26c6da !important;
}

.btn-light-cyan:active,
.btn-light-cyan.active
{
    color: #fff !important;
    background-color: #00acc1 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-cyan:before
{
    background: #00bcd4 !important;
}

.btn-light-teal
{
    color: #009688 !important;
    background-color: #e0f2f1;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-teal:hover,
.btn-light-teal:focus,
.btn-light-teal.hover
{
    color: #fff !important;
    background-color: #26a69a !important;
}

.btn-light-teal:active,
.btn-light-teal.active
{
    color: #fff !important;
    background-color: #00897b !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-teal:before
{
    background: #009688 !important;
}

.btn-light-green
{
    color: #4caf50 !important;
    background-color: #e8f5e9;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-green:hover,
.btn-light-green:focus,
.btn-light-green.hover
{
    color: #fff !important;
    background-color: #66bb6a !important;
}

.btn-light-green:active,
.btn-light-green.active
{
    color: #fff !important;
    background-color: #43a047 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-green:before
{
    background: #4caf50 !important;
}

.btn-light-light-green
{
    color: #8bc34a !important;
    background-color: #f1f8e9;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-light-green:hover,
.btn-light-light-green:focus,
.btn-light-light-green.hover
{
    color: #fff !important;
    background-color: #9ccc65 !important;
}

.btn-light-light-green:active,
.btn-light-light-green.active
{
    color: #fff !important;
    background-color: #7cb342 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-light-green:before
{
    background: #8bc34a !important;
}

.btn-light-lime
{
    color: #cddc39 !important;
    background-color: #f9fbe7;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-lime:hover,
.btn-light-lime:focus,
.btn-light-lime.hover
{
    color: #fff !important;
    background-color: #d4e157 !important;
}

.btn-light-lime:active,
.btn-light-lime.active
{
    color: #fff !important;
    background-color: #c0ca33 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-lime:before
{
    background: #cddc39 !important;
}

.btn-light-yellow
{
    color: #ffeb3b !important;
    background-color: #fffde7;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-yellow:hover,
.btn-light-yellow:focus,
.btn-light-yellow.hover
{
    color: #fff !important;
    background-color: #ffee58 !important;
}

.btn-light-yellow:active,
.btn-light-yellow.active
{
    color: #fff !important;
    background-color: #fdd835 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-yellow:before
{
    background: #ffeb3b !important;
}

.btn-light-amber
{
    color: #ffc107 !important;
    background-color: #fff8e1;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-amber:hover,
.btn-light-amber:focus,
.btn-light-amber.hover
{
    color: #fff !important;
    background-color: #ffca28 !important;
}

.btn-light-amber:active,
.btn-light-amber.active
{
    color: #fff !important;
    background-color: #ffb300 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-amber:before
{
    background: #ffc107 !important;
}

.btn-light-orange
{
    color: #ff9800 !important;
    background-color: #fff3e0;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-orange:hover,
.btn-light-orange:focus,
.btn-light-orange.hover
{
    color: #fff !important;
    background-color: #ffa726 !important;
}

.btn-light-orange:active,
.btn-light-orange.active
{
    color: #fff !important;
    background-color: #fb8c00 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-orange:before
{
    background: #ff9800 !important;
}

.btn-light-deep-orange
{
    color: #ff5722 !important;
    background-color: #fbe9e7;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-deep-orange:hover,
.btn-light-deep-orange:focus,
.btn-light-deep-orange.hover
{
    color: #fff !important;
    background-color: #ff7043 !important;
}

.btn-light-deep-orange:active,
.btn-light-deep-orange.active
{
    color: #fff !important;
    background-color: #f4511e !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-deep-orange:before
{
    background: #ff5722 !important;
}

.btn-light-brown
{
    color: #795548 !important;
    background-color: #efebe9;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-brown:hover,
.btn-light-brown:focus,
.btn-light-brown.hover
{
    color: #fff !important;
    background-color: #8d6e63 !important;
}

.btn-light-brown:active,
.btn-light-brown.active
{
    color: #fff !important;
    background-color: #6d4c41 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-brown:before
{
    background: #795548 !important;
}

.btn-light-blue-grey
{
    color: #607d8b !important;
    background-color: #eceff1;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-blue-grey:hover,
.btn-light-blue-grey:focus,
.btn-light-blue-grey.hover
{
    color: #fff !important;
    background-color: #78909c !important;
}

.btn-light-blue-grey:active,
.btn-light-blue-grey.active
{
    color: #fff !important;
    background-color: #546e7a !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-blue-grey:before
{
    background: #607d8b !important;
}

.btn-light-grey
{
    color: #9e9e9e !important;
    background-color: #fafafa;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);
}

.btn-light-grey:hover,
.btn-light-grey:focus,
.btn-light-grey.hover
{
    color: #fff !important;
    background-color: #bdbdbd !important;
}

.btn-light-grey:active,
.btn-light-grey.active
{
    color: #fff !important;
    background-color: #757575 !important;
}

/* timeline */
.widget-timeline li.timeline-items.timeline-icon-grey:before
{
    background: #9e9e9e !important;
}

/*----------------------------------------
	Avatar
------------------------------------------*/
.avatar-status
{
    line-height: 50px;

    position: relative;

    display: inline-block;

    width: 28px;

    vertical-align: bottom;
    white-space: nowrap;

    border-radius: 50px;
}

.avatar-status i
{
    position: absolute;
    right: -2px;
    bottom: 18px;

    width: 9px !important;
    height: 9px !important;

    border: 1px solid #fff;
    border-radius: 100%;
}

.avatar-status span.text-circle
{
    font-size: 1.2rem;

    display: table-cell;

    text-align: center;
    vertical-align: middle;

    color: #fff;
    background: #fafafa;
}

.avatar-status img
{
    width: 100%;
    max-width: 100%;
    height: auto;

    border: 0 none;
    border-radius: 1000px;
    background: #e6e6e6;
}

.avatar-online i
{
    background-color: #00e676;
}

.avatar-off i
{
    background-color: #bdbdbd;
}

.avatar-busy i
{
    background-color: #ff1744;
}

.avatar-away i
{
    background-color: #ffc400;
}

.avatar-status.avatar-100
{
    width: 100px;
}

.avatar-status.avatar-100 span.text-circle
{
    width: 100px;
    height: 100px;
}

.avatar-status.avatar-100 i
{
    width: 20px;
    height: 20px;
}

.avatar-status.avatar-50
{
    line-height: 0;

    width: 50px;
}

.avatar-status.avatar-50 span.text-circle
{
    width: 50px;
    height: 50px;
}

.avatar-status.avatar-50 i
{
    right: -1px;
    bottom: 21px;

    width: 12px !important;
    height: 12px !important;
}

.avatar-status.avatar-lg
{
    width: 144px;
}

.avatar-status.avatar-lg span.text-circle
{
    width: 144px;
    height: 144px;
}

.avatar-status.avatar-lg i
{
    right: 0;
    bottom: 0;

    width: 20px;
    height: 20px;
}

.avatar-status.avatar-md
{
    width: 40px;
}

.avatar-status.avatar-md span.text-circle
{
    width: 40px;
    height: 40px;
}

.avatar-status.avatar-md i
{
    right: 0;
    bottom: 0;

    width: 10px;
    height: 10px;
}

.avatar-status.avatar-sm
{
    width: 32px;
}

.avatar-status.avatar-sm span.text-circle
{
    width: 32px;
    height: 32px;
}

.avatar-status.avatar-sm i
{
    width: 8px;
    height: 8px;
}

.avatar-status.avatar-xs
{
    width: 24px;
}

.avatar-status.avatar-xs span.text-circle
{
    width: 24px;
    height: 24px;
}

.avatar-status.avatar-xs i
{
    width: 7px;
    height: 7px;
}

.collection .collection-item.avatar:not(.circle-clipper) > .circle
{
    background: #e6e6e6;
}

/*----------------------------------------
	Dropdown
------------------------------------------*/
.dropdown-content li:hover,
.dropdown-content li.active
{
    background-color: #eee;
}

.dropdown-content li > a,
.dropdown-content li > span
{
    padding: 14px 24px;
}

.dropdown-content li > a:hover,
.dropdown-content li > a.active,
.dropdown-content li > span:hover,
.dropdown-content li > span.active
{
    background-color: #eee;
}

.dropdown-content li > a > i
{
    width: 24px;
    margin: 0 12px 0 0;
}

/*----------------------------------------
	Badges
------------------------------------------*/
span.badge
{
    color: #fff;
}

span.badge.pill
{
    font-size: .8rem;
    line-height: 20px;

    min-width: 1rem;
    height: 20px;

    border-radius: 50%;
    border-radius: 9px;
}

#badges-navbar nav .brand-logo
{
    font-size: 2.1rem;
}

/* Buttons */
/*--------*/
.btn,
.btn-flat,
.btn-large,
.btn-small
{
    text-transform: capitalize;
}

.btn-block
{
    display: block;

    width: 100%;
}

/*----------------------------------------
  Material
------------------------------------------*/
@font-face
{
    font-family: 'Material Icons';
    font-weight: 400;
    font-style: normal;

    src: local('Material Icons'), local('MaterialIcons-Regular'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.material-icons
{
    font-family: 'Material Icons';
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 1;
    /* Preferred icon size */

    display: inline-block;

    white-space: nowrap;
    letter-spacing: normal;
    text-transform: none;
    word-wrap: normal;

    direction: ltr;
    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;
    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;
    /* Support for IE. */
    font-feature-settings: 'liga';
}

/* Rules for sizing the icon. */
.material-icons.md-18
{
    font-size: 18px;
}

.material-icons.md-24
{
    font-size: 24px;
}

.material-icons.md-36
{
    font-size: 36px;
}

.material-icons.md-48
{
    font-size: 48px;
}

/* Rules for using icons as black on a light background. */
.material-icons.md-dark
{
    color: rgba(0, 0, 0, .54);
}

.material-icons.md-dark.md-inactive
{
    color: rgba(0, 0, 0, .26);
}

/* Rules for using icons as white on a dark background. */
.material-icons.md-light
{
    color: white;
}

.material-icons.md-light.md-inactive
{
    color: rgba(255, 255, 255, .3);
}

/*----------------------------------------
    Pulse
------------------------------------------*/
.pulse-style-one
{
    display:         flex;
    justify-content: space-around;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)
{
    .modal
    {
        position: -ms-page;
        top: 10%;
    }
    .modal.bottom-sheet
    {
        position: -ms-page;
        top: 155%;

        height: 100%;
    }
    .modal.bottom-sheet + .modal-overlay
    {
        position: -ms-page;
        top: 100%;
    }
    .modal-overlay
    {
        position: -ms-page;
        top: 5%;

        height: 100%;
    }
}

/*----------------------------------------
   Navbar
------------------------------------------*/
.navbar
{
    position: relative;
    z-index: 997;
}

.navbar .header-search-wrapper
{
    position: relative;

    display: inline-block;

    width: calc(100% - 360px);
    height: 40px;
    margin: 10px auto 0 75px;
    transition: .3s ease all;
    backface-visibility: hidden;
}

.navbar .header-search-wrapper i
{
    font-size: 24px;
    line-height: 32px !important;

    position: absolute;
    top: 6px;
    left: 24px;
    transition: color 200ms ease;
}

.navbar .sideNav-lock .header-search-wrapper
{
    width: calc(100% - 560px);
    margin: 10px auto 0 260px;
}

.navbar input.header-search-input
{
    font-size: 16px;
    font-weight: 400;

    display: block;

    box-sizing: border-box;
    width: 100%;
    margin-bottom: 0;
    padding: 8px 8px 8px 65px;
    transition: all 200ms ease;

    border: none;
    border-radius: 3px;
    outline: none;
    background: rgba(255, 255, 255, .3);
    appearance: textfield;
}

.navbar input.header-search-input:hover
{
    background: rgba(255, 255, 255, .5);
}

.navbar input.header-search-input:focus,
.navbar input.header-search-input:active
{
    color: #333 !important;
    border-bottom: none !important;
    background: #fff !important;
    box-shadow: none !important;
}

.navbar .header-search-wrapper-focus i
{
    color: #444 !important;
}

.navbar .header-search-input:focus::placeholder
{
    font-size: 16px;
    font-weight: 400;

    color: #333;
}

.navbar .header-search-input::placeholder
{
    font-size: 16px;
    font-weight: 400;

    color: #fff;
}

.navbar .toggle-fullscreen,
.navbar .notification-button
{
    line-height: 1;
}

.navbar .notification-badge
{
    font-family: 'Muli', sans-serif;

    position: relative;
    top: -20px;
    right: 5px;

    margin: 0 -.8em;
    padding: 2px 5px;

    color: #fff;
    border-radius: 50%;
    background-color: #00bcd4;
    box-shadow: 0 0 10px 0 #00bcd4;
}

.navbar #notifications-dropdown
{
    width: 400px;
}

.navbar #notifications-dropdown h5
{
    font-size: 1rem;
    font-weight: 500;

    text-transform: capitalize;
}

.navbar #notifications-dropdown li
{
    font-size: 1rem;

    padding: 8px 16px;
}

.navbar #notifications-dropdown li > a
{
    font-size: 1.1rem;
    font-weight: 300;

    padding: 0;
}

.navbar #notifications-dropdown li > a > span
{
    font-size: 1.2rem;

    position: relative;
    top: 4px;

    display: inline-block;

    margin-right: 5px;
}

.navbar #notifications-dropdown li > time
{
    font-size: .8rem;
    font-weight: 400;

    position: relative;
    top: -4px;

    margin-left: 38px;
}

.navbar #notifications-dropdown li.divider
{
    padding: 0;
}

.navbar .profile-button span.avatar-status
{
    line-height: 43px;
}

.navbar #profile-dropdown
{
    width: 160px;
}

.navbar #profile-dropdown li a i
{
    margin-right: 10px;
}

.navbar .navbar-light
{
    background: #fff;
}

.navbar .navbar-light ul a
{
    color: rgba(0, 0, 0, .87);
}

.navbar .navbar-light .header-search-wrapper i
{
    color: rgba(0, 0, 0, .87);
}

.navbar .navbar-light .header-search-wrapper input.header-search-input
{
    color: rgba(0, 0, 0, .87);
    border: 1px solid #efefef;
    background: rgba(230, 230, 230, .3);
}

.navbar .navbar-light .header-search-wrapper input.header-search-input:hover,
.navbar .navbar-light .header-search-wrapper input.header-search-input:active,
.navbar .navbar-light .header-search-wrapper input.header-search-input:focus
{
    border: 1px solid #adadad;
    border-bottom: 1px solid #adadad !important;
    background: rgba(230, 230, 230, 0);
}

.navbar .navbar-light .header-search-wrapper input.header-search-input::placeholder
{
    color: rgba(0, 0, 0, .87);
}

.navbar .navbar-dark
{
    background: #37474f;
}

.navbar .navbar-dark ul a
{
    color: #fff;
}

.navbar .navbar-dark .header-search-wrapper i
{
    color: #fff;
}

.navbar .navbar-dark .header-search-wrapper input.header-search-input
{
    color: #fff;
    border: 1px solid rgba(230, 230, 230, .05);
    background: rgba(230, 230, 230, .3);
}

.navbar .navbar-dark .header-search-wrapper input.header-search-input:hover,
.navbar .navbar-dark .header-search-wrapper input.header-search-input:active,
.navbar .navbar-dark .header-search-wrapper input.header-search-input:focus
{
    border: 1px solid rgba(230, 230, 230, .1);
    background: rgba(230, 230, 230, .1);
}

.navbar .navbar-dark .header-search-wrapper input.header-search-input::placeholder
{
    color: #fff;
}

.navbar .no-shadow
{
    box-shadow: none;
}

.horizontal-layout .navbar .header-search-wrapper
{
    width: calc(100% - 560px);
}

.navbar .navbar-main
{
    padding: 0 8px 0 15px;
}

.search-list
{
    position: absolute;
    top: 100%;

    height: calc(100vh - 9rem);
    max-height: 450px;
    margin-top: 0;

    border: none;
    border-radius: 3px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.search-list li
{
    width: 100%;
}

.search-list li a
{
    padding: 8px 20px 5px 20px !important;
}

.search-list li a .search-title
{
    font-size: .9rem;
    font-weight: bold;

    margin: .8rem 0 4px 0;

    color: #9c27b0;
}

.search-list li a span
{
    font-size: 1rem;
    line-height: .9;

    vertical-align: middle;

    color: #9e9e9e;
}

.search-list li a span.material-icons
{
    font-size: 1.4rem;
    line-height: 1.2;
}

.search-list li a .member-info
{
    margin-left: .8rem;
}

.search-list li a .member-info span:hover
{
    color: #9c27b0 !important;
}

.search-list li a .status small:not(:first-child)
{
    color: #757575;
}

.search-list li.current_item a
{
    background-color: #eee;
}

.search-list li.auto-suggestion-title
{
    background-color: #fff !important;
}

.search-list li.auto-suggestion-title a
{
    background-color: #fff !important;
}

.search-list li.auto-suggestion-title a:hover
{
    background-color: #fff !important;
}

.content-overlay
{
    position: fixed;
    z-index: -1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    visibility: hidden;

    width: 100%;
    height: 100%;

    cursor: pointer;
    transition: all .7s;
}

.content-overlay.show
{
    z-index: 995;

    visibility: visible;

    background-color: rgba(0, 0, 0, .5);
}

nav.display-none.search-sm
{
    position: absolute;

    background-color: #fff;
}

nav.display-none.search-sm .nav-wrapper form .input-field input.search-box-sm:not(:focus)
{
    color: #9c27b0;
}

nav.display-none.search-sm .nav-wrapper form .input-field i
{
    color: #444;
}

@media only screen and (max-width: 600px)
{
    .navbar .nav-wrapper .dropdown-content
    {
        left: 25px !important;

        width: calc(100% - 33px) !important;
    }
    .navbar .nav-wrapper .navbar-list > li > a
    {
        padding: 0 13px;
    }
    .navbar .profile-button span.avatar-status
    {
        line-height: 39px;
    }
    .notification-button i
    {
        font-size: 29px;

        position: relative;
        top: 12px;
    }
    .search-button i
    {
        position: relative;
        top: 6px;

        height: 0;
    }
    .search-sm-close
    {
        position: absolute !important;
        top: 12px !important;
    }
    .search-sm-icon
    {
        position: absolute !important;
        top: 14px !important;
    }
}

@media (max-width: 992px)
{
    .navbar .navbar-main
    {
        padding: 0 8px 0 0;
    }
}

/*----------------------------------------
    SideNav - Main Menu
------------------------------------------*/
.sidenav-main
{
    position: fixed;
    z-index: 999;
    top: 0;

    width: 250px;
    height: 100%;
    transition: .3s ease all;
}

.sidenav-main span.badge.new
{
    line-height: 20px;

    margin-top: 11px;
}

.brand-sidebar
{
    position: fixed;
    top: 0;
    left: 0;

    width: inherit;
    height: 64px;

    background: #fff;
    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, .2);
    backface-visibility: hidden;
}

.brand-sidebar .logo-wrapper
{
    font-size: 3rem;
    line-height: 17px !important;

    margin: 0;

    white-space: nowrap;
}

.brand-sidebar .logo-wrapper a.brand-logo img
{
    height: 18px;
}

.brand-sidebar .logo-wrapper a.navbar-toggler
{
    position: absolute;
    top: 7px;
    right: 23px;
}

.brand-sidebar .logo-wrapper a.navbar-toggler i
{
    font-size: 15px;
    line-height: 56px;

    display: block;

    height: 56px;

    color: #333;
}

.brand-sidebar span.logo-text
{
    font-size: 24px;

    visibility: visible;

    padding-left: 8px;
    transition: opacity .2s linear;

    opacity: 1;
}

.brand-sidebar .brand-logo
{
    font-size: 2.1rem;
    line-height: 0;

    position: absolute;

    display: inline-block;

    margin: 1px 0;
    padding: 22px 12px 22px 22px;

    color: #333;
}

.brand-sidebar .brand-logo img
{
    height: 18px;
}

.brand-sidebar .brand-logo.center
{
    left: 50%;
    transform: translateX(-50%);
}

@media only screen and (max-width: 992px)
{
    .brand-sidebar .brand-logo
    {
        left: 50%;
        transform: translateX(-50%);
    }
    .brand-sidebar .brand-logo.left,
    .brand-sidebar .brand-logo.right
    {
        padding: 0;
        transform: none;
    }
    .brand-sidebar .brand-logo.left
    {
        left: .5rem;
    }
    .brand-sidebar .brand-logo.right
    {
        right: .5rem;
        left: auto;
    }
}

.brand-sidebar .brand-logo.right
{
    right: .5rem;

    padding: 0;
}

.brand-sidebar .brand-logo i,
.brand-sidebar .brand-logo [class^='mdi-'],
.brand-sidebar .brand-logo [class*='mdi-'],
.brand-sidebar .brand-logo i.material-icons
{
    float: left;

    margin-right: 15px;
}

.sidenav
{
    top: 64px;

    overflow: hidden;

    width: inherit;
    height: 100%;
    padding-bottom: 65px;
    transition: auto !important;

    border: none;
    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, .2);
    backface-visibility: hidden;
}

.sidenav.native-scroll
{
    overflow-y: scroll !important;
}

.sidenav a
{
    line-height: 42px;

    height: 42px;
}

.sidenav .navigation-header
{
    font-size: .85rem;
    font-weight: 600;

    margin-top: 10px;
    padding: 0 23px;

    text-transform: uppercase;
}

.sidenav .navigation-header .navigation-header-icon
{
    display: none;
}

.sidenav .navigation-header .navigation-header-text
{
    font-size: .85rem;
    font-weight: 600;
    line-height: 30px;

    height: 30px;
    margin: 0;
    padding: 0 !important;

    color: #969696;
}

.sidenav .navigation-header .navigation-header-text:hover
{
    background-color: transparent !important;
}

.sidenav li
{
    line-height: 44px;

    padding: 0;
}

.sidenav li a
{
    margin-right: 1.5rem;

    color: rgba(0, 0, 0, .87);
}

.sidenav li a i
{
    font-size: 1.4rem;
    line-height: inherit;

    display: block;
    float: left;

    width: 2rem;
    margin-right: 1rem;

    text-align: center;
}

.sidenav .collapsible-header
{
    font-weight: 400;
    /* Sidebar nav open close icons*/
}

.sidenav .collapsible-header:after
{
    font-family: 'Material Icons';
    font-size: 18px;

    position: absolute;
    right: 0;

    content: 'keyboard_arrow_right';
    transition: transform .3s ease-in-out, opacity .25s ease-in-out .1s;

    color: #afafaf;
}

.sidenav .collapsible-header.active:after
{
    content: 'keyboard_arrow_down';
}

.sidenav li .collapsible-body
{
    background: transparent;
}

.sidenav li .collapsible-body a i
{
    font-size: .7rem;
}

.sidenav li a.active
{
    margin: 0;

    color: #fff;
    background:         linear-gradient(45deg, #8e24aa, #ff6e40);
    box-shadow: 3px 3px 20px 0 rgba(255, 110, 64, .5);
}

.sidenav li a.active i
{
    color: #fff;
}

.sidenav li:not(.active).open
{
    background-color: rgba(0, 0, 0, .035);
}

.sidenav li.active
{
    background-color: transparent;
}

.sidenav li.active > .collapsible-header:after
{
    transform: rotate(90deg);
}

.sidenav li.open
{
    background: rgba(0, 0, 0, .035);
}

.sidenav li > a,
.sidenav li a.collapsible-header
{
    font-weight: 400;
    line-height: 44px;

    height: 44px;
    padding: 0 16px !important;
}

.sidenav li > a > i.material-icons,
.sidenav li a.collapsible-header > i.material-icons
{
    line-height: 44px;

    height: 44px;
    margin: 0 20px 0 0;
}

.sidenav li > a:not(.active):hover
{
    background-color: rgba(0, 0, 0, .035) !important;
}

.sidenav .collapsible-body > ul:not(.collapsible) > li.active,
.sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active
{
    background-color: #e6b5ee;
}

.sidenav .collapsible-body > ul:not(.collapsible) > li.active a,
.sidenav .collapsible-body > ul:not(.collapsible) > li.active i,
.sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active a,
.sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active i
{
    color: #9c27b0;
    background: none;
}

.nav-expanded .sidenav .menu-title
{
    visibility: visible;
    transition: opacity .2s linear;

    opacity: 1;
}

.nav-expanded .navigation-header-text
{
    display: block;
}

.nav-expanded .navigation-header-icon
{
    display: none;
}

.nav-collapsed.sidenav-main
{
    width: 64px;
}

.nav-collapsed .brand-sidebar .navbar-toggler,
.nav-collapsed .brand-sidebar .brand-logo span
{
    visibility: hidden;
    transition: visibility 0s 2s, opacity .05s linear;

    opacity: 0;
}

.nav-collapsed .brand-sidebar .brand-logo
{
    padding: 22px 12px 22px 15px;
}

.nav-collapsed .navigation-header-text
{
    display: none;
}

.nav-collapsed .navigation-header-icon
{
    display: block !important;
}

.nav-collapsed .sidenav .user-options,
.nav-collapsed .sidenav .menu-title,
.nav-collapsed .sidenav .collapsible-body span,
.nav-collapsed .sidenav .collapsible-header:after
{
    display: none;
}

.nav-collapsed .sidenav .menu-title
{
    visibility: visible;
    transition: opacity .2s linear;

    opacity: 1;
}

.nav-lock .navigation-header-icon
{
    display: none;
}

.nav-collapsible.nav-collapsed span.badge.pill
{
    visibility: hidden;
    transition: visibility 0s 2s, opacity .05s linear;

    opacity: 0;
}

.nav-collapsible span.badge
{
    color: #fff;
}

.nav-collapsible span.badge.pill
{
    position: absolute;
    right: 4px;

    visibility: visible;
    float: none;
    transition: opacity .2s linear;

    opacity: 1;
}

.sidenav-dark
{
    background: #2c323f;
}

.sidenav-dark .brand-sidebar
{
    background: #2c323f;
    box-shadow: 0 -4px 7px 1px rgba(0, 0, 0, .2);
}

.sidenav-dark.sidenav-main .sidenav
{
    background-color: transparent;
}

.sidenav-dark.sidenav-main .sidenav .collapsible-body > ul:not(.collapsible) > li.active,
.sidenav-dark.sidenav-main .sidenav.fixed .collapsible-body > ul:not(.collapsible) > li.active
{
    background: #9c27b0;
}

.sidenav-dark.sidenav-main .sidenav li .navigation-header-text
{
    color: #b0bec5;
}

.sidenav-dark.sidenav-main .sidenav li > a,
.sidenav-dark.sidenav-main .sidenav li .more-text
{
    color: #fff;
}

.sidenav-dark.sidenav-main .sidenav li > a > i,
.sidenav-dark.sidenav-main .sidenav li .more-text > i
{
    color: #fff;
}

.sidenav-dark.sidenav-main .sidenav li.bold > a:not(.active):hover,
.sidenav-dark.sidenav-main .sidenav li:not(.active).open
{
    background-color: rgba(0, 0, 0, .1) !important;
}

.sidenav-dark.sidenav-main .collapsible
{
    border: none;
}

.sidenav-dark.sidenav-main .brand-sidebar .brand-logo,
.sidenav-dark.sidenav-main .brand-sidebar .logo-wrapper a.navbar-toggler i
{
    color: #fff;
}

.sidenav-dark.sidenav-gradient .brand-sidebar
{
    background: transparent;
}

.sidenav-dark.sidenav-gradient.fixed .collapsible-body
{
    background: transparent;
}

.sidenav-dark.sidenav-gradient.sidenav-main .sidenav li .navigation-header-text
{
    color: #ececec;
}

.sidenav-dark .collapsible-header:after
{
    color: #ececec;
}

.sidenav-dark .ps__rail-y:hover
{
    background: transparent;
}

.navbar-full .brand-sidebar
{
    background: #a53394;
}

.navbar-full .brand-sidebar .brand-logo
{
    color: #fff;
}

.navbar-full .brand-sidebar .logo-wrapper a.navbar-toggler i
{
    color: #fff;
}

.sidenav-active-rounded .sidenav li > a.active
{
    margin-right: 1.15rem;

    color: #fff;
    border-radius: 0 25px 25px 0;
}

.sidenav-active-rounded .sidenav li > a.active > i
{
    color: #fff;
}

.sidenav-active-rounded .sidenav li:not(.open) > a.active
{
    color: #fff;
}

.sidenav-active-rounded .sidenav li:not(.open) > a.active > i
{
    color: #fff;
}

.sidenav-active-rounded .sidenav li > a:hover,
.sidenav-active-rounded .sidenav li > li:not(.active) > a:hover
{
    border-radius: 0 25px 25px 0;
}

.sidenav-active-rounded .sidenav li > a,
.sidenav-active-rounded .sidenav li a.collapsible-header
{
    margin-right: 1.15rem;
    padding: 0 0 0 21px !important;
    transition: none;
}

.sidenav-active-rounded .sidenav .collapsible-header:after
{
    right: 4px;
}

.sidenav-active-rounded.nav-collapsed li > a,
.sidenav-active-rounded.nav-collapsed li a.collapsible-header
{
    margin-right: 10px !important;
}

.sidenav-active-rounded.nav-collapsed li.close
{
    background-color: rgba(0, 0, 0, .08);
}

.sidenav-active-square .sidenav li > a.active
{
    margin-right: 1.15rem;

    color: #fff;
    border-radius: 0 5px 5px 0;
}

.sidenav-active-square .sidenav li > a.active > i
{
    color: #fff;
}

.sidenav-active-square .sidenav li:not(.open) > a.active
{
    color: #fff;
}

.sidenav-active-square .sidenav li:not(.open) > a.active > i
{
    color: #fff;
}

.sidenav-active-square .sidenav li > a:hover,
.sidenav-active-square .sidenav li > li:not(.active) > a:hover
{
    border-radius: 0 5px 5px 0;
}

.sidenav-active-square .sidenav li > a,
.sidenav-active-square .sidenav li a.collapsible-header
{
    margin-right: 1.15rem;
    padding: 0 0 0 21px !important;
    transition: none;
}

.sidenav-active-square .sidenav .collapsible-header:after
{
    right: 4px;
}

.sidenav-active-square.nav-collapsed li > a,
.sidenav-active-square.nav-collapsed li a.collapsible-header
{
    margin-right: 10px !important;
}

.sidenav-active-square.nav-collapsed li.close
{
    background-color: rgba(0, 0, 0, .08);
}

@media only screen and (max-width: 992px)
{
    .sidenav-main
    {
        width: auto;
        height: 0;
    }
    .sidenav-main .brand-sidebar
    {
        left: 80px;

        background: transparent;
        box-shadow: none;
    }
    .sidenav-main .brand-sidebar .navbar-toggler
    {
        display: none;
    }
    .sidenav-main .brand-sidebar .logo-wrapper
    {
        padding: 0 !important;
    }
    .sidenav-main .brand-sidebar .sidenav-trigger
    {
        top: -48px;
    }
    .sidenav-main .sidenav
    {
        top: 0;

        width: 250px;
    }
    .sidenav-main .btn-sidenav-toggle
    {
        position: relative;
        top: 10px;
        left: 10px;
    }
    .sidenav-dark.sidenav-main .sidenav
    {
        background: #2c323f;
    }
}

@media only screen and (max-width: 600px)
{
    .sidenav-main .brand-sidebar .brand-logo
    {
        padding: 16px 12px 20px 12px;
    }
    .sidenav-main .btn-sidenav-toggle
    {
        position: relative;
        top: 6px;
        left: 6px;
    }
}

@media screen and (max-width: 992px)
{
    .sidenav
    {
        padding-bottom: 0;
    }
}

@media screen and (-ms-high-contrast: active) and (min-width: 993px), screen and (-ms-high-contrast: none) and (min-width: 993px)
{
    ul#slide-out.sidenav
    {
        height: calc(100% - 64px) !important;
    }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)
{
    .sidenav .collapsible-header
    {
        /* Sidebar nav open close icons*/
    }
    .sidenav .collapsible-header:after
    {
        width: 0;

        content: '+';
    }
    .sidenav li.active > .collapsible-header:after
    {
        right: 0;

        width: 0;

        content: '-';
        transform: rotate(180deg);
    }
}

@-moz-document url-prefix()
{
    @media screen and (min-width: 993px)
    {
        ul#slide-out.sidenav
        {
            height: calc(100% - 64px) !important;
        }
    }
}

@supports (-ms-ime-align: auto)
{
    @media screen and (min-width: 993px)
    {
        ul#slide-out.sidenav
        {
            height: calc(100% - 64px) !important;
        }
    }
}

/*----------------------------------------
    Slideout - Right side chat slide out
------------------------------------------*/
#right-search .input-field
{
    margin-top: 0;
}

#slide-out-right
{
    top: 64px;

    overflow: hidden;
}

#slide-out-right .tab a
{
    padding: 0 !important;
}

#slide-out-right.sidenav
{
    top: 0;

    width: 340px;
    padding-bottom: 0;
}

#slide-out-right.sidenav li a.active
{
    background: none;
    box-shadow: none;
}

#slide-out-right.sidenav .slide-out-right-body
{
    width: 100%;
    height: 100vh;
}

#slide-out-right.sidenav #messages
{
    position: relative;

    height: calc(100vh - 54px);
    padding: .7rem;
}

#slide-out-right.sidenav #messages .header-search-input
{
    width: 86%;
    height: 2.8rem;
    margin: 1rem;
    padding-left: 1rem;

    border: none;
    border-radius: 2rem;
    background-color: #eee;
}

#slide-out-right.sidenav #messages .collection .collection-item
{
    border: none;
}

#slide-out-right.sidenav #messages .collection ul.collection
{
    border: none;
}

#slide-out-right.sidenav #messages .collection ul.collection li
{
    display:         flex;

    padding-top: 1.2rem;

    cursor: pointer;
}

#slide-out-right.sidenav #messages .collection ul.collection li .user-content
{
    margin-top: .4em;
    margin-left: 1rem;
}

#slide-out-right.sidenav #messages .collection ul.collection li .secondary-content
{
    top: 1.6rem;

    color: #c5cae9;
}

#slide-out-right.sidenav #messages .collection ul.collection li:hover
{
    background-color: #f5f5f5;
}

#slide-out-right.sidenav #activity
{
    position: relative;

    height: calc(100vh - 54px);
}

#slide-out-right.sidenav #settings
{
    position: relative;

    height: calc(100vh - 54px);
}

#slide-out-right .fixed-line-height
{
    line-height: 24px;
}

#slide-out-right #chatapp li
{
    line-height: 35px !important;

    min-height: 70px !important;
}

#slide-out-right #chatapp .sidenav li
{
    line-height: 20px !important;
}

.chat-close-collapse
{
    padding: 5px 15px 0 0;
}

.icon-bg-color
{
    font-size: 20px;

    width: 35px;
    height: 35px;
    padding-top: 8px;

    text-align: center;

    border-radius: 50%;
}

.border-bottom-1
{
    border-bottom: 1px solid #f5f5f5;
}

#activity
{
    /* Timeline  */
    /* -------- */
}

#activity .widget-timeline
{
    margin: .5rem 5%;
    padding-left: 40px !important;
}

#activity .widget-timeline li
{
    position: relative;

    padding: 1.1rem 0;

    list-style: none;
}

#activity .widget-timeline li.timeline-items:before
{
    position: absolute;
    z-index: 2;
    top: 22px;
    left: -37px;

    width: 13px;
    height: 13px;

    content: '';

    border: 3px solid #fff;
    border-radius: 50%;
    background: #3f51b5;
    box-shadow: 1px 2px 6px 0 rgba(25, 42, 70, .3);
}

#activity .widget-timeline li.timeline-items.active:not(:last-child):after
{
    position: absolute;
    z-index: 1;
    top: 22px;
    left: -31px;

    width: 1px;
    height: 100%;

    content: '';

    background: #e0e0e0;
}

#activity .widget-timeline li.timeline-items .timeline-content
{
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    display:         flex;

    padding: .5rem 1rem;

    color: #9e9e9e;
    border-radius: .267rem;
    background-color: #fafafa;
    align-items: center;
}

#activity .widget-timeline li .timeline-time
{
    font-size: .75rem;
    line-height: 1.7;

    float: right;
}

#activity .widget-timeline li .timeline-title
{
    font-size: 15px;
    font-weight: 900;
    line-height: 1;

    margin: 0;

    color: #6b6f82;
}

#activity .widget-timeline li .timeline-text
{
    font-size: .75rem;
    line-height: 2.2;

    margin: 0;

    color: #9e9e9e;
}

.slide-out-right-sidenav-chat
{
    top: 0;

    width: 340px;
}

#settings .setting-header
{
    font-size: 1.1rem;
}

#settings ul.collection
{
    max-height: 100% !important;
}

@media only screen and (max-width: 992px)
{
    #slide-out-right
    {
        top: 0;
    }
    #slide-out-right.sidenav
    {
        height: 100% !important;
    }
}

#slide-out-chat .chat-head,
#slide-out-chat .chat-footer
{
    z-index: 1;

    width: 100%;

    background-color: #eceff1;
}

#slide-out-chat .chat-footer
{
    bottom: -.6rem;
}

#slide-out-chat .chat-footer form
{
    background-color: #eceff1;
}

#slide-out-chat .chat-footer input
{
    width: 80%;
    margin-left: -2rem;
    padding-left: 1rem;

    border: none;
    border-radius: 3rem;
    background-color: #fff;
}

#slide-out-chat .chat-footer label
{
    margin-top: -.7rem;
    margin-left: 2rem;
}

#slide-out-chat .chat-footer label:not(.label-icon).active
{
    display: none;
}

#slide-out-chat .chat-footer i
{
    cursor: pointer;
}

#slide-out-chat .chat-footer a
{
    line-height: 2rem;

    position: absolute;

    width: 40px;

    background: transparent;
    box-shadow: none;
}

#slide-out-chat .speech-bubble
{
    position: relative;

    margin-left: 1rem;

    border-radius: .3rem;
    background: #eceff1;
}

#slide-out-chat .speech-bubble:after
{
    position: absolute;
    top: 50%;
    left: -9px;

    width: 0;
    height: 0;
    margin-top: -20px;

    content: '';

    border: 10px solid transparent;
    border-right-color: #eceff1;
    border-left: 0;
}

#slide-out-chat .speech-bubble-right
{
    position: relative;

    margin-left: 1rem;

    color: #fff;
    border-radius: .3rem;
    background-color: #9c27b0;
}

#slide-out-chat .speech-bubble-right:after
{
    position: absolute;
    top: 50%;
    right: 0;

    width: 0;
    height: 0;
    margin-top: -16px;
    margin-right: -8px;

    content: '';

    border: 10px solid transparent;
    border-right: 0;
    border-left-color: #9c27b0;
}

#slide-out-chat .chat-body ul.collection
{
    top: 0;

    margin-top: 0;
    margin-bottom: 0;
}

#slide-out-chat .collection
{
    top: 48px;

    height: calc(100vh - 129px);
}

#slide-out-chat .collection .collection-item
{
    min-height: auto;
    margin-bottom: 1rem;

    border: none;
}

#slide-out-chat .collection .collection-item .user-content
{
    padding: 1rem;
}

@media (max-width: 600px)
{
    #slide-out-right.sidenav
    {
        box-shadow: none;
    }
}

/*----------------------------------------
	Breadcrumb
------------------------------------------*/
#breadcrumbs-wrapper
{
    padding: 20px 0;

    background: transparent;
}

#breadcrumbs-wrapper .breadcrumbs-btn
{
    top: 24px;
}

#breadcrumbs-wrapper h5.breadcrumbs-header
{
    font-size: 1.64rem;
    line-height: 1.804rem;

    margin: 1.5rem 0 0 0;
}

#breadcrumbs-wrapper .breadcrumbs
{
    margin: 15px 0;
    padding: 0;

    list-style: none;
}

#breadcrumbs-wrapper .breadcrumbs > li
{
    display: inline-block;
}

#breadcrumbs-wrapper .breadcrumbs > li + li::before
{
    font-family: 'Material Icons';

    position: relative;
    top: 3px;

    padding: 0 5px 0 4px;

    content: 'keyboard_arrow_right';

    color: #bdbdbd;
}

#breadcrumbs-wrapper .breadcrumbs .active
{
    font-weight: normal;

    color: #9e9e9e;
}

#breadcrumbs-wrapper .breadcrumbs-title
{
    font-size: 1.4rem;
    line-height: 1.4rem;
}

#breadcrumbs-wrapper .breadcrumbs-nav
{
    margin: 8px 0 9px;
}

#breadcrumbs-wrapper.breadcrumbs-bg-image
{
    position: relative;
    z-index: 1;

    color: #fff;
    background-position: center center;
    background-size: cover;
}

#breadcrumbs-wrapper.breadcrumbs-bg-image .breadcrumbs-title
{
    color: #fff;
}

#breadcrumbs-wrapper.breadcrumbs-bg-image .breadcrumbs
{
    margin: 10px 0;
}

#breadcrumbs-wrapper.breadcrumbs-bg-image .breadcrumbs a
{
    color: rgba(255, 255, 255, .8);
}

#breadcrumbs-wrapper.breadcrumbs-bg-image .breadcrumbs .active
{
    color: rgba(255, 255, 255, .9);
}

#breadcrumbs-wrapper.breadcrumbs-bg-image::before
{
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    content: '';

    background-color: rgba(0, 0, 0, .07);
}

#breadcrumbs-wrapper.breadcrumbs-dark .breadcrumbs-title,
#breadcrumbs-wrapper.breadcrumbs-dark a
{
    color: rgba(255, 255, 255, .85);
}

#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs-title,
#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs
{
    display: inline;
}

#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs-left
{
    position: relative;
    top: 8px;
}

#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs-title
{
    padding-right: 20px;

    border-right: 1px solid #bdbdbd;
}

#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs
{
    padding-left: 20px;
}

#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs-btn
{
    top: 0;
}

#breadcrumbs-wrapper .breadcrumbs-right .breadcrumbs
{
    float: right;

    margin-top: 0;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)
{
    #breadcrumbs-wrapper .breadcrumbs > li + li::before
    {
        top: 0;

        width: 0;

        content: '/';
    }
}

/*----------------------------------------
    Forms
------------------------------------------*/
.input-field div.error
{
    font-size: .8rem;

    position: relative;
    top: 0rem;
    left: 0rem;
    transform: translateY(0%);

    color: #ff4081;
}

.input-field label.active
{
    width: 100%;
}

.left-alert input[type=text] + label:after,
.left-alert input[type=password] + label:after,
.left-alert input[type=email] + label:after,
.left-alert input[type=url] + label:after,
.left-alert input[type=time] + label:after,
.left-alert input[type=date] + label:after,
.left-alert input[type=datetime-local] + label:after,
.left-alert input[type=tel] + label:after,
.left-alert input[type=number] + label:after,
.left-alert input[type=search] + label:after,
.left-alert textarea.materialize-textarea + label:after
{
    left: 0;
}

.right-alert input[type=text] + label:after,
.right-alert input[type=password] + label:after,
.right-alert input[type=email] + label:after,
.right-alert input[type=url] + label:after,
.right-alert input[type=time] + label:after,
.right-alert input[type=date] + label:after,
.right-alert input[type=datetime-local] + label:after,
.right-alert input[type=tel] + label:after,
.right-alert input[type=number] + label:after,
.right-alert input[type=search] + label:after,
.right-alert textarea.materialize-textarea + label:after
{
    right: 70px;
}

.select2-icons + .select2-container--default .select2-selection__rendered,
.select2-icons + .select2-container--default .select2-selection__choice
{
    display:         flex !important;

    padding-bottom: 5px !important;
    align-items: center;
}

.select2-icons + .select2-container--default .select2-selection__rendered i,
.select2-icons + .select2-container--default .select2-selection__choice i
{
    margin-right: 1rem;
}

.select2-results .select2-results__option i
{
    position: relative;
    top: 7px;

    margin-right: 1rem;
}

.btn-toolbar
{
    display:         flex;
    flex-wrap: wrap;
}

.btn-toolbar .btn-group-sm
{
    display:         flex;

    margin-bottom: .5rem;
}

.btn-toolbar .btn-group-sm .btn
{
    line-height: 0;

    height: 28px;
    margin-right: 1rem;
    padding: 0 1rem;
}

.select2-selection.select-lg
{
    font-size: 1.2rem;

    min-height: calc(1.4em + 1.334rem + 3.7px) !important;
    margin-bottom: 0 !important;
}

.select2-selection.select-lg .select2-selection__rendered
{
    line-height: 28px;
}

.select2-selection.select-sm
{
    font-size: .75rem;
    line-height: 1.5;

    min-height: calc(1.1em + .94rem + 3.7px) !important;
    margin-bottom: 0 !important;
    padding: 0 .2rem;
}

/*----------------------------------------
    Tables
------------------------------------------*/
table.dataTable.dtr-inline.collapsed > tbody > tr[role='row'] > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr[role='row'] > th:first-child:before
{
    line-height: 15px;

    top: 19px;

    text-indent: -1px !important;
}

table.bordered th,
table.bordered td
{
    padding: 15px !important;

    border: 1px solid rgba(0, 0, 0, .12) !important;
}

/*----------------------------------------
Cards
------------------------------------------*/
.card
{
    margin: 1rem 0 1rem 0;
}

.card .card-title
{
    font-size: 18px;
    font-weight: 400;

    margin: 0;
}

.card .activator
{
    cursor: pointer;
}

.card .card-action
{
    overflow: hidden;
}

#card-stats .card-content
{
    text-align: center;
}

#card-stats .card-stats-title
{
    font-size: 1rem;
}

#card-stats .card-stats-title i
{
    font-size: 1.2rem;

    position: relative;
    top: 3px;
}

#card-stats .card-stats-compare
{
    font-size: .85rem;
}

#card-stats .card-stats-compare i
{
    position: relative;
    top: 8px;
}

#card-stats .card-stats-number
{
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 2rem;

    margin: .8rem 0 .6rem 0;
}

#card-stats .card .card-content
{
    padding: 10px 14px;
}

#card-stats .card .card-action
{
    overflow: hidden;

    padding: 10px 14px;
}

.vertical-align-top
{
    vertical-align: top;
}

.card-animation-1,
.image-n-margin
{
    margin-top: -50px;
    /* Safari */
    transition: .5s;
}

.card-animation-1:hover .image-n-margin
{
    margin-top: -80px;
    margin-bottom: 30px;

    cursor: pointer;
    transition: .5s;
}

/* alert card */
.card-alert .card-content
{
    padding: 10px 20px;
}

.card-alert i
{
    font-size: 20px;

    position: relative;
    top: -1px;

    vertical-align: middle;
}

.card-alert .alert-circle
{
    position: relative;
    top: 0;
    left: -2px;

    display: inline-block;

    width: 40px;

    vertical-align: bottom;
    white-space: nowrap;

    border-radius: 1000px;
}

.card-alert .single-alert
{
    line-height: 42px;
}

.card-alert button
{
    font-size: 20px;

    position: absolute;
    top: 5px;
    right: 10px;

    color: #fff;
    border: none;
    background: none;
}

.card-alert .card .card-content
{
    padding: 20px 40px 20px 20px;
}

.card-alert .card-action i
{
    top: 0;

    margin: 0;
}

/* work card */
#work-collections .collection-header
{
    font-size: 1.14rem;
    font-weight: 500;
}

#work-collections p.collections-title
{
    font-size: 1rem;
    font-weight: 500;

    margin: 0;
    padding: 0;
}

#work-collections p.collections-content
{
    font-size: .9rem;
    font-weight: 400;

    margin: 0;
    padding: 0;
}

#work-collections .collection-item.avatar
{
    height: auto;
    padding-top: 22px;
}

/* flight card */
#flight-card .flight-card-title
{
    font-weight: 300;

    margin: 0;

    color: #fff;
}

#flight-card .flight-card-date
{
    font-size: 1rem;

    margin: 0;

    color: #fff;
}

#flight-card .flight-state
{
    padding-bottom: 15px;
}

#flight-card .flight-state-two
{
    border-left: 1px dashed #bdbdbd;
}

#flight-card .flight-icon
{
    font-size: 2.2rem;

    display: block;

    -webkit-transform: rotate(90deg);
       -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
         -o-transform: rotate(90deg);
}

#flight-card .card-content-bg
{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center;
    background-size: cover;
}

#flight-card .card-content
{
    background: rgba(0, 0, 0, .25);
}

#flight-card .flight-state-wrapper
{
    margin: 0 0 80px 0 !important;
}

#flight-card .card-header .card-title
{
    padding: 20px;
}

/* task card */
#task-card label
{
    display: block;

    height: auto;

    color: rgba(0, 0, 0, .87);
}

#task-card .task-card-title
{
    font-weight: 300;

    margin: 0;

    color: #fff;
}

#task-card .task-card-date
{
    font-size: 1rem;

    margin: 0;

    color: #fff;
}

#task-card .collection-header
{
    padding: 20px;
}

#task-card .task-add
{
    position: absolute;
    top: 76px;
    right: 10px;
}

#task-card .task-cat
{
    font-size: .8rem;
    font-weight: 300;

    margin-left: 37px;
    padding: 2px 4px;

    color: #fff;
    border-radius: 2px;
    background-clip: padding-box;
}

.task-cat
{
    font-size: .8rem;
    font-weight: 300;

    padding: 2px 4px;

    color: #fff;
    border-radius: 2px;
    background-clip: padding-box;
}

.collection .collection-item.avatar i.circle
{
    font-size: 28px;
}

/* profile card */
#profile-card .card-image
{
    height: 150px;
}

#profile-card .card-profile-image
{
    position: absolute;
    z-index: 1;
    top: 110px;

    width: 70px;

    cursor: pointer;
}

#profile-card .btn-move-up
{
    position: relative;
    top: -40px;
    right: -18px;

    margin-right: 10px !important;
}

#profile-card .card-content .profile-card-i
{
    position: relative;
    top: 6px;

    margin-right: 10px;
}

#profile-card .card-content p
{
    font-size: 1rem;

    margin: 10px 0 12px;
}

.card-move-up .move-up
{
    padding: 20px;
}

.black-overlay
{
    background-color: rgba(0, 0, 0, .42) !important;
}

.bg-image-1
{
    width: 100%;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: cover;
}

.bg-image-2
{
    width: 100%;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-size: cover;
}

.bg-image-3
{
    width: 100%;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-size: cover;
}

.icon-background
{
    width: 50px;
    height: 50px;
    margin: 8px;
    padding-top: 11px;
}

#profile-card .card-reveal i.material-icons
{
    position: relative;
    top: 6px;
}

#user-card .flip-card
{
    max-width: 100%;
}

@media screen and (min-width: 1290px)
{
    .icon-background
    {
        width: 3.125rem;
        height: 3.125rem;
        margin: 1.25rem;
        margin-left: 2rem;
        padding-top: .6875rem;
    }
}

@media screen and (max-width: 1366px)
{
    .icon-background
    {
        margin-left: 1.25rem;
    }
}

@media screen and (min-width: 1440px)
{
    .icon-background
    {
        margin-left: 2rem;
    }
}

@media screen and (min-width: 1680px)
{
    .icon-background
    {
        margin-left: 2.6875rem;
    }
}

@media screen and (min-width: 1024px) and (max-width: 1365px)
{
    .icon-background
    {
        margin-left: .25rem;
    }
}

@media screen and (max-width: 992px)
{
    .icon-background
    {
        margin-left: 1.875rem;
    }
}

@media screen and (max-width: 786px)
{
    .icon-background
    {
        margin-left: .9375rem;
    }
}

@media screen and (max-width: 540px)
{
    .icon-background
    {
        margin-left: .625rem;
    }
}

.small-ico-bg
{
    padding: 6px;

    border-radius: 50%;
    background-color: #f3f1f1;
}

@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px)
{
    #cards-extended #gradient-Analytics .card-width,
    #cards-extended #card-with-analytics .card-width,
    #cards-extended #card-panel-type .card-width
    {
        width: 50%;
    }
}

/*----------------------------------------
    Charts
------------------------------------------*/
#card-stats
{
    padding-top: 12px;
}

#chart-dashboard .card
{
    overflow: hidden;
}

#chart-dashboard .card .card-content
{
    padding: 10px 14px;
}

#chartjs .sample-chart-wrapper,
#chartjs2 .sample-chart-wrapper,
#chartjs3 .sample-chart-wrapper
{
    margin-top: -75px;
    margin-bottom: -14px;
}

.sample-chart-wrapper
{
    width: 100%;
}

.chart-title
{
    font-size: 1.6rem;
    font-weight: 300;
}

/* Revenue Chart */
.chart-revenue
{
    float: right;

    padding: 8px;

    text-align: center;

    border-radius: 3px;
}

.chart-revenue .chart-revenue-total
{
    font-size: .9rem;

    margin: 0;
}

.chart-revenue .chart-revenue-per
{
    font-size: .8rem;

    margin: 0;
}

.chart-revenue .chart-revenue-per i
{
    position: relative;
    top: 5px;
}

.chart-revenue-switch
{
    padding-top: 28px;
    padding-right: 10px;

    text-align: right;

    color: #fff;
}

#materialize-chartist .ct-chart-line,
#materialize-chartist .ct-chart-bar,
#materialize-chartist .ct-chart-pie,
#materialize-chartist .ct-chart-donut
{
    height: 400px !important;
}

/* doughnut chart */
.doughnut-chart-status
{
    font-size: 16px;
    font-weight: 500;

    position: relative;
    top: -75px;
    left: 0;

    height: 0;

    text-align: center;
}

.doughnut-chart-status p
{
    margin-top: -5px;
}

.doughnut-chart-legend li
{
    font-size: .9rem;

    padding: 2px 0;
}

.doughnut-chart-legend li:before
{
    display: block;
    float: left;

    width: 8px;
    height: 8px;
    margin-top: 6px;
    margin-right: 4px;

    content: '';
}

a.button-collapse.top-nav
{
    font-size: 32px;

    position: absolute;
    z-index: 2;
    top: 0;
    left: 7.5%;

    float: none;

    margin-left: 1.5rem;

    color: #fff;
}

/* trending bar chart */
.trending-bar-chart-wrapper
{
    width: 100%;
}

.btn-move-up
{
    position: relative;
    top: -28px;
    right: -18px;

    margin-right: 10px !important;
}

/*Sparkline*/
.jqstooltip
{
    box-sizing: content-box;

    border: none !important;
}

.tooltip-class
{
    overflow: hidden;

    width: 30px;
    height: 20px;

    color: #fff;
}

#ct2-chart .ct-series.ct-series-a .ct-area
{
    fill: #00bcd4;
}

#ct2-chart .ct-series.ct-series-a .ct-point
{
    stroke: #00bcd4;
}

#ct2-chart .ct-series.ct-series-a .ct-line
{
    stroke: #54e2f4;
}

/*  Widget */
.socialbox .logo
{
    font-size: 28px;

    position: absolute;
    bottom: 20px;
    left: 20px;

    color: #fff;
}

.socialbox .info
{
    font-size: 15px;

    position: absolute;
    right: 20px;
    bottom: 20px;

    margin: 0;
    padding: 0;

    color: #fff;
}

.chartist-tooltip.tooltip-show
{
    display: inline-block;
}

.chartist-tooltip
{
    display: none;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px)
{
    .doughnut-chart-status
    {
        display: none;
    }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px)
{
    .doughnut-chart-status
    {
        display: none;
    }
    #card-stats .card-stats-compare
    {
        font-size: .8rem;
    }
}

/*----------------------------------------
    Calender
------------------------------------------*/
#full-calendar
{
    padding-top: 30px;
}

#calendar h2
{
    font-size: 1.5rem;
    line-height: 35px;

    text-transform: uppercase;
}

#calendar .fc-day-header
{
    font-weight: 400;

    text-transform: uppercase;
}

#external-events
{
    padding-top: 50px;
}

#external-events .fc-event
{
    margin-bottom: 10px;
    padding: 5px;

    cursor: all-scroll;
    text-decoration: none;

    color: #fff;
    border: none;
}

.fc button
{
    background: #fff;
}

.fc td
{
    border-width: 0 !important;
}

.fc th
{
    border-width: 0 !important;
}

.fc-state-active
{
    color: #9c27b0 !important;
}

.fc-state-down
{
    color: #9c27b0 !important;
}

/*
* Custom Animations
*/
@keyframes fadeUp
{
    0%
    {
        transform: translateY(30px);

        opacity: 0;
    }
    100%
    {
        transform: translateY(0px);

        opacity: 1;
    }
}

.animate.fadeUp
{
    animation: fadeUp;
    animation-duration: 1.5s;
    animation-fill-mode: both;
}

@keyframes fadeLeft
{
    0%
    {
        transform: translateX(-30px);

        opacity: 0;
    }
    100%
    {
        transform: translateX(0px);

        opacity: 1;
    }
}

.animate.fadeLeft
{
    animation: fadeLeft;
    animation-duration: 1.5s;
    animation-fill-mode: both;
}

@keyframes fadeRight
{
    0%
    {
        transform: translateX(30px);

        opacity: 0;
    }
    100%
    {
        transform: translateX(0px);

        opacity: 1;
    }
}

.animate.fadeRight
{
    animation: fadeRight;
    animation-duration: 1.5s;
    animation-fill-mode: both;
}

.animation-fast
{
    animation-delay: .1s;
}

.animation-slow
{
    animation-delay: 2s;
}

.delay-1
{
    animation-delay: .3s !important;
}

.delay-2
{
    animation-delay: .4s !important;
}

.delay-3
{
    animation-delay: .5s !important;
}

.delay-4
{
    animation-delay: .6s !important;
}

.delay-5
{
    animation-delay: .7s !important;
}

/*----------------------------------------
  Miscellaneous CSS for demo purpose only
------------------------------------------*/
.dynamic-color .red,
.dynamic-color .pink,
.dynamic-color .purple,
.dynamic-color .deep-purple,
.dynamic-color .indigo,
.dynamic-color .blue,
.dynamic-color .light-blue,
.dynamic-color .cyan,
.dynamic-color .teal,
.dynamic-color .green,
.dynamic-color .light-green,
.dynamic-color .lime,
.dynamic-color .yellow,
.dynamic-color .amber,
.dynamic-color .orange,
.dynamic-color .deep-orange,
.dynamic-color .brown,
.dynamic-color .grey,
.dynamic-color .blue-grey
{
    font-size: 12px;
    font-weight: 500;
    line-height: 55px;

    display: block;

    box-sizing: border-box;
    width: 100%;
    height: 55px;
    padding: 0 15px;
}

.dynamic-color .col
{
    margin-bottom: 55px;
}

tr.group
{
    background-color: #ddd !important;
}

tr.group:hover
{
    background-color: #ddd !important;
}

@media only screen and (max-width: 1024px)
{
    tfoot
    {
        display: none;
    }
}

/*----------------------------------------
    Grid - Flat Site Mockup
------------------------------------------*/
.site-layout-example-left
{
    height: 300px;

    background-color: #90a4ae;
}

.site-layout-example-right
{
    height: 300px;

    background-color: #00bfa5;
}

.site-layout-example-top
{
    height: 50px;

    background-color: #ff5252;
}

.flat-text-header
{
    display: block;

    width: 80%;
    height: 35px;
    margin: 27px auto;

    background-color: rgba(255, 255, 255, .15);
}

.flat-text
{
    display: block;

    width: 80%;
    height: 25px;
    margin: 27px auto;

    background-color: rgba(0, 0, 0, .15);
}

.flat-text.small
{
    width: 25%;
    height: 25px;

    background-color: rgba(0, 0, 0, .15);
}

.flat-text.full-width
{
    width: 100%;
}

.col.grid-example
{
    font-size: 28px;
    line-height: 50px;

    margin: 7px 0;
    padding: 0;

    text-align: center;

    color: #fff;
    border: 1px solid #eee;
    background-color: #ff6347;
}

.col.grid-example span
{
    font-weight: 200;
    line-height: 50px;
}

.waves-color-demo .collection-item
{
    line-height: 57px;

    height: 57px;
}

.collection a.collection-item:not(.active):hover
{
    background-color: #f9f9f9;
}

/*----------------------------------------
    Chrome Browser Grid Example
------------------------------------------*/
.browser-window
{
    display: inline-block;
    overflow: hidden;

    width: 100%;
    height: auto;
    margin: 20px 0;

    text-align: left;

    border-radius: 5px 5px 2px 2px;
    background-color: transparent;
    background-clip: padding-box;
}

.browser-window .top-bar
{
    height: 30px;

    border-top: thin solid #eaeae9;
    border-bottom: thin solid #ddd;
    border-radius: 5px 5px 0 0;
    background:         linear-gradient(#e7e7e6, #e0e0e0);
    background-clip: padding-box;
}

.browser-window .circle
{
    display: inline-block;

    width: 10px;
    height: 10px;
    margin-right: 1px;

    border-radius: 50%;
}

.browser-window .circles
{
    margin: 5px 12px;
}

.browser-window .content
{
    display: inline-block;

    width: 100%;
    margin: 0;

    border-radius: 0 0 5px 5px;
    background-color: #fafafa;
}

.browser-window .row
{
    margin: 0;
}

.close-circle
{
    background-color: #ff5c5a;
}

.minimize-circle
{
    background-color: #fdb45c;
}

.maximize-circle
{
    background-color: #1bc656;
}

.clear
{
    clear: both;
}

.promo i
{
    font-size: 6rem;

    display: block;

    color: #ee6e73;
}

.promo-caption
{
    font-size: 1.7rem;
    font-weight: 500;

    margin-top: 5px;
    margin-bottom: 0;
}

/*----------------------------------------
    Shadow effect
------------------------------------------*/
.shadow-demo
{
    width: 100px;
    height: 100px;
    margin: 20px auto;

    background-color: #26a69a;
}

#input-select .input-field label
{
    font-size: .8rem;

    position: absolute;
    top: -14px;
}

/*----------------------------------------
    Footer
------------------------------------------*/
.page-footer.footer-fixed
{
    position: fixed;
    bottom: 0;

    width: 100%;
}

.page-footer .container
{
    padding: 0 15px;
}

.page-footer .footer-copyright
{
    background-color: transparent;
}

#world-map-markers
{
    height: 300px;
}

#polar-chart-holder
{
    padding-top: 20px;
}

.footer-light
{
    background-color: #fff;
}

.footer-light.page-footer
{
    border-top: 1px solid #d2d2d2 !important;
}

.footer-light .footer-copyright
{
    color: rgba(0, 0, 0, .87);
}

.footer-dark
{
    background: #37474f;
}

.footer-dark .footer-copyright
{
    color: rgba(255, 255, 255, .8);
}

.footer-dark .footer-copyright a
{
    color: #fff;
}

/*---------------------------------
    Theme Customizer
-----------------------------------*/
.btn-customizer
{
    padding: 0 1rem;
}

.btn-customizer i
{
    animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin
{
    0%
    {
        transform: rotate(0deg);
    }
    100%
    {
        transform: rotate(359deg);
    }
}

.theme-cutomizer
{
    z-index: 99999;
    top: 0;

    width: 360px;
}

.theme-cutomizer .sidenav-close
{
    position: absolute;
    top: 5px;
    right: 10px;
}

.theme-cutomizer .customize-devider
{
    border: 1px solid #e4e4e4;
}

.theme-cutomizer .menu-options .menu-color-option,
.theme-cutomizer .menu-options .menu-bg-color-option,
.theme-cutomizer .menu-options .navbar-color-option,
.theme-cutomizer .navbar-options .menu-color-option,
.theme-cutomizer .navbar-options .menu-bg-color-option,
.theme-cutomizer .navbar-options .navbar-color-option
{
    display: inline-block;

    width: 24px;
    height: 24px;
    margin-right: 8px;
    margin-bottom: 10px;

    cursor: pointer;

    border: 3px solid #fff;
    border-radius: 12px;
}

.theme-cutomizer .menu-options .menu-color-option.selected,
.theme-cutomizer .menu-options .menu-bg-color-option.selected,
.theme-cutomizer .menu-options .navbar-color-option.selected,
.theme-cutomizer .navbar-options .menu-color-option.selected,
.theme-cutomizer .navbar-options .menu-bg-color-option.selected,
.theme-cutomizer .navbar-options .navbar-color-option.selected
{
    box-shadow: 0 0 10px 3px #03a9f4;
}

.btn-buy-now
{
    position: fixed;
    z-index: 99;
    top: 50%;
    right: -2px;

    padding: 0 1rem;
}

.buy-now-animated
{
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
}

@keyframes tada
{
    0%
    {
        transform: scale3d(1, 1, 1);
    }
    10%,
    20%
    {
        transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
    }
    30%,
    50%,
    70%,
    90%
    {
        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    }
    40%,
    60%,
    80%
    {
        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    }
    100%
    {
        transform: scale3d(1, 1, 1);
    }
}

.tada
{
    animation-name: tada;
}

.theme-cutomizer-trigger
{
    position: fixed;
    z-index: 99;
    top: 40%;
    right: -2px;
}

.myBt
{
    display: none !important;
}

.luckysheet-postil-show-main{
    z-index: 1100 !important;
    min-width: 305px !important;
}
.formulaInputFocus{
    width: auto !important;
}

.luckysheet-filter-options{
    color: #000000 !important;
    cursor: pointer !important;
    position: absolute !important;
    border: 0px solid #897bff !important;
    border-radius: 3px !important;
    margin-left: 0 !important;
    padding: 0 4px !important;
    font-size: 12px !important;
    height: 15px !important;
    background: transparent !important;
}

#luckysheet-postil-overshow-style-fiki{
    z-index: 1100 !important;
    overflow-wrap: break-word !important;
    word-wrap: break-word !important; /* For older browsers */
    white-space: normal !important; /* To allow normal whitespace handling */
    width: 200px !important; /* Adjust the width to fit your layout */
    border: 1px solid #ccc !important; /* Optional border for visualization */
}

.luckysheet-freezebar-horizontal-drop{
    z-index: 1000 !important;
}

#freezen_7{
    /*z-index: 20 !important;*/
}


@keyframes loading-rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}

.loadingAnimation {
  width: 3em;
  height: 3em;
  animation: loading-rotate 2s linear infinite;
}

.loadingAnimation circle {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: currentColor;
  stroke-linecap: round;
}

.luckysheet-modal-dialog{
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/css/Style.css"],"names":[],"mappings":"AAAA;;kDAEkD;AAElD;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;CAEC;AACD;;2CAE2C;AAC3C;;;IAGI,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAGY,2BAA2B;AACvC;;AAEA;;IAEI,8BAA8B;IAC9B,eAAe;IAGP,wBAAwB;IAGxB,2BAA2B;AACvC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,OAAO;;IAEP,WAAW;IACX,aAAa;IAGL,wBAAwB;AACpC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,YAAY;;IAEZ,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI;;QAEI,WAAW;IACf;AACJ;;AAEA;;IAEI;;QAEI,8BAA8B;IAClC;AACJ;;AAEA;;IAEI;;QAEI,WAAW;IACf;IACA;;QAEI,6BAA6B;IACjC;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;IACA;;QAEI,kBAAkB;IACtB;IACA;;QAEI,mBAAmB;IACvB;IACA;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;;QAEI,SAAS;IACb;AACJ;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;;;IAKI,eAAe;;IAEf,wBAAwB;AAC5B;;AAEA;;2CAE2C;AAC3C,UAAU;AACV;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA,gBAAgB;AAChB;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA,eAAe;AACf;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA,gBAAgB;AAChB;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA,kBAAkB;AAClB;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA,mBAAmB;AACnB;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA,mBAAmB;AACnB;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI;;QAEI,2BAA2B;IAC/B;IACA;;QAEI,4BAA4B;IAChC;IACA;;QAEI,6BAA6B;IACjC;AACJ;;AAEA;;IAEI;;QAEI,2BAA2B;IAC/B;IACA;;QAEI,4BAA4B;IAChC;IACA;;QAEI,6BAA6B;IACjC;AACJ;;AAEA;;IAEI;;QAEI,2BAA2B;IAC/B;IACA;;QAEI,4BAA4B;IAChC;IACA;;QAEI,6BAA6B;IACjC;AACJ;;AAEA;;IAEI;;QAEI,2BAA2B;IAC/B;IACA;;QAEI,4BAA4B;IAChC;IACA;;QAEI,6BAA6B;IACjC;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA,0BAA0B;AAC1B;;IAEI,aAAa;;IAEb,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;;IAEI,eAAe;AACnB;;AAEA,cAAc;AACd;;IAEI,UAAU;AACd;;AAEA,8BAA8B;AAC9B;;IAEI,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,yBAAyB;AACzB;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,aAAa;AACb;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA,mBAAmB;AACnB;;IAEI,kBAAkB;IAClB,QAAQ;IAIA,2BAA2B;AACvC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;;IAEI,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;;IAEI,cAAc;;IAEd,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAKI,qBAAqB;AACzB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,kBAAkB;;IAElB,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAKY,yBAAyB;AACrC;;AAEA;;IAKY,8BAA8B;AAC1C;;AAEA;;IAKY,uBAAuB;AACnC;;AAEA;;IAKY,mBAAmB;AAC/B;;AAEA;;IAKY,YAAY;AACxB;;AAEA;;IAIY,eAAe;AAC3B;;AAEA;;YAEY,sBAAsB;AAMlC;;AAEA;;IAEI,gBAAgB;;IAEhB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;oCAEoC;AACpC;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,0CAA0C;IAC1C,mBAAmB;IACnB,gBAAgB;;IAEhB,cAAc;AAClB;;AAEA;;IAEI;;QAEI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;AACJ;;AAEA;;;;;;;IAOI,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;;IAEhB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;;;;;;IAOI,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;;IAEjB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;;IAEjB,4BAA4B;AAChC;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;;IAEjB,4BAA4B;AAChC;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;;IAEjB,2BAA2B;AAC/B;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;;IAEjB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;;IAEjB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;QAEI,kCAAkC;IACtC;IACA;;QAEI,6BAA6B;;QAE7B,kBAAkB;;QAElB,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;;IAErB,2BAA2B;;IAE3B,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;;IAEhB,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;;IAEhB,yBAAyB;AAC7B;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;;IAEhB,iBAAiB;;IAEjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;;IAEb,sBAAsB;AAC1B;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;2CAE2C;AAC3C;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;CAEC;AACD;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,mBAAmB;IAEnB,uEAAuE;AAC3E;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;;IAEI,mBAAmB;IAEnB,wEAAwE;AAC5E;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,0GAA0G;AAC9G;;AAEA;;;;IAII,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,aAAa;AACb;;IAEI,8BAA8B;AAClC;;AAEA;;2CAE2C;AAC3C;;IAEI,iBAAiB;;IAEjB,kBAAkB;;IAElB,qBAAqB;;IAErB,WAAW;;IAEX,sBAAsB;IACtB,mBAAmB;;IAEnB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;;IAEZ,qBAAqB;IACrB,sBAAsB;;IAEtB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;;IAEjB,mBAAmB;;IAEnB,kBAAkB;IAClB,sBAAsB;;IAEtB,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,YAAY;;IAEZ,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,cAAc;;IAEd,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;;IAEZ,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,QAAQ;IACR,SAAS;;IAET,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,QAAQ;IACR,SAAS;;IAET,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;2CAE2C;AAC3C;;;IAGI,sBAAsB;AAC1B;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;;;;;IAKI,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;2CAE2C;AAC3C;;IAEI,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;;IAEjB,eAAe;IACf,YAAY;;IAEZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA,YAAY;AACZ,WAAW;AACX;;;;;IAKI,0BAA0B;AAC9B;;AAEA;;IAEI,cAAc;;IAEd,WAAW;AACf;;AAEA;;2CAE2C;AAC3C;;IAEI,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;;IAElB,kRAA6Z;AACja;;AAEA;;IAEI,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,wBAAwB;;IAExB,qBAAqB;;IAErB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;;IAEjB,cAAc;IACd,qCAAqC;IACrC,mCAAmC;IACnC,mCAAmC;IACnC,kCAAkC;IAClC,yBAAyB;IACzB,kCAAkC;IAClC,oBAAoB;IAEZ,6BAA6B;AACzC;;AAEA,+BAA+B;AAC/B;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA,0DAA0D;AAC1D;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA,yDAAyD;AACzD;;IAEI,YAAY;AAChB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;2CAE2C;AAC3C;;IAKI,qBAAqB;IAIb,6BAA6B;AACzC;;AAEA;;IAEI;;QAEI,kBAAkB;QAClB,QAAQ;IACZ;IACA;;QAEI,kBAAkB;QAClB,SAAS;;QAET,YAAY;IAChB;IACA;;QAEI,kBAAkB;QAClB,SAAS;IACb;IACA;;QAEI,kBAAkB;QAClB,OAAO;;QAEP,YAAY;IAChB;AACJ;;AAEA;;2CAE2C;AAC3C;;IAEI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;;IAElB,qBAAqB;;IAErB,yBAAyB;IACzB,YAAY;IACZ,wBAAwB;IAGhB,wBAAwB;IAGxB,2BAA2B;AACvC;;AAEA;;IAEI,eAAe;IACf,4BAA4B;;IAE5B,kBAAkB;IAClB,QAAQ;IACR,UAAU;IAGF,4BAA4B;AACxC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IAGjB,0BAA0B;;IAElC,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mCAAmC;IAI3B,qBAAqB;AACjC;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;;;IAGI,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;;IAEI,sBAAsB;AAC1B;;AA0DA;;IAEI,eAAe;IACf,gBAAgB;;IAEhB,WAAW;AACf;;AA0CA;;IAEI,eAAe;IACf,gBAAgB;;IAEhB,WAAW;AACf;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;IAEI,+BAA+B;;IAE/B,kBAAkB;IAClB,UAAU;IACV,UAAU;;IAEV,eAAe;IACf,gBAAgB;;IAEhB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;;IAEhB,0BAA0B;AAC9B;;AAEA;;IAEI,eAAe;;IAEf,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;;IAEhB,UAAU;AACd;;AAEA;;IAEI,iBAAiB;;IAEjB,kBAAkB;IAClB,QAAQ;;IAER,qBAAqB;;IAErB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;;IAEhB,kBAAkB;IAClB,SAAS;;IAET,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;;;;IAII,yBAAyB;IACzB,2CAA2C;IAC3C,kCAAkC;AACtC;;AAsBA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA;;;;IAII,yCAAyC;IACzC,mCAAmC;AACvC;;AAsBA;;IAEI,WAAW;AACf;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;;IAET,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;;IAEb,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;;IAEjB,qBAAqB;;IAErB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,eAAe;;IAEf,sBAAsB;;IAEtB,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;;IAEP,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,eAAe;IAEP,mBAAmB;AAC/B;;AAEA;;IAEI,YAAY;;IAEZ,mBAAmB;;IAEnB,mCAAmC;AACvC;;AAEA;;IAEI,kBAAkB;;IAElB,sBAAsB;AAC1B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI;;QAEI,qBAAqB;;QAErB,mCAAmC;IACvC;IACA;;QAEI,eAAe;IACnB;IACA;;QAEI,iBAAiB;IACrB;IACA;;QAEI,eAAe;;QAEf,kBAAkB;QAClB,SAAS;IACb;IACA;;QAEI,kBAAkB;QAClB,QAAQ;;QAER,SAAS;IACb;IACA;;QAEI,6BAA6B;QAC7B,oBAAoB;IACxB;IACA;;QAEI,6BAA6B;QAC7B,oBAAoB;IACxB;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;2CAE2C;AAC3C;;IAEI,eAAe;IACf,YAAY;IACZ,MAAM;;IAEN,YAAY;IACZ,YAAY;IAGJ,wBAAwB;AACpC;;AAEA;;IAEI,iBAAiB;;IAEjB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,MAAM;IACN,OAAO;;IAEP,cAAc;IACd,YAAY;;IAEZ,gBAAgB;IAChB,yCAAyC;IAGjC,2BAA2B;AACvC;;AAEA;;IAEI,eAAe;IACf,4BAA4B;;IAE5B,SAAS;;IAET,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,iBAAiB;;IAEjB,cAAc;;IAEd,YAAY;;IAEZ,WAAW;AACf;;AAEA;;IAEI,eAAe;;IAEf,mBAAmB;;IAEnB,iBAAiB;IAGT,8BAA8B;;IAEtC,UAAU;AACd;;AAEA;;IAEI,iBAAiB;IACjB,cAAc;;IAEd,kBAAkB;;IAElB,qBAAqB;;IAErB,aAAa;IACb,4BAA4B;;IAE5B,WAAW;AACf;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,SAAS;IAID,2BAA2B;AACvC;;AAEA;;IAEI;;QAEI,SAAS;QAID,2BAA2B;IACvC;IACA;;;QAGI,UAAU;QAIF,eAAe;IAC3B;IACA;;QAEI,WAAW;IACf;IACA;;QAEI,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;;IAEI,YAAY;;IAEZ,UAAU;AACd;;AAEA;;;;;IAKI,WAAW;;IAEX,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;;IAET,gBAAgB;;IAEhB,cAAc;IACd,YAAY;IACZ,oBAAoB;IAGZ,2BAA2B;;IAEnC,YAAY;IACZ,yCAAyC;IAGjC,2BAA2B;AACvC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,iBAAiB;;IAEjB,YAAY;AAChB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;;IAEhB,gBAAgB;IAChB,eAAe;;IAEf,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;;IAEjB,YAAY;IACZ,SAAS;IACT,qBAAqB;;IAErB,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,iBAAiB;;IAEjB,UAAU;AACd;;AAEA;;IAEI,oBAAoB;;IAEpB,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;;IAEpB,cAAc;IACd,WAAW;;IAEX,WAAW;IACX,kBAAkB;;IAElB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;;IAEI,6BAA6B;IAC7B,eAAe;;IAEf,kBAAkB;IAClB,QAAQ;;IAER,+BAA+B;IAC/B,mEAAsG;;IAEtG,cAAc;AAClB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;;IAET,WAAW;IAEX,4DAA4D;IAC5D,iDAAiD;AACrD;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAIY,wBAAwB;AACpC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;;IAGI,gBAAgB;IAChB,iBAAiB;;IAEjB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;;;IAGI,iBAAiB;;IAEjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,gDAAgD;AACpD;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;;;IAKI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IAGX,8BAA8B;;IAEtC,UAAU;AACd;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;;IAGI,kBAAkB;IAGV,iDAAiD;;IAEzD,UAAU;AACd;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;;;IAKI,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;IAGX,8BAA8B;;IAEtC,UAAU;AACd;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAGV,iDAAiD;;IAEzD,UAAU;AACd;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;;IAEV,mBAAmB;IACnB,WAAW;IAGH,8BAA8B;;IAEtC,UAAU;AACd;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;;IAGI,8CAA8C;AAClD;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,qBAAqB;;IAErB,WAAW;IACX,4BAA4B;AAChC;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;;IAGI,4BAA4B;AAChC;;AAEA;;;IAGI,qBAAqB;IACrB,8BAA8B;IAGtB,gBAAgB;AAC5B;;AAEA;;IAEI,UAAU;AACd;;AAEA;;;IAGI,6BAA6B;AACjC;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,qBAAqB;;IAErB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;;IAGI,0BAA0B;AAC9B;;AAEA;;;IAGI,qBAAqB;IACrB,8BAA8B;IAGtB,gBAAgB;AAC5B;;AAEA;;IAEI,UAAU;AACd;;AAEA;;;IAGI,6BAA6B;AACjC;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI;;QAEI,WAAW;QACX,SAAS;IACb;IACA;;QAEI,UAAU;;QAEV,uBAAuB;QACvB,gBAAgB;IACpB;IACA;;QAEI,aAAa;IACjB;IACA;;QAEI,qBAAqB;IACzB;IACA;;QAEI,UAAU;IACd;IACA;;QAEI,MAAM;;QAEN,YAAY;IAChB;IACA;;QAEI,kBAAkB;QAClB,SAAS;QACT,UAAU;IACd;IACA;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,4BAA4B;IAChC;IACA;;QAEI,kBAAkB;QAClB,QAAQ;QACR,SAAS;IACb;AACJ;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;QAEI,oCAAoC;IACxC;AACJ;;AAEA;;IAEI;;QAEI,gCAAgC;IACpC;IACA;;QAEI,QAAQ;;QAER,YAAY;IAChB;IACA;;QAEI,QAAQ;;QAER,QAAQ;;QAER,YAAY;QAGJ,yBAAyB;IACrC;AACJ;;AAEA;;IAEI;;QAEI;;YAEI,oCAAoC;QACxC;IACJ;AACJ;;AAEA;;IAEI;;QAEI;;YAEI,oCAAoC;QACxC;IACJ;AACJ;;AAEA;;2CAE2C;AAC3C;;IAEI,aAAa;AACjB;;AAEA;;IAEI,SAAS;;IAET,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,MAAM;;IAEN,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;;IAElB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;;IAEI,UAAU;IACV,cAAc;IACd,YAAY;IACZ,kBAAkB;;IAElB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAKI,qBAAqB;;IAErB,mBAAmB;;IAEnB,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;;IAEX,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;;IAElB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;;IAElB,0BAA0B;AAC9B;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,4BAA4B;;IAE5B,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;;IAEf,WAAW;IACX,YAAY;IACZ,gBAAgB;;IAEhB,kBAAkB;;IAElB,kBAAkB;AACtB;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,cAAc;IACd,aAAa;AACjB;;AAEA;;IAEI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;;IAElB,iBAAiB;;IAEjB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;;IAEX,WAAW;IACX,YAAY;;IAEZ,WAAW;;IAEX,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;;IAEX,UAAU;IACV,YAAY;;IAEZ,WAAW;;IAEX,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;IAKd,qBAAqB;;IAErB,mBAAmB;;IAEnB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IAKjB,mBAAmB;AAC/B;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;;IAEhB,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;;IAEd,SAAS;;IAET,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;;IAEhB,SAAS;;IAET,cAAc;AAClB;;AAEA;;IAEI,MAAM;;IAEN,YAAY;AAChB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI;;QAEI,MAAM;IACV;IACA;;QAEI,uBAAuB;IAC3B;AACJ;;AAEA;;;IAGI,UAAU;;IAEV,WAAW;;IAEX,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB,kBAAkB;;IAElB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;;IAEjB,kBAAkB;;IAElB,WAAW;;IAEX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;;IAElB,iBAAiB;;IAEjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,UAAU;;IAEV,QAAQ;IACR,SAAS;IACT,iBAAiB;;IAEjB,WAAW;;IAEX,8BAA8B;IAC9B,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;;IAElB,iBAAiB;;IAEjB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;;IAER,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,kBAAkB;;IAElB,WAAW;;IAEX,8BAA8B;IAC9B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;;IAEI,MAAM;;IAEN,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;;IAET,2BAA2B;AAC/B;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;;IAEnB,YAAY;AAChB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;;2CAE2C;AAC3C;;IAEI,eAAe;;IAEf,uBAAuB;AAC3B;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,qBAAqB;;IAErB,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;IACd,UAAU;;IAEV,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,6BAA6B;;IAE7B,kBAAkB;IAClB,QAAQ;;IAER,oBAAoB;;IAEpB,+BAA+B;;IAE/B,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;;IAEnB,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;;IAEV,WAAW;IACX,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;;IAEP,WAAW;;IAEX,oCAAoC;AACxC;;AAEA;;;IAGI,+BAA+B;AACnC;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;IAEI,mBAAmB;;IAEnB,+BAA+B;AACnC;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,MAAM;AACV;;AAEA;;IAEI,YAAY;;IAEZ,aAAa;AACjB;;AAEA;;IAEI;;QAEI,MAAM;;QAEN,QAAQ;;QAER,YAAY;IAChB;AACJ;;AAEA;;2CAE2C;AAC3C;;IAEI,gBAAgB;;IAEhB,kBAAkB;IAClB,SAAS;IACT,UAAU;IAIF,yBAAyB;;IAEjC,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;;;;;;;;;;;IAYI,OAAO;AACX;;AAEA;;;;;;;;;;;;IAYI,WAAW;AACf;;AAEA;;;IAMI,gCAAgC;;IAEhC,8BAA8B;IAKtB,mBAAmB;AAC/B;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;;IAER,kBAAkB;AACtB;;AAEA;;IAKI,qBAAqB;IAIb,eAAe;AAC3B;;AAEA;;IAKI,qBAAqB;;IAErB,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;;IAEd,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;;IAEjB,qDAAqD;IACrD,2BAA2B;AAC/B;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;;IAEhB,mDAAmD;IACnD,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;;2CAE2C;AAC3C;;;IAGI,iBAAiB;;IAEjB,SAAS;;IAET,4BAA4B;AAChC;;AAEA;;;IAGI,wBAAwB;;IAExB,+CAA+C;AACnD;;AAEA;;2CAE2C;AAC3C;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;;IAEhB,SAAS;AACb;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;;IAEjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;;IAEjB,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;;IAEhB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;IAGI,iBAAiB;IAGjB,WAAW;IAEH,eAAe;AAC3B;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;;IAEnB,eAAe;IAEP,eAAe;AAC3B;;AAEA,eAAe;AACf;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;;IAEf,kBAAkB;IAClB,SAAS;;IAET,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,UAAU;;IAEV,qBAAqB;;IAErB,WAAW;;IAEX,sBAAsB;IACtB,mBAAmB;;IAEnB,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;;IAEf,kBAAkB;IAClB,QAAQ;IACR,WAAW;;IAEX,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,MAAM;;IAEN,SAAS;AACb;;AAEA,cAAc;AACd;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;;IAEhB,SAAS;IACT,UAAU;AACd;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;;IAEhB,SAAS;IACT,UAAU;AACd;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;AACrB;;AAEA,gBAAgB;AAChB;;IAEI,gBAAgB;;IAEhB,SAAS;;IAET,WAAW;AACf;;AAEA;;IAEI,eAAe;;IAEf,SAAS;;IAET,WAAW;AACf;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,iBAAiB;;IAEjB,cAAc;;IAEd,gCAAgC;OAC7B,6BAA6B;QAC5B,4BAA4B;SAC3B,2BAA2B;AACpC;;AAEA;;IAEI,2EAA4E;IAC5E,sBAAsB;AAC1B;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;AACjB;;AAEA,cAAc;AACd;;IAEI,cAAc;;IAEd,YAAY;;IAEZ,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;;IAEhB,SAAS;;IAET,WAAW;AACf;;AAEA;;IAEI,eAAe;;IAEf,SAAS;;IAET,WAAW;AACf;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;;IAEhB,iBAAiB;IACjB,gBAAgB;;IAEhB,WAAW;IACX,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;;IAEhB,gBAAgB;;IAEhB,WAAW;IACX,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;;IAEI,eAAe;AACnB;;AAEA,iBAAiB;AACjB;;IAEI,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,UAAU;;IAEV,WAAW;;IAEX,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,YAAY;;IAEZ,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;;IAER,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;;IAEf,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;;IAEI,WAAW;;IAEX,yDAA8D;IAC9D,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;;IAEX,yDAA6D;IAC7D,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;;IAEX,yDAAiE;IACjE,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI;;QAEI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;;QAEI,oBAAoB;IACxB;AACJ;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;QAEI,sBAAsB;IAC1B;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;;QAEI,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;;QAEI,oBAAoB;IACxB;AACJ;;AAEA;;IAEI,YAAY;;IAEZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;IAEI;;;;QAII,UAAU;IACd;AACJ;;AAEA;;2CAE2C;AAC3C;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;;;IAII,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;;IAEI,YAAY;;IAEZ,YAAY;;IAEZ,kBAAkB;;IAElB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;;IAEhB,SAAS;AACb;;AAEA;;IAEI,gBAAgB;;IAEhB,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;;IAEnB,iBAAiB;;IAEjB,WAAW;AACf;;AAEA;;;;;IAKI,wBAAwB;AAC5B;;AAEA,mBAAmB;AACnB;;IAEI,eAAe;IACf,gBAAgB;;IAEhB,kBAAkB;IAClB,UAAU;IACV,OAAO;;IAEP,SAAS;;IAET,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;;IAEhB,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,WAAW;;IAEX,UAAU;IACV,WAAW;IACX,eAAe;IACf,iBAAiB;;IAEjB,WAAW;AACf;;AAEA;;IAEI,eAAe;;IAEf,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,UAAU;;IAEV,WAAW;;IAEX,mBAAmB;;IAEnB,WAAW;AACf;;AAEA,uBAAuB;AACvB;;IAEI,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,YAAY;;IAEZ,6BAA6B;AACjC;;AAEA,YAAY;AACZ;;IAEI,uBAAuB;;IAEvB,uBAAuB;AAC3B;;AAEA;;IAEI,gBAAgB;;IAEhB,WAAW;IACX,YAAY;;IAEZ,WAAW;AACf;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA,YAAY;AACZ;;IAEI,eAAe;;IAEf,kBAAkB;IAClB,YAAY;IACZ,UAAU;;IAEV,WAAW;AACf;;AAEA;;IAEI,eAAe;;IAEf,kBAAkB;IAClB,WAAW;IACX,YAAY;;IAEZ,SAAS;IACT,UAAU;;IAEV,WAAW;AACf;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI;;QAEI,aAAa;IACjB;AACJ;;AAEA;;IAEI;;QAEI,aAAa;IACjB;IACA;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;;2CAE2C;AAC3C;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;;IAEjB,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;;IAEhB,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;;IAEZ,kBAAkB;IAClB,qBAAqB;;IAErB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;CAEC;AAkBD;;IAEI;;QAGY,2BAA2B;;QAEnC,UAAU;IACd;IACA;;QAGY,0BAA0B;;QAElC,UAAU;IACd;AACJ;;AAEA;;IAGY,iBAAiB;IAEjB,wBAAwB;IAGxB,yBAAyB;AACrC;;AAoBA;;IAEI;;QAGY,4BAA4B;;QAEpC,UAAU;IACd;IACA;;QAGY,0BAA0B;;QAElC,UAAU;IACd;AACJ;;AAEA;;IAGY,mBAAmB;IAEnB,wBAAwB;IAGxB,yBAAyB;AACrC;;AAoBA;;IAEI;;QAGY,2BAA2B;;QAEnC,UAAU;IACd;IACA;;QAGY,0BAA0B;;QAElC,UAAU;IACd;AACJ;;AAEA;;IAGY,oBAAoB;IAEpB,wBAAwB;IAGxB,yBAAyB;AACrC;;AAEA;;IAGY,oBAAoB;AAChC;;AAEA;;IAGY,mBAAmB;AAC/B;;AAEA;;IAGY,+BAA+B;AAC3C;;AAEA;;IAGY,+BAA+B;AAC3C;;AAEA;;IAGY,+BAA+B;AAC3C;;AAEA;;IAGY,+BAA+B;AAC3C;;AAEA;;IAGY,+BAA+B;AAC3C;;AAEA;;2CAE2C;AAC3C;;;;;;;;;;;;;;;;;;;;IAoBI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;IAEjB,cAAc;;IAEd,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI;;QAEI,aAAa;IACjB;AACJ;;AAEA;;2CAE2C;AAC3C;;IAEI,aAAa;;IAEb,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;;IAEb,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;;IAEZ,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;;IAEd,UAAU;IACV,YAAY;IACZ,iBAAiB;;IAEjB,0CAA0C;AAC9C;;AAEA;;IAEI,cAAc;;IAEd,UAAU;IACV,YAAY;IACZ,iBAAiB;;IAEjB,oCAAoC;AACxC;;AAEA;;IAEI,UAAU;IACV,YAAY;;IAEZ,oCAAoC;AACxC;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,iBAAiB;;IAEjB,aAAa;IACb,UAAU;;IAEV,kBAAkB;;IAElB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;;IAEjB,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;2CAE2C;AAC3C;;IAEI,qBAAqB;IACrB,gBAAgB;;IAEhB,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,gBAAgB;;IAEhB,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;;IAEI,YAAY;;IAEZ,8BAA8B;IAC9B,8BAA8B;IAC9B,0BAA0B;IAE1B,qDAAqD;IACrD,4BAA4B;AAChC;;AAEA;;IAEI,qBAAqB;;IAErB,WAAW;IACX,YAAY;IACZ,iBAAiB;;IAEjB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;;IAErB,WAAW;IACX,SAAS;;IAET,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,eAAe;;IAEf,cAAc;;IAEd,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;;IAEhB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;2CAE2C;AAC3C;;IAEI,YAAY;IACZ,aAAa;IACb,iBAAiB;;IAEjB,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;;IAEhB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;2CAE2C;AAC3C;;IAEI,eAAe;IACf,SAAS;;IAET,WAAW;AACf;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,WAAW;AACf;;AAEA;;oCAEoC;AACpC;;IAEI,eAAe;AACnB;;AAEA;;IAGY,qCAAqC;AACjD;;AAgBA;;IAEI;;QAGY,uBAAuB;IACnC;IACA;;QAGY,yBAAyB;IACrC;AACJ;;AAEA;;IAEI,cAAc;IACd,MAAM;;IAEN,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;;;;;IAOI,qBAAqB;;IAErB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;;IAEnB,eAAe;;IAEf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;;;;;;IAOI,gCAAgC;AACpC;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,WAAW;;IAEX,eAAe;AACnB;;AAEA;;IAGY,wBAAwB;IAExB,mCAAmC;IAGnC,yBAAyB;AACrC;;AAqCA;;IAEI;;QAGY,2BAA2B;IACvC;IACA;;;QAIY,uDAAuD;IACnE;IACA;;;;;QAMY,yDAAyD;IACrE;IACA;;;;QAKY,0DAA0D;IACtE;IACA;;QAGY,2BAA2B;IACvC;AACJ;;AAEA;;IAGY,oBAAoB;AAChC;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,WAAW;AACf;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,6BAA6B;IAC7B,oCAAoC;IACpC,6BAA6B;IAC7B,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;IACxB,oCAAoC;IACpC,gCAAgC,EAAE,uBAAuB;IACzD,8BAA8B,EAAE,wCAAwC;IACxE,uBAAuB,EAAE,wCAAwC;IACjE,iCAAiC,EAAE,sCAAsC;AAC7E;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/*-------------------------------------------------\n\tStyle file contain theme components style\n-------------------------------------------------*/\n@import url(https://fonts.googleapis.com/css?family=Muli:300,300i,400,400i,500,600);\n.materialize-red\n{\n    background-color: #e51c23 !important;\n}\n\n.materialize-red-text\n{\n    color: #e51c23 !important;\n}\n\n.materialize-red.lighten-5\n{\n    background-color: #fdeaeb !important;\n}\n\n.materialize-red-text.text-lighten-5\n{\n    color: #fdeaeb !important;\n}\n\n.materialize-red.lighten-4\n{\n    background-color: #f8c1c3 !important;\n}\n\n.materialize-red-text.text-lighten-4\n{\n    color: #f8c1c3 !important;\n}\n\n.materialize-red.lighten-3\n{\n    background-color: #f3989b !important;\n}\n\n.materialize-red-text.text-lighten-3\n{\n    color: #f3989b !important;\n}\n\n.materialize-red.lighten-2\n{\n    background-color: #ee6e73 !important;\n}\n\n.materialize-red-text.text-lighten-2\n{\n    color: #ee6e73 !important;\n}\n\n.materialize-red.lighten-1\n{\n    background-color: #ea454b !important;\n}\n\n.materialize-red-text.text-lighten-1\n{\n    color: #ea454b !important;\n}\n\n.materialize-red.darken-1\n{\n    background-color: #d0181e !important;\n}\n\n.materialize-red-text.text-darken-1\n{\n    color: #d0181e !important;\n}\n\n.materialize-red.darken-2\n{\n    background-color: #b9151b !important;\n}\n\n.materialize-red-text.text-darken-2\n{\n    color: #b9151b !important;\n}\n\n.materialize-red.darken-3\n{\n    background-color: #a21318 !important;\n}\n\n.materialize-red-text.text-darken-3\n{\n    color: #a21318 !important;\n}\n\n.materialize-red.darken-4\n{\n    background-color: #8b1014 !important;\n}\n\n.materialize-red-text.text-darken-4\n{\n    color: #8b1014 !important;\n}\n\n.red\n{\n    background-color: #f44336 !important;\n}\n\n.red-text\n{\n    color: #f44336 !important;\n}\n\n.red.lighten-5\n{\n    background-color: #ffebee !important;\n}\n\n.red-text.text-lighten-5\n{\n    color: #ffebee !important;\n}\n\n.red.lighten-4\n{\n    background-color: #ffcdd2 !important;\n}\n\n.red-text.text-lighten-4\n{\n    color: #ffcdd2 !important;\n}\n\n.red.lighten-3\n{\n    background-color: #ef9a9a !important;\n}\n\n.red-text.text-lighten-3\n{\n    color: #ef9a9a !important;\n}\n\n.red.lighten-2\n{\n    background-color: #e57373 !important;\n}\n\n.red-text.text-lighten-2\n{\n    color: #e57373 !important;\n}\n\n.red.lighten-1\n{\n    background-color: #ef5350 !important;\n}\n\n.red-text.text-lighten-1\n{\n    color: #ef5350 !important;\n}\n\n.red.darken-1\n{\n    background-color: #e53935 !important;\n}\n\n.red-text.text-darken-1\n{\n    color: #e53935 !important;\n}\n\n.red.darken-2\n{\n    background-color: #d32f2f !important;\n}\n\n.red-text.text-darken-2\n{\n    color: #d32f2f !important;\n}\n\n.red.darken-3\n{\n    background-color: #c62828 !important;\n}\n\n.red-text.text-darken-3\n{\n    color: #c62828 !important;\n}\n\n.red.darken-4\n{\n    background-color: #b71c1c !important;\n}\n\n.red-text.text-darken-4\n{\n    color: #b71c1c !important;\n}\n\n.red.accent-1\n{\n    background-color: #ff8a80 !important;\n}\n\n.red-text.text-accent-1\n{\n    color: #ff8a80 !important;\n}\n\n.red.accent-2\n{\n    background-color: #ff5252 !important;\n}\n\n.red-text.text-accent-2\n{\n    color: #ff5252 !important;\n}\n\n.red.accent-3\n{\n    background-color: #ff1744 !important;\n}\n\n.red-text.text-accent-3\n{\n    color: #ff1744 !important;\n}\n\n.red.accent-4\n{\n    background-color: #d50000 !important;\n}\n\n.red-text.text-accent-4\n{\n    color: #d50000 !important;\n}\n\n.pink\n{\n    background-color: #e91e63 !important;\n}\n\n.pink-text\n{\n    color: #e91e63 !important;\n}\n\n.pink.lighten-5\n{\n    background-color: #fce4ec !important;\n}\n\n.pink-text.text-lighten-5\n{\n    color: #fce4ec !important;\n}\n\n.pink.lighten-4\n{\n    background-color: #f8bbd0 !important;\n}\n\n.pink-text.text-lighten-4\n{\n    color: #f8bbd0 !important;\n}\n\n.pink.lighten-3\n{\n    background-color: #f48fb1 !important;\n}\n\n.pink-text.text-lighten-3\n{\n    color: #f48fb1 !important;\n}\n\n.pink.lighten-2\n{\n    background-color: #f06292 !important;\n}\n\n.pink-text.text-lighten-2\n{\n    color: #f06292 !important;\n}\n\n.pink.lighten-1\n{\n    background-color: #ec407a !important;\n}\n\n.pink-text.text-lighten-1\n{\n    color: #ec407a !important;\n}\n\n.pink.darken-1\n{\n    background-color: #d81b60 !important;\n}\n\n.pink-text.text-darken-1\n{\n    color: #d81b60 !important;\n}\n\n.pink.darken-2\n{\n    background-color: #c2185b !important;\n}\n\n.pink-text.text-darken-2\n{\n    color: #c2185b !important;\n}\n\n.pink.darken-3\n{\n    background-color: #ad1457 !important;\n}\n\n.pink-text.text-darken-3\n{\n    color: #ad1457 !important;\n}\n\n.pink.darken-4\n{\n    background-color: #880e4f !important;\n}\n\n.pink-text.text-darken-4\n{\n    color: #880e4f !important;\n}\n\n.pink.accent-1\n{\n    background-color: #ff80ab !important;\n}\n\n.pink-text.text-accent-1\n{\n    color: #ff80ab !important;\n}\n\n.pink.accent-2\n{\n    background-color: #ff4081 !important;\n}\n\n.pink-text.text-accent-2\n{\n    color: #ff4081 !important;\n}\n\n.pink.accent-3\n{\n    background-color: #f50057 !important;\n}\n\n.pink-text.text-accent-3\n{\n    color: #f50057 !important;\n}\n\n.pink.accent-4\n{\n    background-color: #c51162 !important;\n}\n\n.pink-text.text-accent-4\n{\n    color: #c51162 !important;\n}\n\n.purple\n{\n    background-color: #9c27b0 !important;\n}\n\n.purple-text\n{\n    color: #9c27b0 !important;\n}\n\n.purple.lighten-5\n{\n    background-color: #f3e5f5 !important;\n}\n\n.purple-text.text-lighten-5\n{\n    color: #f3e5f5 !important;\n}\n\n.purple.lighten-4\n{\n    background-color: #e1bee7 !important;\n}\n\n.purple-text.text-lighten-4\n{\n    color: #e1bee7 !important;\n}\n\n.purple.lighten-3\n{\n    background-color: #ce93d8 !important;\n}\n\n.purple-text.text-lighten-3\n{\n    color: #ce93d8 !important;\n}\n\n.purple.lighten-2\n{\n    background-color: #ba68c8 !important;\n}\n\n.purple-text.text-lighten-2\n{\n    color: #ba68c8 !important;\n}\n\n.purple.lighten-1\n{\n    background-color: #ab47bc !important;\n}\n\n.purple-text.text-lighten-1\n{\n    color: #ab47bc !important;\n}\n\n.purple.darken-1\n{\n    background-color: #8e24aa !important;\n}\n\n.purple-text.text-darken-1\n{\n    color: #8e24aa !important;\n}\n\n.purple.darken-2\n{\n    background-color: #7b1fa2 !important;\n}\n\n.purple-text.text-darken-2\n{\n    color: #7b1fa2 !important;\n}\n\n.purple.darken-3\n{\n    background-color: #6a1b9a !important;\n}\n\n.purple-text.text-darken-3\n{\n    color: #6a1b9a !important;\n}\n\n.purple.darken-4\n{\n    background-color: #4a148c !important;\n}\n\n.purple-text.text-darken-4\n{\n    color: #4a148c !important;\n}\n\n.purple.accent-1\n{\n    background-color: #ea80fc !important;\n}\n\n.purple-text.text-accent-1\n{\n    color: #ea80fc !important;\n}\n\n.purple.accent-2\n{\n    background-color: #e040fb !important;\n}\n\n.purple-text.text-accent-2\n{\n    color: #e040fb !important;\n}\n\n.purple.accent-3\n{\n    background-color: #d500f9 !important;\n}\n\n.purple-text.text-accent-3\n{\n    color: #d500f9 !important;\n}\n\n.purple.accent-4\n{\n    background-color: #a0f !important;\n}\n\n.purple-text.text-accent-4\n{\n    color: #a0f !important;\n}\n\n.deep-purple\n{\n    background-color: #673ab7 !important;\n}\n\n.deep-purple-text\n{\n    color: #673ab7 !important;\n}\n\n.deep-purple.lighten-5\n{\n    background-color: #ede7f6 !important;\n}\n\n.deep-purple-text.text-lighten-5\n{\n    color: #ede7f6 !important;\n}\n\n.deep-purple.lighten-4\n{\n    background-color: #d1c4e9 !important;\n}\n\n.deep-purple-text.text-lighten-4\n{\n    color: #d1c4e9 !important;\n}\n\n.deep-purple.lighten-3\n{\n    background-color: #b39ddb !important;\n}\n\n.deep-purple-text.text-lighten-3\n{\n    color: #b39ddb !important;\n}\n\n.deep-purple.lighten-2\n{\n    background-color: #9575cd !important;\n}\n\n.deep-purple-text.text-lighten-2\n{\n    color: #9575cd !important;\n}\n\n.deep-purple.lighten-1\n{\n    background-color: #7e57c2 !important;\n}\n\n.deep-purple-text.text-lighten-1\n{\n    color: #7e57c2 !important;\n}\n\n.deep-purple.darken-1\n{\n    background-color: #5e35b1 !important;\n}\n\n.deep-purple-text.text-darken-1\n{\n    color: #5e35b1 !important;\n}\n\n.deep-purple.darken-2\n{\n    background-color: #512da8 !important;\n}\n\n.deep-purple-text.text-darken-2\n{\n    color: #512da8 !important;\n}\n\n.deep-purple.darken-3\n{\n    background-color: #4527a0 !important;\n}\n\n.deep-purple-text.text-darken-3\n{\n    color: #4527a0 !important;\n}\n\n.deep-purple.darken-4\n{\n    background-color: #311b92 !important;\n}\n\n.deep-purple-text.text-darken-4\n{\n    color: #311b92 !important;\n}\n\n.deep-purple.accent-1\n{\n    background-color: #b388ff !important;\n}\n\n.deep-purple-text.text-accent-1\n{\n    color: #b388ff !important;\n}\n\n.deep-purple.accent-2\n{\n    background-color: #7c4dff !important;\n}\n\n.deep-purple-text.text-accent-2\n{\n    color: #7c4dff !important;\n}\n\n.deep-purple.accent-3\n{\n    background-color: #651fff !important;\n}\n\n.deep-purple-text.text-accent-3\n{\n    color: #651fff !important;\n}\n\n.deep-purple.accent-4\n{\n    background-color: #6200ea !important;\n}\n\n.deep-purple-text.text-accent-4\n{\n    color: #6200ea !important;\n}\n\n.indigo\n{\n    background-color: #3f51b5 !important;\n}\n\n.indigo-text\n{\n    color: #3f51b5 !important;\n}\n\n.indigo.lighten-5\n{\n    background-color: #e8eaf6 !important;\n}\n\n.indigo-text.text-lighten-5\n{\n    color: #e8eaf6 !important;\n}\n\n.indigo.lighten-4\n{\n    background-color: #c5cae9 !important;\n}\n\n.indigo-text.text-lighten-4\n{\n    color: #c5cae9 !important;\n}\n\n.indigo.lighten-3\n{\n    background-color: #9fa8da !important;\n}\n\n.indigo-text.text-lighten-3\n{\n    color: #9fa8da !important;\n}\n\n.indigo.lighten-2\n{\n    background-color: #7986cb !important;\n}\n\n.indigo-text.text-lighten-2\n{\n    color: #7986cb !important;\n}\n\n.indigo.lighten-1\n{\n    background-color: #5c6bc0 !important;\n}\n\n.indigo-text.text-lighten-1\n{\n    color: #5c6bc0 !important;\n}\n\n.indigo.darken-1\n{\n    background-color: #3949ab !important;\n}\n\n.indigo-text.text-darken-1\n{\n    color: #3949ab !important;\n}\n\n.indigo.darken-2\n{\n    background-color: #303f9f !important;\n}\n\n.indigo-text.text-darken-2\n{\n    color: #303f9f !important;\n}\n\n.indigo.darken-3\n{\n    background-color: #283593 !important;\n}\n\n.indigo-text.text-darken-3\n{\n    color: #283593 !important;\n}\n\n.indigo.darken-4\n{\n    background-color: #1a237e !important;\n}\n\n.indigo-text.text-darken-4\n{\n    color: #1a237e !important;\n}\n\n.indigo.accent-1\n{\n    background-color: #8c9eff !important;\n}\n\n.indigo-text.text-accent-1\n{\n    color: #8c9eff !important;\n}\n\n.indigo.accent-2\n{\n    background-color: #536dfe !important;\n}\n\n.indigo-text.text-accent-2\n{\n    color: #536dfe !important;\n}\n\n.indigo.accent-3\n{\n    background-color: #3d5afe !important;\n}\n\n.indigo-text.text-accent-3\n{\n    color: #3d5afe !important;\n}\n\n.indigo.accent-4\n{\n    background-color: #304ffe !important;\n}\n\n.indigo-text.text-accent-4\n{\n    color: #304ffe !important;\n}\n\n.blue\n{\n    background-color: #2196f3 !important;\n}\n\n.blue-text\n{\n    color: #2196f3 !important;\n}\n\n.blue.lighten-5\n{\n    background-color: #e3f2fd !important;\n}\n\n.blue-text.text-lighten-5\n{\n    color: #e3f2fd !important;\n}\n\n.blue.lighten-4\n{\n    background-color: #bbdefb !important;\n}\n\n.blue-text.text-lighten-4\n{\n    color: #bbdefb !important;\n}\n\n.blue.lighten-3\n{\n    background-color: #90caf9 !important;\n}\n\n.blue-text.text-lighten-3\n{\n    color: #90caf9 !important;\n}\n\n.blue.lighten-2\n{\n    background-color: #64b5f6 !important;\n}\n\n.blue-text.text-lighten-2\n{\n    color: #64b5f6 !important;\n}\n\n.blue.lighten-1\n{\n    background-color: #42a5f5 !important;\n}\n\n.blue-text.text-lighten-1\n{\n    color: #42a5f5 !important;\n}\n\n.blue.darken-1\n{\n    background-color: #1e88e5 !important;\n}\n\n.blue-text.text-darken-1\n{\n    color: #1e88e5 !important;\n}\n\n.blue.darken-2\n{\n    background-color: #1976d2 !important;\n}\n\n.blue-text.text-darken-2\n{\n    color: #1976d2 !important;\n}\n\n.blue.darken-3\n{\n    background-color: #1565c0 !important;\n}\n\n.blue-text.text-darken-3\n{\n    color: #1565c0 !important;\n}\n\n.blue.darken-4\n{\n    background-color: #0d47a1 !important;\n}\n\n.blue-text.text-darken-4\n{\n    color: #0d47a1 !important;\n}\n\n.blue.accent-1\n{\n    background-color: #82b1ff !important;\n}\n\n.blue-text.text-accent-1\n{\n    color: #82b1ff !important;\n}\n\n.blue.accent-2\n{\n    background-color: #448aff !important;\n}\n\n.blue-text.text-accent-2\n{\n    color: #448aff !important;\n}\n\n.blue.accent-3\n{\n    background-color: #2979ff !important;\n}\n\n.blue-text.text-accent-3\n{\n    color: #2979ff !important;\n}\n\n.blue.accent-4\n{\n    background-color: #2962ff !important;\n}\n\n.blue-text.text-accent-4\n{\n    color: #2962ff !important;\n}\n\n.light-blue\n{\n    background-color: #03a9f4 !important;\n}\n\n.light-blue-text\n{\n    color: #03a9f4 !important;\n}\n\n.light-blue.lighten-5\n{\n    background-color: #e1f5fe !important;\n}\n\n.light-blue-text.text-lighten-5\n{\n    color: #e1f5fe !important;\n}\n\n.light-blue.lighten-4\n{\n    background-color: #b3e5fc !important;\n}\n\n.light-blue-text.text-lighten-4\n{\n    color: #b3e5fc !important;\n}\n\n.light-blue.lighten-3\n{\n    background-color: #81d4fa !important;\n}\n\n.light-blue-text.text-lighten-3\n{\n    color: #81d4fa !important;\n}\n\n.light-blue.lighten-2\n{\n    background-color: #4fc3f7 !important;\n}\n\n.light-blue-text.text-lighten-2\n{\n    color: #4fc3f7 !important;\n}\n\n.light-blue.lighten-1\n{\n    background-color: #29b6f6 !important;\n}\n\n.light-blue-text.text-lighten-1\n{\n    color: #29b6f6 !important;\n}\n\n.light-blue.darken-1\n{\n    background-color: #039be5 !important;\n}\n\n.light-blue-text.text-darken-1\n{\n    color: #039be5 !important;\n}\n\n.light-blue.darken-2\n{\n    background-color: #0288d1 !important;\n}\n\n.light-blue-text.text-darken-2\n{\n    color: #0288d1 !important;\n}\n\n.light-blue.darken-3\n{\n    background-color: #0277bd !important;\n}\n\n.light-blue-text.text-darken-3\n{\n    color: #0277bd !important;\n}\n\n.light-blue.darken-4\n{\n    background-color: #01579b !important;\n}\n\n.light-blue-text.text-darken-4\n{\n    color: #01579b !important;\n}\n\n.light-blue.accent-1\n{\n    background-color: #80d8ff !important;\n}\n\n.light-blue-text.text-accent-1\n{\n    color: #80d8ff !important;\n}\n\n.light-blue.accent-2\n{\n    background-color: #40c4ff !important;\n}\n\n.light-blue-text.text-accent-2\n{\n    color: #40c4ff !important;\n}\n\n.light-blue.accent-3\n{\n    background-color: #00b0ff !important;\n}\n\n.light-blue-text.text-accent-3\n{\n    color: #00b0ff !important;\n}\n\n.light-blue.accent-4\n{\n    background-color: #0091ea !important;\n}\n\n.light-blue-text.text-accent-4\n{\n    color: #0091ea !important;\n}\n\n.cyan\n{\n    background-color: #00bcd4 !important;\n}\n\n.cyan-text\n{\n    color: #00bcd4 !important;\n}\n\n.cyan.lighten-5\n{\n    background-color: #e0f7fa !important;\n}\n\n.cyan-text.text-lighten-5\n{\n    color: #e0f7fa !important;\n}\n\n.cyan.lighten-4\n{\n    background-color: #b2ebf2 !important;\n}\n\n.cyan-text.text-lighten-4\n{\n    color: #b2ebf2 !important;\n}\n\n.cyan.lighten-3\n{\n    background-color: #80deea !important;\n}\n\n.cyan-text.text-lighten-3\n{\n    color: #80deea !important;\n}\n\n.cyan.lighten-2\n{\n    background-color: #4dd0e1 !important;\n}\n\n.cyan-text.text-lighten-2\n{\n    color: #4dd0e1 !important;\n}\n\n.cyan.lighten-1\n{\n    background-color: #26c6da !important;\n}\n\n.cyan-text.text-lighten-1\n{\n    color: #26c6da !important;\n}\n\n.cyan.darken-1\n{\n    background-color: #00acc1 !important;\n}\n\n.cyan-text.text-darken-1\n{\n    color: #00acc1 !important;\n}\n\n.cyan.darken-2\n{\n    background-color: #0097a7 !important;\n}\n\n.cyan-text.text-darken-2\n{\n    color: #0097a7 !important;\n}\n\n.cyan.darken-3\n{\n    background-color: #00838f !important;\n}\n\n.cyan-text.text-darken-3\n{\n    color: #00838f !important;\n}\n\n.cyan.darken-4\n{\n    background-color: #006064 !important;\n}\n\n.cyan-text.text-darken-4\n{\n    color: #006064 !important;\n}\n\n.cyan.accent-1\n{\n    background-color: #84ffff !important;\n}\n\n.cyan-text.text-accent-1\n{\n    color: #84ffff !important;\n}\n\n.cyan.accent-2\n{\n    background-color: #18ffff !important;\n}\n\n.cyan-text.text-accent-2\n{\n    color: #18ffff !important;\n}\n\n.cyan.accent-3\n{\n    background-color: #00e5ff !important;\n}\n\n.cyan-text.text-accent-3\n{\n    color: #00e5ff !important;\n}\n\n.cyan.accent-4\n{\n    background-color: #00b8d4 !important;\n}\n\n.cyan-text.text-accent-4\n{\n    color: #00b8d4 !important;\n}\n\n.teal\n{\n    background-color: #009688 !important;\n}\n\n.teal-text\n{\n    color: #009688 !important;\n}\n\n.teal.lighten-5\n{\n    background-color: #e0f2f1 !important;\n}\n\n.teal-text.text-lighten-5\n{\n    color: #e0f2f1 !important;\n}\n\n.teal.lighten-4\n{\n    background-color: #b2dfdb !important;\n}\n\n.teal-text.text-lighten-4\n{\n    color: #b2dfdb !important;\n}\n\n.teal.lighten-3\n{\n    background-color: #80cbc4 !important;\n}\n\n.teal-text.text-lighten-3\n{\n    color: #80cbc4 !important;\n}\n\n.teal.lighten-2\n{\n    background-color: #4db6ac !important;\n}\n\n.teal-text.text-lighten-2\n{\n    color: #4db6ac !important;\n}\n\n.teal.lighten-1\n{\n    background-color: #26a69a !important;\n}\n\n.teal-text.text-lighten-1\n{\n    color: #26a69a !important;\n}\n\n.teal.darken-1\n{\n    background-color: #00897b !important;\n}\n\n.teal-text.text-darken-1\n{\n    color: #00897b !important;\n}\n\n.teal.darken-2\n{\n    background-color: #00796b !important;\n}\n\n.teal-text.text-darken-2\n{\n    color: #00796b !important;\n}\n\n.teal.darken-3\n{\n    background-color: #00695c !important;\n}\n\n.teal-text.text-darken-3\n{\n    color: #00695c !important;\n}\n\n.teal.darken-4\n{\n    background-color: #004d40 !important;\n}\n\n.teal-text.text-darken-4\n{\n    color: #004d40 !important;\n}\n\n.teal.accent-1\n{\n    background-color: #a7ffeb !important;\n}\n\n.teal-text.text-accent-1\n{\n    color: #a7ffeb !important;\n}\n\n.teal.accent-2\n{\n    background-color: #64ffda !important;\n}\n\n.teal-text.text-accent-2\n{\n    color: #64ffda !important;\n}\n\n.teal.accent-3\n{\n    background-color: #1de9b6 !important;\n}\n\n.teal-text.text-accent-3\n{\n    color: #1de9b6 !important;\n}\n\n.teal.accent-4\n{\n    background-color: #00bfa5 !important;\n}\n\n.teal-text.text-accent-4\n{\n    color: #00bfa5 !important;\n}\n\n.green\n{\n    background-color: #4caf50 !important;\n}\n\n.green-text\n{\n    color: #4caf50 !important;\n}\n\n.green.lighten-5\n{\n    background-color: #e8f5e9 !important;\n}\n\n.green-text.text-lighten-5\n{\n    color: #e8f5e9 !important;\n}\n\n.green.lighten-4\n{\n    background-color: #c8e6c9 !important;\n}\n\n.green-text.text-lighten-4\n{\n    color: #c8e6c9 !important;\n}\n\n.green.lighten-3\n{\n    background-color: #a5d6a7 !important;\n}\n\n.green-text.text-lighten-3\n{\n    color: #a5d6a7 !important;\n}\n\n.green.lighten-2\n{\n    background-color: #81c784 !important;\n}\n\n.green-text.text-lighten-2\n{\n    color: #81c784 !important;\n}\n\n.green.lighten-1\n{\n    background-color: #66bb6a !important;\n}\n\n.green-text.text-lighten-1\n{\n    color: #66bb6a !important;\n}\n\n.green.darken-1\n{\n    background-color: #43a047 !important;\n}\n\n.green-text.text-darken-1\n{\n    color: #43a047 !important;\n}\n\n.green.darken-2\n{\n    background-color: #388e3c !important;\n}\n\n.green-text.text-darken-2\n{\n    color: #388e3c !important;\n}\n\n.green.darken-3\n{\n    background-color: #2e7d32 !important;\n}\n\n.green-text.text-darken-3\n{\n    color: #2e7d32 !important;\n}\n\n.green.darken-4\n{\n    background-color: #1b5e20 !important;\n}\n\n.green-text.text-darken-4\n{\n    color: #1b5e20 !important;\n}\n\n.green.accent-1\n{\n    background-color: #b9f6ca !important;\n}\n\n.green-text.text-accent-1\n{\n    color: #b9f6ca !important;\n}\n\n.green.accent-2\n{\n    background-color: #69f0ae !important;\n}\n\n.green-text.text-accent-2\n{\n    color: #69f0ae !important;\n}\n\n.green.accent-3\n{\n    background-color: #00e676 !important;\n}\n\n.green-text.text-accent-3\n{\n    color: #00e676 !important;\n}\n\n.green.accent-4\n{\n    background-color: #00c853 !important;\n}\n\n.green-text.text-accent-4\n{\n    color: #00c853 !important;\n}\n\n.light-green\n{\n    background-color: #8bc34a !important;\n}\n\n.light-green-text\n{\n    color: #8bc34a !important;\n}\n\n.light-green.lighten-5\n{\n    background-color: #f1f8e9 !important;\n}\n\n.light-green-text.text-lighten-5\n{\n    color: #f1f8e9 !important;\n}\n\n.light-green.lighten-4\n{\n    background-color: #dcedc8 !important;\n}\n\n.light-green-text.text-lighten-4\n{\n    color: #dcedc8 !important;\n}\n\n.light-green.lighten-3\n{\n    background-color: #c5e1a5 !important;\n}\n\n.light-green-text.text-lighten-3\n{\n    color: #c5e1a5 !important;\n}\n\n.light-green.lighten-2\n{\n    background-color: #aed581 !important;\n}\n\n.light-green-text.text-lighten-2\n{\n    color: #aed581 !important;\n}\n\n.light-green.lighten-1\n{\n    background-color: #9ccc65 !important;\n}\n\n.light-green-text.text-lighten-1\n{\n    color: #9ccc65 !important;\n}\n\n.light-green.darken-1\n{\n    background-color: #7cb342 !important;\n}\n\n.light-green-text.text-darken-1\n{\n    color: #7cb342 !important;\n}\n\n.light-green.darken-2\n{\n    background-color: #689f38 !important;\n}\n\n.light-green-text.text-darken-2\n{\n    color: #689f38 !important;\n}\n\n.light-green.darken-3\n{\n    background-color: #558b2f !important;\n}\n\n.light-green-text.text-darken-3\n{\n    color: #558b2f !important;\n}\n\n.light-green.darken-4\n{\n    background-color: #33691e !important;\n}\n\n.light-green-text.text-darken-4\n{\n    color: #33691e !important;\n}\n\n.light-green.accent-1\n{\n    background-color: #ccff90 !important;\n}\n\n.light-green-text.text-accent-1\n{\n    color: #ccff90 !important;\n}\n\n.light-green.accent-2\n{\n    background-color: #b2ff59 !important;\n}\n\n.light-green-text.text-accent-2\n{\n    color: #b2ff59 !important;\n}\n\n.light-green.accent-3\n{\n    background-color: #76ff03 !important;\n}\n\n.light-green-text.text-accent-3\n{\n    color: #76ff03 !important;\n}\n\n.light-green.accent-4\n{\n    background-color: #64dd17 !important;\n}\n\n.light-green-text.text-accent-4\n{\n    color: #64dd17 !important;\n}\n\n.lime\n{\n    background-color: #cddc39 !important;\n}\n\n.lime-text\n{\n    color: #cddc39 !important;\n}\n\n.lime.lighten-5\n{\n    background-color: #f9fbe7 !important;\n}\n\n.lime-text.text-lighten-5\n{\n    color: #f9fbe7 !important;\n}\n\n.lime.lighten-4\n{\n    background-color: #f0f4c3 !important;\n}\n\n.lime-text.text-lighten-4\n{\n    color: #f0f4c3 !important;\n}\n\n.lime.lighten-3\n{\n    background-color: #e6ee9c !important;\n}\n\n.lime-text.text-lighten-3\n{\n    color: #e6ee9c !important;\n}\n\n.lime.lighten-2\n{\n    background-color: #dce775 !important;\n}\n\n.lime-text.text-lighten-2\n{\n    color: #dce775 !important;\n}\n\n.lime.lighten-1\n{\n    background-color: #d4e157 !important;\n}\n\n.lime-text.text-lighten-1\n{\n    color: #d4e157 !important;\n}\n\n.lime.darken-1\n{\n    background-color: #c0ca33 !important;\n}\n\n.lime-text.text-darken-1\n{\n    color: #c0ca33 !important;\n}\n\n.lime.darken-2\n{\n    background-color: #afb42b !important;\n}\n\n.lime-text.text-darken-2\n{\n    color: #afb42b !important;\n}\n\n.lime.darken-3\n{\n    background-color: #9e9d24 !important;\n}\n\n.lime-text.text-darken-3\n{\n    color: #9e9d24 !important;\n}\n\n.lime.darken-4\n{\n    background-color: #827717 !important;\n}\n\n.lime-text.text-darken-4\n{\n    color: #827717 !important;\n}\n\n.lime.accent-1\n{\n    background-color: #f4ff81 !important;\n}\n\n.lime-text.text-accent-1\n{\n    color: #f4ff81 !important;\n}\n\n.lime.accent-2\n{\n    background-color: #eeff41 !important;\n}\n\n.lime-text.text-accent-2\n{\n    color: #eeff41 !important;\n}\n\n.lime.accent-3\n{\n    background-color: #c6ff00 !important;\n}\n\n.lime-text.text-accent-3\n{\n    color: #c6ff00 !important;\n}\n\n.lime.accent-4\n{\n    background-color: #aeea00 !important;\n}\n\n.lime-text.text-accent-4\n{\n    color: #aeea00 !important;\n}\n\n.yellow\n{\n    background-color: #ffeb3b !important;\n}\n\n.yellow-text\n{\n    color: #ffeb3b !important;\n}\n\n.yellow.lighten-5\n{\n    background-color: #fffde7 !important;\n}\n\n.yellow-text.text-lighten-5\n{\n    color: #fffde7 !important;\n}\n\n.yellow.lighten-4\n{\n    background-color: #fff9c4 !important;\n}\n\n.yellow-text.text-lighten-4\n{\n    color: #fff9c4 !important;\n}\n\n.yellow.lighten-3\n{\n    background-color: #fff59d !important;\n}\n\n.yellow-text.text-lighten-3\n{\n    color: #fff59d !important;\n}\n\n.yellow.lighten-2\n{\n    background-color: #fff176 !important;\n}\n\n.yellow-text.text-lighten-2\n{\n    color: #fff176 !important;\n}\n\n.yellow.lighten-1\n{\n    background-color: #ffee58 !important;\n}\n\n.yellow-text.text-lighten-1\n{\n    color: #ffee58 !important;\n}\n\n.yellow.darken-1\n{\n    background-color: #fdd835 !important;\n}\n\n.yellow-text.text-darken-1\n{\n    color: #fdd835 !important;\n}\n\n.yellow.darken-2\n{\n    background-color: #fbc02d !important;\n}\n\n.yellow-text.text-darken-2\n{\n    color: #fbc02d !important;\n}\n\n.yellow.darken-3\n{\n    background-color: #f9a825 !important;\n}\n\n.yellow-text.text-darken-3\n{\n    color: #f9a825 !important;\n}\n\n.yellow.darken-4\n{\n    background-color: #f57f17 !important;\n}\n\n.yellow-text.text-darken-4\n{\n    color: #f57f17 !important;\n}\n\n.yellow.accent-1\n{\n    background-color: #ffff8d !important;\n}\n\n.yellow-text.text-accent-1\n{\n    color: #ffff8d !important;\n}\n\n.yellow.accent-2\n{\n    background-color: #ff0 !important;\n}\n\n.yellow-text.text-accent-2\n{\n    color: #ff0 !important;\n}\n\n.yellow.accent-3\n{\n    background-color: #ffea00 !important;\n}\n\n.yellow-text.text-accent-3\n{\n    color: #ffea00 !important;\n}\n\n.yellow.accent-4\n{\n    background-color: #ffd600 !important;\n}\n\n.yellow-text.text-accent-4\n{\n    color: #ffd600 !important;\n}\n\n.amber\n{\n    background-color: #ffc107 !important;\n}\n\n.amber-text\n{\n    color: #ffc107 !important;\n}\n\n.amber.lighten-5\n{\n    background-color: #fff8e1 !important;\n}\n\n.amber-text.text-lighten-5\n{\n    color: #fff8e1 !important;\n}\n\n.amber.lighten-4\n{\n    background-color: #ffecb3 !important;\n}\n\n.amber-text.text-lighten-4\n{\n    color: #ffecb3 !important;\n}\n\n.amber.lighten-3\n{\n    background-color: #ffe082 !important;\n}\n\n.amber-text.text-lighten-3\n{\n    color: #ffe082 !important;\n}\n\n.amber.lighten-2\n{\n    background-color: #ffd54f !important;\n}\n\n.amber-text.text-lighten-2\n{\n    color: #ffd54f !important;\n}\n\n.amber.lighten-1\n{\n    background-color: #ffca28 !important;\n}\n\n.amber-text.text-lighten-1\n{\n    color: #ffca28 !important;\n}\n\n.amber.darken-1\n{\n    background-color: #ffb300 !important;\n}\n\n.amber-text.text-darken-1\n{\n    color: #ffb300 !important;\n}\n\n.amber.darken-2\n{\n    background-color: #ffa000 !important;\n}\n\n.amber-text.text-darken-2\n{\n    color: #ffa000 !important;\n}\n\n.amber.darken-3\n{\n    background-color: #ff8f00 !important;\n}\n\n.amber-text.text-darken-3\n{\n    color: #ff8f00 !important;\n}\n\n.amber.darken-4\n{\n    background-color: #ff6f00 !important;\n}\n\n.amber-text.text-darken-4\n{\n    color: #ff6f00 !important;\n}\n\n.amber.accent-1\n{\n    background-color: #ffe57f !important;\n}\n\n.amber-text.text-accent-1\n{\n    color: #ffe57f !important;\n}\n\n.amber.accent-2\n{\n    background-color: #ffd740 !important;\n}\n\n.amber-text.text-accent-2\n{\n    color: #ffd740 !important;\n}\n\n.amber.accent-3\n{\n    background-color: #ffc400 !important;\n}\n\n.amber-text.text-accent-3\n{\n    color: #ffc400 !important;\n}\n\n.amber.accent-4\n{\n    background-color: #ffab00 !important;\n}\n\n.amber-text.text-accent-4\n{\n    color: #ffab00 !important;\n}\n\n.orange\n{\n    background-color: #ff9800 !important;\n}\n\n.orange-text\n{\n    color: #ff9800 !important;\n}\n\n.orange.lighten-5\n{\n    background-color: #fff3e0 !important;\n}\n\n.orange-text.text-lighten-5\n{\n    color: #fff3e0 !important;\n}\n\n.orange.lighten-4\n{\n    background-color: #ffe0b2 !important;\n}\n\n.orange-text.text-lighten-4\n{\n    color: #ffe0b2 !important;\n}\n\n.orange.lighten-3\n{\n    background-color: #ffcc80 !important;\n}\n\n.orange-text.text-lighten-3\n{\n    color: #ffcc80 !important;\n}\n\n.orange.lighten-2\n{\n    background-color: #ffb74d !important;\n}\n\n.orange-text.text-lighten-2\n{\n    color: #ffb74d !important;\n}\n\n.orange.lighten-1\n{\n    background-color: #ffa726 !important;\n}\n\n.orange-text.text-lighten-1\n{\n    color: #ffa726 !important;\n}\n\n.orange.darken-1\n{\n    background-color: #fb8c00 !important;\n}\n\n.orange-text.text-darken-1\n{\n    color: #fb8c00 !important;\n}\n\n.orange.darken-2\n{\n    background-color: #f57c00 !important;\n}\n\n.orange-text.text-darken-2\n{\n    color: #f57c00 !important;\n}\n\n.orange.darken-3\n{\n    background-color: #ef6c00 !important;\n}\n\n.orange-text.text-darken-3\n{\n    color: #ef6c00 !important;\n}\n\n.orange.darken-4\n{\n    background-color: #e65100 !important;\n}\n\n.orange-text.text-darken-4\n{\n    color: #e65100 !important;\n}\n\n.orange.accent-1\n{\n    background-color: #ffd180 !important;\n}\n\n.orange-text.text-accent-1\n{\n    color: #ffd180 !important;\n}\n\n.orange.accent-2\n{\n    background-color: #ffab40 !important;\n}\n\n.orange-text.text-accent-2\n{\n    color: #ffab40 !important;\n}\n\n.orange.accent-3\n{\n    background-color: #ff9100 !important;\n}\n\n.orange-text.text-accent-3\n{\n    color: #ff9100 !important;\n}\n\n.orange.accent-4\n{\n    background-color: #ff6d00 !important;\n}\n\n.orange-text.text-accent-4\n{\n    color: #ff6d00 !important;\n}\n\n.deep-orange\n{\n    background-color: #ff5722 !important;\n}\n\n.deep-orange-text\n{\n    color: #ff5722 !important;\n}\n\n.deep-orange.lighten-5\n{\n    background-color: #fbe9e7 !important;\n}\n\n.deep-orange-text.text-lighten-5\n{\n    color: #fbe9e7 !important;\n}\n\n.deep-orange.lighten-4\n{\n    background-color: #ffccbc !important;\n}\n\n.deep-orange-text.text-lighten-4\n{\n    color: #ffccbc !important;\n}\n\n.deep-orange.lighten-3\n{\n    background-color: #ffab91 !important;\n}\n\n.deep-orange-text.text-lighten-3\n{\n    color: #ffab91 !important;\n}\n\n.deep-orange.lighten-2\n{\n    background-color: #ff8a65 !important;\n}\n\n.deep-orange-text.text-lighten-2\n{\n    color: #ff8a65 !important;\n}\n\n.deep-orange.lighten-1\n{\n    background-color: #ff7043 !important;\n}\n\n.deep-orange-text.text-lighten-1\n{\n    color: #ff7043 !important;\n}\n\n.deep-orange.darken-1\n{\n    background-color: #f4511e !important;\n}\n\n.deep-orange-text.text-darken-1\n{\n    color: #f4511e !important;\n}\n\n.deep-orange.darken-2\n{\n    background-color: #e64a19 !important;\n}\n\n.deep-orange-text.text-darken-2\n{\n    color: #e64a19 !important;\n}\n\n.deep-orange.darken-3\n{\n    background-color: #d84315 !important;\n}\n\n.deep-orange-text.text-darken-3\n{\n    color: #d84315 !important;\n}\n\n.deep-orange.darken-4\n{\n    background-color: #bf360c !important;\n}\n\n.deep-orange-text.text-darken-4\n{\n    color: #bf360c !important;\n}\n\n.deep-orange.accent-1\n{\n    background-color: #ff9e80 !important;\n}\n\n.deep-orange-text.text-accent-1\n{\n    color: #ff9e80 !important;\n}\n\n.deep-orange.accent-2\n{\n    background-color: #ff6e40 !important;\n}\n\n.deep-orange-text.text-accent-2\n{\n    color: #ff6e40 !important;\n}\n\n.deep-orange.accent-3\n{\n    background-color: #ff3d00 !important;\n}\n\n.deep-orange-text.text-accent-3\n{\n    color: #ff3d00 !important;\n}\n\n.deep-orange.accent-4\n{\n    background-color: #dd2c00 !important;\n}\n\n.deep-orange-text.text-accent-4\n{\n    color: #dd2c00 !important;\n}\n\n.brown\n{\n    background-color: #795548 !important;\n}\n\n.brown-text\n{\n    color: #795548 !important;\n}\n\n.brown.lighten-5\n{\n    background-color: #efebe9 !important;\n}\n\n.brown-text.text-lighten-5\n{\n    color: #efebe9 !important;\n}\n\n.brown.lighten-4\n{\n    background-color: #d7ccc8 !important;\n}\n\n.brown-text.text-lighten-4\n{\n    color: #d7ccc8 !important;\n}\n\n.brown.lighten-3\n{\n    background-color: #bcaaa4 !important;\n}\n\n.brown-text.text-lighten-3\n{\n    color: #bcaaa4 !important;\n}\n\n.brown.lighten-2\n{\n    background-color: #a1887f !important;\n}\n\n.brown-text.text-lighten-2\n{\n    color: #a1887f !important;\n}\n\n.brown.lighten-1\n{\n    background-color: #8d6e63 !important;\n}\n\n.brown-text.text-lighten-1\n{\n    color: #8d6e63 !important;\n}\n\n.brown.darken-1\n{\n    background-color: #6d4c41 !important;\n}\n\n.brown-text.text-darken-1\n{\n    color: #6d4c41 !important;\n}\n\n.brown.darken-2\n{\n    background-color: #5d4037 !important;\n}\n\n.brown-text.text-darken-2\n{\n    color: #5d4037 !important;\n}\n\n.brown.darken-3\n{\n    background-color: #4e342e !important;\n}\n\n.brown-text.text-darken-3\n{\n    color: #4e342e !important;\n}\n\n.brown.darken-4\n{\n    background-color: #3e2723 !important;\n}\n\n.brown-text.text-darken-4\n{\n    color: #3e2723 !important;\n}\n\n.blue-grey\n{\n    background-color: #607d8b !important;\n}\n\n.blue-grey-text\n{\n    color: #607d8b !important;\n}\n\n.blue-grey.lighten-5\n{\n    background-color: #eceff1 !important;\n}\n\n.blue-grey-text.text-lighten-5\n{\n    color: #eceff1 !important;\n}\n\n.blue-grey.lighten-4\n{\n    background-color: #cfd8dc !important;\n}\n\n.blue-grey-text.text-lighten-4\n{\n    color: #cfd8dc !important;\n}\n\n.blue-grey.lighten-3\n{\n    background-color: #b0bec5 !important;\n}\n\n.blue-grey-text.text-lighten-3\n{\n    color: #b0bec5 !important;\n}\n\n.blue-grey.lighten-2\n{\n    background-color: #90a4ae !important;\n}\n\n.blue-grey-text.text-lighten-2\n{\n    color: #90a4ae !important;\n}\n\n.blue-grey.lighten-1\n{\n    background-color: #78909c !important;\n}\n\n.blue-grey-text.text-lighten-1\n{\n    color: #78909c !important;\n}\n\n.blue-grey.darken-1\n{\n    background-color: #546e7a !important;\n}\n\n.blue-grey-text.text-darken-1\n{\n    color: #546e7a !important;\n}\n\n.blue-grey.darken-2\n{\n    background-color: #455a64 !important;\n}\n\n.blue-grey-text.text-darken-2\n{\n    color: #455a64 !important;\n}\n\n.blue-grey.darken-3\n{\n    background-color: #37474f !important;\n}\n\n.blue-grey-text.text-darken-3\n{\n    color: #37474f !important;\n}\n\n.blue-grey.darken-4\n{\n    background-color: #263238 !important;\n}\n\n.blue-grey-text.text-darken-4\n{\n    color: #263238 !important;\n}\n\n.grey\n{\n    background-color: #9e9e9e !important;\n}\n\n.grey-text\n{\n    color: #9e9e9e !important;\n}\n\n.grey.lighten-5\n{\n    background-color: #fafafa !important;\n}\n\n.grey-text.text-lighten-5\n{\n    color: #fafafa !important;\n}\n\n.grey.lighten-4\n{\n    background-color: #f5f5f5 !important;\n}\n\n.grey-text.text-lighten-4\n{\n    color: #f5f5f5 !important;\n}\n\n.grey.lighten-3\n{\n    background-color: #eee !important;\n}\n\n.grey-text.text-lighten-3\n{\n    color: #eee !important;\n}\n\n.grey.lighten-2\n{\n    background-color: #e0e0e0 !important;\n}\n\n.grey-text.text-lighten-2\n{\n    color: #e0e0e0 !important;\n}\n\n.grey.lighten-1\n{\n    background-color: #bdbdbd !important;\n}\n\n.grey-text.text-lighten-1\n{\n    color: #bdbdbd !important;\n}\n\n.grey.darken-1\n{\n    background-color: #757575 !important;\n}\n\n.grey-text.text-darken-1\n{\n    color: #757575 !important;\n}\n\n.grey.darken-2\n{\n    background-color: #616161 !important;\n}\n\n.grey-text.text-darken-2\n{\n    color: #616161 !important;\n}\n\n.grey.darken-3\n{\n    background-color: #424242 !important;\n}\n\n.grey-text.text-darken-3\n{\n    color: #424242 !important;\n}\n\n.grey.darken-4\n{\n    background-color: #212121 !important;\n}\n\n.grey-text.text-darken-4\n{\n    color: #212121 !important;\n}\n\n.black\n{\n    background-color: #000 !important;\n}\n\n.black-text\n{\n    color: #000 !important;\n}\n\n.white\n{\n    background-color: #fff !important;\n}\n\n.white-text\n{\n    color: #fff !important;\n}\n\n.transparent\n{\n    background-color: transparent !important;\n}\n\n.transparent-text\n{\n    color: transparent !important;\n}\n\n/*\n  Autogenerated theme file\n*/\n/*----------------------------------------\n  General Layout Style\n------------------------------------------*/\nhtml,\nbody\n{\n    height: 100%;\n}\n\nbody\n{\n    background-color: #f2f4f8;\n    overflow: hidden;\n}\n\n@media only screen and (max-width: 600px)\n{\n    .layout-semi-dark #header nav.navbar-color\n    {\n        background: #37474f;\n    }\n}\n\n.preload-transitions *\n{\n    -webkit-transition: none !important;\n            transition: none !important;\n}\n\n#main\n{\n    min-height: calc(100% - 116px);\n    padding-left: 0;\n\n    -webkit-transition: .3s ease all;\n            transition: .3s ease all;\n\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n}\n\n#main.main-full\n{\n    padding-left: 0;\n}\n\n#main .content-wrapper-before\n{\n    position: absolute;\n    z-index: -1;\n    top: 64px;\n    left: 0;\n\n    width: 100%;\n    height: 185px;\n\n    -webkit-transition: .3s ease all;\n            transition: .3s ease all;\n}\n\nfooter\n{\n    padding: 0 10px;\n}\n\nfooter.page-footer\n{\n    padding-top: 1px;\n}\n\nselect\n{\n    width: 100%;\n    height: 3rem;\n    padding: 5px;\n\n    border: none;\n    border-bottom: 1px solid #bdbdbd;\n    border-radius: 2px;\n    background-color: transparent;\n}\n\n.container\n{\n    width: 100%;\n    max-width: 100% !important;\n    margin: 0 auto;\n    padding: 0 .5rem;\n}\n\n.container .dropdown-settings i.right\n{\n    margin-left: 0;\n}\n\n@media only screen and (min-width: 601px)\n{\n    .container\n    {\n        width: 100%;\n    }\n}\n\n@media only screen and (max-width: 600px)\n{\n    #main\n    {\n        min-height: calc(100% - 107px);\n    }\n}\n\n@media only screen and (min-width: 993px)\n{\n    .container\n    {\n        width: 100%;\n    }\n    .sidenav-overlay\n    {\n        background-color: transparent;\n    }\n}\n\n@media only screen and (min-width: 993px)\n{\n    #main\n    {\n        padding-left: 250px;\n    }\n    #main.main-full\n    {\n        padding-left: 64px;\n    }\n    .nav-lock ~ footer\n    {\n        padding-left: 257px;\n    }\n    footer\n    {\n        padding-left: 71px;\n    }\n}\n\n@media only screen and (max-width: 600px)\n{\n    #main .content-wrapper-before\n    {\n        top: 56px;\n    }\n}\n\n.ps-scrollbar-x-rail\n{\n    z-index: 9999;\n}\n\n.ps-scrollbar-y-rail\n{\n    z-index: 9999;\n}\n\n.bg-opacity-8\n{\n    background-color: rgba(255, 255, 255, .8);\n}\n\n.height-100vh\n{\n    height: 100vh;\n}\n\nbutton,\nhtml [type='button'],\n[type='reset'],\n[type='submit']\n{\n    cursor: pointer;\n\n    -webkit-appearance: none;\n}\n\n/*----------------------------------------\n  Healper Classes\n------------------------------------------*/\n/* Width */\n.width-10\n{\n    width: 10% !important;\n}\n\n.width-20\n{\n    width: 20% !important;\n}\n\n.width-30\n{\n    width: 30% !important;\n}\n\n.width-40\n{\n    width: 40% !important;\n}\n\n.width-50\n{\n    width: 50% !important;\n}\n\n.width-60\n{\n    width: 60% !important;\n}\n\n.width-70\n{\n    width: 70% !important;\n}\n\n.width-80\n{\n    width: 80% !important;\n}\n\n.width-90\n{\n    width: 90% !important;\n}\n\n.width-100\n{\n    width: 100% !important;\n}\n\n/* Border Radius */\n.border-radius-1\n{\n    border-radius: 1px !important;\n}\n\n.border-radius-2\n{\n    border-radius: 2px !important;\n}\n\n.border-radius-3\n{\n    border-radius: 3px !important;\n}\n\n.border-radius-4\n{\n    border-radius: 4px !important;\n}\n\n.border-radius-5\n{\n    border-radius: 5px !important;\n}\n\n.border-radius-6\n{\n    border-radius: 6px !important;\n}\n\n.border-radius-7\n{\n    border-radius: 7px !important;\n}\n\n.border-radius-8\n{\n    border-radius: 8px !important;\n}\n\n.border-radius-9\n{\n    border-radius: 9px !important;\n}\n\n.border-radius-10\n{\n    border-radius: 10px !important;\n}\n\n.border-round\n{\n    border-radius: 150px !important;\n}\n\n/* Font Weight */\n.font-weight-100\n{\n    font-weight: 100 !important;\n}\n\n.font-weight-200\n{\n    font-weight: 200 !important;\n}\n\n.font-weight-300\n{\n    font-weight: 300 !important;\n}\n\n.font-weight-400\n{\n    font-weight: 400 !important;\n}\n\n.font-weight-500\n{\n    font-weight: 500 !important;\n}\n\n.font-weight-600\n{\n    font-weight: 600 !important;\n}\n\n.font-weight-700\n{\n    font-weight: 700 !important;\n}\n\n.font-weight-800\n{\n    font-weight: 800 !important;\n}\n\n.font-weight-900\n{\n    font-weight: 900 !important;\n}\n\n.m-0\n{\n    margin: 0 !important;\n}\n\n/* Margin Top */\n.mt-0\n{\n    margin-top: 0 !important;\n}\n\n.mt-1\n{\n    margin-top: 1% !important;\n}\n\n.mt-2\n{\n    margin-top: 2% !important;\n}\n\n.mt-3\n{\n    margin-top: 3% !important;\n}\n\n.mt-4\n{\n    margin-top: 4% !important;\n}\n\n.mt-5\n{\n    margin-top: 5% !important;\n}\n\n.mt-6\n{\n    margin-top: 6% !important;\n}\n\n.mt-7\n{\n    margin-top: 7% !important;\n}\n\n.mt-8\n{\n    margin-top: 8% !important;\n}\n\n.mt-9\n{\n    margin-top: 9% !important;\n}\n\n.mt-10\n{\n    margin-top: 10% !important;\n}\n\n/* Margin Right */\n.mr-0\n{\n    margin-right: 0 !important;\n}\n\n.mr-1\n{\n    margin-right: 1% !important;\n}\n\n.mr-2\n{\n    margin-right: 2% !important;\n}\n\n.mr-3\n{\n    margin-right: 3% !important;\n}\n\n.mr-4\n{\n    margin-right: 4% !important;\n}\n\n.mr-5\n{\n    margin-right: 5% !important;\n}\n\n.mr-6\n{\n    margin-right: 6% !important;\n}\n\n.mr-7\n{\n    margin-right: 7% !important;\n}\n\n.mr-8\n{\n    margin-right: 8% !important;\n}\n\n.mr-9\n{\n    margin-right: 9% !important;\n}\n\n.mr-10\n{\n    margin-right: 10% !important;\n}\n\n/* Margin Left */\n.ml-0\n{\n    margin-left: 0 !important;\n}\n\n.ml-1\n{\n    margin-left: 1% !important;\n}\n\n.ml-2\n{\n    margin-left: 2% !important;\n}\n\n.ml-3\n{\n    margin-left: 3% !important;\n}\n\n.ml-4\n{\n    margin-left: 4% !important;\n}\n\n.ml-5\n{\n    margin-left: 5% !important;\n}\n\n.ml-6\n{\n    margin-left: 6% !important;\n}\n\n.ml-7\n{\n    margin-left: 7% !important;\n}\n\n.ml-8\n{\n    margin-left: 8% !important;\n}\n\n.ml-9\n{\n    margin-left: 9% !important;\n}\n\n.ml-10\n{\n    margin-left: 10% !important;\n}\n\n/* Margin Bottom */\n.mb-0\n{\n    margin-bottom: 0 !important;\n}\n\n.mb-1\n{\n    margin-bottom: 1% !important;\n}\n\n.mb-2\n{\n    margin-bottom: 2% !important;\n}\n\n.mb-3\n{\n    margin-bottom: 3% !important;\n}\n\n.mb-4\n{\n    margin-bottom: 4% !important;\n}\n\n.mb-5\n{\n    margin-bottom: 5% !important;\n}\n\n.mb-6\n{\n    margin-bottom: 6% !important;\n}\n\n.mb-7\n{\n    margin-bottom: 7% !important;\n}\n\n.mb-8\n{\n    margin-bottom: 8% !important;\n}\n\n.mb-9\n{\n    margin-bottom: 9% !important;\n}\n\n.mb-10\n{\n    margin-bottom: 10% !important;\n}\n\n/* Padding All */\n.padding-1\n{\n    padding: 1% !important;\n}\n\n.padding-2\n{\n    padding: 2% !important;\n}\n\n.padding-3\n{\n    padding: 3% !important;\n}\n\n.padding-4\n{\n    padding: 4% !important;\n}\n\n.padding-5\n{\n    padding: 5% !important;\n}\n\n.padding-6\n{\n    padding: 6% !important;\n}\n\n.padding-7\n{\n    padding: 7% !important;\n}\n\n.padding-8\n{\n    padding: 8% !important;\n}\n\n.padding-9\n{\n    padding: 9% !important;\n}\n\n.padding-10\n{\n    padding: 10% !important;\n}\n\n.p-0\n{\n    padding: 0 !important;\n}\n\n/* Padding Top */\n.pt-0\n{\n    padding-top: 0 !important;\n}\n\n.pt-1\n{\n    padding-top: 1% !important;\n}\n\n.pt-2\n{\n    padding-top: 2% !important;\n}\n\n.pt-3\n{\n    padding-top: 3% !important;\n}\n\n.pt-4\n{\n    padding-top: 4% !important;\n}\n\n.pt-5\n{\n    padding-top: 5% !important;\n}\n\n.pt-6\n{\n    padding-top: 6% !important;\n}\n\n.pt-7\n{\n    padding-top: 7% !important;\n}\n\n.pt-8\n{\n    padding-top: 8% !important;\n}\n\n.pt-9\n{\n    padding-top: 9% !important;\n}\n\n.pt-10\n{\n    padding-top: 10% !important;\n}\n\n/* Padding Right */\n.pr-0\n{\n    padding-right: 0 !important;\n}\n\n.pr-1\n{\n    padding-right: 1% !important;\n}\n\n.pr-2\n{\n    padding-right: 2% !important;\n}\n\n.pr-3\n{\n    padding-right: 3% !important;\n}\n\n.pr-4\n{\n    padding-right: 4% !important;\n}\n\n.pr-5\n{\n    padding-right: 5% !important;\n}\n\n.pr-6\n{\n    padding-right: 6% !important;\n}\n\n.pr-7\n{\n    padding-right: 7% !important;\n}\n\n.pr-8\n{\n    padding-right: 8% !important;\n}\n\n.pr-9\n{\n    padding-right: 9% !important;\n}\n\n.pr-10\n{\n    padding-right: 10% !important;\n}\n\n/* Padding Right */\n.pl-0\n{\n    padding-left: 0 !important;\n}\n\n.pl-1\n{\n    padding-left: 1% !important;\n}\n\n.pl-2\n{\n    padding-left: 2% !important;\n}\n\n.pl-3\n{\n    padding-left: 3% !important;\n}\n\n.pl-4\n{\n    padding-left: 4% !important;\n}\n\n.pl-5\n{\n    padding-left: 5% !important;\n}\n\n.pl-6\n{\n    padding-left: 6% !important;\n}\n\n.pl-7\n{\n    padding-left: 7% !important;\n}\n\n.pl-8\n{\n    padding-left: 8% !important;\n}\n\n.pl-9\n{\n    padding-left: 9% !important;\n}\n\n.pl-10\n{\n    padding-left: 10% !important;\n}\n\n/* Padding Bottom */\n.pb-0\n{\n    padding-bottom: 0 !important;\n}\n\n.pb-1\n{\n    padding-bottom: 1% !important;\n}\n\n.pb-2\n{\n    padding-bottom: 2% !important;\n}\n\n.pb-3\n{\n    padding-bottom: 3% !important;\n}\n\n.pb-4\n{\n    padding-bottom: 4% !important;\n}\n\n.pb-5\n{\n    padding-bottom: 5% !important;\n}\n\n.pb-6\n{\n    padding-bottom: 6% !important;\n}\n\n.pb-7\n{\n    padding-bottom: 7% !important;\n}\n\n.pb-8\n{\n    padding-bottom: 8% !important;\n}\n\n.pb-9\n{\n    padding-bottom: 9% !important;\n}\n\n.pb-10\n{\n    padding-bottom: 10% !important;\n}\n\n/* Minimum Height */\n.min-height-100\n{\n    min-height: 100px !important;\n}\n\n.min-height-150\n{\n    min-height: 150px !important;\n}\n\n.min-height-200\n{\n    min-height: 200px !important;\n}\n\n.min-height-250\n{\n    min-height: 250px !important;\n}\n\n.min-height-300\n{\n    min-height: 300px !important;\n}\n\n@media (min-width: 576px)\n{\n    .left-align-sm\n    {\n        text-align: left !important;\n    }\n    .right-align-sm\n    {\n        text-align: right !important;\n    }\n    .center-align-sm\n    {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 768px)\n{\n    .left-align-md\n    {\n        text-align: left !important;\n    }\n    .right-align-md\n    {\n        text-align: right !important;\n    }\n    .center-align-md\n    {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 992px)\n{\n    .left-align-lg\n    {\n        text-align: left !important;\n    }\n    .right-align-lg\n    {\n        text-align: right !important;\n    }\n    .center-align-lg\n    {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 1200px)\n{\n    .left-align-xl\n    {\n        text-align: left !important;\n    }\n    .right-align-xl\n    {\n        text-align: right !important;\n    }\n    .center-align-xl\n    {\n        text-align: center !important;\n    }\n}\n\n.mx-auto\n{\n    margin-right: auto !important;\n    margin-left: auto !important;\n}\n\n.text-lowercase\n{\n    text-transform: lowercase !important;\n}\n\n.text-uppercase\n{\n    text-transform: uppercase !important;\n}\n\n.text-capitalize\n{\n    text-transform: capitalize !important;\n}\n\n/* Icon Background Round */\n.background-round\n{\n    padding: 15px;\n\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, .18);\n}\n\n.cursor-pointer\n{\n    cursor: pointer;\n}\n\n/* opacity 0 */\n.opacity-0\n{\n    opacity: 0;\n}\n\n/* Border None & Shadow None */\n.border-none\n{\n    border-top: none !important;\n    border-right: none !important;\n    border-bottom: none !important;\n    border-left: none !important;\n}\n\n.box-shadow-none\n{\n    box-shadow: none !important;\n}\n\n/* Margin 0 & Padding 0 */\n.no-margin\n{\n    margin: 0 !important;\n}\n\n.no-padding\n{\n    padding: 0 !important;\n}\n\n/* Position */\n.position-absolute\n{\n    position: absolute;\n}\n\n.position-none\n{\n    position: unset;\n}\n\n/* Vertical Align */\n.vertical-align-center\n{\n    position: absolute;\n    top: 50%;\n\n    -webkit-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n}\n\n.vertical-align-bottom\n{\n    vertical-align: bottom;\n}\n\n.vertical-align-super\n{\n    vertical-align: super;\n}\n\n.vertical-text-top\n{\n    vertical-align: text-top !important;\n}\n\n.vertical-text-sub\n{\n    vertical-align: sub;\n}\n\n.vertical-text-middle\n{\n    vertical-align: middle;\n}\n\n.height-100vh\n{\n    height: 100vh;\n}\n\n/* Line Height */\n.line-height-0\n{\n    line-height: 0 !important;\n}\n\n/* Icon Background */\n.icon-bg-circle\n{\n    padding: .4rem;\n\n    color: #fff;\n    border-radius: 50%;\n}\n\n.text-shadow\n{\n    text-shadow: -1px 2px 4px black;\n}\n\n.display-none\n{\n    display: none;\n}\n\n.display-inline\n{\n    display: inline;\n}\n\n.display-block\n{\n    display: block;\n}\n\n.display-grid\n{\n    display: grid;\n}\n\n.display-flex\n{\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display:         flex;\n}\n\n.float-none\n{\n    float: none !important;\n}\n\n.float-left\n{\n    float: left !important;\n}\n\n.float-right\n{\n    float: right !important;\n}\n\n.float-inherit\n{\n    float: inherit !important;\n}\n\n.clear-both\n{\n    clear: both;\n}\n\nul.list-type-bullet\n{\n    padding-left: 40px;\n\n    list-style-type: inherit;\n}\n\nul.list-type-bullet li\n{\n    list-style-type: inherit;\n}\n\n.justify-content-end\n{\n    -webkit-box-pack: end;\n    -webkit-justify-content: flex-end;\n    -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n\n.justify-content-between\n{\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n\n.justify-content-center\n{\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n            justify-content: center;\n}\n\n.align-items-center\n{\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n            align-items: center;\n}\n\n.flex-grow-1\n{\n    -webkit-box-flex: 1;\n    -webkit-flex-grow: 1;\n    -ms-flex-positive: 1;\n            flex-grow: 1;\n}\n\n.flex-wrap\n{\n    -webkit-flex-wrap: wrap;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n}\n\n.flex-column\n{\n            flex-direction: column;\n\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n}\n\n.text-ellipsis\n{\n    overflow: hidden;\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.text-nowrap\n{\n    white-space: nowrap;\n}\n\n/*---------------------------------\n    Typography\n-----------------------------------*/\na\n{\n    text-decoration: none;\n}\n\nhtml\n{\n    font-family: 'Muli', sans-serif !important;\n    font-weight: normal;\n    line-height: 1.5;\n\n    color: #6b6f82;\n}\n\n@media only screen and (min-width: 0)\n{\n    html\n    {\n        font-size: 14px;\n    }\n}\n\n@media only screen and (min-width: 992px)\n{\n    html\n    {\n        font-size: 14.5px;\n    }\n}\n\n@media only screen and (min-width: 1200px)\n{\n    html\n    {\n        font-size: 15px;\n    }\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6\n{\n    font-family: 'Muli', sans-serif;\n    font-weight: 400;\n    line-height: 1.1;\n\n    color: #333;\n}\nh6.text_pt {\n    background: #ffd500;\n    width: fit-content;\n    padding: 10px;\n    border-radius: 5px;\n    font-weight: 500;\n}\n\np\n{\n    font-family: 'Muli', sans-serif;\n}\n\nh1 a,\nh2 a,\nh3 a,\nh4 a,\nh5 a,\nh6 a\n{\n    font-weight: inherit;\n}\n\nh1\n{\n    font-size: 4.2rem;\n    line-height: 110%;\n\n    margin: 2.1rem 0 1.68rem 0;\n}\n\nh2\n{\n    font-size: 3.56rem;\n    line-height: 110%;\n\n    margin: 1.78rem 0 1.424rem 0;\n}\n\nh3\n{\n    font-size: 2.92rem;\n    line-height: 110%;\n\n    margin: 1.46rem 0 1.168rem 0;\n}\n\nh4\n{\n    font-size: 2.28rem;\n    line-height: 110%;\n\n    margin: 1.14rem 0 .912rem 0;\n}\n\nh5\n{\n    font-size: 1.64rem;\n    line-height: 110%;\n\n    margin: .82rem 0 .656rem 0;\n}\n\nh6\n{\n    font-size: 1.15rem;\n    line-height: 110%;\n\n    margin: .575rem 0 .46rem 0;\n}\n\nem\n{\n    font-style: italic;\n}\n\nstrong\n{\n    font-weight: 500;\n}\n\nsmall\n{\n    font-size: 75%;\n}\n\n.light\n{\n    font-weight: 300;\n}\n\n.thin\n{\n    font-weight: 200;\n}\n\n.flow-text\n{\n    font-weight: 300;\n}\n\n@media only screen and (min-width: 360px)\n{\n    .flow-text\n    {\n        font-size: 1.2rem;\n    }\n}\n\n@media only screen and (min-width: 390px)\n{\n    .flow-text\n    {\n        font-size: 1.224rem;\n    }\n}\n\n@media only screen and (min-width: 420px)\n{\n    .flow-text\n    {\n        font-size: 1.248rem;\n    }\n}\n\n@media only screen and (min-width: 450px)\n{\n    .flow-text\n    {\n        font-size: 1.272rem;\n    }\n}\n\n@media only screen and (min-width: 480px)\n{\n    .flow-text\n    {\n        font-size: 1.296rem;\n    }\n}\n\n@media only screen and (min-width: 510px)\n{\n    .flow-text\n    {\n        font-size: 1.32rem;\n    }\n}\n\n@media only screen and (min-width: 540px)\n{\n    .flow-text\n    {\n        font-size: 1.344rem;\n    }\n}\n\n@media only screen and (min-width: 570px)\n{\n    .flow-text\n    {\n        font-size: 1.368rem;\n    }\n}\n\n@media only screen and (min-width: 600px)\n{\n    .flow-text\n    {\n        font-size: 1.392rem;\n    }\n}\n\n@media only screen and (min-width: 630px)\n{\n    .flow-text\n    {\n        font-size: 1.416rem;\n    }\n}\n\n@media only screen and (min-width: 660px)\n{\n    .flow-text\n    {\n        font-size: 1.44rem;\n    }\n}\n\n@media only screen and (min-width: 690px)\n{\n    .flow-text\n    {\n        font-size: 1.464rem;\n    }\n}\n\n@media only screen and (min-width: 720px)\n{\n    .flow-text\n    {\n        font-size: 1.488rem;\n    }\n}\n\n@media only screen and (min-width: 750px)\n{\n    .flow-text\n    {\n        font-size: 1.512rem;\n    }\n}\n\n@media only screen and (min-width: 780px)\n{\n    .flow-text\n    {\n        font-size: 1.536rem;\n    }\n}\n\n@media only screen and (min-width: 810px)\n{\n    .flow-text\n    {\n        font-size: 1.56rem;\n    }\n}\n\n@media only screen and (min-width: 840px)\n{\n    .flow-text\n    {\n        font-size: 1.584rem;\n    }\n}\n\n@media only screen and (min-width: 870px)\n{\n    .flow-text\n    {\n        font-size: 1.608rem;\n    }\n}\n\n@media only screen and (min-width: 900px)\n{\n    .flow-text\n    {\n        font-size: 1.632rem;\n    }\n}\n\n@media only screen and (min-width: 930px)\n{\n    .flow-text\n    {\n        font-size: 1.656rem;\n    }\n}\n\n@media only screen and (min-width: 960px)\n{\n    .flow-text\n    {\n        font-size: 1.68rem;\n    }\n}\n\n@media only screen and (max-width: 360px)\n{\n    .flow-text\n    {\n        font-size: 1.2rem;\n    }\n}\n\n@media only screen and (max-width: 768px)\n{\n    .nav-expanded .brand-sidebar\n    {\n        background: transparent !important;\n    }\n    .brand-sidebar .logo-wrapper\n    {\n        padding: 17px 18px !important;\n\n        text-align: center;\n\n        background: transparent;\n    }\n}\n\n.small\n{\n    font-size: 1.0rem !important;\n}\n\n.medium-small\n{\n    font-size: .9rem !important;\n}\n\n.ultra-small\n{\n    font-size: .8rem !important;\n}\n\nsmall\n{\n    font-size: .8rem;\n}\n\n.strong\n{\n    font-weight: 600;\n}\n\nh4.header\n{\n    font-size: 1.4rem;\n    font-weight: 400;\n    line-height: 2.508rem;\n\n    margin: 1.14rem 0 .912rem 0;\n\n    text-transform: uppercase;\n}\n\nh4.header2\n{\n    font-size: 1.1rem;\n    font-weight: 400;\n\n    text-transform: uppercase;\n}\n\np.title\n{\n    font-size: 1.3rem;\n}\n\np.header\n{\n    font-size: 1rem;\n    font-weight: 500;\n\n    text-transform: uppercase;\n}\n\nli.li-hover:hover\n{\n    background: transparent !important;\n}\n\nli.search-out:hover\n{\n    background: transparent;\n}\n\nli.mobile:before\n{\n    background: #f7464a;\n}\n\nli.kitchen:before\n{\n    background: #46bfbd;\n}\n\nli.home:before\n{\n    background: #fdb45c;\n}\n\n.more-text\n{\n    font-weight: 500;\n\n    padding: 5px 20px;\n\n    letter-spacing: 1px;\n    text-transform: uppercase;\n}\n\n.valign-demo\n{\n    height: 400px;\n\n    background-color: #ddd;\n}\n\n.margin\n{\n    margin: 0 !important;\n}\n\n.uppercase\n{\n    text-transform: uppercase;\n}\n\n/*----------------------------------------\n  Grid \n------------------------------------------*/\n.section\n{\n    padding: .5rem 0;\n}\n\n.row\n{\n    margin-bottom: 0;\n}\n\n.row .col\n{\n    padding: 0 1rem;\n}\n\n.materialize-red\n{\n    background-color: #e51c23 !important;\n}\n\n.materialize-red-text\n{\n    color: #e51c23 !important;\n}\n\n.materialize-red.lighten-5\n{\n    background-color: #fdeaeb !important;\n}\n\n.materialize-red-text.text-lighten-5\n{\n    color: #fdeaeb !important;\n}\n\n.materialize-red.lighten-4\n{\n    background-color: #f8c1c3 !important;\n}\n\n.materialize-red-text.text-lighten-4\n{\n    color: #f8c1c3 !important;\n}\n\n.materialize-red.lighten-3\n{\n    background-color: #f3989b !important;\n}\n\n.materialize-red-text.text-lighten-3\n{\n    color: #f3989b !important;\n}\n\n.materialize-red.lighten-2\n{\n    background-color: #ee6e73 !important;\n}\n\n.materialize-red-text.text-lighten-2\n{\n    color: #ee6e73 !important;\n}\n\n.materialize-red.lighten-1\n{\n    background-color: #ea454b !important;\n}\n\n.materialize-red-text.text-lighten-1\n{\n    color: #ea454b !important;\n}\n\n.materialize-red.darken-1\n{\n    background-color: #d0181e !important;\n}\n\n.materialize-red-text.text-darken-1\n{\n    color: #d0181e !important;\n}\n\n.materialize-red.darken-2\n{\n    background-color: #b9151b !important;\n}\n\n.materialize-red-text.text-darken-2\n{\n    color: #b9151b !important;\n}\n\n.materialize-red.darken-3\n{\n    background-color: #a21318 !important;\n}\n\n.materialize-red-text.text-darken-3\n{\n    color: #a21318 !important;\n}\n\n.materialize-red.darken-4\n{\n    background-color: #8b1014 !important;\n}\n\n.materialize-red-text.text-darken-4\n{\n    color: #8b1014 !important;\n}\n\n.red\n{\n    background-color: #f44336 !important;\n}\n\n.red-text\n{\n    color: #f44336 !important;\n}\n\n.red.lighten-5\n{\n    background-color: #ffebee !important;\n}\n\n.red-text.text-lighten-5\n{\n    color: #ffebee !important;\n}\n\n.red.lighten-4\n{\n    background-color: #ffcdd2 !important;\n}\n\n.red-text.text-lighten-4\n{\n    color: #ffcdd2 !important;\n}\n\n.red.lighten-3\n{\n    background-color: #ef9a9a !important;\n}\n\n.red-text.text-lighten-3\n{\n    color: #ef9a9a !important;\n}\n\n.red.lighten-2\n{\n    background-color: #e57373 !important;\n}\n\n.red-text.text-lighten-2\n{\n    color: #e57373 !important;\n}\n\n.red.lighten-1\n{\n    background-color: #ef5350 !important;\n}\n\n.red-text.text-lighten-1\n{\n    color: #ef5350 !important;\n}\n\n.red.darken-1\n{\n    background-color: #e53935 !important;\n}\n\n.red-text.text-darken-1\n{\n    color: #e53935 !important;\n}\n\n.red.darken-2\n{\n    background-color: #d32f2f !important;\n}\n\n.red-text.text-darken-2\n{\n    color: #d32f2f !important;\n}\n\n.red.darken-3\n{\n    background-color: #c62828 !important;\n}\n\n.red-text.text-darken-3\n{\n    color: #c62828 !important;\n}\n\n.red.darken-4\n{\n    background-color: #b71c1c !important;\n}\n\n.red-text.text-darken-4\n{\n    color: #b71c1c !important;\n}\n\n.red.accent-1\n{\n    background-color: #ff8a80 !important;\n}\n\n.red-text.text-accent-1\n{\n    color: #ff8a80 !important;\n}\n\n.red.accent-2\n{\n    background-color: #ff5252 !important;\n}\n\n.red-text.text-accent-2\n{\n    color: #ff5252 !important;\n}\n\n.red.accent-3\n{\n    background-color: #ff1744 !important;\n}\n\n.red-text.text-accent-3\n{\n    color: #ff1744 !important;\n}\n\n.red.accent-4\n{\n    background-color: #d50000 !important;\n}\n\n.red-text.text-accent-4\n{\n    color: #d50000 !important;\n}\n\n.pink\n{\n    background-color: #e91e63 !important;\n}\n\n.pink-text\n{\n    color: #e91e63 !important;\n}\n\n.pink.lighten-5\n{\n    background-color: #fce4ec !important;\n}\n\n.pink-text.text-lighten-5\n{\n    color: #fce4ec !important;\n}\n\n.pink.lighten-4\n{\n    background-color: #f8bbd0 !important;\n}\n\n.pink-text.text-lighten-4\n{\n    color: #f8bbd0 !important;\n}\n\n.pink.lighten-3\n{\n    background-color: #f48fb1 !important;\n}\n\n.pink-text.text-lighten-3\n{\n    color: #f48fb1 !important;\n}\n\n.pink.lighten-2\n{\n    background-color: #f06292 !important;\n}\n\n.pink-text.text-lighten-2\n{\n    color: #f06292 !important;\n}\n\n.pink.lighten-1\n{\n    background-color: #ec407a !important;\n}\n\n.pink-text.text-lighten-1\n{\n    color: #ec407a !important;\n}\n\n.pink.darken-1\n{\n    background-color: #d81b60 !important;\n}\n\n.pink-text.text-darken-1\n{\n    color: #d81b60 !important;\n}\n\n.pink.darken-2\n{\n    background-color: #c2185b !important;\n}\n\n.pink-text.text-darken-2\n{\n    color: #c2185b !important;\n}\n\n.pink.darken-3\n{\n    background-color: #ad1457 !important;\n}\n\n.pink-text.text-darken-3\n{\n    color: #ad1457 !important;\n}\n\n.pink.darken-4\n{\n    background-color: #880e4f !important;\n}\n\n.pink-text.text-darken-4\n{\n    color: #880e4f !important;\n}\n\n.pink.accent-1\n{\n    background-color: #ff80ab !important;\n}\n\n.pink-text.text-accent-1\n{\n    color: #ff80ab !important;\n}\n\n.pink.accent-2\n{\n    background-color: #ff4081 !important;\n}\n\n.pink-text.text-accent-2\n{\n    color: #ff4081 !important;\n}\n\n.pink.accent-3\n{\n    background-color: #f50057 !important;\n}\n\n.pink-text.text-accent-3\n{\n    color: #f50057 !important;\n}\n\n.pink.accent-4\n{\n    background-color: #c51162 !important;\n}\n\n.pink-text.text-accent-4\n{\n    color: #c51162 !important;\n}\n\n.purple\n{\n    background-color: #9c27b0 !important;\n}\n\n.purple-text\n{\n    color: #9c27b0 !important;\n}\n\n.purple.lighten-5\n{\n    background-color: #f3e5f5 !important;\n}\n\n.purple-text.text-lighten-5\n{\n    color: #f3e5f5 !important;\n}\n\n.purple.lighten-4\n{\n    background-color: #e1bee7 !important;\n}\n\n.purple-text.text-lighten-4\n{\n    color: #e1bee7 !important;\n}\n\n.purple.lighten-3\n{\n    background-color: #ce93d8 !important;\n}\n\n.purple-text.text-lighten-3\n{\n    color: #ce93d8 !important;\n}\n\n.purple.lighten-2\n{\n    background-color: #ba68c8 !important;\n}\n\n.purple-text.text-lighten-2\n{\n    color: #ba68c8 !important;\n}\n\n.purple.lighten-1\n{\n    background-color: #ab47bc !important;\n}\n\n.purple-text.text-lighten-1\n{\n    color: #ab47bc !important;\n}\n\n.purple.darken-1\n{\n    background-color: #8e24aa !important;\n}\n\n.purple-text.text-darken-1\n{\n    color: #8e24aa !important;\n}\n\n.purple.darken-2\n{\n    background-color: #7b1fa2 !important;\n}\n\n.purple-text.text-darken-2\n{\n    color: #7b1fa2 !important;\n}\n\n.purple.darken-3\n{\n    background-color: #6a1b9a !important;\n}\n\n.purple-text.text-darken-3\n{\n    color: #6a1b9a !important;\n}\n\n.purple.darken-4\n{\n    background-color: #4a148c !important;\n}\n\n.purple-text.text-darken-4\n{\n    color: #4a148c !important;\n}\n\n.purple.accent-1\n{\n    background-color: #ea80fc !important;\n}\n\n.purple-text.text-accent-1\n{\n    color: #ea80fc !important;\n}\n\n.purple.accent-2\n{\n    background-color: #e040fb !important;\n}\n\n.purple-text.text-accent-2\n{\n    color: #e040fb !important;\n}\n\n.purple.accent-3\n{\n    background-color: #d500f9 !important;\n}\n\n.purple-text.text-accent-3\n{\n    color: #d500f9 !important;\n}\n\n.purple.accent-4\n{\n    background-color: #a0f !important;\n}\n\n.purple-text.text-accent-4\n{\n    color: #a0f !important;\n}\n\n.deep-purple\n{\n    background-color: #673ab7 !important;\n}\n\n.deep-purple-text\n{\n    color: #673ab7 !important;\n}\n\n.deep-purple.lighten-5\n{\n    background-color: #ede7f6 !important;\n}\n\n.deep-purple-text.text-lighten-5\n{\n    color: #ede7f6 !important;\n}\n\n.deep-purple.lighten-4\n{\n    background-color: #d1c4e9 !important;\n}\n\n.deep-purple-text.text-lighten-4\n{\n    color: #d1c4e9 !important;\n}\n\n.deep-purple.lighten-3\n{\n    background-color: #b39ddb !important;\n}\n\n.deep-purple-text.text-lighten-3\n{\n    color: #b39ddb !important;\n}\n\n.deep-purple.lighten-2\n{\n    background-color: #9575cd !important;\n}\n\n.deep-purple-text.text-lighten-2\n{\n    color: #9575cd !important;\n}\n\n.deep-purple.lighten-1\n{\n    background-color: #7e57c2 !important;\n}\n\n.deep-purple-text.text-lighten-1\n{\n    color: #7e57c2 !important;\n}\n\n.deep-purple.darken-1\n{\n    background-color: #5e35b1 !important;\n}\n\n.deep-purple-text.text-darken-1\n{\n    color: #5e35b1 !important;\n}\n\n.deep-purple.darken-2\n{\n    background-color: #512da8 !important;\n}\n\n.deep-purple-text.text-darken-2\n{\n    color: #512da8 !important;\n}\n\n.deep-purple.darken-3\n{\n    background-color: #4527a0 !important;\n}\n\n.deep-purple-text.text-darken-3\n{\n    color: #4527a0 !important;\n}\n\n.deep-purple.darken-4\n{\n    background-color: #311b92 !important;\n}\n\n.deep-purple-text.text-darken-4\n{\n    color: #311b92 !important;\n}\n\n.deep-purple.accent-1\n{\n    background-color: #b388ff !important;\n}\n\n.deep-purple-text.text-accent-1\n{\n    color: #b388ff !important;\n}\n\n.deep-purple.accent-2\n{\n    background-color: #7c4dff !important;\n}\n\n.deep-purple-text.text-accent-2\n{\n    color: #7c4dff !important;\n}\n\n.deep-purple.accent-3\n{\n    background-color: #651fff !important;\n}\n\n.deep-purple-text.text-accent-3\n{\n    color: #651fff !important;\n}\n\n.deep-purple.accent-4\n{\n    background-color: #6200ea !important;\n}\n\n.deep-purple-text.text-accent-4\n{\n    color: #6200ea !important;\n}\n\n.indigo\n{\n    background-color: #3f51b5 !important;\n}\n\n.indigo-text\n{\n    color: #3f51b5 !important;\n}\n\n.indigo.lighten-5\n{\n    background-color: #e8eaf6 !important;\n}\n\n.indigo-text.text-lighten-5\n{\n    color: #e8eaf6 !important;\n}\n\n.indigo.lighten-4\n{\n    background-color: #c5cae9 !important;\n}\n\n.indigo-text.text-lighten-4\n{\n    color: #c5cae9 !important;\n}\n\n.indigo.lighten-3\n{\n    background-color: #9fa8da !important;\n}\n\n.indigo-text.text-lighten-3\n{\n    color: #9fa8da !important;\n}\n\n.indigo.lighten-2\n{\n    background-color: #7986cb !important;\n}\n\n.indigo-text.text-lighten-2\n{\n    color: #7986cb !important;\n}\n\n.indigo.lighten-1\n{\n    background-color: #5c6bc0 !important;\n}\n\n.indigo-text.text-lighten-1\n{\n    color: #5c6bc0 !important;\n}\n\n.indigo.darken-1\n{\n    background-color: #3949ab !important;\n}\n\n.indigo-text.text-darken-1\n{\n    color: #3949ab !important;\n}\n\n.indigo.darken-2\n{\n    background-color: #303f9f !important;\n}\n\n.indigo-text.text-darken-2\n{\n    color: #303f9f !important;\n}\n\n.indigo.darken-3\n{\n    background-color: #283593 !important;\n}\n\n.indigo-text.text-darken-3\n{\n    color: #283593 !important;\n}\n\n.indigo.darken-4\n{\n    background-color: #1a237e !important;\n}\n\n.indigo-text.text-darken-4\n{\n    color: #1a237e !important;\n}\n\n.indigo.accent-1\n{\n    background-color: #8c9eff !important;\n}\n\n.indigo-text.text-accent-1\n{\n    color: #8c9eff !important;\n}\n\n.indigo.accent-2\n{\n    background-color: #536dfe !important;\n}\n\n.indigo-text.text-accent-2\n{\n    color: #536dfe !important;\n}\n\n.indigo.accent-3\n{\n    background-color: #3d5afe !important;\n}\n\n.indigo-text.text-accent-3\n{\n    color: #3d5afe !important;\n}\n\n.indigo.accent-4\n{\n    background-color: #304ffe !important;\n}\n\n.indigo-text.text-accent-4\n{\n    color: #304ffe !important;\n}\n\n.blue\n{\n    background-color: #2196f3 !important;\n}\n\n.blue-text\n{\n    color: #2196f3 !important;\n}\n\n.blue.lighten-5\n{\n    background-color: #e3f2fd !important;\n}\n\n.blue-text.text-lighten-5\n{\n    color: #e3f2fd !important;\n}\n\n.blue.lighten-4\n{\n    background-color: #bbdefb !important;\n}\n\n.blue-text.text-lighten-4\n{\n    color: #bbdefb !important;\n}\n\n.blue.lighten-3\n{\n    background-color: #90caf9 !important;\n}\n\n.blue-text.text-lighten-3\n{\n    color: #90caf9 !important;\n}\n\n.blue.lighten-2\n{\n    background-color: #64b5f6 !important;\n}\n\n.blue-text.text-lighten-2\n{\n    color: #64b5f6 !important;\n}\n\n.blue.lighten-1\n{\n    background-color: #42a5f5 !important;\n}\n\n.blue-text.text-lighten-1\n{\n    color: #42a5f5 !important;\n}\n\n.blue.darken-1\n{\n    background-color: #1e88e5 !important;\n}\n\n.blue-text.text-darken-1\n{\n    color: #1e88e5 !important;\n}\n\n.blue.darken-2\n{\n    background-color: #1976d2 !important;\n}\n\n.blue-text.text-darken-2\n{\n    color: #1976d2 !important;\n}\n\n.blue.darken-3\n{\n    background-color: #1565c0 !important;\n}\n\n.blue-text.text-darken-3\n{\n    color: #1565c0 !important;\n}\n\n.blue.darken-4\n{\n    background-color: #0d47a1 !important;\n}\n\n.blue-text.text-darken-4\n{\n    color: #0d47a1 !important;\n}\n\n.blue.accent-1\n{\n    background-color: #82b1ff !important;\n}\n\n.blue-text.text-accent-1\n{\n    color: #82b1ff !important;\n}\n\n.blue.accent-2\n{\n    background-color: #448aff !important;\n}\n\n.blue-text.text-accent-2\n{\n    color: #448aff !important;\n}\n\n.blue.accent-3\n{\n    background-color: #2979ff !important;\n}\n\n.blue-text.text-accent-3\n{\n    color: #2979ff !important;\n}\n\n.blue.accent-4\n{\n    background-color: #2962ff !important;\n}\n\n.blue-text.text-accent-4\n{\n    color: #2962ff !important;\n}\n\n.light-blue\n{\n    background-color: #03a9f4 !important;\n}\n\n.light-blue-text\n{\n    color: #03a9f4 !important;\n}\n\n.light-blue.lighten-5\n{\n    background-color: #e1f5fe !important;\n}\n\n.light-blue-text.text-lighten-5\n{\n    color: #e1f5fe !important;\n}\n\n.light-blue.lighten-4\n{\n    background-color: #b3e5fc !important;\n}\n\n.light-blue-text.text-lighten-4\n{\n    color: #b3e5fc !important;\n}\n\n.light-blue.lighten-3\n{\n    background-color: #81d4fa !important;\n}\n\n.light-blue-text.text-lighten-3\n{\n    color: #81d4fa !important;\n}\n\n.light-blue.lighten-2\n{\n    background-color: #4fc3f7 !important;\n}\n\n.light-blue-text.text-lighten-2\n{\n    color: #4fc3f7 !important;\n}\n\n.light-blue.lighten-1\n{\n    background-color: #29b6f6 !important;\n}\n\n.light-blue-text.text-lighten-1\n{\n    color: #29b6f6 !important;\n}\n\n.light-blue.darken-1\n{\n    background-color: #039be5 !important;\n}\n\n.light-blue-text.text-darken-1\n{\n    color: #039be5 !important;\n}\n\n.light-blue.darken-2\n{\n    background-color: #0288d1 !important;\n}\n\n.light-blue-text.text-darken-2\n{\n    color: #0288d1 !important;\n}\n\n.light-blue.darken-3\n{\n    background-color: #0277bd !important;\n}\n\n.light-blue-text.text-darken-3\n{\n    color: #0277bd !important;\n}\n\n.light-blue.darken-4\n{\n    background-color: #01579b !important;\n}\n\n.light-blue-text.text-darken-4\n{\n    color: #01579b !important;\n}\n\n.light-blue.accent-1\n{\n    background-color: #80d8ff !important;\n}\n\n.light-blue-text.text-accent-1\n{\n    color: #80d8ff !important;\n}\n\n.light-blue.accent-2\n{\n    background-color: #40c4ff !important;\n}\n\n.light-blue-text.text-accent-2\n{\n    color: #40c4ff !important;\n}\n\n.light-blue.accent-3\n{\n    background-color: #00b0ff !important;\n}\n\n.light-blue-text.text-accent-3\n{\n    color: #00b0ff !important;\n}\n\n.light-blue.accent-4\n{\n    background-color: #0091ea !important;\n}\n\n.light-blue-text.text-accent-4\n{\n    color: #0091ea !important;\n}\n\n.cyan\n{\n    background-color: #00bcd4 !important;\n}\n\n.cyan-text\n{\n    color: #00bcd4 !important;\n}\n\n.cyan.lighten-5\n{\n    background-color: #e0f7fa !important;\n}\n\n.cyan-text.text-lighten-5\n{\n    color: #e0f7fa !important;\n}\n\n.cyan.lighten-4\n{\n    background-color: #b2ebf2 !important;\n}\n\n.cyan-text.text-lighten-4\n{\n    color: #b2ebf2 !important;\n}\n\n.cyan.lighten-3\n{\n    background-color: #80deea !important;\n}\n\n.cyan-text.text-lighten-3\n{\n    color: #80deea !important;\n}\n\n.cyan.lighten-2\n{\n    background-color: #4dd0e1 !important;\n}\n\n.cyan-text.text-lighten-2\n{\n    color: #4dd0e1 !important;\n}\n\n.cyan.lighten-1\n{\n    background-color: #26c6da !important;\n}\n\n.cyan-text.text-lighten-1\n{\n    color: #26c6da !important;\n}\n\n.cyan.darken-1\n{\n    background-color: #00acc1 !important;\n}\n\n.cyan-text.text-darken-1\n{\n    color: #00acc1 !important;\n}\n\n.cyan.darken-2\n{\n    background-color: #0097a7 !important;\n}\n\n.cyan-text.text-darken-2\n{\n    color: #0097a7 !important;\n}\n\n.cyan.darken-3\n{\n    background-color: #00838f !important;\n}\n\n.cyan-text.text-darken-3\n{\n    color: #00838f !important;\n}\n\n.cyan.darken-4\n{\n    background-color: #006064 !important;\n}\n\n.cyan-text.text-darken-4\n{\n    color: #006064 !important;\n}\n\n.cyan.accent-1\n{\n    background-color: #84ffff !important;\n}\n\n.cyan-text.text-accent-1\n{\n    color: #84ffff !important;\n}\n\n.cyan.accent-2\n{\n    background-color: #18ffff !important;\n}\n\n.cyan-text.text-accent-2\n{\n    color: #18ffff !important;\n}\n\n.cyan.accent-3\n{\n    background-color: #00e5ff !important;\n}\n\n.cyan-text.text-accent-3\n{\n    color: #00e5ff !important;\n}\n\n.cyan.accent-4\n{\n    background-color: #00b8d4 !important;\n}\n\n.cyan-text.text-accent-4\n{\n    color: #00b8d4 !important;\n}\n\n.teal\n{\n    background-color: #009688 !important;\n}\n\n.teal-text\n{\n    color: #009688 !important;\n}\n\n.teal.lighten-5\n{\n    background-color: #e0f2f1 !important;\n}\n\n.teal-text.text-lighten-5\n{\n    color: #e0f2f1 !important;\n}\n\n.teal.lighten-4\n{\n    background-color: #b2dfdb !important;\n}\n\n.teal-text.text-lighten-4\n{\n    color: #b2dfdb !important;\n}\n\n.teal.lighten-3\n{\n    background-color: #80cbc4 !important;\n}\n\n.teal-text.text-lighten-3\n{\n    color: #80cbc4 !important;\n}\n\n.teal.lighten-2\n{\n    background-color: #4db6ac !important;\n}\n\n.teal-text.text-lighten-2\n{\n    color: #4db6ac !important;\n}\n\n.teal.lighten-1\n{\n    background-color: #26a69a !important;\n}\n\n.teal-text.text-lighten-1\n{\n    color: #26a69a !important;\n}\n\n.teal.darken-1\n{\n    background-color: #00897b !important;\n}\n\n.teal-text.text-darken-1\n{\n    color: #00897b !important;\n}\n\n.teal.darken-2\n{\n    background-color: #00796b !important;\n}\n\n.teal-text.text-darken-2\n{\n    color: #00796b !important;\n}\n\n.teal.darken-3\n{\n    background-color: #00695c !important;\n}\n\n.teal-text.text-darken-3\n{\n    color: #00695c !important;\n}\n\n.teal.darken-4\n{\n    background-color: #004d40 !important;\n}\n\n.teal-text.text-darken-4\n{\n    color: #004d40 !important;\n}\n\n.teal.accent-1\n{\n    background-color: #a7ffeb !important;\n}\n\n.teal-text.text-accent-1\n{\n    color: #a7ffeb !important;\n}\n\n.teal.accent-2\n{\n    background-color: #64ffda !important;\n}\n\n.teal-text.text-accent-2\n{\n    color: #64ffda !important;\n}\n\n.teal.accent-3\n{\n    background-color: #1de9b6 !important;\n}\n\n.teal-text.text-accent-3\n{\n    color: #1de9b6 !important;\n}\n\n.teal.accent-4\n{\n    background-color: #00bfa5 !important;\n}\n\n.teal-text.text-accent-4\n{\n    color: #00bfa5 !important;\n}\n\n.green\n{\n    background-color: #4caf50 !important;\n}\n\n.green-text\n{\n    color: #4caf50 !important;\n}\n\n.green.lighten-5\n{\n    background-color: #e8f5e9 !important;\n}\n\n.green-text.text-lighten-5\n{\n    color: #e8f5e9 !important;\n}\n\n.green.lighten-4\n{\n    background-color: #c8e6c9 !important;\n}\n\n.green-text.text-lighten-4\n{\n    color: #c8e6c9 !important;\n}\n\n.green.lighten-3\n{\n    background-color: #a5d6a7 !important;\n}\n\n.green-text.text-lighten-3\n{\n    color: #a5d6a7 !important;\n}\n\n.green.lighten-2\n{\n    background-color: #81c784 !important;\n}\n\n.green-text.text-lighten-2\n{\n    color: #81c784 !important;\n}\n\n.green.lighten-1\n{\n    background-color: #66bb6a !important;\n}\n\n.green-text.text-lighten-1\n{\n    color: #66bb6a !important;\n}\n\n.green.darken-1\n{\n    background-color: #43a047 !important;\n}\n\n.green-text.text-darken-1\n{\n    color: #43a047 !important;\n}\n\n.green.darken-2\n{\n    background-color: #388e3c !important;\n}\n\n.green-text.text-darken-2\n{\n    color: #388e3c !important;\n}\n\n.green.darken-3\n{\n    background-color: #2e7d32 !important;\n}\n\n.green-text.text-darken-3\n{\n    color: #2e7d32 !important;\n}\n\n.green.darken-4\n{\n    background-color: #1b5e20 !important;\n}\n\n.green-text.text-darken-4\n{\n    color: #1b5e20 !important;\n}\n\n.green.accent-1\n{\n    background-color: #b9f6ca !important;\n}\n\n.green-text.text-accent-1\n{\n    color: #b9f6ca !important;\n}\n\n.green.accent-2\n{\n    background-color: #69f0ae !important;\n}\n\n.green-text.text-accent-2\n{\n    color: #69f0ae !important;\n}\n\n.green.accent-3\n{\n    background-color: #00e676 !important;\n}\n\n.green-text.text-accent-3\n{\n    color: #00e676 !important;\n}\n\n.green.accent-4\n{\n    background-color: #00c853 !important;\n}\n\n.green-text.text-accent-4\n{\n    color: #00c853 !important;\n}\n\n.light-green\n{\n    background-color: #8bc34a !important;\n}\n\n.light-green-text\n{\n    color: #8bc34a !important;\n}\n\n.light-green.lighten-5\n{\n    background-color: #f1f8e9 !important;\n}\n\n.light-green-text.text-lighten-5\n{\n    color: #f1f8e9 !important;\n}\n\n.light-green.lighten-4\n{\n    background-color: #dcedc8 !important;\n}\n\n.light-green-text.text-lighten-4\n{\n    color: #dcedc8 !important;\n}\n\n.light-green.lighten-3\n{\n    background-color: #c5e1a5 !important;\n}\n\n.light-green-text.text-lighten-3\n{\n    color: #c5e1a5 !important;\n}\n\n.light-green.lighten-2\n{\n    background-color: #aed581 !important;\n}\n\n.light-green-text.text-lighten-2\n{\n    color: #aed581 !important;\n}\n\n.light-green.lighten-1\n{\n    background-color: #9ccc65 !important;\n}\n\n.light-green-text.text-lighten-1\n{\n    color: #9ccc65 !important;\n}\n\n.light-green.darken-1\n{\n    background-color: #7cb342 !important;\n}\n\n.light-green-text.text-darken-1\n{\n    color: #7cb342 !important;\n}\n\n.light-green.darken-2\n{\n    background-color: #689f38 !important;\n}\n\n.light-green-text.text-darken-2\n{\n    color: #689f38 !important;\n}\n\n.light-green.darken-3\n{\n    background-color: #558b2f !important;\n}\n\n.light-green-text.text-darken-3\n{\n    color: #558b2f !important;\n}\n\n.light-green.darken-4\n{\n    background-color: #33691e !important;\n}\n\n.light-green-text.text-darken-4\n{\n    color: #33691e !important;\n}\n\n.light-green.accent-1\n{\n    background-color: #ccff90 !important;\n}\n\n.light-green-text.text-accent-1\n{\n    color: #ccff90 !important;\n}\n\n.light-green.accent-2\n{\n    background-color: #b2ff59 !important;\n}\n\n.light-green-text.text-accent-2\n{\n    color: #b2ff59 !important;\n}\n\n.light-green.accent-3\n{\n    background-color: #76ff03 !important;\n}\n\n.light-green-text.text-accent-3\n{\n    color: #76ff03 !important;\n}\n\n.light-green.accent-4\n{\n    background-color: #64dd17 !important;\n}\n\n.light-green-text.text-accent-4\n{\n    color: #64dd17 !important;\n}\n\n.lime\n{\n    background-color: #cddc39 !important;\n}\n\n.lime-text\n{\n    color: #cddc39 !important;\n}\n\n.lime.lighten-5\n{\n    background-color: #f9fbe7 !important;\n}\n\n.lime-text.text-lighten-5\n{\n    color: #f9fbe7 !important;\n}\n\n.lime.lighten-4\n{\n    background-color: #f0f4c3 !important;\n}\n\n.lime-text.text-lighten-4\n{\n    color: #f0f4c3 !important;\n}\n\n.lime.lighten-3\n{\n    background-color: #e6ee9c !important;\n}\n\n.lime-text.text-lighten-3\n{\n    color: #e6ee9c !important;\n}\n\n.lime.lighten-2\n{\n    background-color: #dce775 !important;\n}\n\n.lime-text.text-lighten-2\n{\n    color: #dce775 !important;\n}\n\n.lime.lighten-1\n{\n    background-color: #d4e157 !important;\n}\n\n.lime-text.text-lighten-1\n{\n    color: #d4e157 !important;\n}\n\n.lime.darken-1\n{\n    background-color: #c0ca33 !important;\n}\n\n.lime-text.text-darken-1\n{\n    color: #c0ca33 !important;\n}\n\n.lime.darken-2\n{\n    background-color: #afb42b !important;\n}\n\n.lime-text.text-darken-2\n{\n    color: #afb42b !important;\n}\n\n.lime.darken-3\n{\n    background-color: #9e9d24 !important;\n}\n\n.lime-text.text-darken-3\n{\n    color: #9e9d24 !important;\n}\n\n.lime.darken-4\n{\n    background-color: #827717 !important;\n}\n\n.lime-text.text-darken-4\n{\n    color: #827717 !important;\n}\n\n.lime.accent-1\n{\n    background-color: #f4ff81 !important;\n}\n\n.lime-text.text-accent-1\n{\n    color: #f4ff81 !important;\n}\n\n.lime.accent-2\n{\n    background-color: #eeff41 !important;\n}\n\n.lime-text.text-accent-2\n{\n    color: #eeff41 !important;\n}\n\n.lime.accent-3\n{\n    background-color: #c6ff00 !important;\n}\n\n.lime-text.text-accent-3\n{\n    color: #c6ff00 !important;\n}\n\n.lime.accent-4\n{\n    background-color: #aeea00 !important;\n}\n\n.lime-text.text-accent-4\n{\n    color: #aeea00 !important;\n}\n\n.yellow\n{\n    background-color: #ffeb3b !important;\n}\n\n.yellow-text\n{\n    color: #ffeb3b !important;\n}\n\n.yellow.lighten-5\n{\n    background-color: #fffde7 !important;\n}\n\n.yellow-text.text-lighten-5\n{\n    color: #fffde7 !important;\n}\n\n.yellow.lighten-4\n{\n    background-color: #fff9c4 !important;\n}\n\n.yellow-text.text-lighten-4\n{\n    color: #fff9c4 !important;\n}\n\n.yellow.lighten-3\n{\n    background-color: #fff59d !important;\n}\n\n.yellow-text.text-lighten-3\n{\n    color: #fff59d !important;\n}\n\n.yellow.lighten-2\n{\n    background-color: #fff176 !important;\n}\n\n.yellow-text.text-lighten-2\n{\n    color: #fff176 !important;\n}\n\n.yellow.lighten-1\n{\n    background-color: #ffee58 !important;\n}\n\n.yellow-text.text-lighten-1\n{\n    color: #ffee58 !important;\n}\n\n.yellow.darken-1\n{\n    background-color: #fdd835 !important;\n}\n\n.yellow-text.text-darken-1\n{\n    color: #fdd835 !important;\n}\n\n.yellow.darken-2\n{\n    background-color: #fbc02d !important;\n}\n\n.yellow-text.text-darken-2\n{\n    color: #fbc02d !important;\n}\n\n.yellow.darken-3\n{\n    background-color: #f9a825 !important;\n}\n\n.yellow-text.text-darken-3\n{\n    color: #f9a825 !important;\n}\n\n.yellow.darken-4\n{\n    background-color: #f57f17 !important;\n}\n\n.yellow-text.text-darken-4\n{\n    color: #f57f17 !important;\n}\n\n.yellow.accent-1\n{\n    background-color: #ffff8d !important;\n}\n\n.yellow-text.text-accent-1\n{\n    color: #ffff8d !important;\n}\n\n.yellow.accent-2\n{\n    background-color: #ff0 !important;\n}\n\n.yellow-text.text-accent-2\n{\n    color: #ff0 !important;\n}\n\n.yellow.accent-3\n{\n    background-color: #ffea00 !important;\n}\n\n.yellow-text.text-accent-3\n{\n    color: #ffea00 !important;\n}\n\n.yellow.accent-4\n{\n    background-color: #ffd600 !important;\n}\n\n.yellow-text.text-accent-4\n{\n    color: #ffd600 !important;\n}\n\n.amber\n{\n    background-color: #ffc107 !important;\n}\n\n.amber-text\n{\n    color: #ffc107 !important;\n}\n\n.amber.lighten-5\n{\n    background-color: #fff8e1 !important;\n}\n\n.amber-text.text-lighten-5\n{\n    color: #fff8e1 !important;\n}\n\n.amber.lighten-4\n{\n    background-color: #ffecb3 !important;\n}\n\n.amber-text.text-lighten-4\n{\n    color: #ffecb3 !important;\n}\n\n.amber.lighten-3\n{\n    background-color: #ffe082 !important;\n}\n\n.amber-text.text-lighten-3\n{\n    color: #ffe082 !important;\n}\n\n.amber.lighten-2\n{\n    background-color: #ffd54f !important;\n}\n\n.amber-text.text-lighten-2\n{\n    color: #ffd54f !important;\n}\n\n.amber.lighten-1\n{\n    background-color: #ffca28 !important;\n}\n\n.amber-text.text-lighten-1\n{\n    color: #ffca28 !important;\n}\n\n.amber.darken-1\n{\n    background-color: #ffb300 !important;\n}\n\n.amber-text.text-darken-1\n{\n    color: #ffb300 !important;\n}\n\n.amber.darken-2\n{\n    background-color: #ffa000 !important;\n}\n\n.amber-text.text-darken-2\n{\n    color: #ffa000 !important;\n}\n\n.amber.darken-3\n{\n    background-color: #ff8f00 !important;\n}\n\n.amber-text.text-darken-3\n{\n    color: #ff8f00 !important;\n}\n\n.amber.darken-4\n{\n    background-color: #ff6f00 !important;\n}\n\n.amber-text.text-darken-4\n{\n    color: #ff6f00 !important;\n}\n\n.amber.accent-1\n{\n    background-color: #ffe57f !important;\n}\n\n.amber-text.text-accent-1\n{\n    color: #ffe57f !important;\n}\n\n.amber.accent-2\n{\n    background-color: #ffd740 !important;\n}\n\n.amber-text.text-accent-2\n{\n    color: #ffd740 !important;\n}\n\n.amber.accent-3\n{\n    background-color: #ffc400 !important;\n}\n\n.amber-text.text-accent-3\n{\n    color: #ffc400 !important;\n}\n\n.amber.accent-4\n{\n    background-color: #ffab00 !important;\n}\n\n.amber-text.text-accent-4\n{\n    color: #ffab00 !important;\n}\n\n.orange\n{\n    background-color: #ff9800 !important;\n}\n\n.orange-text\n{\n    color: #ff9800 !important;\n}\n\n.orange.lighten-5\n{\n    background-color: #fff3e0 !important;\n}\n\n.orange-text.text-lighten-5\n{\n    color: #fff3e0 !important;\n}\n\n.orange.lighten-4\n{\n    background-color: #ffe0b2 !important;\n}\n\n.orange-text.text-lighten-4\n{\n    color: #ffe0b2 !important;\n}\n\n.orange.lighten-3\n{\n    background-color: #ffcc80 !important;\n}\n\n.orange-text.text-lighten-3\n{\n    color: #ffcc80 !important;\n}\n\n.orange.lighten-2\n{\n    background-color: #ffb74d !important;\n}\n\n.orange-text.text-lighten-2\n{\n    color: #ffb74d !important;\n}\n\n.orange.lighten-1\n{\n    background-color: #ffa726 !important;\n}\n\n.orange-text.text-lighten-1\n{\n    color: #ffa726 !important;\n}\n\n.orange.darken-1\n{\n    background-color: #fb8c00 !important;\n}\n\n.orange-text.text-darken-1\n{\n    color: #fb8c00 !important;\n}\n\n.orange.darken-2\n{\n    background-color: #f57c00 !important;\n}\n\n.orange-text.text-darken-2\n{\n    color: #f57c00 !important;\n}\n\n.orange.darken-3\n{\n    background-color: #ef6c00 !important;\n}\n\n.orange-text.text-darken-3\n{\n    color: #ef6c00 !important;\n}\n\n.orange.darken-4\n{\n    background-color: #e65100 !important;\n}\n\n.orange-text.text-darken-4\n{\n    color: #e65100 !important;\n}\n\n.orange.accent-1\n{\n    background-color: #ffd180 !important;\n}\n\n.orange-text.text-accent-1\n{\n    color: #ffd180 !important;\n}\n\n.orange.accent-2\n{\n    background-color: #ffab40 !important;\n}\n\n.orange-text.text-accent-2\n{\n    color: #ffab40 !important;\n}\n\n.orange.accent-3\n{\n    background-color: #ff9100 !important;\n}\n\n.orange-text.text-accent-3\n{\n    color: #ff9100 !important;\n}\n\n.orange.accent-4\n{\n    background-color: #ff6d00 !important;\n}\n\n.orange-text.text-accent-4\n{\n    color: #ff6d00 !important;\n}\n\n.deep-orange\n{\n    background-color: #ff5722 !important;\n}\n\n.deep-orange-text\n{\n    color: #ff5722 !important;\n}\n\n.deep-orange.lighten-5\n{\n    background-color: #fbe9e7 !important;\n}\n\n.deep-orange-text.text-lighten-5\n{\n    color: #fbe9e7 !important;\n}\n\n.deep-orange.lighten-4\n{\n    background-color: #ffccbc !important;\n}\n\n.deep-orange-text.text-lighten-4\n{\n    color: #ffccbc !important;\n}\n\n.deep-orange.lighten-3\n{\n    background-color: #ffab91 !important;\n}\n\n.deep-orange-text.text-lighten-3\n{\n    color: #ffab91 !important;\n}\n\n.deep-orange.lighten-2\n{\n    background-color: #ff8a65 !important;\n}\n\n.deep-orange-text.text-lighten-2\n{\n    color: #ff8a65 !important;\n}\n\n.deep-orange.lighten-1\n{\n    background-color: #ff7043 !important;\n}\n\n.deep-orange-text.text-lighten-1\n{\n    color: #ff7043 !important;\n}\n\n.deep-orange.darken-1\n{\n    background-color: #f4511e !important;\n}\n\n.deep-orange-text.text-darken-1\n{\n    color: #f4511e !important;\n}\n\n.deep-orange.darken-2\n{\n    background-color: #e64a19 !important;\n}\n\n.deep-orange-text.text-darken-2\n{\n    color: #e64a19 !important;\n}\n\n.deep-orange.darken-3\n{\n    background-color: #d84315 !important;\n}\n\n.deep-orange-text.text-darken-3\n{\n    color: #d84315 !important;\n}\n\n.deep-orange.darken-4\n{\n    background-color: #bf360c !important;\n}\n\n.deep-orange-text.text-darken-4\n{\n    color: #bf360c !important;\n}\n\n.deep-orange.accent-1\n{\n    background-color: #ff9e80 !important;\n}\n\n.deep-orange-text.text-accent-1\n{\n    color: #ff9e80 !important;\n}\n\n.deep-orange.accent-2\n{\n    background-color: #ff6e40 !important;\n}\n\n.deep-orange-text.text-accent-2\n{\n    color: #ff6e40 !important;\n}\n\n.deep-orange.accent-3\n{\n    background-color: #ff3d00 !important;\n}\n\n.deep-orange-text.text-accent-3\n{\n    color: #ff3d00 !important;\n}\n\n.deep-orange.accent-4\n{\n    background-color: #dd2c00 !important;\n}\n\n.deep-orange-text.text-accent-4\n{\n    color: #dd2c00 !important;\n}\n\n.brown\n{\n    background-color: #795548 !important;\n}\n\n.brown-text\n{\n    color: #795548 !important;\n}\n\n.brown.lighten-5\n{\n    background-color: #efebe9 !important;\n}\n\n.brown-text.text-lighten-5\n{\n    color: #efebe9 !important;\n}\n\n.brown.lighten-4\n{\n    background-color: #d7ccc8 !important;\n}\n\n.brown-text.text-lighten-4\n{\n    color: #d7ccc8 !important;\n}\n\n.brown.lighten-3\n{\n    background-color: #bcaaa4 !important;\n}\n\n.brown-text.text-lighten-3\n{\n    color: #bcaaa4 !important;\n}\n\n.brown.lighten-2\n{\n    background-color: #a1887f !important;\n}\n\n.brown-text.text-lighten-2\n{\n    color: #a1887f !important;\n}\n\n.brown.lighten-1\n{\n    background-color: #8d6e63 !important;\n}\n\n.brown-text.text-lighten-1\n{\n    color: #8d6e63 !important;\n}\n\n.brown.darken-1\n{\n    background-color: #6d4c41 !important;\n}\n\n.brown-text.text-darken-1\n{\n    color: #6d4c41 !important;\n}\n\n.brown.darken-2\n{\n    background-color: #5d4037 !important;\n}\n\n.brown-text.text-darken-2\n{\n    color: #5d4037 !important;\n}\n\n.brown.darken-3\n{\n    background-color: #4e342e !important;\n}\n\n.brown-text.text-darken-3\n{\n    color: #4e342e !important;\n}\n\n.brown.darken-4\n{\n    background-color: #3e2723 !important;\n}\n\n.brown-text.text-darken-4\n{\n    color: #3e2723 !important;\n}\n\n.blue-grey\n{\n    background-color: #607d8b !important;\n}\n\n.blue-grey-text\n{\n    color: #607d8b !important;\n}\n\n.blue-grey.lighten-5\n{\n    background-color: #eceff1 !important;\n}\n\n.blue-grey-text.text-lighten-5\n{\n    color: #eceff1 !important;\n}\n\n.blue-grey.lighten-4\n{\n    background-color: #cfd8dc !important;\n}\n\n.blue-grey-text.text-lighten-4\n{\n    color: #cfd8dc !important;\n}\n\n.blue-grey.lighten-3\n{\n    background-color: #b0bec5 !important;\n}\n\n.blue-grey-text.text-lighten-3\n{\n    color: #b0bec5 !important;\n}\n\n.blue-grey.lighten-2\n{\n    background-color: #90a4ae !important;\n}\n\n.blue-grey-text.text-lighten-2\n{\n    color: #90a4ae !important;\n}\n\n.blue-grey.lighten-1\n{\n    background-color: #78909c !important;\n}\n\n.blue-grey-text.text-lighten-1\n{\n    color: #78909c !important;\n}\n\n.blue-grey.darken-1\n{\n    background-color: #546e7a !important;\n}\n\n.blue-grey-text.text-darken-1\n{\n    color: #546e7a !important;\n}\n\n.blue-grey.darken-2\n{\n    background-color: #455a64 !important;\n}\n\n.blue-grey-text.text-darken-2\n{\n    color: #455a64 !important;\n}\n\n.blue-grey.darken-3\n{\n    background-color: #37474f !important;\n}\n\n.blue-grey-text.text-darken-3\n{\n    color: #37474f !important;\n}\n\n.blue-grey.darken-4\n{\n    background-color: #263238 !important;\n}\n\n.blue-grey-text.text-darken-4\n{\n    color: #263238 !important;\n}\n\n.grey\n{\n    background-color: #9e9e9e !important;\n}\n\n.grey-text\n{\n    color: #9e9e9e !important;\n}\n\n.grey.lighten-5\n{\n    background-color: #fafafa !important;\n}\n\n.grey-text.text-lighten-5\n{\n    color: #fafafa !important;\n}\n\n.grey.lighten-4\n{\n    background-color: #f5f5f5 !important;\n}\n\n.grey-text.text-lighten-4\n{\n    color: #f5f5f5 !important;\n}\n\n.grey.lighten-3\n{\n    background-color: #eee !important;\n}\n\n.grey-text.text-lighten-3\n{\n    color: #eee !important;\n}\n\n.grey.lighten-2\n{\n    background-color: #e0e0e0 !important;\n}\n\n.grey-text.text-lighten-2\n{\n    color: #e0e0e0 !important;\n}\n\n.grey.lighten-1\n{\n    background-color: #bdbdbd !important;\n}\n\n.grey-text.text-lighten-1\n{\n    color: #bdbdbd !important;\n}\n\n.grey.darken-1\n{\n    background-color: #757575 !important;\n}\n\n.grey-text.text-darken-1\n{\n    color: #757575 !important;\n}\n\n.grey.darken-2\n{\n    background-color: #616161 !important;\n}\n\n.grey-text.text-darken-2\n{\n    color: #616161 !important;\n}\n\n.grey.darken-3\n{\n    background-color: #424242 !important;\n}\n\n.grey-text.text-darken-3\n{\n    color: #424242 !important;\n}\n\n.grey.darken-4\n{\n    background-color: #212121 !important;\n}\n\n.grey-text.text-darken-4\n{\n    color: #212121 !important;\n}\n\n.black\n{\n    background-color: #000 !important;\n}\n\n.black-text\n{\n    color: #000 !important;\n}\n\n.white\n{\n    background-color: #fff !important;\n}\n\n.white-text\n{\n    color: #fff !important;\n}\n\n.transparent\n{\n    background-color: transparent !important;\n}\n\n.transparent-text\n{\n    color: transparent !important;\n}\n\n/*\n  Gradient color mixin\n*/\n.gradient-45deg-light-blue-teal\n{\n    background: #b3e5fc;\n    background: -webkit-linear-gradient(45deg, #b3e5fc, #64ffda) !important;\n    background:         linear-gradient(45deg, #b3e5fc, #64ffda) !important;\n}\n\n.gradient-45deg-light-blue-teal.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(100, 255, 218, .5) !important;\n}\n\n.gradient-45deg-indigo-light-blue\n{\n    background: #3949ab;\n    background: -webkit-linear-gradient(45deg, #3949ab, #4fc3f7) !important;\n    background:         linear-gradient(45deg, #3949ab, #4fc3f7) !important;\n}\n\n.gradient-45deg-indigo-light-blue.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(79, 195, 247, .5) !important;\n}\n\n.gradient-45deg-light-blue-indigo\n{\n    background: #b3e5fc;\n    background: -webkit-linear-gradient(45deg, #b3e5fc, #9fa8da) !important;\n    background:         linear-gradient(45deg, #b3e5fc, #9fa8da) !important;\n}\n\n.gradient-45deg-light-blue-indigo.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(159, 168, 218, .5) !important;\n}\n\n.gradient-45deg-yellow-green\n{\n    background: #ffff8d;\n    background: -webkit-linear-gradient(45deg, #ffff8d, #b9f6ca) !important;\n    background:         linear-gradient(45deg, #ffff8d, #b9f6ca) !important;\n}\n\n.gradient-45deg-yellow-green.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(185, 246, 202, .5) !important;\n}\n\n.gradient-45deg-orange-deep-orange\n{\n    background: #ffe0b2;\n    background: -webkit-linear-gradient(45deg, #ffe0b2, #ffccbc) !important;\n    background:         linear-gradient(45deg, #ffe0b2, #ffccbc) !important;\n}\n\n.gradient-45deg-orange-deep-orange.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(255, 204, 188, .5) !important;\n}\n\n.gradient-45deg-deep-purple-purple\n{\n    background: #d1c4e9;\n    background: -webkit-linear-gradient(45deg, #d1c4e9, #f3e5f5) !important;\n    background:         linear-gradient(45deg, #d1c4e9, #f3e5f5) !important;\n}\n\n.gradient-45deg-deep-purple-purple.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(243, 229, 245, .5) !important;\n}\n\n.gradient-45deg-red-pink\n{\n    background: #ff5252;\n    background: -webkit-linear-gradient(45deg, #ff5252, #f48fb1) !important;\n    background:         linear-gradient(45deg, #ff5252, #f48fb1) !important;\n}\n\n.gradient-45deg-red-pink.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(244, 143, 177, .5) !important;\n}\n\n.gradient-45deg-light-green-amber\n{\n    background: #c5e1a5;\n    background: -webkit-linear-gradient(45deg, #c5e1a5, #fff8e1) !important;\n    background:         linear-gradient(45deg, #c5e1a5, #fff8e1) !important;\n}\n\n.gradient-45deg-light-green-amber.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(255, 248, 225, .5) !important;\n}\n\n.gradient-45deg-amber-amber\n{\n    background: #ff6f00;\n    background: -webkit-linear-gradient(45deg, #ff6f00, #ffca28) !important;\n    background:         linear-gradient(45deg, #ff6f00, #ffca28) !important;\n}\n\n.gradient-45deg-amber-amber.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(255, 202, 40, .5) !important;\n}\n\n.gradient-45deg-purple-pink\n{\n    background: #ea80fc;\n    background: -webkit-linear-gradient(45deg, #ea80fc, #fce4ec) !important;\n    background:         linear-gradient(45deg, #ea80fc, #fce4ec) !important;\n}\n\n.gradient-45deg-purple-pink.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(252, 228, 236, .5) !important;\n}\n\n.gradient-45deg-teal-cyan\n{\n    background: #e0f2f1;\n    background: -webkit-linear-gradient(45deg, #e0f2f1, #00e5ff) !important;\n    background:         linear-gradient(45deg, #e0f2f1, #00e5ff) !important;\n}\n\n.gradient-45deg-teal-cyan.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(0, 229, 255, .5) !important;\n}\n\n.gradient-45deg-blue-grey-blue-grey\n{\n    background: #cfd8dc;\n    background: -webkit-linear-gradient(45deg, #cfd8dc, #546e7a) !important;\n    background:         linear-gradient(45deg, #cfd8dc, #546e7a) !important;\n}\n\n.gradient-45deg-blue-grey-blue-grey.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(84, 110, 122, .5) !important;\n}\n\n.gradient-45deg-orange-amber\n{\n    background: #e65100;\n    background: -webkit-linear-gradient(45deg, #e65100, #1976d2) !important;\n    background:         linear-gradient(45deg, #e65100, #1976d2) !important;\n}\n\n.gradient-45deg-orange-amber.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(25, 118, 210, .5) !important;\n}\n\n.gradient-45deg-indigo-blue\n{\n    background: #303f9f;\n    background: -webkit-linear-gradient(45deg, #303f9f, #1976d2) !important;\n    background:         linear-gradient(45deg, #303f9f, #1976d2) !important;\n}\n\n.gradient-45deg-indigo-blue.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(25, 118, 210, .5) !important;\n}\n\n.gradient-45deg-brown-brown\n{\n    background: #6d4c41;\n    background: -webkit-linear-gradient(45deg, #6d4c41, #bbdefb) !important;\n    background:         linear-gradient(45deg, #6d4c41, #bbdefb) !important;\n}\n\n.gradient-45deg-brown-brown.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(187, 222, 251, .5) !important;\n}\n\n.gradient-45deg-blue-grey-blue\n{\n    background: #263238;\n    background: -webkit-linear-gradient(45deg, #263238, #2979ff) !important;\n    background:         linear-gradient(45deg, #263238, #2979ff) !important;\n}\n\n.gradient-45deg-blue-grey-blue.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(41, 121, 255, .5) !important;\n}\n\n.gradient-45deg-purple-deep-orange\n{\n    background: #8e24aa;\n    background: -webkit-linear-gradient(45deg, #8e24aa, #ff6e40) !important;\n    background:         linear-gradient(45deg, #8e24aa, #ff6e40) !important;\n}\n\n.gradient-45deg-purple-deep-orange.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(255, 110, 64, .5) !important;\n}\n\n.gradient-45deg-green-teal\n{\n    background: #43a047;\n    background: -webkit-linear-gradient(45deg, #43a047, #1de9b6) !important;\n    background:         linear-gradient(45deg, #43a047, #1de9b6) !important;\n}\n\n.gradient-45deg-green-teal.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(29, 233, 182, .5) !important;\n}\n\n.gradient-45deg-purple-light-blue\n{\n    background: #e040fb;\n    background: -webkit-linear-gradient(45deg, #e040fb, #4fc3f7) !important;\n    background:         linear-gradient(45deg, #e040fb, #4fc3f7) !important;\n}\n\n.gradient-45deg-purple-light-blue.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(79, 195, 247, .5) !important;\n}\n\n.gradient-45deg-cyan-cyan\n{\n    background: #18ffff;\n    background: -webkit-linear-gradient(45deg, #18ffff, #00e5ff) !important;\n    background:         linear-gradient(45deg, #18ffff, #00e5ff) !important;\n}\n\n.gradient-45deg-cyan-cyan.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(0, 229, 255, .5) !important;\n}\n\n.gradient-45deg-yellow-teal\n{\n    background: #fff9c4;\n    background: -webkit-linear-gradient(45deg, #fff9c4, #64ffda) !important;\n    background:         linear-gradient(45deg, #fff9c4, #64ffda) !important;\n}\n\n.gradient-45deg-yellow-teal.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(100, 255, 218, .5) !important;\n}\n\n.gradient-45deg-purple-deep-purple\n{\n    background: #7b1fa2;\n    background: -webkit-linear-gradient(45deg, #7b1fa2, #7c4dff) !important;\n    background:         linear-gradient(45deg, #7b1fa2, #7c4dff) !important;\n}\n\n.gradient-45deg-purple-deep-purple.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(124, 77, 255, .5) !important;\n}\n\n.gradient-45deg-cyan-light-green\n{\n    background: #0097a7;\n    background: -webkit-linear-gradient(45deg, #0097a7, #b2ff59) !important;\n    background:         linear-gradient(45deg, #0097a7, #b2ff59) !important;\n}\n\n.gradient-45deg-cyan-light-green.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(178, 255, 89, .5) !important;\n}\n\n.gradient-45deg-purple-amber\n{\n    background: #d500f9;\n    background: -webkit-linear-gradient(45deg, #d500f9, #ffa000) !important;\n    background:         linear-gradient(45deg, #d500f9, #ffa000) !important;\n}\n\n.gradient-45deg-purple-amber.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(255, 160, 0, .5) !important;\n}\n\n.gradient-45deg-indigo-purple\n{\n    background: #303f9f;\n    background: -webkit-linear-gradient(45deg, #303f9f, #7b1fa2) !important;\n    background:         linear-gradient(45deg, #303f9f, #7b1fa2) !important;\n}\n\n.gradient-45deg-indigo-purple.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(123, 31, 162, .5) !important;\n}\n\n.gradient-45deg-deep-purple-blue\n{\n    background: #6200ea;\n    background: -webkit-linear-gradient(45deg, #6200ea, #1976d2) !important;\n    background:         linear-gradient(45deg, #6200ea, #1976d2) !important;\n}\n\n.gradient-45deg-deep-purple-blue.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(25, 118, 210, .5) !important;\n}\n\n.gradient-45deg-deep-orange-orange\n{\n    background: #bf360c;\n    background: -webkit-linear-gradient(45deg, #bf360c, #f57c00) !important;\n    background:         linear-gradient(45deg, #bf360c, #f57c00) !important;\n}\n\n.gradient-45deg-deep-orange-orange.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(245, 124, 0, .5) !important;\n}\n\n.gradient-45deg-light-blue-cyan\n{\n    background: #0288d1;\n    background: -webkit-linear-gradient(45deg, #0288d1, #26c6da) !important;\n    background:         linear-gradient(45deg, #0288d1, #26c6da) !important;\n}\n\n.gradient-45deg-light-blue-cyan.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(38, 198, 218, .5) !important;\n}\n\n.gradient-45deg-blue-indigo\n{\n    background: #2962ff;\n    background: -webkit-linear-gradient(45deg, #2962ff, #3949ab) !important;\n    background:         linear-gradient(45deg, #2962ff, #3949ab) !important;\n}\n\n.gradient-45deg-blue-indigo.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(57, 73, 171, .5) !important;\n}\n\n.gradient-45deg-semi-dark\n{\n    background: #00aeff;\n    background: -webkit-linear-gradient(right, #00aeff, #3369e6) !important;\n    background:         linear-gradient(-90deg, #00aeff, #3369e6) !important;\n}\n\n.gradient-45deg-semi-dark.gradient-shadow\n{\n    box-shadow: 0 6px 20px 0 rgba(51, 105, 230, .5) !important;\n}\n\n.btn-light-materialize-red\n{\n    color: #e51c23 !important;\n    background-color: #fdeaeb;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-materialize-red:hover,\n.btn-light-materialize-red:focus,\n.btn-light-materialize-red.hover\n{\n    color: #fff !important;\n    background-color: #ea454b !important;\n}\n\n.btn-light-materialize-red:active,\n.btn-light-materialize-red.active\n{\n    color: #fff !important;\n    background-color: #d0181e !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-materialize-red:before\n{\n    background: #e51c23 !important;\n}\n\n.btn-light-red\n{\n    color: #f44336 !important;\n    background-color: #ffebee;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-red:hover,\n.btn-light-red:focus,\n.btn-light-red.hover\n{\n    color: #fff !important;\n    background-color: #ef5350 !important;\n}\n\n.btn-light-red:active,\n.btn-light-red.active\n{\n    color: #fff !important;\n    background-color: #e53935 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-red:before\n{\n    background: #f44336 !important;\n}\n\n.btn-light-pink\n{\n    color: #e91e63 !important;\n    background-color: #fce4ec;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-pink:hover,\n.btn-light-pink:focus,\n.btn-light-pink.hover\n{\n    color: #fff !important;\n    background-color: #ec407a !important;\n}\n\n.btn-light-pink:active,\n.btn-light-pink.active\n{\n    color: #fff !important;\n    background-color: #d81b60 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-pink:before\n{\n    background: #e91e63 !important;\n}\n\n.btn-light-purple\n{\n    color: #9c27b0 !important;\n    background-color: #f3e5f5;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-purple:hover,\n.btn-light-purple:focus,\n.btn-light-purple.hover\n{\n    color: #fff !important;\n    background-color: #ab47bc !important;\n}\n\n.btn-light-purple:active,\n.btn-light-purple.active\n{\n    color: #fff !important;\n    background-color: #8e24aa !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-purple:before\n{\n    background: #9c27b0 !important;\n}\n\n.btn-light-deep-purple\n{\n    color: #673ab7 !important;\n    background-color: #ede7f6;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-deep-purple:hover,\n.btn-light-deep-purple:focus,\n.btn-light-deep-purple.hover\n{\n    color: #fff !important;\n    background-color: #7e57c2 !important;\n}\n\n.btn-light-deep-purple:active,\n.btn-light-deep-purple.active\n{\n    color: #fff !important;\n    background-color: #5e35b1 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-deep-purple:before\n{\n    background: #673ab7 !important;\n}\n\n.btn-light-indigo\n{\n    color: #3f51b5 !important;\n    background-color: #e8eaf6;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-indigo:hover,\n.btn-light-indigo:focus,\n.btn-light-indigo.hover\n{\n    color: #fff !important;\n    background-color: #5c6bc0 !important;\n}\n\n.btn-light-indigo:active,\n.btn-light-indigo.active\n{\n    color: #fff !important;\n    background-color: #3949ab !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-indigo:before\n{\n    background: #3f51b5 !important;\n}\n\n.btn-light-blue\n{\n    color: #2196f3 !important;\n    background-color: #e3f2fd;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-blue:hover,\n.btn-light-blue:focus,\n.btn-light-blue.hover\n{\n    color: #fff !important;\n    background-color: #42a5f5 !important;\n}\n\n.btn-light-blue:active,\n.btn-light-blue.active\n{\n    color: #fff !important;\n    background-color: #1e88e5 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-blue:before\n{\n    background: #2196f3 !important;\n}\n\n.btn-light-light-blue\n{\n    color: #03a9f4 !important;\n    background-color: #e1f5fe;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-light-blue:hover,\n.btn-light-light-blue:focus,\n.btn-light-light-blue.hover\n{\n    color: #fff !important;\n    background-color: #29b6f6 !important;\n}\n\n.btn-light-light-blue:active,\n.btn-light-light-blue.active\n{\n    color: #fff !important;\n    background-color: #039be5 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-light-blue:before\n{\n    background: #03a9f4 !important;\n}\n\n.btn-light-cyan\n{\n    color: #00bcd4 !important;\n    background-color: #e0f7fa;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-cyan:hover,\n.btn-light-cyan:focus,\n.btn-light-cyan.hover\n{\n    color: #fff !important;\n    background-color: #26c6da !important;\n}\n\n.btn-light-cyan:active,\n.btn-light-cyan.active\n{\n    color: #fff !important;\n    background-color: #00acc1 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-cyan:before\n{\n    background: #00bcd4 !important;\n}\n\n.btn-light-teal\n{\n    color: #009688 !important;\n    background-color: #e0f2f1;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-teal:hover,\n.btn-light-teal:focus,\n.btn-light-teal.hover\n{\n    color: #fff !important;\n    background-color: #26a69a !important;\n}\n\n.btn-light-teal:active,\n.btn-light-teal.active\n{\n    color: #fff !important;\n    background-color: #00897b !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-teal:before\n{\n    background: #009688 !important;\n}\n\n.btn-light-green\n{\n    color: #4caf50 !important;\n    background-color: #e8f5e9;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-green:hover,\n.btn-light-green:focus,\n.btn-light-green.hover\n{\n    color: #fff !important;\n    background-color: #66bb6a !important;\n}\n\n.btn-light-green:active,\n.btn-light-green.active\n{\n    color: #fff !important;\n    background-color: #43a047 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-green:before\n{\n    background: #4caf50 !important;\n}\n\n.btn-light-light-green\n{\n    color: #8bc34a !important;\n    background-color: #f1f8e9;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-light-green:hover,\n.btn-light-light-green:focus,\n.btn-light-light-green.hover\n{\n    color: #fff !important;\n    background-color: #9ccc65 !important;\n}\n\n.btn-light-light-green:active,\n.btn-light-light-green.active\n{\n    color: #fff !important;\n    background-color: #7cb342 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-light-green:before\n{\n    background: #8bc34a !important;\n}\n\n.btn-light-lime\n{\n    color: #cddc39 !important;\n    background-color: #f9fbe7;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-lime:hover,\n.btn-light-lime:focus,\n.btn-light-lime.hover\n{\n    color: #fff !important;\n    background-color: #d4e157 !important;\n}\n\n.btn-light-lime:active,\n.btn-light-lime.active\n{\n    color: #fff !important;\n    background-color: #c0ca33 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-lime:before\n{\n    background: #cddc39 !important;\n}\n\n.btn-light-yellow\n{\n    color: #ffeb3b !important;\n    background-color: #fffde7;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-yellow:hover,\n.btn-light-yellow:focus,\n.btn-light-yellow.hover\n{\n    color: #fff !important;\n    background-color: #ffee58 !important;\n}\n\n.btn-light-yellow:active,\n.btn-light-yellow.active\n{\n    color: #fff !important;\n    background-color: #fdd835 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-yellow:before\n{\n    background: #ffeb3b !important;\n}\n\n.btn-light-amber\n{\n    color: #ffc107 !important;\n    background-color: #fff8e1;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-amber:hover,\n.btn-light-amber:focus,\n.btn-light-amber.hover\n{\n    color: #fff !important;\n    background-color: #ffca28 !important;\n}\n\n.btn-light-amber:active,\n.btn-light-amber.active\n{\n    color: #fff !important;\n    background-color: #ffb300 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-amber:before\n{\n    background: #ffc107 !important;\n}\n\n.btn-light-orange\n{\n    color: #ff9800 !important;\n    background-color: #fff3e0;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-orange:hover,\n.btn-light-orange:focus,\n.btn-light-orange.hover\n{\n    color: #fff !important;\n    background-color: #ffa726 !important;\n}\n\n.btn-light-orange:active,\n.btn-light-orange.active\n{\n    color: #fff !important;\n    background-color: #fb8c00 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-orange:before\n{\n    background: #ff9800 !important;\n}\n\n.btn-light-deep-orange\n{\n    color: #ff5722 !important;\n    background-color: #fbe9e7;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-deep-orange:hover,\n.btn-light-deep-orange:focus,\n.btn-light-deep-orange.hover\n{\n    color: #fff !important;\n    background-color: #ff7043 !important;\n}\n\n.btn-light-deep-orange:active,\n.btn-light-deep-orange.active\n{\n    color: #fff !important;\n    background-color: #f4511e !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-deep-orange:before\n{\n    background: #ff5722 !important;\n}\n\n.btn-light-brown\n{\n    color: #795548 !important;\n    background-color: #efebe9;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-brown:hover,\n.btn-light-brown:focus,\n.btn-light-brown.hover\n{\n    color: #fff !important;\n    background-color: #8d6e63 !important;\n}\n\n.btn-light-brown:active,\n.btn-light-brown.active\n{\n    color: #fff !important;\n    background-color: #6d4c41 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-brown:before\n{\n    background: #795548 !important;\n}\n\n.btn-light-blue-grey\n{\n    color: #607d8b !important;\n    background-color: #eceff1;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-blue-grey:hover,\n.btn-light-blue-grey:focus,\n.btn-light-blue-grey.hover\n{\n    color: #fff !important;\n    background-color: #78909c !important;\n}\n\n.btn-light-blue-grey:active,\n.btn-light-blue-grey.active\n{\n    color: #fff !important;\n    background-color: #546e7a !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-blue-grey:before\n{\n    background: #607d8b !important;\n}\n\n.btn-light-grey\n{\n    color: #9e9e9e !important;\n    background-color: #fafafa;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, .08);\n}\n\n.btn-light-grey:hover,\n.btn-light-grey:focus,\n.btn-light-grey.hover\n{\n    color: #fff !important;\n    background-color: #bdbdbd !important;\n}\n\n.btn-light-grey:active,\n.btn-light-grey.active\n{\n    color: #fff !important;\n    background-color: #757575 !important;\n}\n\n/* timeline */\n.widget-timeline li.timeline-items.timeline-icon-grey:before\n{\n    background: #9e9e9e !important;\n}\n\n/*----------------------------------------\n\tAvatar\n------------------------------------------*/\n.avatar-status\n{\n    line-height: 50px;\n\n    position: relative;\n\n    display: inline-block;\n\n    width: 28px;\n\n    vertical-align: bottom;\n    white-space: nowrap;\n\n    border-radius: 50px;\n}\n\n.avatar-status i\n{\n    position: absolute;\n    right: -2px;\n    bottom: 18px;\n\n    width: 9px !important;\n    height: 9px !important;\n\n    border: 1px solid #fff;\n    border-radius: 100%;\n}\n\n.avatar-status span.text-circle\n{\n    font-size: 1.2rem;\n\n    display: table-cell;\n\n    text-align: center;\n    vertical-align: middle;\n\n    color: #fff;\n    background: #fafafa;\n}\n\n.avatar-status img\n{\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n\n    border: 0 none;\n    border-radius: 1000px;\n    background: #e6e6e6;\n}\n\n.avatar-online i\n{\n    background-color: #00e676;\n}\n\n.avatar-off i\n{\n    background-color: #bdbdbd;\n}\n\n.avatar-busy i\n{\n    background-color: #ff1744;\n}\n\n.avatar-away i\n{\n    background-color: #ffc400;\n}\n\n.avatar-status.avatar-100\n{\n    width: 100px;\n}\n\n.avatar-status.avatar-100 span.text-circle\n{\n    width: 100px;\n    height: 100px;\n}\n\n.avatar-status.avatar-100 i\n{\n    width: 20px;\n    height: 20px;\n}\n\n.avatar-status.avatar-50\n{\n    line-height: 0;\n\n    width: 50px;\n}\n\n.avatar-status.avatar-50 span.text-circle\n{\n    width: 50px;\n    height: 50px;\n}\n\n.avatar-status.avatar-50 i\n{\n    right: -1px;\n    bottom: 21px;\n\n    width: 12px !important;\n    height: 12px !important;\n}\n\n.avatar-status.avatar-lg\n{\n    width: 144px;\n}\n\n.avatar-status.avatar-lg span.text-circle\n{\n    width: 144px;\n    height: 144px;\n}\n\n.avatar-status.avatar-lg i\n{\n    right: 0;\n    bottom: 0;\n\n    width: 20px;\n    height: 20px;\n}\n\n.avatar-status.avatar-md\n{\n    width: 40px;\n}\n\n.avatar-status.avatar-md span.text-circle\n{\n    width: 40px;\n    height: 40px;\n}\n\n.avatar-status.avatar-md i\n{\n    right: 0;\n    bottom: 0;\n\n    width: 10px;\n    height: 10px;\n}\n\n.avatar-status.avatar-sm\n{\n    width: 32px;\n}\n\n.avatar-status.avatar-sm span.text-circle\n{\n    width: 32px;\n    height: 32px;\n}\n\n.avatar-status.avatar-sm i\n{\n    width: 8px;\n    height: 8px;\n}\n\n.avatar-status.avatar-xs\n{\n    width: 24px;\n}\n\n.avatar-status.avatar-xs span.text-circle\n{\n    width: 24px;\n    height: 24px;\n}\n\n.avatar-status.avatar-xs i\n{\n    width: 7px;\n    height: 7px;\n}\n\n.collection .collection-item.avatar:not(.circle-clipper) > .circle\n{\n    background: #e6e6e6;\n}\n\n/*----------------------------------------\n\tDropdown\n------------------------------------------*/\n.dropdown-content li:hover,\n.dropdown-content li.active\n{\n    background-color: #eee;\n}\n\n.dropdown-content li > a,\n.dropdown-content li > span\n{\n    padding: 14px 24px;\n}\n\n.dropdown-content li > a:hover,\n.dropdown-content li > a.active,\n.dropdown-content li > span:hover,\n.dropdown-content li > span.active\n{\n    background-color: #eee;\n}\n\n.dropdown-content li > a > i\n{\n    width: 24px;\n    margin: 0 12px 0 0;\n}\n\n/*----------------------------------------\n\tBadges\n------------------------------------------*/\nspan.badge\n{\n    color: #fff;\n}\n\nspan.badge.pill\n{\n    font-size: .8rem;\n    line-height: 20px;\n\n    min-width: 1rem;\n    height: 20px;\n\n    border-radius: 50%;\n    border-radius: 9px;\n}\n\n#badges-navbar nav .brand-logo\n{\n    font-size: 2.1rem;\n}\n\n/* Buttons */\n/*--------*/\n.btn,\n.btn-flat,\n.btn-large,\n.btn-small\n{\n    text-transform: capitalize;\n}\n\n.btn-block\n{\n    display: block;\n\n    width: 100%;\n}\n\n/*----------------------------------------\n  Material\n------------------------------------------*/\n@font-face\n{\n    font-family: 'Material Icons';\n    font-weight: 400;\n    font-style: normal;\n\n    src: local('Material Icons'), local('MaterialIcons-Regular'), url('../../public/fonts/material-design-icons/MaterialIcons-Regular.ttf') format('truetype'), url('../../public/fonts/material-design-icons/MaterialIcons-Regular.woff2') format('woff2'), url('../../public/fonts/material-design-icons/MaterialIcons-Regular.woff') format('woff'), url('../../public/fonts/material-design-icons/MaterialIcons-Regular.eot');\n}\n\n.material-icons\n{\n    font-family: 'Material Icons';\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    line-height: 1;\n    /* Preferred icon size */\n\n    display: inline-block;\n\n    white-space: nowrap;\n    letter-spacing: normal;\n    text-transform: none;\n    word-wrap: normal;\n\n    direction: ltr;\n    /* Support for all WebKit browsers. */\n    -webkit-font-smoothing: antialiased;\n    /* Support for Safari and Chrome. */\n    text-rendering: optimizeLegibility;\n    /* Support for Firefox. */\n    -moz-osx-font-smoothing: grayscale;\n    /* Support for IE. */\n    -webkit-font-feature-settings: 'liga';\n            font-feature-settings: 'liga';\n}\n\n/* Rules for sizing the icon. */\n.material-icons.md-18\n{\n    font-size: 18px;\n}\n\n.material-icons.md-24\n{\n    font-size: 24px;\n}\n\n.material-icons.md-36\n{\n    font-size: 36px;\n}\n\n.material-icons.md-48\n{\n    font-size: 48px;\n}\n\n/* Rules for using icons as black on a light background. */\n.material-icons.md-dark\n{\n    color: rgba(0, 0, 0, .54);\n}\n\n.material-icons.md-dark.md-inactive\n{\n    color: rgba(0, 0, 0, .26);\n}\n\n/* Rules for using icons as white on a dark background. */\n.material-icons.md-light\n{\n    color: white;\n}\n\n.material-icons.md-light.md-inactive\n{\n    color: rgba(255, 255, 255, .3);\n}\n\n/*----------------------------------------\n    Pulse\n------------------------------------------*/\n.pulse-style-one\n{\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display:         flex;\n\n    -webkit-justify-content: space-around;\n    -ms-flex-pack: distribute;\n            justify-content: space-around;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)\n{\n    .modal\n    {\n        position: -ms-page;\n        top: 10%;\n    }\n    .modal.bottom-sheet\n    {\n        position: -ms-page;\n        top: 155%;\n\n        height: 100%;\n    }\n    .modal.bottom-sheet + .modal-overlay\n    {\n        position: -ms-page;\n        top: 100%;\n    }\n    .modal-overlay\n    {\n        position: -ms-page;\n        top: 5%;\n\n        height: 100%;\n    }\n}\n\n/*----------------------------------------\n   Navbar\n------------------------------------------*/\n.navbar\n{\n    position: relative;\n    z-index: 997;\n}\n\n.navbar .header-search-wrapper\n{\n    position: relative;\n\n    display: inline-block;\n\n    width: calc(100% - 360px);\n    height: 40px;\n    margin: 10px auto 0 75px;\n\n    -webkit-transition: .3s ease all;\n            transition: .3s ease all;\n\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n}\n\n.navbar .header-search-wrapper i\n{\n    font-size: 24px;\n    line-height: 32px !important;\n\n    position: absolute;\n    top: 6px;\n    left: 24px;\n\n    -webkit-transition: color 200ms ease;\n            transition: color 200ms ease;\n}\n\n.navbar .sideNav-lock .header-search-wrapper\n{\n    width: calc(100% - 560px);\n    margin: 10px auto 0 260px;\n}\n\n.navbar input.header-search-input\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    display: block;\n\n    box-sizing: border-box;\n    width: 100%;\n    margin-bottom: 0;\n    padding: 8px 8px 8px 65px;\n\n    -webkit-transition: all 200ms ease;\n            transition: all 200ms ease;\n\n    border: none;\n    border-radius: 3px;\n    outline: none;\n    background: rgba(255, 255, 255, .3);\n\n    -webkit-appearance: textfield;\n       -moz-appearance: textfield;\n            appearance: textfield;\n}\n\n.navbar input.header-search-input:hover\n{\n    background: rgba(255, 255, 255, .5);\n}\n\n.navbar input.header-search-input:focus,\n.navbar input.header-search-input:active\n{\n    color: #333 !important;\n    border-bottom: none !important;\n    background: #fff !important;\n    box-shadow: none !important;\n}\n\n.navbar .header-search-wrapper-focus i\n{\n    color: #444 !important;\n}\n\n.navbar .header-search-input::-webkit-input-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #fff;\n}\n\n.navbar .header-search-input::-moz-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #fff;\n}\n\n.navbar .header-search-input:-ms-input-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #fff;\n}\n\n.navbar .header-search-input:focus::-webkit-input-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #333;\n}\n\n.navbar .header-search-input:focus::-moz-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #333;\n}\n\n.navbar .header-search-input:focus:-ms-input-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #333;\n}\n\n.navbar .header-search-input:focus::-ms-input-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #333;\n}\n\n.navbar .header-search-input:focus::placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #333;\n}\n\n.navbar .header-search-input:focus:-ms-input-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #333;\n}\n\n.navbar .header-search-input::-webkit-input-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #fff;\n}\n\n.navbar .header-search-input::-moz-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #fff;\n}\n\n.navbar .header-search-input:-ms-input-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #fff;\n}\n\n.navbar .header-search-input::-ms-input-placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #fff;\n}\n\n.navbar .header-search-input::placeholder\n{\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #fff;\n}\n\n.navbar .toggle-fullscreen,\n.navbar .notification-button\n{\n    line-height: 1;\n}\n\n.navbar .notification-badge\n{\n    font-family: 'Muli', sans-serif;\n\n    position: relative;\n    top: -20px;\n    right: 5px;\n\n    margin: 0 -.8em;\n    padding: 2px 5px;\n\n    color: #fff;\n    border-radius: 50%;\n    background-color: #00bcd4;\n    box-shadow: 0 0 10px 0 #00bcd4;\n}\n\n.navbar #notifications-dropdown\n{\n    width: 400px;\n}\n\n.navbar #notifications-dropdown h5\n{\n    font-size: 1rem;\n    font-weight: 500;\n\n    text-transform: capitalize;\n}\n\n.navbar #notifications-dropdown li\n{\n    font-size: 1rem;\n\n    padding: 8px 16px;\n}\n\n.navbar #notifications-dropdown li > a\n{\n    font-size: 1.1rem;\n    font-weight: 300;\n\n    padding: 0;\n}\n\n.navbar #notifications-dropdown li > a > span\n{\n    font-size: 1.2rem;\n\n    position: relative;\n    top: 4px;\n\n    display: inline-block;\n\n    margin-right: 5px;\n}\n\n.navbar #notifications-dropdown li > time\n{\n    font-size: .8rem;\n    font-weight: 400;\n\n    position: relative;\n    top: -4px;\n\n    margin-left: 38px;\n}\n\n.navbar #notifications-dropdown li.divider\n{\n    padding: 0;\n}\n\n.navbar .profile-button span.avatar-status\n{\n    line-height: 43px;\n}\n\n.navbar #profile-dropdown\n{\n    width: 160px;\n}\n\n.navbar #profile-dropdown li a i\n{\n    margin-right: 10px;\n}\n\n.navbar .navbar-light\n{\n    background: #fff;\n}\n\n.navbar .navbar-light ul a\n{\n    color: rgba(0, 0, 0, .87);\n}\n\n.navbar .navbar-light .header-search-wrapper i\n{\n    color: rgba(0, 0, 0, .87);\n}\n\n.navbar .navbar-light .header-search-wrapper input.header-search-input\n{\n    color: rgba(0, 0, 0, .87);\n    border: 1px solid #efefef;\n    background: rgba(230, 230, 230, .3);\n}\n\n.navbar .navbar-light .header-search-wrapper input.header-search-input:hover,\n.navbar .navbar-light .header-search-wrapper input.header-search-input:active,\n.navbar .navbar-light .header-search-wrapper input.header-search-input:focus\n{\n    border: 1px solid #adadad;\n    border-bottom: 1px solid #adadad !important;\n    background: rgba(230, 230, 230, 0);\n}\n\n.navbar .navbar-light .header-search-wrapper input.header-search-input::-webkit-input-placeholder\n{\n    color: rgba(0, 0, 0, .87);\n}\n\n.navbar .navbar-light .header-search-wrapper input.header-search-input::-moz-placeholder\n{\n    color: rgba(0, 0, 0, .87);\n}\n\n.navbar .navbar-light .header-search-wrapper input.header-search-input:-ms-input-placeholder\n{\n    color: rgba(0, 0, 0, .87);\n}\n\n.navbar .navbar-light .header-search-wrapper input.header-search-input::-ms-input-placeholder\n{\n    color: rgba(0, 0, 0, .87);\n}\n\n.navbar .navbar-light .header-search-wrapper input.header-search-input::placeholder\n{\n    color: rgba(0, 0, 0, .87);\n}\n\n.navbar .navbar-dark\n{\n    background: #37474f;\n}\n\n.navbar .navbar-dark ul a\n{\n    color: #fff;\n}\n\n.navbar .navbar-dark .header-search-wrapper i\n{\n    color: #fff;\n}\n\n.navbar .navbar-dark .header-search-wrapper input.header-search-input\n{\n    color: #fff;\n    border: 1px solid rgba(230, 230, 230, .05);\n    background: rgba(230, 230, 230, .3);\n}\n\n.navbar .navbar-dark .header-search-wrapper input.header-search-input:hover,\n.navbar .navbar-dark .header-search-wrapper input.header-search-input:active,\n.navbar .navbar-dark .header-search-wrapper input.header-search-input:focus\n{\n    border: 1px solid rgba(230, 230, 230, .1);\n    background: rgba(230, 230, 230, .1);\n}\n\n.navbar .navbar-dark .header-search-wrapper input.header-search-input::-webkit-input-placeholder\n{\n    color: #fff;\n}\n\n.navbar .navbar-dark .header-search-wrapper input.header-search-input::-moz-placeholder\n{\n    color: #fff;\n}\n\n.navbar .navbar-dark .header-search-wrapper input.header-search-input:-ms-input-placeholder\n{\n    color: #fff;\n}\n\n.navbar .navbar-dark .header-search-wrapper input.header-search-input::-ms-input-placeholder\n{\n    color: #fff;\n}\n\n.navbar .navbar-dark .header-search-wrapper input.header-search-input::placeholder\n{\n    color: #fff;\n}\n\n.navbar .no-shadow\n{\n    box-shadow: none;\n}\n\n.horizontal-layout .navbar .header-search-wrapper\n{\n    width: calc(100% - 560px);\n}\n\n.navbar .navbar-main\n{\n    padding: 0 8px 0 15px;\n}\n\n.search-list\n{\n    position: absolute;\n    top: 100%;\n\n    height: calc(100vh - 9rem);\n    max-height: 450px;\n    margin-top: 0;\n\n    border: none;\n    border-radius: 3px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n\n.search-list li\n{\n    width: 100%;\n}\n\n.search-list li a\n{\n    padding: 8px 20px 5px 20px !important;\n}\n\n.search-list li a .search-title\n{\n    font-size: .9rem;\n    font-weight: bold;\n\n    margin: .8rem 0 4px 0;\n\n    color: #9c27b0;\n}\n\n.search-list li a span\n{\n    font-size: 1rem;\n    line-height: .9;\n\n    vertical-align: middle;\n\n    color: #9e9e9e;\n}\n\n.search-list li a span.material-icons\n{\n    font-size: 1.4rem;\n    line-height: 1.2;\n}\n\n.search-list li a .member-info\n{\n    margin-left: .8rem;\n}\n\n.search-list li a .member-info span:hover\n{\n    color: #9c27b0 !important;\n}\n\n.search-list li a .status small:not(:first-child)\n{\n    color: #757575;\n}\n\n.search-list li.current_item a\n{\n    background-color: #eee;\n}\n\n.search-list li.auto-suggestion-title\n{\n    background-color: #fff !important;\n}\n\n.search-list li.auto-suggestion-title a\n{\n    background-color: #fff !important;\n}\n\n.search-list li.auto-suggestion-title a:hover\n{\n    background-color: #fff !important;\n}\n\n.content-overlay\n{\n    position: fixed;\n    z-index: -1;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n\n    visibility: hidden;\n\n    width: 100%;\n    height: 100%;\n\n    cursor: pointer;\n    -webkit-transition: all .7s;\n            transition: all .7s;\n}\n\n.content-overlay.show\n{\n    z-index: 995;\n\n    visibility: visible;\n\n    background-color: rgba(0, 0, 0, .5);\n}\n\nnav.display-none.search-sm\n{\n    position: absolute;\n\n    background-color: #fff;\n}\n\nnav.display-none.search-sm .nav-wrapper form .input-field input.search-box-sm:not(:focus)\n{\n    color: #9c27b0;\n}\n\nnav.display-none.search-sm .nav-wrapper form .input-field i\n{\n    color: #444;\n}\n\n@media only screen and (max-width: 600px)\n{\n    .navbar .nav-wrapper .dropdown-content\n    {\n        left: 25px !important;\n\n        width: calc(100% - 33px) !important;\n    }\n    .navbar .nav-wrapper .navbar-list > li > a\n    {\n        padding: 0 13px;\n    }\n    .navbar .profile-button span.avatar-status\n    {\n        line-height: 39px;\n    }\n    .notification-button i\n    {\n        font-size: 29px;\n\n        position: relative;\n        top: 12px;\n    }\n    .search-button i\n    {\n        position: relative;\n        top: 6px;\n\n        height: 0;\n    }\n    .search-sm-close\n    {\n        position: absolute !important;\n        top: 12px !important;\n    }\n    .search-sm-icon\n    {\n        position: absolute !important;\n        top: 14px !important;\n    }\n}\n\n@media (max-width: 992px)\n{\n    .navbar .navbar-main\n    {\n        padding: 0 8px 0 0;\n    }\n}\n\n/*----------------------------------------\n    SideNav - Main Menu\n------------------------------------------*/\n.sidenav-main\n{\n    position: fixed;\n    z-index: 999;\n    top: 0;\n\n    width: 250px;\n    height: 100%;\n\n    -webkit-transition: .3s ease all;\n            transition: .3s ease all;\n}\n\n.sidenav-main span.badge.new\n{\n    line-height: 20px;\n\n    margin-top: 11px;\n}\n\n.brand-sidebar\n{\n    position: fixed;\n    top: 0;\n    left: 0;\n\n    width: inherit;\n    height: 64px;\n\n    background: #fff;\n    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, .2);\n\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n}\n\n.brand-sidebar .logo-wrapper\n{\n    font-size: 3rem;\n    line-height: 17px !important;\n\n    margin: 0;\n\n    white-space: nowrap;\n}\n\n.brand-sidebar .logo-wrapper a.brand-logo img\n{\n    height: 18px;\n}\n\n.brand-sidebar .logo-wrapper a.navbar-toggler\n{\n    position: absolute;\n    top: 7px;\n    right: 23px;\n}\n\n.brand-sidebar .logo-wrapper a.navbar-toggler i\n{\n    font-size: 15px;\n    line-height: 56px;\n\n    display: block;\n\n    height: 56px;\n\n    color: #333;\n}\n\n.brand-sidebar span.logo-text\n{\n    font-size: 24px;\n\n    visibility: visible;\n\n    padding-left: 8px;\n\n    -webkit-transition: opacity .2s linear;\n            transition: opacity .2s linear;\n\n    opacity: 1;\n}\n\n.brand-sidebar .brand-logo\n{\n    font-size: 2.1rem;\n    line-height: 0;\n\n    position: absolute;\n\n    display: inline-block;\n\n    margin: 1px 0;\n    padding: 22px 12px 22px 22px;\n\n    color: #333;\n}\n\n.brand-sidebar .brand-logo img\n{\n    height: 18px;\n}\n\n.brand-sidebar .brand-logo.center\n{\n    left: 50%;\n\n    -webkit-transform: translateX(-50%);\n        -ms-transform: translateX(-50%);\n            transform: translateX(-50%);\n}\n\n@media only screen and (max-width: 992px)\n{\n    .brand-sidebar .brand-logo\n    {\n        left: 50%;\n\n        -webkit-transform: translateX(-50%);\n            -ms-transform: translateX(-50%);\n                transform: translateX(-50%);\n    }\n    .brand-sidebar .brand-logo.left,\n    .brand-sidebar .brand-logo.right\n    {\n        padding: 0;\n\n        -webkit-transform: none;\n            -ms-transform: none;\n                transform: none;\n    }\n    .brand-sidebar .brand-logo.left\n    {\n        left: .5rem;\n    }\n    .brand-sidebar .brand-logo.right\n    {\n        right: .5rem;\n        left: auto;\n    }\n}\n\n.brand-sidebar .brand-logo.right\n{\n    right: .5rem;\n\n    padding: 0;\n}\n\n.brand-sidebar .brand-logo i,\n.brand-sidebar .brand-logo [class^='mdi-'],\n.brand-sidebar .brand-logo [class*='mdi-'],\n.brand-sidebar .brand-logo i.material-icons\n{\n    float: left;\n\n    margin-right: 15px;\n}\n\n.sidenav\n{\n    top: 64px;\n\n    overflow: hidden;\n\n    width: inherit;\n    height: 100%;\n    padding-bottom: 65px;\n\n    -webkit-transition: auto !important;\n            transition: auto !important;\n\n    border: none;\n    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, .2);\n\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n}\n\n.sidenav.native-scroll\n{\n    overflow-y: scroll !important;\n}\n\n.sidenav a\n{\n    line-height: 42px;\n\n    height: 42px;\n}\n\n.sidenav .navigation-header\n{\n    font-size: .85rem;\n    font-weight: 600;\n\n    margin-top: 10px;\n    padding: 0 23px;\n\n    text-transform: uppercase;\n}\n\n.sidenav .navigation-header .navigation-header-icon\n{\n    display: none;\n}\n\n.sidenav .navigation-header .navigation-header-text\n{\n    font-size: .85rem;\n    font-weight: 600;\n    line-height: 30px;\n\n    height: 30px;\n    margin: 0;\n    padding: 0 !important;\n\n    color: #969696;\n}\n\n.sidenav .navigation-header .navigation-header-text:hover\n{\n    background-color: transparent !important;\n}\n\n.sidenav li\n{\n    line-height: 44px;\n\n    padding: 0;\n}\n\n.sidenav li a\n{\n    margin-right: 1.5rem;\n\n    color: rgba(0, 0, 0, .87);\n}\n\n.sidenav li a i\n{\n    font-size: 1.4rem;\n    line-height: inherit;\n\n    display: block;\n    float: left;\n\n    width: 2rem;\n    margin-right: 1rem;\n\n    text-align: center;\n}\n\n.sidenav .collapsible-header\n{\n    font-weight: 400;\n    /* Sidebar nav open close icons*/\n}\n\n.sidenav .collapsible-header:after\n{\n    font-family: 'Material Icons';\n    font-size: 18px;\n\n    position: absolute;\n    right: 0;\n\n    content: 'keyboard_arrow_right';\n    transition: transform .3s ease-in-out, opacity .25s ease-in-out .1s, -webkit-transform .3s ease-in-out;\n\n    color: #afafaf;\n}\n\n.sidenav .collapsible-header.active:after\n{\n    content: 'keyboard_arrow_down';\n}\n\n.sidenav li .collapsible-body\n{\n    background: transparent;\n}\n\n.sidenav li .collapsible-body a i\n{\n    font-size: .7rem;\n}\n\n.sidenav li a.active\n{\n    margin: 0;\n\n    color: #fff;\n    background: -webkit-linear-gradient(45deg, #8e24aa, #ff6e40);\n    background:         linear-gradient(45deg, #8e24aa, #ff6e40);\n    box-shadow: 3px 3px 20px 0 rgba(255, 110, 64, .5);\n}\n\n.sidenav li a.active i\n{\n    color: #fff;\n}\n\n.sidenav li:not(.active).open\n{\n    background-color: rgba(0, 0, 0, .035);\n}\n\n.sidenav li.active\n{\n    background-color: transparent;\n}\n\n.sidenav li.active > .collapsible-header:after\n{\n    -webkit-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n            transform: rotate(90deg);\n}\n\n.sidenav li.open\n{\n    background: rgba(0, 0, 0, .035);\n}\n\n.sidenav li > a,\n.sidenav li a.collapsible-header\n{\n    font-weight: 400;\n    line-height: 44px;\n\n    height: 44px;\n    padding: 0 16px !important;\n}\n\n.sidenav li > a > i.material-icons,\n.sidenav li a.collapsible-header > i.material-icons\n{\n    line-height: 44px;\n\n    height: 44px;\n    margin: 0 20px 0 0;\n}\n\n.sidenav li > a:not(.active):hover\n{\n    background-color: rgba(0, 0, 0, .035) !important;\n}\n\n.sidenav .collapsible-body > ul:not(.collapsible) > li.active,\n.sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active\n{\n    background-color: #e6b5ee;\n}\n\n.sidenav .collapsible-body > ul:not(.collapsible) > li.active a,\n.sidenav .collapsible-body > ul:not(.collapsible) > li.active i,\n.sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active a,\n.sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active i\n{\n    color: #9c27b0;\n    background: none;\n}\n\n.nav-expanded .sidenav .menu-title\n{\n    visibility: visible;\n\n    -webkit-transition: opacity .2s linear;\n            transition: opacity .2s linear;\n\n    opacity: 1;\n}\n\n.nav-expanded .navigation-header-text\n{\n    display: block;\n}\n\n.nav-expanded .navigation-header-icon\n{\n    display: none;\n}\n\n.nav-collapsed.sidenav-main\n{\n    width: 64px;\n}\n\n.nav-collapsed .brand-sidebar .navbar-toggler,\n.nav-collapsed .brand-sidebar .brand-logo span\n{\n    visibility: hidden;\n\n    -webkit-transition: visibility 0s 2s, opacity .05s linear;\n            transition: visibility 0s 2s, opacity .05s linear;\n\n    opacity: 0;\n}\n\n.nav-collapsed .brand-sidebar .brand-logo\n{\n    padding: 22px 12px 22px 15px;\n}\n\n.nav-collapsed .navigation-header-text\n{\n    display: none;\n}\n\n.nav-collapsed .navigation-header-icon\n{\n    display: block !important;\n}\n\n.nav-collapsed .sidenav .user-options,\n.nav-collapsed .sidenav .menu-title,\n.nav-collapsed .sidenav .collapsible-body span,\n.nav-collapsed .sidenav .collapsible-header:after\n{\n    display: none;\n}\n\n.nav-collapsed .sidenav .menu-title\n{\n    visibility: visible;\n\n    -webkit-transition: opacity .2s linear;\n            transition: opacity .2s linear;\n\n    opacity: 1;\n}\n\n.nav-lock .navigation-header-icon\n{\n    display: none;\n}\n\n.nav-collapsible.nav-collapsed span.badge.pill\n{\n    visibility: hidden;\n\n    -webkit-transition: visibility 0s 2s, opacity .05s linear;\n            transition: visibility 0s 2s, opacity .05s linear;\n\n    opacity: 0;\n}\n\n.nav-collapsible span.badge\n{\n    color: #fff;\n}\n\n.nav-collapsible span.badge.pill\n{\n    position: absolute;\n    right: 4px;\n\n    visibility: visible;\n    float: none;\n\n    -webkit-transition: opacity .2s linear;\n            transition: opacity .2s linear;\n\n    opacity: 1;\n}\n\n.sidenav-dark\n{\n    background: #2c323f;\n}\n\n.sidenav-dark .brand-sidebar\n{\n    background: #2c323f;\n    box-shadow: 0 -4px 7px 1px rgba(0, 0, 0, .2);\n}\n\n.sidenav-dark.sidenav-main .sidenav\n{\n    background-color: transparent;\n}\n\n.sidenav-dark.sidenav-main .sidenav .collapsible-body > ul:not(.collapsible) > li.active,\n.sidenav-dark.sidenav-main .sidenav.fixed .collapsible-body > ul:not(.collapsible) > li.active\n{\n    background: #9c27b0;\n}\n\n.sidenav-dark.sidenav-main .sidenav li .navigation-header-text\n{\n    color: #b0bec5;\n}\n\n.sidenav-dark.sidenav-main .sidenav li > a,\n.sidenav-dark.sidenav-main .sidenav li .more-text\n{\n    color: #fff;\n}\n\n.sidenav-dark.sidenav-main .sidenav li > a > i,\n.sidenav-dark.sidenav-main .sidenav li .more-text > i\n{\n    color: #fff;\n}\n\n.sidenav-dark.sidenav-main .sidenav li.bold > a:not(.active):hover,\n.sidenav-dark.sidenav-main .sidenav li:not(.active).open\n{\n    background-color: rgba(0, 0, 0, .1) !important;\n}\n\n.sidenav-dark.sidenav-main .collapsible\n{\n    border: none;\n}\n\n.sidenav-dark.sidenav-main .brand-sidebar .brand-logo,\n.sidenav-dark.sidenav-main .brand-sidebar .logo-wrapper a.navbar-toggler i\n{\n    color: #fff;\n}\n\n.sidenav-dark.sidenav-gradient .brand-sidebar\n{\n    background: transparent;\n}\n\n.sidenav-dark.sidenav-gradient.fixed .collapsible-body\n{\n    background: transparent;\n}\n\n.sidenav-dark.sidenav-gradient.sidenav-main .sidenav li .navigation-header-text\n{\n    color: #ececec;\n}\n\n.sidenav-dark .collapsible-header:after\n{\n    color: #ececec;\n}\n\n.sidenav-dark .ps__rail-y:hover\n{\n    background: transparent;\n}\n\n.navbar-full .brand-sidebar\n{\n    background: #a53394;\n}\n\n.navbar-full .brand-sidebar .brand-logo\n{\n    color: #fff;\n}\n\n.navbar-full .brand-sidebar .logo-wrapper a.navbar-toggler i\n{\n    color: #fff;\n}\n\n.sidenav-active-rounded .sidenav li > a.active\n{\n    margin-right: 1.15rem;\n\n    color: #fff;\n    border-radius: 0 25px 25px 0;\n}\n\n.sidenav-active-rounded .sidenav li > a.active > i\n{\n    color: #fff;\n}\n\n.sidenav-active-rounded .sidenav li:not(.open) > a.active\n{\n    color: #fff;\n}\n\n.sidenav-active-rounded .sidenav li:not(.open) > a.active > i\n{\n    color: #fff;\n}\n\n.sidenav-active-rounded .sidenav li > a:hover,\n.sidenav-active-rounded .sidenav li > li:not(.active) > a:hover\n{\n    border-radius: 0 25px 25px 0;\n}\n\n.sidenav-active-rounded .sidenav li > a,\n.sidenav-active-rounded .sidenav li a.collapsible-header\n{\n    margin-right: 1.15rem;\n    padding: 0 0 0 21px !important;\n\n    -webkit-transition: none;\n            transition: none;\n}\n\n.sidenav-active-rounded .sidenav .collapsible-header:after\n{\n    right: 4px;\n}\n\n.sidenav-active-rounded.nav-collapsed li > a,\n.sidenav-active-rounded.nav-collapsed li a.collapsible-header\n{\n    margin-right: 10px !important;\n}\n\n.sidenav-active-rounded.nav-collapsed li.close\n{\n    background-color: rgba(0, 0, 0, .08);\n}\n\n.sidenav-active-square .sidenav li > a.active\n{\n    margin-right: 1.15rem;\n\n    color: #fff;\n    border-radius: 0 5px 5px 0;\n}\n\n.sidenav-active-square .sidenav li > a.active > i\n{\n    color: #fff;\n}\n\n.sidenav-active-square .sidenav li:not(.open) > a.active\n{\n    color: #fff;\n}\n\n.sidenav-active-square .sidenav li:not(.open) > a.active > i\n{\n    color: #fff;\n}\n\n.sidenav-active-square .sidenav li > a:hover,\n.sidenav-active-square .sidenav li > li:not(.active) > a:hover\n{\n    border-radius: 0 5px 5px 0;\n}\n\n.sidenav-active-square .sidenav li > a,\n.sidenav-active-square .sidenav li a.collapsible-header\n{\n    margin-right: 1.15rem;\n    padding: 0 0 0 21px !important;\n\n    -webkit-transition: none;\n            transition: none;\n}\n\n.sidenav-active-square .sidenav .collapsible-header:after\n{\n    right: 4px;\n}\n\n.sidenav-active-square.nav-collapsed li > a,\n.sidenav-active-square.nav-collapsed li a.collapsible-header\n{\n    margin-right: 10px !important;\n}\n\n.sidenav-active-square.nav-collapsed li.close\n{\n    background-color: rgba(0, 0, 0, .08);\n}\n\n@media only screen and (max-width: 992px)\n{\n    .sidenav-main\n    {\n        width: auto;\n        height: 0;\n    }\n    .sidenav-main .brand-sidebar\n    {\n        left: 80px;\n\n        background: transparent;\n        box-shadow: none;\n    }\n    .sidenav-main .brand-sidebar .navbar-toggler\n    {\n        display: none;\n    }\n    .sidenav-main .brand-sidebar .logo-wrapper\n    {\n        padding: 0 !important;\n    }\n    .sidenav-main .brand-sidebar .sidenav-trigger\n    {\n        top: -48px;\n    }\n    .sidenav-main .sidenav\n    {\n        top: 0;\n\n        width: 250px;\n    }\n    .sidenav-main .btn-sidenav-toggle\n    {\n        position: relative;\n        top: 10px;\n        left: 10px;\n    }\n    .sidenav-dark.sidenav-main .sidenav\n    {\n        background: #2c323f;\n    }\n}\n\n@media only screen and (max-width: 600px)\n{\n    .sidenav-main .brand-sidebar .brand-logo\n    {\n        padding: 16px 12px 20px 12px;\n    }\n    .sidenav-main .btn-sidenav-toggle\n    {\n        position: relative;\n        top: 6px;\n        left: 6px;\n    }\n}\n\n@media screen and (max-width: 992px)\n{\n    .sidenav\n    {\n        padding-bottom: 0;\n    }\n}\n\n@media screen and (-ms-high-contrast: active) and (min-width: 993px), screen and (-ms-high-contrast: none) and (min-width: 993px)\n{\n    ul#slide-out.sidenav\n    {\n        height: calc(100% - 64px) !important;\n    }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)\n{\n    .sidenav .collapsible-header\n    {\n        /* Sidebar nav open close icons*/\n    }\n    .sidenav .collapsible-header:after\n    {\n        width: 0;\n\n        content: '+';\n    }\n    .sidenav li.active > .collapsible-header:after\n    {\n        right: 0;\n\n        width: 0;\n\n        content: '-';\n        -webkit-transform: rotate(180deg);\n            -ms-transform: rotate(180deg);\n                transform: rotate(180deg);\n    }\n}\n\n@-moz-document url-prefix()\n{\n    @media screen and (min-width: 993px)\n    {\n        ul#slide-out.sidenav\n        {\n            height: calc(100% - 64px) !important;\n        }\n    }\n}\n\n@supports (-ms-ime-align: auto)\n{\n    @media screen and (min-width: 993px)\n    {\n        ul#slide-out.sidenav\n        {\n            height: calc(100% - 64px) !important;\n        }\n    }\n}\n\n/*----------------------------------------\n    Slideout - Right side chat slide out\n------------------------------------------*/\n#right-search .input-field\n{\n    margin-top: 0;\n}\n\n#slide-out-right\n{\n    top: 64px;\n\n    overflow: hidden;\n}\n\n#slide-out-right .tab a\n{\n    padding: 0 !important;\n}\n\n#slide-out-right.sidenav\n{\n    top: 0;\n\n    width: 340px;\n    padding-bottom: 0;\n}\n\n#slide-out-right.sidenav li a.active\n{\n    background: none;\n    box-shadow: none;\n}\n\n#slide-out-right.sidenav .slide-out-right-body\n{\n    width: 100%;\n    height: 100vh;\n}\n\n#slide-out-right.sidenav #messages\n{\n    position: relative;\n\n    height: calc(100vh - 54px);\n    padding: .7rem;\n}\n\n#slide-out-right.sidenav #messages .header-search-input\n{\n    width: 86%;\n    height: 2.8rem;\n    margin: 1rem;\n    padding-left: 1rem;\n\n    border: none;\n    border-radius: 2rem;\n    background-color: #eee;\n}\n\n#slide-out-right.sidenav #messages .collection .collection-item\n{\n    border: none;\n}\n\n#slide-out-right.sidenav #messages .collection ul.collection\n{\n    border: none;\n}\n\n#slide-out-right.sidenav #messages .collection ul.collection li\n{\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display:         flex;\n\n    padding-top: 1.2rem;\n\n    cursor: pointer;\n}\n\n#slide-out-right.sidenav #messages .collection ul.collection li .user-content\n{\n    margin-top: .4em;\n    margin-left: 1rem;\n}\n\n#slide-out-right.sidenav #messages .collection ul.collection li .secondary-content\n{\n    top: 1.6rem;\n\n    color: #c5cae9;\n}\n\n#slide-out-right.sidenav #messages .collection ul.collection li:hover\n{\n    background-color: #f5f5f5;\n}\n\n#slide-out-right.sidenav #activity\n{\n    position: relative;\n\n    height: calc(100vh - 54px);\n}\n\n#slide-out-right.sidenav #settings\n{\n    position: relative;\n\n    height: calc(100vh - 54px);\n}\n\n#slide-out-right .fixed-line-height\n{\n    line-height: 24px;\n}\n\n#slide-out-right #chatapp li\n{\n    line-height: 35px !important;\n\n    min-height: 70px !important;\n}\n\n#slide-out-right #chatapp .sidenav li\n{\n    line-height: 20px !important;\n}\n\n.chat-close-collapse\n{\n    padding: 5px 15px 0 0;\n}\n\n.icon-bg-color\n{\n    font-size: 20px;\n\n    width: 35px;\n    height: 35px;\n    padding-top: 8px;\n\n    text-align: center;\n\n    border-radius: 50%;\n}\n\n.border-bottom-1\n{\n    border-bottom: 1px solid #f5f5f5;\n}\n\n#activity\n{\n    /* Timeline  */\n    /* -------- */\n}\n\n#activity .widget-timeline\n{\n    margin: .5rem 5%;\n    padding-left: 40px !important;\n}\n\n#activity .widget-timeline li\n{\n    position: relative;\n\n    padding: 1.1rem 0;\n\n    list-style: none;\n}\n\n#activity .widget-timeline li.timeline-items:before\n{\n    position: absolute;\n    z-index: 2;\n    top: 22px;\n    left: -37px;\n\n    width: 13px;\n    height: 13px;\n\n    content: '';\n\n    border: 3px solid #fff;\n    border-radius: 50%;\n    background: #3f51b5;\n    box-shadow: 1px 2px 6px 0 rgba(25, 42, 70, .3);\n}\n\n#activity .widget-timeline li.timeline-items.active:not(:last-child):after\n{\n    position: absolute;\n    z-index: 1;\n    top: 22px;\n    left: -31px;\n\n    width: 1px;\n    height: 100%;\n\n    content: '';\n\n    background: #e0e0e0;\n}\n\n#activity .widget-timeline li.timeline-items .timeline-content\n{\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1;\n\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display:         flex;\n\n    padding: .5rem 1rem;\n\n    color: #9e9e9e;\n    border-radius: .267rem;\n    background-color: #fafafa;\n\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n            align-items: center;\n}\n\n#activity .widget-timeline li .timeline-time\n{\n    font-size: .75rem;\n    line-height: 1.7;\n\n    float: right;\n}\n\n#activity .widget-timeline li .timeline-title\n{\n    font-size: 15px;\n    font-weight: 900;\n    line-height: 1;\n\n    margin: 0;\n\n    color: #6b6f82;\n}\n\n#activity .widget-timeline li .timeline-text\n{\n    font-size: .75rem;\n    line-height: 2.2;\n\n    margin: 0;\n\n    color: #9e9e9e;\n}\n\n.slide-out-right-sidenav-chat\n{\n    top: 0;\n\n    width: 340px;\n}\n\n#settings .setting-header\n{\n    font-size: 1.1rem;\n}\n\n#settings ul.collection\n{\n    max-height: 100% !important;\n}\n\n@media only screen and (max-width: 992px)\n{\n    #slide-out-right\n    {\n        top: 0;\n    }\n    #slide-out-right.sidenav\n    {\n        height: 100% !important;\n    }\n}\n\n#slide-out-chat .chat-head,\n#slide-out-chat .chat-footer\n{\n    z-index: 1;\n\n    width: 100%;\n\n    background-color: #eceff1;\n}\n\n#slide-out-chat .chat-footer\n{\n    bottom: -.6rem;\n}\n\n#slide-out-chat .chat-footer form\n{\n    background-color: #eceff1;\n}\n\n#slide-out-chat .chat-footer input\n{\n    width: 80%;\n    margin-left: -2rem;\n    padding-left: 1rem;\n\n    border: none;\n    border-radius: 3rem;\n    background-color: #fff;\n}\n\n#slide-out-chat .chat-footer label\n{\n    margin-top: -.7rem;\n    margin-left: 2rem;\n}\n\n#slide-out-chat .chat-footer label:not(.label-icon).active\n{\n    display: none;\n}\n\n#slide-out-chat .chat-footer i\n{\n    cursor: pointer;\n}\n\n#slide-out-chat .chat-footer a\n{\n    line-height: 2rem;\n\n    position: absolute;\n\n    width: 40px;\n\n    background: transparent;\n    box-shadow: none;\n}\n\n#slide-out-chat .speech-bubble\n{\n    position: relative;\n\n    margin-left: 1rem;\n\n    border-radius: .3rem;\n    background: #eceff1;\n}\n\n#slide-out-chat .speech-bubble:after\n{\n    position: absolute;\n    top: 50%;\n    left: -9px;\n\n    width: 0;\n    height: 0;\n    margin-top: -20px;\n\n    content: '';\n\n    border: 10px solid transparent;\n    border-right-color: #eceff1;\n    border-left: 0;\n}\n\n#slide-out-chat .speech-bubble-right\n{\n    position: relative;\n\n    margin-left: 1rem;\n\n    color: #fff;\n    border-radius: .3rem;\n    background-color: #9c27b0;\n}\n\n#slide-out-chat .speech-bubble-right:after\n{\n    position: absolute;\n    top: 50%;\n    right: 0;\n\n    width: 0;\n    height: 0;\n    margin-top: -16px;\n    margin-right: -8px;\n\n    content: '';\n\n    border: 10px solid transparent;\n    border-right: 0;\n    border-left-color: #9c27b0;\n}\n\n#slide-out-chat .chat-body ul.collection\n{\n    top: 0;\n\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n#slide-out-chat .collection\n{\n    top: 48px;\n\n    height: calc(100vh - 129px);\n}\n\n#slide-out-chat .collection .collection-item\n{\n    min-height: auto;\n    margin-bottom: 1rem;\n\n    border: none;\n}\n\n#slide-out-chat .collection .collection-item .user-content\n{\n    padding: 1rem;\n}\n\n@media (max-width: 600px)\n{\n    #slide-out-right.sidenav\n    {\n        box-shadow: none;\n    }\n}\n\n/*----------------------------------------\n\tBreadcrumb\n------------------------------------------*/\n#breadcrumbs-wrapper\n{\n    padding: 20px 0;\n\n    background: transparent;\n}\n\n#breadcrumbs-wrapper .breadcrumbs-btn\n{\n    top: 24px;\n}\n\n#breadcrumbs-wrapper h5.breadcrumbs-header\n{\n    font-size: 1.64rem;\n    line-height: 1.804rem;\n\n    margin: 1.5rem 0 0 0;\n}\n\n#breadcrumbs-wrapper .breadcrumbs\n{\n    margin: 15px 0;\n    padding: 0;\n\n    list-style: none;\n}\n\n#breadcrumbs-wrapper .breadcrumbs > li\n{\n    display: inline-block;\n}\n\n#breadcrumbs-wrapper .breadcrumbs > li + li::before\n{\n    font-family: 'Material Icons';\n\n    position: relative;\n    top: 3px;\n\n    padding: 0 5px 0 4px;\n\n    content: 'keyboard_arrow_right';\n\n    color: #bdbdbd;\n}\n\n#breadcrumbs-wrapper .breadcrumbs .active\n{\n    font-weight: normal;\n\n    color: #9e9e9e;\n}\n\n#breadcrumbs-wrapper .breadcrumbs-title\n{\n    font-size: 1.4rem;\n    line-height: 1.4rem;\n}\n\n#breadcrumbs-wrapper .breadcrumbs-nav\n{\n    margin: 8px 0 9px;\n}\n\n#breadcrumbs-wrapper.breadcrumbs-bg-image\n{\n    position: relative;\n    z-index: 1;\n\n    color: #fff;\n    background-position: center center;\n    background-size: cover;\n}\n\n#breadcrumbs-wrapper.breadcrumbs-bg-image .breadcrumbs-title\n{\n    color: #fff;\n}\n\n#breadcrumbs-wrapper.breadcrumbs-bg-image .breadcrumbs\n{\n    margin: 10px 0;\n}\n\n#breadcrumbs-wrapper.breadcrumbs-bg-image .breadcrumbs a\n{\n    color: rgba(255, 255, 255, .8);\n}\n\n#breadcrumbs-wrapper.breadcrumbs-bg-image .breadcrumbs .active\n{\n    color: rgba(255, 255, 255, .9);\n}\n\n#breadcrumbs-wrapper.breadcrumbs-bg-image::before\n{\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n\n    content: '';\n\n    background-color: rgba(0, 0, 0, .07);\n}\n\n#breadcrumbs-wrapper.breadcrumbs-dark .breadcrumbs-title,\n#breadcrumbs-wrapper.breadcrumbs-dark a\n{\n    color: rgba(255, 255, 255, .85);\n}\n\n#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs-title,\n#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs\n{\n    display: inline;\n}\n\n#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs-left\n{\n    position: relative;\n    top: 8px;\n}\n\n#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs-title\n{\n    padding-right: 20px;\n\n    border-right: 1px solid #bdbdbd;\n}\n\n#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs\n{\n    padding-left: 20px;\n}\n\n#breadcrumbs-wrapper.breadcrumbs-inline .breadcrumbs-btn\n{\n    top: 0;\n}\n\n#breadcrumbs-wrapper .breadcrumbs-right .breadcrumbs\n{\n    float: right;\n\n    margin-top: 0;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)\n{\n    #breadcrumbs-wrapper .breadcrumbs > li + li::before\n    {\n        top: 0;\n\n        width: 0;\n\n        content: '/';\n    }\n}\n\n/*----------------------------------------\n    Forms\n------------------------------------------*/\n.input-field div.error\n{\n    font-size: .8rem;\n\n    position: relative;\n    top: 0rem;\n    left: 0rem;\n\n    -webkit-transform: translateY(0%);\n        -ms-transform: translateY(0%);\n            transform: translateY(0%);\n\n    color: #ff4081;\n}\n\n.input-field label.active\n{\n    width: 100%;\n}\n\n.left-alert input[type=text] + label:after,\n.left-alert input[type=password] + label:after,\n.left-alert input[type=email] + label:after,\n.left-alert input[type=url] + label:after,\n.left-alert input[type=time] + label:after,\n.left-alert input[type=date] + label:after,\n.left-alert input[type=datetime-local] + label:after,\n.left-alert input[type=tel] + label:after,\n.left-alert input[type=number] + label:after,\n.left-alert input[type=search] + label:after,\n.left-alert textarea.materialize-textarea + label:after\n{\n    left: 0;\n}\n\n.right-alert input[type=text] + label:after,\n.right-alert input[type=password] + label:after,\n.right-alert input[type=email] + label:after,\n.right-alert input[type=url] + label:after,\n.right-alert input[type=time] + label:after,\n.right-alert input[type=date] + label:after,\n.right-alert input[type=datetime-local] + label:after,\n.right-alert input[type=tel] + label:after,\n.right-alert input[type=number] + label:after,\n.right-alert input[type=search] + label:after,\n.right-alert textarea.materialize-textarea + label:after\n{\n    right: 70px;\n}\n\n.select2-icons + .select2-container--default .select2-selection__rendered,\n.select2-icons + .select2-container--default .select2-selection__choice\n{\n    display: -webkit-box !important;\n    display: -webkit-flex !important;\n    display: -ms-flexbox !important;\n    display:         flex !important;\n\n    padding-bottom: 5px !important;\n\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n            align-items: center;\n}\n\n.select2-icons + .select2-container--default .select2-selection__rendered i,\n.select2-icons + .select2-container--default .select2-selection__choice i\n{\n    margin-right: 1rem;\n}\n\n.select2-results .select2-results__option i\n{\n    position: relative;\n    top: 7px;\n\n    margin-right: 1rem;\n}\n\n.btn-toolbar\n{\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display:         flex;\n\n    -webkit-flex-wrap: wrap;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n}\n\n.btn-toolbar .btn-group-sm\n{\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display:         flex;\n\n    margin-bottom: .5rem;\n}\n\n.btn-toolbar .btn-group-sm .btn\n{\n    line-height: 0;\n\n    height: 28px;\n    margin-right: 1rem;\n    padding: 0 1rem;\n}\n\n.select2-selection.select-lg\n{\n    font-size: 1.2rem;\n\n    min-height: calc(1.4em + 1.334rem + 3.7px) !important;\n    margin-bottom: 0 !important;\n}\n\n.select2-selection.select-lg .select2-selection__rendered\n{\n    line-height: 28px;\n}\n\n.select2-selection.select-sm\n{\n    font-size: .75rem;\n    line-height: 1.5;\n\n    min-height: calc(1.1em + .94rem + 3.7px) !important;\n    margin-bottom: 0 !important;\n    padding: 0 .2rem;\n}\n\n/*----------------------------------------\n    Tables\n------------------------------------------*/\ntable.dataTable.dtr-inline.collapsed > tbody > tr[role='row'] > td:first-child:before,\ntable.dataTable.dtr-inline.collapsed > tbody > tr[role='row'] > th:first-child:before\n{\n    line-height: 15px;\n\n    top: 19px;\n\n    text-indent: -1px !important;\n}\n\ntable.bordered th,\ntable.bordered td\n{\n    padding: 15px !important;\n\n    border: 1px solid rgba(0, 0, 0, .12) !important;\n}\n\n/*----------------------------------------\nCards\n------------------------------------------*/\n.card\n{\n    margin: 1rem 0 1rem 0;\n}\n\n.card .card-title\n{\n    font-size: 18px;\n    font-weight: 400;\n\n    margin: 0;\n}\n\n.card .activator\n{\n    cursor: pointer;\n}\n\n.card .card-action\n{\n    overflow: hidden;\n}\n\n#card-stats .card-content\n{\n    text-align: center;\n}\n\n#card-stats .card-stats-title\n{\n    font-size: 1rem;\n}\n\n#card-stats .card-stats-title i\n{\n    font-size: 1.2rem;\n\n    position: relative;\n    top: 3px;\n}\n\n#card-stats .card-stats-compare\n{\n    font-size: .85rem;\n}\n\n#card-stats .card-stats-compare i\n{\n    position: relative;\n    top: 8px;\n}\n\n#card-stats .card-stats-number\n{\n    font-size: 1.8rem;\n    font-weight: 600;\n    line-height: 2rem;\n\n    margin: .8rem 0 .6rem 0;\n}\n\n#card-stats .card .card-content\n{\n    padding: 10px 14px;\n}\n\n#card-stats .card .card-action\n{\n    overflow: hidden;\n\n    padding: 10px 14px;\n}\n\n.vertical-align-top\n{\n    vertical-align: top;\n}\n\n.card-animation-1,\n.image-n-margin\n{\n    margin-top: -50px;\n\n    -webkit-transition: .3s;\n    /* Safari */\n    -webkit-transition: .5s;\n            transition: .5s;\n}\n\n.card-animation-1:hover .image-n-margin\n{\n    margin-top: -80px;\n    margin-bottom: 30px;\n\n    cursor: pointer;\n    -webkit-transition: .5s;\n            transition: .5s;\n}\n\n/* alert card */\n.card-alert .card-content\n{\n    padding: 10px 20px;\n}\n\n.card-alert i\n{\n    font-size: 20px;\n\n    position: relative;\n    top: -1px;\n\n    vertical-align: middle;\n}\n\n.card-alert .alert-circle\n{\n    position: relative;\n    top: 0;\n    left: -2px;\n\n    display: inline-block;\n\n    width: 40px;\n\n    vertical-align: bottom;\n    white-space: nowrap;\n\n    border-radius: 1000px;\n}\n\n.card-alert .single-alert\n{\n    line-height: 42px;\n}\n\n.card-alert button\n{\n    font-size: 20px;\n\n    position: absolute;\n    top: 5px;\n    right: 10px;\n\n    color: #fff;\n    border: none;\n    background: none;\n}\n\n.card-alert .card .card-content\n{\n    padding: 20px 40px 20px 20px;\n}\n\n.card-alert .card-action i\n{\n    top: 0;\n\n    margin: 0;\n}\n\n/* work card */\n#work-collections .collection-header\n{\n    font-size: 1.14rem;\n    font-weight: 500;\n}\n\n#work-collections p.collections-title\n{\n    font-size: 1rem;\n    font-weight: 500;\n\n    margin: 0;\n    padding: 0;\n}\n\n#work-collections p.collections-content\n{\n    font-size: .9rem;\n    font-weight: 400;\n\n    margin: 0;\n    padding: 0;\n}\n\n#work-collections .collection-item.avatar\n{\n    height: auto;\n    padding-top: 22px;\n}\n\n/* flight card */\n#flight-card .flight-card-title\n{\n    font-weight: 300;\n\n    margin: 0;\n\n    color: #fff;\n}\n\n#flight-card .flight-card-date\n{\n    font-size: 1rem;\n\n    margin: 0;\n\n    color: #fff;\n}\n\n#flight-card .flight-state\n{\n    padding-bottom: 15px;\n}\n\n#flight-card .flight-state-two\n{\n    border-left: 1px dashed #bdbdbd;\n}\n\n#flight-card .flight-icon\n{\n    font-size: 2.2rem;\n\n    display: block;\n\n    -webkit-transform: rotate(90deg);\n       -moz-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n         -o-transform: rotate(90deg);\n}\n\n#flight-card .card-content-bg\n{\n    background: url('../../public/images/gallery/3.png') no-repeat center center;\n    background-size: cover;\n}\n\n#flight-card .card-content\n{\n    background: rgba(0, 0, 0, .25);\n}\n\n#flight-card .flight-state-wrapper\n{\n    margin: 0 0 80px 0 !important;\n}\n\n#flight-card .card-header .card-title\n{\n    padding: 20px;\n}\n\n/* task card */\n#task-card label\n{\n    display: block;\n\n    height: auto;\n\n    color: rgba(0, 0, 0, .87);\n}\n\n#task-card .task-card-title\n{\n    font-weight: 300;\n\n    margin: 0;\n\n    color: #fff;\n}\n\n#task-card .task-card-date\n{\n    font-size: 1rem;\n\n    margin: 0;\n\n    color: #fff;\n}\n\n#task-card .collection-header\n{\n    padding: 20px;\n}\n\n#task-card .task-add\n{\n    position: absolute;\n    top: 76px;\n    right: 10px;\n}\n\n#task-card .task-cat\n{\n    font-size: .8rem;\n    font-weight: 300;\n\n    margin-left: 37px;\n    padding: 2px 4px;\n\n    color: #fff;\n    border-radius: 2px;\n    background-clip: padding-box;\n}\n\n.task-cat\n{\n    font-size: .8rem;\n    font-weight: 300;\n\n    padding: 2px 4px;\n\n    color: #fff;\n    border-radius: 2px;\n    background-clip: padding-box;\n}\n\n.collection .collection-item.avatar i.circle\n{\n    font-size: 28px;\n}\n\n/* profile card */\n#profile-card .card-image\n{\n    height: 150px;\n}\n\n#profile-card .card-profile-image\n{\n    position: absolute;\n    z-index: 1;\n    top: 110px;\n\n    width: 70px;\n\n    cursor: pointer;\n}\n\n#profile-card .btn-move-up\n{\n    position: relative;\n    top: -40px;\n    right: -18px;\n\n    margin-right: 10px !important;\n}\n\n#profile-card .card-content .profile-card-i\n{\n    position: relative;\n    top: 6px;\n\n    margin-right: 10px;\n}\n\n#profile-card .card-content p\n{\n    font-size: 1rem;\n\n    margin: 10px 0 12px;\n}\n\n.card-move-up .move-up\n{\n    padding: 20px;\n}\n\n.black-overlay\n{\n    background-color: rgba(0, 0, 0, .42) !important;\n}\n\n.bg-image-1\n{\n    width: 100%;\n\n    background-image: url('../../public/images/cards/macbook.png');\n    background-size: cover;\n}\n\n.bg-image-2\n{\n    width: 100%;\n\n    background-image: url('../../public/images/cards/iphone.png');\n    background-size: cover;\n}\n\n.bg-image-3\n{\n    width: 100%;\n\n    background-image: url('../../public/images/cards/applewatch.png');\n    background-size: cover;\n}\n\n.icon-background\n{\n    width: 50px;\n    height: 50px;\n    margin: 8px;\n    padding-top: 11px;\n}\n\n#profile-card .card-reveal i.material-icons\n{\n    position: relative;\n    top: 6px;\n}\n\n#user-card .flip-card\n{\n    max-width: 100%;\n}\n\n@media screen and (min-width: 1290px)\n{\n    .icon-background\n    {\n        width: 3.125rem;\n        height: 3.125rem;\n        margin: 1.25rem;\n        margin-left: 2rem;\n        padding-top: .6875rem;\n    }\n}\n\n@media screen and (max-width: 1366px)\n{\n    .icon-background\n    {\n        margin-left: 1.25rem;\n    }\n}\n\n@media screen and (min-width: 1440px)\n{\n    .icon-background\n    {\n        margin-left: 2rem;\n    }\n}\n\n@media screen and (min-width: 1680px)\n{\n    .icon-background\n    {\n        margin-left: 2.6875rem;\n    }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1365px)\n{\n    .icon-background\n    {\n        margin-left: .25rem;\n    }\n}\n\n@media screen and (max-width: 992px)\n{\n    .icon-background\n    {\n        margin-left: 1.875rem;\n    }\n}\n\n@media screen and (max-width: 786px)\n{\n    .icon-background\n    {\n        margin-left: .9375rem;\n    }\n}\n\n@media screen and (max-width: 540px)\n{\n    .icon-background\n    {\n        margin-left: .625rem;\n    }\n}\n\n.small-ico-bg\n{\n    padding: 6px;\n\n    border-radius: 50%;\n    background-color: #f3f1f1;\n}\n\n@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px)\n{\n    #cards-extended #gradient-Analytics .card-width,\n    #cards-extended #card-with-analytics .card-width,\n    #cards-extended #card-panel-type .card-width\n    {\n        width: 50%;\n    }\n}\n\n/*----------------------------------------\n    Charts\n------------------------------------------*/\n#card-stats\n{\n    padding-top: 12px;\n}\n\n#chart-dashboard .card\n{\n    overflow: hidden;\n}\n\n#chart-dashboard .card .card-content\n{\n    padding: 10px 14px;\n}\n\n#chartjs .sample-chart-wrapper,\n#chartjs2 .sample-chart-wrapper,\n#chartjs3 .sample-chart-wrapper\n{\n    margin-top: -75px;\n    margin-bottom: -14px;\n}\n\n.sample-chart-wrapper\n{\n    width: 100%;\n}\n\n.chart-title\n{\n    font-size: 1.6rem;\n    font-weight: 300;\n}\n\n/* Revenue Chart */\n.chart-revenue\n{\n    float: right;\n\n    padding: 8px;\n\n    text-align: center;\n\n    border-radius: 3px;\n}\n\n.chart-revenue .chart-revenue-total\n{\n    font-size: .9rem;\n\n    margin: 0;\n}\n\n.chart-revenue .chart-revenue-per\n{\n    font-size: .8rem;\n\n    margin: 0;\n}\n\n.chart-revenue .chart-revenue-per i\n{\n    position: relative;\n    top: 5px;\n}\n\n.chart-revenue-switch\n{\n    padding-top: 28px;\n    padding-right: 10px;\n\n    text-align: right;\n\n    color: #fff;\n}\n\n#materialize-chartist .ct-chart-line,\n#materialize-chartist .ct-chart-bar,\n#materialize-chartist .ct-chart-pie,\n#materialize-chartist .ct-chart-donut\n{\n    height: 400px !important;\n}\n\n/* doughnut chart */\n.doughnut-chart-status\n{\n    font-size: 16px;\n    font-weight: 500;\n\n    position: relative;\n    top: -75px;\n    left: 0;\n\n    height: 0;\n\n    text-align: center;\n}\n\n.doughnut-chart-status p\n{\n    margin-top: -5px;\n}\n\n.doughnut-chart-legend li\n{\n    font-size: .9rem;\n\n    padding: 2px 0;\n}\n\n.doughnut-chart-legend li:before\n{\n    display: block;\n    float: left;\n\n    width: 8px;\n    height: 8px;\n    margin-top: 6px;\n    margin-right: 4px;\n\n    content: '';\n}\n\na.button-collapse.top-nav\n{\n    font-size: 32px;\n\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    left: 7.5%;\n\n    float: none;\n\n    margin-left: 1.5rem;\n\n    color: #fff;\n}\n\n/* trending bar chart */\n.trending-bar-chart-wrapper\n{\n    width: 100%;\n}\n\n.btn-move-up\n{\n    position: relative;\n    top: -28px;\n    right: -18px;\n\n    margin-right: 10px !important;\n}\n\n/*Sparkline*/\n.jqstooltip\n{\n    box-sizing: content-box;\n\n    border: none !important;\n}\n\n.tooltip-class\n{\n    overflow: hidden;\n\n    width: 30px;\n    height: 20px;\n\n    color: #fff;\n}\n\n#ct2-chart .ct-series.ct-series-a .ct-area\n{\n    fill: #00bcd4;\n}\n\n#ct2-chart .ct-series.ct-series-a .ct-point\n{\n    stroke: #00bcd4;\n}\n\n#ct2-chart .ct-series.ct-series-a .ct-line\n{\n    stroke: #54e2f4;\n}\n\n/*  Widget */\n.socialbox .logo\n{\n    font-size: 28px;\n\n    position: absolute;\n    bottom: 20px;\n    left: 20px;\n\n    color: #fff;\n}\n\n.socialbox .info\n{\n    font-size: 15px;\n\n    position: absolute;\n    right: 20px;\n    bottom: 20px;\n\n    margin: 0;\n    padding: 0;\n\n    color: #fff;\n}\n\n.chartist-tooltip.tooltip-show\n{\n    display: inline-block;\n}\n\n.chartist-tooltip\n{\n    display: none;\n}\n\n@media only screen and (min-device-width: 320px) and (max-device-width: 480px)\n{\n    .doughnut-chart-status\n    {\n        display: none;\n    }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px)\n{\n    .doughnut-chart-status\n    {\n        display: none;\n    }\n    #card-stats .card-stats-compare\n    {\n        font-size: .8rem;\n    }\n}\n\n/*----------------------------------------\n    Calender\n------------------------------------------*/\n#full-calendar\n{\n    padding-top: 30px;\n}\n\n#calendar h2\n{\n    font-size: 1.5rem;\n    line-height: 35px;\n\n    text-transform: uppercase;\n}\n\n#calendar .fc-day-header\n{\n    font-weight: 400;\n\n    text-transform: uppercase;\n}\n\n#external-events\n{\n    padding-top: 50px;\n}\n\n#external-events .fc-event\n{\n    margin-bottom: 10px;\n    padding: 5px;\n\n    cursor: all-scroll;\n    text-decoration: none;\n\n    color: #fff;\n    border: none;\n}\n\n.fc button\n{\n    background: #fff;\n}\n\n.fc td\n{\n    border-width: 0 !important;\n}\n\n.fc th\n{\n    border-width: 0 !important;\n}\n\n.fc-state-active\n{\n    color: #9c27b0 !important;\n}\n\n.fc-state-down\n{\n    color: #9c27b0 !important;\n}\n\n/*\n* Custom Animations\n*/\n@-webkit-keyframes fadeUp\n{\n    0%\n    {\n        -webkit-transform: translateY(30px);\n                transform: translateY(30px);\n\n        opacity: 0;\n    }\n    100%\n    {\n        -webkit-transform: translateY(0px);\n                transform: translateY(0px);\n\n        opacity: 1;\n    }\n}\n@keyframes fadeUp\n{\n    0%\n    {\n        -webkit-transform: translateY(30px);\n                transform: translateY(30px);\n\n        opacity: 0;\n    }\n    100%\n    {\n        -webkit-transform: translateY(0px);\n                transform: translateY(0px);\n\n        opacity: 1;\n    }\n}\n\n.animate.fadeUp\n{\n    -webkit-animation: fadeUp;\n            animation: fadeUp;\n    -webkit-animation-duration: 1.5s;\n            animation-duration: 1.5s;\n\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeLeft\n{\n    0%\n    {\n        -webkit-transform: translateX(-30px);\n                transform: translateX(-30px);\n\n        opacity: 0;\n    }\n    100%\n    {\n        -webkit-transform: translateX(0px);\n                transform: translateX(0px);\n\n        opacity: 1;\n    }\n}\n\n@keyframes fadeLeft\n{\n    0%\n    {\n        -webkit-transform: translateX(-30px);\n                transform: translateX(-30px);\n\n        opacity: 0;\n    }\n    100%\n    {\n        -webkit-transform: translateX(0px);\n                transform: translateX(0px);\n\n        opacity: 1;\n    }\n}\n\n.animate.fadeLeft\n{\n    -webkit-animation: fadeLeft;\n            animation: fadeLeft;\n    -webkit-animation-duration: 1.5s;\n            animation-duration: 1.5s;\n\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeRight\n{\n    0%\n    {\n        -webkit-transform: translateX(30px);\n                transform: translateX(30px);\n\n        opacity: 0;\n    }\n    100%\n    {\n        -webkit-transform: translateX(0px);\n                transform: translateX(0px);\n\n        opacity: 1;\n    }\n}\n\n@keyframes fadeRight\n{\n    0%\n    {\n        -webkit-transform: translateX(30px);\n                transform: translateX(30px);\n\n        opacity: 0;\n    }\n    100%\n    {\n        -webkit-transform: translateX(0px);\n                transform: translateX(0px);\n\n        opacity: 1;\n    }\n}\n\n.animate.fadeRight\n{\n    -webkit-animation: fadeRight;\n            animation: fadeRight;\n    -webkit-animation-duration: 1.5s;\n            animation-duration: 1.5s;\n\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n\n.animation-fast\n{\n    -webkit-animation-delay: .1s;\n            animation-delay: .1s;\n}\n\n.animation-slow\n{\n    -webkit-animation-delay: 2s;\n            animation-delay: 2s;\n}\n\n.delay-1\n{\n    -webkit-animation-delay: .3s !important;\n            animation-delay: .3s !important;\n}\n\n.delay-2\n{\n    -webkit-animation-delay: .4s !important;\n            animation-delay: .4s !important;\n}\n\n.delay-3\n{\n    -webkit-animation-delay: .5s !important;\n            animation-delay: .5s !important;\n}\n\n.delay-4\n{\n    -webkit-animation-delay: .6s !important;\n            animation-delay: .6s !important;\n}\n\n.delay-5\n{\n    -webkit-animation-delay: .7s !important;\n            animation-delay: .7s !important;\n}\n\n/*----------------------------------------\n  Miscellaneous CSS for demo purpose only\n------------------------------------------*/\n.dynamic-color .red,\n.dynamic-color .pink,\n.dynamic-color .purple,\n.dynamic-color .deep-purple,\n.dynamic-color .indigo,\n.dynamic-color .blue,\n.dynamic-color .light-blue,\n.dynamic-color .cyan,\n.dynamic-color .teal,\n.dynamic-color .green,\n.dynamic-color .light-green,\n.dynamic-color .lime,\n.dynamic-color .yellow,\n.dynamic-color .amber,\n.dynamic-color .orange,\n.dynamic-color .deep-orange,\n.dynamic-color .brown,\n.dynamic-color .grey,\n.dynamic-color .blue-grey\n{\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 55px;\n\n    display: block;\n\n    box-sizing: border-box;\n    width: 100%;\n    height: 55px;\n    padding: 0 15px;\n}\n\n.dynamic-color .col\n{\n    margin-bottom: 55px;\n}\n\ntr.group\n{\n    background-color: #ddd !important;\n}\n\ntr.group:hover\n{\n    background-color: #ddd !important;\n}\n\n@media only screen and (max-width: 1024px)\n{\n    tfoot\n    {\n        display: none;\n    }\n}\n\n/*----------------------------------------\n    Grid - Flat Site Mockup\n------------------------------------------*/\n.site-layout-example-left\n{\n    height: 300px;\n\n    background-color: #90a4ae;\n}\n\n.site-layout-example-right\n{\n    height: 300px;\n\n    background-color: #00bfa5;\n}\n\n.site-layout-example-top\n{\n    height: 50px;\n\n    background-color: #ff5252;\n}\n\n.flat-text-header\n{\n    display: block;\n\n    width: 80%;\n    height: 35px;\n    margin: 27px auto;\n\n    background-color: rgba(255, 255, 255, .15);\n}\n\n.flat-text\n{\n    display: block;\n\n    width: 80%;\n    height: 25px;\n    margin: 27px auto;\n\n    background-color: rgba(0, 0, 0, .15);\n}\n\n.flat-text.small\n{\n    width: 25%;\n    height: 25px;\n\n    background-color: rgba(0, 0, 0, .15);\n}\n\n.flat-text.full-width\n{\n    width: 100%;\n}\n\n.col.grid-example\n{\n    font-size: 28px;\n    line-height: 50px;\n\n    margin: 7px 0;\n    padding: 0;\n\n    text-align: center;\n\n    color: #fff;\n    border: 1px solid #eee;\n    background-color: #ff6347;\n}\n\n.col.grid-example span\n{\n    font-weight: 200;\n    line-height: 50px;\n}\n\n.waves-color-demo .collection-item\n{\n    line-height: 57px;\n\n    height: 57px;\n}\n\n.collection a.collection-item:not(.active):hover\n{\n    background-color: #f9f9f9;\n}\n\n/*----------------------------------------\n    Chrome Browser Grid Example\n------------------------------------------*/\n.browser-window\n{\n    display: inline-block;\n    overflow: hidden;\n\n    width: 100%;\n    height: auto;\n    margin: 20px 0;\n\n    text-align: left;\n\n    border-radius: 5px 5px 2px 2px;\n    background-color: transparent;\n    background-clip: padding-box;\n}\n\n.browser-window .top-bar\n{\n    height: 30px;\n\n    border-top: thin solid #eaeae9;\n    border-bottom: thin solid #ddd;\n    border-radius: 5px 5px 0 0;\n    background: -webkit-linear-gradient(#e7e7e6, #e0e0e0);\n    background:         linear-gradient(#e7e7e6, #e0e0e0);\n    background-clip: padding-box;\n}\n\n.browser-window .circle\n{\n    display: inline-block;\n\n    width: 10px;\n    height: 10px;\n    margin-right: 1px;\n\n    border-radius: 50%;\n}\n\n.browser-window .circles\n{\n    margin: 5px 12px;\n}\n\n.browser-window .content\n{\n    display: inline-block;\n\n    width: 100%;\n    margin: 0;\n\n    border-radius: 0 0 5px 5px;\n    background-color: #fafafa;\n}\n\n.browser-window .row\n{\n    margin: 0;\n}\n\n.close-circle\n{\n    background-color: #ff5c5a;\n}\n\n.minimize-circle\n{\n    background-color: #fdb45c;\n}\n\n.maximize-circle\n{\n    background-color: #1bc656;\n}\n\n.clear\n{\n    clear: both;\n}\n\n.promo i\n{\n    font-size: 6rem;\n\n    display: block;\n\n    color: #ee6e73;\n}\n\n.promo-caption\n{\n    font-size: 1.7rem;\n    font-weight: 500;\n\n    margin-top: 5px;\n    margin-bottom: 0;\n}\n\n/*----------------------------------------\n    Shadow effect\n------------------------------------------*/\n.shadow-demo\n{\n    width: 100px;\n    height: 100px;\n    margin: 20px auto;\n\n    background-color: #26a69a;\n}\n\n#input-select .input-field label\n{\n    font-size: .8rem;\n\n    position: absolute;\n    top: -14px;\n}\n\n/*----------------------------------------\n    Footer\n------------------------------------------*/\n.page-footer.footer-fixed\n{\n    position: fixed;\n    bottom: 0;\n\n    width: 100%;\n}\n\n.page-footer .container\n{\n    padding: 0 15px;\n}\n\n.page-footer .footer-copyright\n{\n    background-color: transparent;\n}\n\n#world-map-markers\n{\n    height: 300px;\n}\n\n#polar-chart-holder\n{\n    padding-top: 20px;\n}\n\n.footer-light\n{\n    background-color: #fff;\n}\n\n.footer-light.page-footer\n{\n    border-top: 1px solid #d2d2d2 !important;\n}\n\n.footer-light .footer-copyright\n{\n    color: rgba(0, 0, 0, .87);\n}\n\n.footer-dark\n{\n    background: #37474f;\n}\n\n.footer-dark .footer-copyright\n{\n    color: rgba(255, 255, 255, .8);\n}\n\n.footer-dark .footer-copyright a\n{\n    color: #fff;\n}\n\n/*---------------------------------\n    Theme Customizer\n-----------------------------------*/\n.btn-customizer\n{\n    padding: 0 1rem;\n}\n\n.btn-customizer i\n{\n    -webkit-animation: fa-spin 2s infinite linear;\n            animation: fa-spin 2s infinite linear;\n}\n\n@-webkit-keyframes fa-spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0deg);\n                transform: rotate(0deg);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n\n@keyframes fa-spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0deg);\n                transform: rotate(0deg);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n\n.theme-cutomizer\n{\n    z-index: 99999;\n    top: 0;\n\n    width: 360px;\n}\n\n.theme-cutomizer .sidenav-close\n{\n    position: absolute;\n    top: 5px;\n    right: 10px;\n}\n\n.theme-cutomizer .customize-devider\n{\n    border: 1px solid #e4e4e4;\n}\n\n.theme-cutomizer .menu-options .menu-color-option,\n.theme-cutomizer .menu-options .menu-bg-color-option,\n.theme-cutomizer .menu-options .navbar-color-option,\n.theme-cutomizer .navbar-options .menu-color-option,\n.theme-cutomizer .navbar-options .menu-bg-color-option,\n.theme-cutomizer .navbar-options .navbar-color-option\n{\n    display: inline-block;\n\n    width: 24px;\n    height: 24px;\n    margin-right: 8px;\n    margin-bottom: 10px;\n\n    cursor: pointer;\n\n    border: 3px solid #fff;\n    border-radius: 12px;\n}\n\n.theme-cutomizer .menu-options .menu-color-option.selected,\n.theme-cutomizer .menu-options .menu-bg-color-option.selected,\n.theme-cutomizer .menu-options .navbar-color-option.selected,\n.theme-cutomizer .navbar-options .menu-color-option.selected,\n.theme-cutomizer .navbar-options .menu-bg-color-option.selected,\n.theme-cutomizer .navbar-options .navbar-color-option.selected\n{\n    box-shadow: 0 0 10px 3px #03a9f4;\n}\n\n.btn-buy-now\n{\n    position: fixed;\n    z-index: 99;\n    top: 50%;\n    right: -2px;\n\n    padding: 0 1rem;\n}\n\n.buy-now-animated\n{\n    -webkit-animation-duration: 1.5s;\n            animation-duration: 1.5s;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite;\n\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n\n@-webkit-keyframes tada\n{\n    0%\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n                transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n    }\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n                transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n    }\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n                transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n    }\n    100%\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n\n@keyframes tada\n{\n    0%\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n                transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n    }\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n                transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n    }\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n                transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n    }\n    100%\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n\n.tada\n{\n    -webkit-animation-name: tada;\n            animation-name: tada;\n}\n\n.theme-cutomizer-trigger\n{\n    position: fixed;\n    z-index: 99;\n    top: 40%;\n    right: -2px;\n}\n\n.myBt\n{\n    display: none !important;\n}\n\n.luckysheet-postil-show-main{\n    z-index: 1100 !important;\n    min-width: 305px !important;\n}\n.formulaInputFocus{\n    width: auto !important;\n}\n\n.luckysheet-filter-options{\n    color: #000000 !important;\n    cursor: pointer !important;\n    position: absolute !important;\n    border: 0px solid #897bff !important;\n    border-radius: 3px !important;\n    margin-left: 0 !important;\n    padding: 0 4px !important;\n    font-size: 12px !important;\n    height: 15px !important;\n    background: transparent !important;\n}\n\n#luckysheet-postil-overshow-style-fiki{\n    z-index: 1100 !important;\n    overflow-wrap: break-word !important;\n    word-wrap: break-word !important; /* For older browsers */\n    white-space: normal !important; /* To allow normal whitespace handling */\n    width: 200px !important; /* Adjust the width to fit your layout */\n    border: 1px solid #ccc !important; /* Optional border for visualization */\n}\n\n.luckysheet-freezebar-horizontal-drop{\n    z-index: 1000 !important;\n}\n\n#freezen_7{\n    /*z-index: 20 !important;*/\n}\n\n\n@keyframes loading-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loading-dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -40px;\n  }\n\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -120px;\n  }\n}\n\n.loadingAnimation {\n  width: 3em;\n  height: 3em;\n  animation: loading-rotate 2s linear infinite;\n}\n\n.loadingAnimation circle {\n  animation: loading-dash 1.5s ease-in-out infinite;\n  stroke-dasharray: 90, 150;\n  stroke-dashoffset: 0;\n  stroke-width: 2;\n  stroke: currentColor;\n  stroke-linecap: round;\n}\n\n.luckysheet-modal-dialog{\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
